
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/** Demo implementation of 3D particle Verlet/Euler integration simulation. */ var $29ef9b50340ec350$exports = {};
(function(global, factory) {
    $29ef9b50340ec350$exports = factory();
})($29ef9b50340ec350$exports, function() {
    "use strict";
    var isTypedArray = function(x) {
        return x instanceof Uint8Array || x instanceof Uint16Array || x instanceof Uint32Array || x instanceof Int8Array || x instanceof Int16Array || x instanceof Int32Array || x instanceof Float32Array || x instanceof Float64Array || x instanceof Uint8ClampedArray;
    };
    var extend = function(base, opts) {
        var keys = Object.keys(opts);
        for(var i = 0; i < keys.length; ++i)base[keys[i]] = opts[keys[i]];
        return base;
    };
    // Error checking and parameter validation.
    //
    // Statements for the form `check.someProcedure(...)` get removed by
    // a browserify transform for optimized/minified bundles.
    //
    /* globals atob */ var endl = "\n";
    // only used for extracting shader names.  if atob not present, then errors
    // will be slightly crappier
    function decodeB64(str) {
        if (typeof atob !== "undefined") return atob(str);
        return "base64:" + str;
    }
    function raise(message) {
        var error = new Error("(regl) " + message);
        console.error(error);
        throw error;
    }
    function check(pred, message) {
        if (!pred) raise(message);
    }
    function encolon(message) {
        if (message) return ": " + message;
        return "";
    }
    function checkParameter(param, possibilities, message) {
        if (!(param in possibilities)) raise("unknown parameter (" + param + ")" + encolon(message) + ". possible values: " + Object.keys(possibilities).join());
    }
    function checkIsTypedArray(data, message) {
        if (!isTypedArray(data)) raise("invalid parameter type" + encolon(message) + ". must be a typed array");
    }
    function standardTypeEh(value, type) {
        switch(type){
            case "number":
                return typeof value === "number";
            case "object":
                return typeof value === "object";
            case "string":
                return typeof value === "string";
            case "boolean":
                return typeof value === "boolean";
            case "function":
                return typeof value === "function";
            case "undefined":
                return typeof value === "undefined";
            case "symbol":
                return typeof value === "symbol";
        }
    }
    function checkTypeOf(value, type, message) {
        if (!standardTypeEh(value, type)) raise("invalid parameter type" + encolon(message) + ". expected " + type + ", got " + typeof value);
    }
    function checkNonNegativeInt(value, message) {
        if (!(value >= 0 && (value | 0) === value)) raise("invalid parameter type, (" + value + ")" + encolon(message) + ". must be a nonnegative integer");
    }
    function checkOneOf(value, list, message) {
        if (list.indexOf(value) < 0) raise("invalid value" + encolon(message) + ". must be one of: " + list);
    }
    var constructorKeys = [
        "gl",
        "canvas",
        "container",
        "attributes",
        "pixelRatio",
        "extensions",
        "optionalExtensions",
        "profile",
        "onDone"
    ];
    function checkConstructor(obj) {
        Object.keys(obj).forEach(function(key) {
            if (constructorKeys.indexOf(key) < 0) raise('invalid regl constructor argument "' + key + '". must be one of ' + constructorKeys);
        });
    }
    function leftPad(str, n) {
        str = str + "";
        while(str.length < n)str = " " + str;
        return str;
    }
    function ShaderFile() {
        this.name = "unknown";
        this.lines = [];
        this.index = {};
        this.hasErrors = false;
    }
    function ShaderLine(number, line) {
        this.number = number;
        this.line = line;
        this.errors = [];
    }
    function ShaderError(fileNumber, lineNumber, message) {
        this.file = fileNumber;
        this.line = lineNumber;
        this.message = message;
    }
    function guessCommand() {
        var error = new Error();
        var stack = (error.stack || error).toString();
        var pat = /compileProcedure.*\n\s*at.*\((.*)\)/.exec(stack);
        if (pat) return pat[1];
        var pat2 = /compileProcedure.*\n\s*at\s+(.*)(\n|$)/.exec(stack);
        if (pat2) return pat2[1];
        return "unknown";
    }
    function guessCallSite() {
        var error = new Error();
        var stack = (error.stack || error).toString();
        var pat = /at REGLCommand.*\n\s+at.*\((.*)\)/.exec(stack);
        if (pat) return pat[1];
        var pat2 = /at REGLCommand.*\n\s+at\s+(.*)\n/.exec(stack);
        if (pat2) return pat2[1];
        return "unknown";
    }
    function parseSource(source, command) {
        var lines = source.split("\n");
        var lineNumber = 1;
        var fileNumber = 0;
        var files = {
            unknown: new ShaderFile(),
            0: new ShaderFile()
        };
        files.unknown.name = files[0].name = command || guessCommand();
        files.unknown.lines.push(new ShaderLine(0, ""));
        for(var i = 0; i < lines.length; ++i){
            var line = lines[i];
            var parts = /^\s*#\s*(\w+)\s+(.+)\s*$/.exec(line);
            if (parts) switch(parts[1]){
                case "line":
                    var lineNumberInfo = /(\d+)(\s+\d+)?/.exec(parts[2]);
                    if (lineNumberInfo) {
                        lineNumber = lineNumberInfo[1] | 0;
                        if (lineNumberInfo[2]) {
                            fileNumber = lineNumberInfo[2] | 0;
                            if (!(fileNumber in files)) files[fileNumber] = new ShaderFile();
                        }
                    }
                    break;
                case "define":
                    var nameInfo = /SHADER_NAME(_B64)?\s+(.*)$/.exec(parts[2]);
                    if (nameInfo) files[fileNumber].name = nameInfo[1] ? decodeB64(nameInfo[2]) : nameInfo[2];
                    break;
            }
            files[fileNumber].lines.push(new ShaderLine(lineNumber++, line));
        }
        Object.keys(files).forEach(function(fileNumber) {
            var file = files[fileNumber];
            file.lines.forEach(function(line) {
                file.index[line.number] = line;
            });
        });
        return files;
    }
    function parseErrorLog(errLog) {
        var result = [];
        errLog.split("\n").forEach(function(errMsg) {
            if (errMsg.length < 5) return;
            var parts = /^ERROR:\s+(\d+):(\d+):\s*(.*)$/.exec(errMsg);
            if (parts) result.push(new ShaderError(parts[1] | 0, parts[2] | 0, parts[3].trim()));
            else if (errMsg.length > 0) result.push(new ShaderError("unknown", 0, errMsg));
        });
        return result;
    }
    function annotateFiles(files, errors) {
        errors.forEach(function(error) {
            var file = files[error.file];
            if (file) {
                var line = file.index[error.line];
                if (line) {
                    line.errors.push(error);
                    file.hasErrors = true;
                    return;
                }
            }
            files.unknown.hasErrors = true;
            files.unknown.lines[0].errors.push(error);
        });
    }
    function checkShaderError(gl, shader, source, type, command) {
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            var errLog = gl.getShaderInfoLog(shader);
            var typeName = type === gl.FRAGMENT_SHADER ? "fragment" : "vertex";
            checkCommandType(source, "string", typeName + " shader source must be a string", command);
            var files = parseSource(source, command);
            var errors = parseErrorLog(errLog);
            annotateFiles(files, errors);
            Object.keys(files).forEach(function(fileNumber) {
                var file = files[fileNumber];
                if (!file.hasErrors) return;
                var strings = [
                    ""
                ];
                var styles = [
                    ""
                ];
                function push(str, style) {
                    strings.push(str);
                    styles.push(style || "");
                }
                push("file number " + fileNumber + ": " + file.name + "\n", "color:red;text-decoration:underline;font-weight:bold");
                file.lines.forEach(function(line) {
                    if (line.errors.length > 0) {
                        push(leftPad(line.number, 4) + "|  ", "background-color:yellow; font-weight:bold");
                        push(line.line + endl, "color:red; background-color:yellow; font-weight:bold");
                        // try to guess token
                        var offset = 0;
                        line.errors.forEach(function(error) {
                            var message = error.message;
                            var token = /^\s*'(.*)'\s*:\s*(.*)$/.exec(message);
                            if (token) {
                                var tokenPat = token[1];
                                message = token[2];
                                switch(tokenPat){
                                    case "assign":
                                        tokenPat = "=";
                                        break;
                                }
                                offset = Math.max(line.line.indexOf(tokenPat, offset), 0);
                            } else offset = 0;
                            push(leftPad("| ", 6));
                            push(leftPad("^^^", offset + 3) + endl, "font-weight:bold");
                            push(leftPad("| ", 6));
                            push(message + endl, "font-weight:bold");
                        });
                        push(leftPad("| ", 6) + endl);
                    } else {
                        push(leftPad(line.number, 4) + "|  ");
                        push(line.line + endl, "color:red");
                    }
                });
                if (typeof document !== "undefined" && !window.chrome) {
                    styles[0] = strings.join("%c");
                    console.log.apply(console, styles);
                } else console.log(strings.join(""));
            });
            check.raise("Error compiling " + typeName + " shader, " + files[0].name);
        }
    }
    function checkLinkError(gl, program, fragShader, vertShader, command) {
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            var errLog = gl.getProgramInfoLog(program);
            var fragParse = parseSource(fragShader, command);
            var vertParse = parseSource(vertShader, command);
            var header = 'Error linking program with vertex shader, "' + vertParse[0].name + '", and fragment shader "' + fragParse[0].name + '"';
            if (typeof document !== "undefined") console.log("%c" + header + endl + "%c" + errLog, "color:red;text-decoration:underline;font-weight:bold", "color:red");
            else console.log(header + endl + errLog);
            check.raise(header);
        }
    }
    function saveCommandRef(object) {
        object._commandRef = guessCommand();
    }
    function saveDrawCommandInfo(opts, uniforms, attributes, stringStore) {
        saveCommandRef(opts);
        function id(str) {
            if (str) return stringStore.id(str);
            return 0;
        }
        opts._fragId = id(opts.static.frag);
        opts._vertId = id(opts.static.vert);
        function addProps(dict, set) {
            Object.keys(set).forEach(function(u) {
                dict[stringStore.id(u)] = true;
            });
        }
        var uniformSet = opts._uniformSet = {};
        addProps(uniformSet, uniforms.static);
        addProps(uniformSet, uniforms.dynamic);
        var attributeSet = opts._attributeSet = {};
        addProps(attributeSet, attributes.static);
        addProps(attributeSet, attributes.dynamic);
        opts._hasCount = "count" in opts.static || "count" in opts.dynamic || "elements" in opts.static || "elements" in opts.dynamic;
    }
    function commandRaise(message, command) {
        var callSite = guessCallSite();
        raise(message + " in command " + (command || guessCommand()) + (callSite === "unknown" ? "" : " called from " + callSite));
    }
    function checkCommand(pred, message, command) {
        if (!pred) commandRaise(message, command || guessCommand());
    }
    function checkParameterCommand(param, possibilities, message, command) {
        if (!(param in possibilities)) commandRaise("unknown parameter (" + param + ")" + encolon(message) + ". possible values: " + Object.keys(possibilities).join(), command || guessCommand());
    }
    function checkCommandType(value, type, message, command) {
        if (!standardTypeEh(value, type)) commandRaise("invalid parameter type" + encolon(message) + ". expected " + type + ", got " + typeof value, command || guessCommand());
    }
    function checkOptional(block) {
        block();
    }
    function checkFramebufferFormat(attachment, texFormats, rbFormats) {
        if (attachment.texture) checkOneOf(attachment.texture._texture.internalformat, texFormats, "unsupported texture format for attachment");
        else checkOneOf(attachment.renderbuffer._renderbuffer.format, rbFormats, "unsupported renderbuffer format for attachment");
    }
    var GL_CLAMP_TO_EDGE = 0x812F;
    var GL_NEAREST = 0x2600;
    var GL_NEAREST_MIPMAP_NEAREST = 0x2700;
    var GL_LINEAR_MIPMAP_NEAREST = 0x2701;
    var GL_NEAREST_MIPMAP_LINEAR = 0x2702;
    var GL_LINEAR_MIPMAP_LINEAR = 0x2703;
    var GL_BYTE = 5120;
    var GL_UNSIGNED_BYTE = 5121;
    var GL_SHORT = 5122;
    var GL_UNSIGNED_SHORT = 5123;
    var GL_INT = 5124;
    var GL_UNSIGNED_INT = 5125;
    var GL_FLOAT = 5126;
    var GL_UNSIGNED_SHORT_4_4_4_4 = 0x8033;
    var GL_UNSIGNED_SHORT_5_5_5_1 = 0x8034;
    var GL_UNSIGNED_SHORT_5_6_5 = 0x8363;
    var GL_UNSIGNED_INT_24_8_WEBGL = 0x84FA;
    var GL_HALF_FLOAT_OES = 0x8D61;
    var TYPE_SIZE = {};
    TYPE_SIZE[GL_BYTE] = TYPE_SIZE[GL_UNSIGNED_BYTE] = 1;
    TYPE_SIZE[GL_SHORT] = TYPE_SIZE[GL_UNSIGNED_SHORT] = TYPE_SIZE[GL_HALF_FLOAT_OES] = TYPE_SIZE[GL_UNSIGNED_SHORT_5_6_5] = TYPE_SIZE[GL_UNSIGNED_SHORT_4_4_4_4] = TYPE_SIZE[GL_UNSIGNED_SHORT_5_5_5_1] = 2;
    TYPE_SIZE[GL_INT] = TYPE_SIZE[GL_UNSIGNED_INT] = TYPE_SIZE[GL_FLOAT] = TYPE_SIZE[GL_UNSIGNED_INT_24_8_WEBGL] = 4;
    function pixelSize(type, channels) {
        if (type === GL_UNSIGNED_SHORT_5_5_5_1 || type === GL_UNSIGNED_SHORT_4_4_4_4 || type === GL_UNSIGNED_SHORT_5_6_5) return 2;
        else if (type === GL_UNSIGNED_INT_24_8_WEBGL) return 4;
        else return TYPE_SIZE[type] * channels;
    }
    function isPow2(v) {
        return !(v & v - 1) && !!v;
    }
    function checkTexture2D(info, mipData, limits) {
        var i;
        var w = mipData.width;
        var h = mipData.height;
        var c = mipData.channels;
        // Check texture shape
        check(w > 0 && w <= limits.maxTextureSize && h > 0 && h <= limits.maxTextureSize, "invalid texture shape");
        // check wrap mode
        if (info.wrapS !== GL_CLAMP_TO_EDGE || info.wrapT !== GL_CLAMP_TO_EDGE) check(isPow2(w) && isPow2(h), "incompatible wrap mode for texture, both width and height must be power of 2");
        if (mipData.mipmask === 1) {
            if (w !== 1 && h !== 1) check(info.minFilter !== GL_NEAREST_MIPMAP_NEAREST && info.minFilter !== GL_NEAREST_MIPMAP_LINEAR && info.minFilter !== GL_LINEAR_MIPMAP_NEAREST && info.minFilter !== GL_LINEAR_MIPMAP_LINEAR, "min filter requires mipmap");
        } else {
            // texture must be power of 2
            check(isPow2(w) && isPow2(h), "texture must be a square power of 2 to support mipmapping");
            check(mipData.mipmask === (w << 1) - 1, "missing or incomplete mipmap data");
        }
        if (mipData.type === GL_FLOAT) {
            if (limits.extensions.indexOf("oes_texture_float_linear") < 0) check(info.minFilter === GL_NEAREST && info.magFilter === GL_NEAREST, "filter not supported, must enable oes_texture_float_linear");
            check(!info.genMipmaps, "mipmap generation not supported with float textures");
        }
        // check image complete
        var mipimages = mipData.images;
        for(i = 0; i < 16; ++i){
            if (mipimages[i]) {
                var mw = w >> i;
                var mh = h >> i;
                check(mipData.mipmask & 1 << i, "missing mipmap data");
                var img = mipimages[i];
                check(img.width === mw && img.height === mh, "invalid shape for mip images");
                check(img.format === mipData.format && img.internalformat === mipData.internalformat && img.type === mipData.type, "incompatible type for mip image");
                if (img.compressed) ;
                else if (img.data) {
                    // check(img.data.byteLength === mw * mh *
                    // Math.max(pixelSize(img.type, c), img.unpackAlignment),
                    var rowSize = Math.ceil(pixelSize(img.type, c) * mw / img.unpackAlignment) * img.unpackAlignment;
                    check(img.data.byteLength === rowSize * mh, "invalid data for image, buffer size is inconsistent with image format");
                } else if (img.element) ;
                else img.copy;
            } else if (!info.genMipmaps) check((mipData.mipmask & 1 << i) === 0, "extra mipmap data");
        }
        if (mipData.compressed) check(!info.genMipmaps, "mipmap generation for compressed images not supported");
    }
    function checkTextureCube(texture, info, faces, limits) {
        var w = texture.width;
        var h = texture.height;
        var c = texture.channels;
        // Check texture shape
        check(w > 0 && w <= limits.maxTextureSize && h > 0 && h <= limits.maxTextureSize, "invalid texture shape");
        check(w === h, "cube map must be square");
        check(info.wrapS === GL_CLAMP_TO_EDGE && info.wrapT === GL_CLAMP_TO_EDGE, "wrap mode not supported by cube map");
        for(var i = 0; i < faces.length; ++i){
            var face = faces[i];
            check(face.width === w && face.height === h, "inconsistent cube map face shape");
            if (info.genMipmaps) {
                check(!face.compressed, "can not generate mipmap for compressed textures");
                check(face.mipmask === 1, "can not specify mipmaps and generate mipmaps");
            }
            var mipmaps = face.images;
            for(var j = 0; j < 16; ++j){
                var img = mipmaps[j];
                if (img) {
                    var mw = w >> j;
                    var mh = h >> j;
                    check(face.mipmask & 1 << j, "missing mipmap data");
                    check(img.width === mw && img.height === mh, "invalid shape for mip images");
                    check(img.format === texture.format && img.internalformat === texture.internalformat && img.type === texture.type, "incompatible type for mip image");
                    if (img.compressed) ;
                    else if (img.data) check(img.data.byteLength === mw * mh * Math.max(pixelSize(img.type, c), img.unpackAlignment), "invalid data for image, buffer size is inconsistent with image format");
                    else if (img.element) ;
                    else img.copy;
                }
            }
        }
    }
    var check$1 = extend(check, {
        optional: checkOptional,
        raise: raise,
        commandRaise: commandRaise,
        command: checkCommand,
        parameter: checkParameter,
        commandParameter: checkParameterCommand,
        constructor: checkConstructor,
        type: checkTypeOf,
        commandType: checkCommandType,
        isTypedArray: checkIsTypedArray,
        nni: checkNonNegativeInt,
        oneOf: checkOneOf,
        shaderError: checkShaderError,
        linkError: checkLinkError,
        callSite: guessCallSite,
        saveCommandRef: saveCommandRef,
        saveDrawInfo: saveDrawCommandInfo,
        framebufferFormat: checkFramebufferFormat,
        guessCommand: guessCommand,
        texture2D: checkTexture2D,
        textureCube: checkTextureCube
    });
    var VARIABLE_COUNTER = 0;
    var DYN_FUNC = 0;
    var DYN_CONSTANT = 5;
    var DYN_ARRAY = 6;
    function DynamicVariable(type, data) {
        this.id = VARIABLE_COUNTER++;
        this.type = type;
        this.data = data;
    }
    function escapeStr(str) {
        return str.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    }
    function splitParts(str) {
        if (str.length === 0) return [];
        var firstChar = str.charAt(0);
        var lastChar = str.charAt(str.length - 1);
        if (str.length > 1 && firstChar === lastChar && (firstChar === '"' || firstChar === "'")) return [
            '"' + escapeStr(str.substr(1, str.length - 2)) + '"'
        ];
        var parts = /\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(str);
        if (parts) return splitParts(str.substr(0, parts.index)).concat(splitParts(parts[1])).concat(splitParts(str.substr(parts.index + parts[0].length)));
        var subparts = str.split(".");
        if (subparts.length === 1) return [
            '"' + escapeStr(str) + '"'
        ];
        var result = [];
        for(var i = 0; i < subparts.length; ++i)result = result.concat(splitParts(subparts[i]));
        return result;
    }
    function toAccessorString(str) {
        return "[" + splitParts(str).join("][") + "]";
    }
    function defineDynamic(type, data) {
        return new DynamicVariable(type, toAccessorString(data + ""));
    }
    function isDynamic(x) {
        return typeof x === "function" && !x._reglType || x instanceof DynamicVariable;
    }
    function unbox(x, path) {
        if (typeof x === "function") return new DynamicVariable(DYN_FUNC, x);
        else if (typeof x === "number" || typeof x === "boolean") return new DynamicVariable(DYN_CONSTANT, x);
        else if (Array.isArray(x)) return new DynamicVariable(DYN_ARRAY, x.map(function(y, i) {
            return unbox(y, path + "[" + i + "]");
        }));
        else if (x instanceof DynamicVariable) return x;
        check$1(false, "invalid option type in uniform " + path);
    }
    var dynamic = {
        DynamicVariable: DynamicVariable,
        define: defineDynamic,
        isDynamic: isDynamic,
        unbox: unbox,
        accessor: toAccessorString
    };
    /* globals requestAnimationFrame, cancelAnimationFrame */ var raf = {
        next: typeof requestAnimationFrame === "function" ? function(cb) {
            return requestAnimationFrame(cb);
        } : function(cb) {
            return setTimeout(cb, 16);
        },
        cancel: typeof cancelAnimationFrame === "function" ? function(raf) {
            return cancelAnimationFrame(raf);
        } : clearTimeout
    };
    /* globals performance */ var clock = typeof performance !== "undefined" && performance.now ? function() {
        return performance.now();
    } : function() {
        return +new Date();
    };
    function createStringStore() {
        var stringIds = {
            "": 0
        };
        var stringValues = [
            ""
        ];
        return {
            id: function(str) {
                var result = stringIds[str];
                if (result) return result;
                result = stringIds[str] = stringValues.length;
                stringValues.push(str);
                return result;
            },
            str: function(id) {
                return stringValues[id];
            }
        };
    }
    // Context and canvas creation helper functions
    function createCanvas(element, onDone, pixelRatio) {
        var canvas = document.createElement("canvas");
        extend(canvas.style, {
            border: 0,
            margin: 0,
            padding: 0,
            top: 0,
            left: 0,
            width: "100%",
            height: "100%"
        });
        element.appendChild(canvas);
        if (element === document.body) {
            canvas.style.position = "absolute";
            extend(element.style, {
                margin: 0,
                padding: 0
            });
        }
        function resize() {
            var w = window.innerWidth;
            var h = window.innerHeight;
            if (element !== document.body) {
                var bounds = canvas.getBoundingClientRect();
                w = bounds.right - bounds.left;
                h = bounds.bottom - bounds.top;
            }
            canvas.width = pixelRatio * w;
            canvas.height = pixelRatio * h;
        }
        var resizeObserver;
        if (element !== document.body && typeof ResizeObserver === "function") {
            // ignore 'ResizeObserver' is not defined
            // eslint-disable-next-line
            resizeObserver = new ResizeObserver(function() {
                // setTimeout to avoid flicker
                setTimeout(resize);
            });
            resizeObserver.observe(element);
        } else window.addEventListener("resize", resize, false);
        function onDestroy() {
            if (resizeObserver) resizeObserver.disconnect();
            else window.removeEventListener("resize", resize);
            element.removeChild(canvas);
        }
        resize();
        return {
            canvas: canvas,
            onDestroy: onDestroy
        };
    }
    function createContext(canvas, contextAttributes) {
        function get(name) {
            try {
                return canvas.getContext(name, contextAttributes);
            } catch (e) {
                return null;
            }
        }
        return get("webgl") || get("experimental-webgl") || get("webgl-experimental");
    }
    function isHTMLElement(obj) {
        return typeof obj.nodeName === "string" && typeof obj.appendChild === "function" && typeof obj.getBoundingClientRect === "function";
    }
    function isWebGLContext(obj) {
        return typeof obj.drawArrays === "function" || typeof obj.drawElements === "function";
    }
    function parseExtensions(input) {
        if (typeof input === "string") return input.split();
        check$1(Array.isArray(input), "invalid extension array");
        return input;
    }
    function getElement(desc) {
        if (typeof desc === "string") {
            check$1(typeof document !== "undefined", "not supported outside of DOM");
            return document.querySelector(desc);
        }
        return desc;
    }
    function parseArgs(args_) {
        var args = args_ || {};
        var element, container, canvas, gl;
        var contextAttributes = {};
        var extensions = [];
        var optionalExtensions = [];
        var pixelRatio = typeof window === "undefined" ? 1 : window.devicePixelRatio;
        var profile = false;
        var onDone = function(err) {
            if (err) check$1.raise(err);
        };
        var onDestroy = function() {};
        if (typeof args === "string") {
            check$1(typeof document !== "undefined", "selector queries only supported in DOM enviroments");
            element = document.querySelector(args);
            check$1(element, "invalid query string for element");
        } else if (typeof args === "object") {
            if (isHTMLElement(args)) element = args;
            else if (isWebGLContext(args)) {
                gl = args;
                canvas = gl.canvas;
            } else {
                check$1.constructor(args);
                if ("gl" in args) gl = args.gl;
                else if ("canvas" in args) canvas = getElement(args.canvas);
                else if ("container" in args) container = getElement(args.container);
                if ("attributes" in args) {
                    contextAttributes = args.attributes;
                    check$1.type(contextAttributes, "object", "invalid context attributes");
                }
                if ("extensions" in args) extensions = parseExtensions(args.extensions);
                if ("optionalExtensions" in args) optionalExtensions = parseExtensions(args.optionalExtensions);
                if ("onDone" in args) {
                    check$1.type(args.onDone, "function", "invalid or missing onDone callback");
                    onDone = args.onDone;
                }
                if ("profile" in args) profile = !!args.profile;
                if ("pixelRatio" in args) {
                    pixelRatio = +args.pixelRatio;
                    check$1(pixelRatio > 0, "invalid pixel ratio");
                }
            }
        } else check$1.raise("invalid arguments to regl");
        if (element) {
            if (element.nodeName.toLowerCase() === "canvas") canvas = element;
            else container = element;
        }
        if (!gl) {
            if (!canvas) {
                check$1(typeof document !== "undefined", "must manually specify webgl context outside of DOM environments");
                var result = createCanvas(container || document.body, onDone, pixelRatio);
                if (!result) return null;
                canvas = result.canvas;
                onDestroy = result.onDestroy;
            }
            // workaround for chromium bug, premultiplied alpha value is platform dependent
            if (contextAttributes.premultipliedAlpha === undefined) contextAttributes.premultipliedAlpha = true;
            gl = createContext(canvas, contextAttributes);
        }
        if (!gl) {
            onDestroy();
            onDone("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org");
            return null;
        }
        return {
            gl: gl,
            canvas: canvas,
            container: container,
            extensions: extensions,
            optionalExtensions: optionalExtensions,
            pixelRatio: pixelRatio,
            profile: profile,
            onDone: onDone,
            onDestroy: onDestroy
        };
    }
    function createExtensionCache(gl, config) {
        var extensions = {};
        function tryLoadExtension(name_) {
            check$1.type(name_, "string", "extension name must be string");
            var name = name_.toLowerCase();
            var ext;
            try {
                ext = extensions[name] = gl.getExtension(name);
            } catch (e) {}
            return !!ext;
        }
        for(var i = 0; i < config.extensions.length; ++i){
            var name = config.extensions[i];
            if (!tryLoadExtension(name)) {
                config.onDestroy();
                config.onDone('"' + name + '" extension is not supported by the current WebGL context, try upgrading your system or a different browser');
                return null;
            }
        }
        config.optionalExtensions.forEach(tryLoadExtension);
        return {
            extensions: extensions,
            restore: function() {
                Object.keys(extensions).forEach(function(name) {
                    if (extensions[name] && !tryLoadExtension(name)) throw new Error("(regl): error restoring extension " + name);
                });
            }
        };
    }
    function loop(n, f) {
        var result = Array(n);
        for(var i = 0; i < n; ++i)result[i] = f(i);
        return result;
    }
    var GL_BYTE$1 = 5120;
    var GL_UNSIGNED_BYTE$2 = 5121;
    var GL_SHORT$1 = 5122;
    var GL_UNSIGNED_SHORT$1 = 5123;
    var GL_INT$1 = 5124;
    var GL_UNSIGNED_INT$1 = 5125;
    var GL_FLOAT$2 = 5126;
    function nextPow16(v) {
        for(var i = 16; i <= 268435456; i *= 16){
            if (v <= i) return i;
        }
        return 0;
    }
    function log2(v) {
        var r, shift;
        r = (v > 0xFFFF) << 4;
        v >>>= r;
        shift = (v > 0xFF) << 3;
        v >>>= shift;
        r |= shift;
        shift = (v > 0xF) << 2;
        v >>>= shift;
        r |= shift;
        shift = (v > 0x3) << 1;
        v >>>= shift;
        r |= shift;
        return r | v >> 1;
    }
    function createPool() {
        var bufferPool = loop(8, function() {
            return [];
        });
        function alloc(n) {
            var sz = nextPow16(n);
            var bin = bufferPool[log2(sz) >> 2];
            if (bin.length > 0) return bin.pop();
            return new ArrayBuffer(sz);
        }
        function free(buf) {
            bufferPool[log2(buf.byteLength) >> 2].push(buf);
        }
        function allocType(type, n) {
            var result = null;
            switch(type){
                case GL_BYTE$1:
                    result = new Int8Array(alloc(n), 0, n);
                    break;
                case GL_UNSIGNED_BYTE$2:
                    result = new Uint8Array(alloc(n), 0, n);
                    break;
                case GL_SHORT$1:
                    result = new Int16Array(alloc(2 * n), 0, n);
                    break;
                case GL_UNSIGNED_SHORT$1:
                    result = new Uint16Array(alloc(2 * n), 0, n);
                    break;
                case GL_INT$1:
                    result = new Int32Array(alloc(4 * n), 0, n);
                    break;
                case GL_UNSIGNED_INT$1:
                    result = new Uint32Array(alloc(4 * n), 0, n);
                    break;
                case GL_FLOAT$2:
                    result = new Float32Array(alloc(4 * n), 0, n);
                    break;
                default:
                    return null;
            }
            if (result.length !== n) return result.subarray(0, n);
            return result;
        }
        function freeType(array) {
            free(array.buffer);
        }
        return {
            alloc: alloc,
            free: free,
            allocType: allocType,
            freeType: freeType
        };
    }
    var pool = createPool();
    // zero pool for initial zero data
    pool.zero = createPool();
    var GL_SUBPIXEL_BITS = 0x0D50;
    var GL_RED_BITS = 0x0D52;
    var GL_GREEN_BITS = 0x0D53;
    var GL_BLUE_BITS = 0x0D54;
    var GL_ALPHA_BITS = 0x0D55;
    var GL_DEPTH_BITS = 0x0D56;
    var GL_STENCIL_BITS = 0x0D57;
    var GL_ALIASED_POINT_SIZE_RANGE = 0x846D;
    var GL_ALIASED_LINE_WIDTH_RANGE = 0x846E;
    var GL_MAX_TEXTURE_SIZE = 0x0D33;
    var GL_MAX_VIEWPORT_DIMS = 0x0D3A;
    var GL_MAX_VERTEX_ATTRIBS = 0x8869;
    var GL_MAX_VERTEX_UNIFORM_VECTORS = 0x8DFB;
    var GL_MAX_VARYING_VECTORS = 0x8DFC;
    var GL_MAX_COMBINED_TEXTURE_IMAGE_UNITS = 0x8B4D;
    var GL_MAX_VERTEX_TEXTURE_IMAGE_UNITS = 0x8B4C;
    var GL_MAX_TEXTURE_IMAGE_UNITS = 0x8872;
    var GL_MAX_FRAGMENT_UNIFORM_VECTORS = 0x8DFD;
    var GL_MAX_CUBE_MAP_TEXTURE_SIZE = 0x851C;
    var GL_MAX_RENDERBUFFER_SIZE = 0x84E8;
    var GL_VENDOR = 0x1F00;
    var GL_RENDERER = 0x1F01;
    var GL_VERSION = 0x1F02;
    var GL_SHADING_LANGUAGE_VERSION = 0x8B8C;
    var GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT = 0x84FF;
    var GL_MAX_COLOR_ATTACHMENTS_WEBGL = 0x8CDF;
    var GL_MAX_DRAW_BUFFERS_WEBGL = 0x8824;
    var GL_TEXTURE_2D = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP = 0x8513;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X = 0x8515;
    var GL_TEXTURE0 = 0x84C0;
    var GL_RGBA = 0x1908;
    var GL_FLOAT$1 = 0x1406;
    var GL_UNSIGNED_BYTE$1 = 0x1401;
    var GL_FRAMEBUFFER = 0x8D40;
    var GL_FRAMEBUFFER_COMPLETE = 0x8CD5;
    var GL_COLOR_ATTACHMENT0 = 0x8CE0;
    var GL_COLOR_BUFFER_BIT$1 = 0x4000;
    var wrapLimits = function(gl, extensions) {
        var maxAnisotropic = 1;
        if (extensions.ext_texture_filter_anisotropic) maxAnisotropic = gl.getParameter(GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        var maxDrawbuffers = 1;
        var maxColorAttachments = 1;
        if (extensions.webgl_draw_buffers) {
            maxDrawbuffers = gl.getParameter(GL_MAX_DRAW_BUFFERS_WEBGL);
            maxColorAttachments = gl.getParameter(GL_MAX_COLOR_ATTACHMENTS_WEBGL);
        }
        // detect if reading float textures is available (Safari doesn't support)
        var readFloat = !!extensions.oes_texture_float;
        if (readFloat) {
            var readFloatTexture = gl.createTexture();
            gl.bindTexture(GL_TEXTURE_2D, readFloatTexture);
            gl.texImage2D(GL_TEXTURE_2D, 0, GL_RGBA, 1, 1, 0, GL_RGBA, GL_FLOAT$1, null);
            var fbo = gl.createFramebuffer();
            gl.bindFramebuffer(GL_FRAMEBUFFER, fbo);
            gl.framebufferTexture2D(GL_FRAMEBUFFER, GL_COLOR_ATTACHMENT0, GL_TEXTURE_2D, readFloatTexture, 0);
            gl.bindTexture(GL_TEXTURE_2D, null);
            if (gl.checkFramebufferStatus(GL_FRAMEBUFFER) !== GL_FRAMEBUFFER_COMPLETE) readFloat = false;
            else {
                gl.viewport(0, 0, 1, 1);
                gl.clearColor(1.0, 0.0, 0.0, 1.0);
                gl.clear(GL_COLOR_BUFFER_BIT$1);
                var pixels = pool.allocType(GL_FLOAT$1, 4);
                gl.readPixels(0, 0, 1, 1, GL_RGBA, GL_FLOAT$1, pixels);
                if (gl.getError()) readFloat = false;
                else {
                    gl.deleteFramebuffer(fbo);
                    gl.deleteTexture(readFloatTexture);
                    readFloat = pixels[0] === 1.0;
                }
                pool.freeType(pixels);
            }
        }
        // detect non power of two cube textures support (IE doesn't support)
        var isIE = typeof navigator !== "undefined" && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent));
        var npotTextureCube = true;
        if (!isIE) {
            var cubeTexture = gl.createTexture();
            var data = pool.allocType(GL_UNSIGNED_BYTE$1, 36);
            gl.activeTexture(GL_TEXTURE0);
            gl.bindTexture(GL_TEXTURE_CUBE_MAP, cubeTexture);
            gl.texImage2D(GL_TEXTURE_CUBE_MAP_POSITIVE_X, 0, GL_RGBA, 3, 3, 0, GL_RGBA, GL_UNSIGNED_BYTE$1, data);
            pool.freeType(data);
            gl.bindTexture(GL_TEXTURE_CUBE_MAP, null);
            gl.deleteTexture(cubeTexture);
            npotTextureCube = !gl.getError();
        }
        return {
            // drawing buffer bit depth
            colorBits: [
                gl.getParameter(GL_RED_BITS),
                gl.getParameter(GL_GREEN_BITS),
                gl.getParameter(GL_BLUE_BITS),
                gl.getParameter(GL_ALPHA_BITS)
            ],
            depthBits: gl.getParameter(GL_DEPTH_BITS),
            stencilBits: gl.getParameter(GL_STENCIL_BITS),
            subpixelBits: gl.getParameter(GL_SUBPIXEL_BITS),
            // supported extensions
            extensions: Object.keys(extensions).filter(function(ext) {
                return !!extensions[ext];
            }),
            // max aniso samples
            maxAnisotropic: maxAnisotropic,
            // max draw buffers
            maxDrawbuffers: maxDrawbuffers,
            maxColorAttachments: maxColorAttachments,
            // point and line size ranges
            pointSizeDims: gl.getParameter(GL_ALIASED_POINT_SIZE_RANGE),
            lineWidthDims: gl.getParameter(GL_ALIASED_LINE_WIDTH_RANGE),
            maxViewportDims: gl.getParameter(GL_MAX_VIEWPORT_DIMS),
            maxCombinedTextureUnits: gl.getParameter(GL_MAX_COMBINED_TEXTURE_IMAGE_UNITS),
            maxCubeMapSize: gl.getParameter(GL_MAX_CUBE_MAP_TEXTURE_SIZE),
            maxRenderbufferSize: gl.getParameter(GL_MAX_RENDERBUFFER_SIZE),
            maxTextureUnits: gl.getParameter(GL_MAX_TEXTURE_IMAGE_UNITS),
            maxTextureSize: gl.getParameter(GL_MAX_TEXTURE_SIZE),
            maxAttributes: gl.getParameter(GL_MAX_VERTEX_ATTRIBS),
            maxVertexUniforms: gl.getParameter(GL_MAX_VERTEX_UNIFORM_VECTORS),
            maxVertexTextureUnits: gl.getParameter(GL_MAX_VERTEX_TEXTURE_IMAGE_UNITS),
            maxVaryingVectors: gl.getParameter(GL_MAX_VARYING_VECTORS),
            maxFragmentUniforms: gl.getParameter(GL_MAX_FRAGMENT_UNIFORM_VECTORS),
            // vendor info
            glsl: gl.getParameter(GL_SHADING_LANGUAGE_VERSION),
            renderer: gl.getParameter(GL_RENDERER),
            vendor: gl.getParameter(GL_VENDOR),
            version: gl.getParameter(GL_VERSION),
            // quirks
            readFloat: readFloat,
            npotTextureCube: npotTextureCube
        };
    };
    function isNDArrayLike(obj) {
        return !!obj && typeof obj === "object" && Array.isArray(obj.shape) && Array.isArray(obj.stride) && typeof obj.offset === "number" && obj.shape.length === obj.stride.length && (Array.isArray(obj.data) || isTypedArray(obj.data));
    }
    var values = function(obj) {
        return Object.keys(obj).map(function(key) {
            return obj[key];
        });
    };
    var flattenUtils = {
        shape: arrayShape$1,
        flatten: flattenArray
    };
    function flatten1D(array, nx, out) {
        for(var i = 0; i < nx; ++i)out[i] = array[i];
    }
    function flatten2D(array, nx, ny, out) {
        var ptr = 0;
        for(var i = 0; i < nx; ++i){
            var row = array[i];
            for(var j = 0; j < ny; ++j)out[ptr++] = row[j];
        }
    }
    function flatten3D(array, nx, ny, nz, out, ptr_) {
        var ptr = ptr_;
        for(var i = 0; i < nx; ++i){
            var row = array[i];
            for(var j = 0; j < ny; ++j){
                var col = row[j];
                for(var k = 0; k < nz; ++k)out[ptr++] = col[k];
            }
        }
    }
    function flattenRec(array, shape, level, out, ptr) {
        var stride = 1;
        for(var i = level + 1; i < shape.length; ++i)stride *= shape[i];
        var n = shape[level];
        if (shape.length - level === 4) {
            var nx = shape[level + 1];
            var ny = shape[level + 2];
            var nz = shape[level + 3];
            for(i = 0; i < n; ++i){
                flatten3D(array[i], nx, ny, nz, out, ptr);
                ptr += stride;
            }
        } else for(i = 0; i < n; ++i){
            flattenRec(array[i], shape, level + 1, out, ptr);
            ptr += stride;
        }
    }
    function flattenArray(array, shape, type, out_) {
        var sz = 1;
        if (shape.length) for(var i = 0; i < shape.length; ++i)sz *= shape[i];
        else sz = 0;
        var out = out_ || pool.allocType(type, sz);
        switch(shape.length){
            case 0:
                break;
            case 1:
                flatten1D(array, shape[0], out);
                break;
            case 2:
                flatten2D(array, shape[0], shape[1], out);
                break;
            case 3:
                flatten3D(array, shape[0], shape[1], shape[2], out, 0);
                break;
            default:
                flattenRec(array, shape, 0, out, 0);
        }
        return out;
    }
    function arrayShape$1(array_) {
        var shape = [];
        for(var array = array_; array.length; array = array[0])shape.push(array.length);
        return shape;
    }
    var arrayTypes = {
        "[object Int8Array]": 5120,
        "[object Int16Array]": 5122,
        "[object Int32Array]": 5124,
        "[object Uint8Array]": 5121,
        "[object Uint8ClampedArray]": 5121,
        "[object Uint16Array]": 5123,
        "[object Uint32Array]": 5125,
        "[object Float32Array]": 5126,
        "[object Float64Array]": 5121,
        "[object ArrayBuffer]": 5121
    };
    var int8 = 5120;
    var int16 = 5122;
    var int32 = 5124;
    var uint8 = 5121;
    var uint16 = 5123;
    var uint32 = 5125;
    var float = 5126;
    var float32 = 5126;
    var glTypes = {
        int8: int8,
        int16: int16,
        int32: int32,
        uint8: uint8,
        uint16: uint16,
        uint32: uint32,
        float: float,
        float32: float32
    };
    var dynamic$1 = 35048;
    var stream = 35040;
    var usageTypes = {
        dynamic: dynamic$1,
        stream: stream,
        "static": 35044
    };
    var arrayFlatten = flattenUtils.flatten;
    var arrayShape = flattenUtils.shape;
    var GL_STATIC_DRAW = 0x88E4;
    var GL_STREAM_DRAW = 0x88E0;
    var GL_UNSIGNED_BYTE$3 = 5121;
    var GL_FLOAT$3 = 5126;
    var DTYPES_SIZES = [];
    DTYPES_SIZES[5120] = 1 // int8
    ;
    DTYPES_SIZES[5122] = 2 // int16
    ;
    DTYPES_SIZES[5124] = 4 // int32
    ;
    DTYPES_SIZES[5121] = 1 // uint8
    ;
    DTYPES_SIZES[5123] = 2 // uint16
    ;
    DTYPES_SIZES[5125] = 4 // uint32
    ;
    DTYPES_SIZES[5126] = 4 // float32
    ;
    function typedArrayCode(data) {
        return arrayTypes[Object.prototype.toString.call(data)] | 0;
    }
    function copyArray(out, inp) {
        for(var i = 0; i < inp.length; ++i)out[i] = inp[i];
    }
    function transpose(result, data, shapeX, shapeY, strideX, strideY, offset) {
        var ptr = 0;
        for(var i = 0; i < shapeX; ++i)for(var j = 0; j < shapeY; ++j)result[ptr++] = data[strideX * i + strideY * j + offset];
    }
    function wrapBufferState(gl, stats, config, destroyBuffer) {
        var bufferCount = 0;
        var bufferSet = {};
        function REGLBuffer(type) {
            this.id = bufferCount++;
            this.buffer = gl.createBuffer();
            this.type = type;
            this.usage = GL_STATIC_DRAW;
            this.byteLength = 0;
            this.dimension = 1;
            this.dtype = GL_UNSIGNED_BYTE$3;
            this.persistentData = null;
            if (config.profile) this.stats = {
                size: 0
            };
        }
        REGLBuffer.prototype.bind = function() {
            gl.bindBuffer(this.type, this.buffer);
        };
        REGLBuffer.prototype.destroy = function() {
            destroy(this);
        };
        var streamPool = [];
        function createStream(type, data) {
            var buffer = streamPool.pop();
            if (!buffer) buffer = new REGLBuffer(type);
            buffer.bind();
            initBufferFromData(buffer, data, GL_STREAM_DRAW, 0, 1, false);
            return buffer;
        }
        function destroyStream(stream$$1) {
            streamPool.push(stream$$1);
        }
        function initBufferFromTypedArray(buffer, data, usage) {
            buffer.byteLength = data.byteLength;
            gl.bufferData(buffer.type, data, usage);
        }
        function initBufferFromData(buffer, data, usage, dtype, dimension, persist) {
            var shape;
            buffer.usage = usage;
            if (Array.isArray(data)) {
                buffer.dtype = dtype || GL_FLOAT$3;
                if (data.length > 0) {
                    var flatData;
                    if (Array.isArray(data[0])) {
                        shape = arrayShape(data);
                        var dim = 1;
                        for(var i = 1; i < shape.length; ++i)dim *= shape[i];
                        buffer.dimension = dim;
                        flatData = arrayFlatten(data, shape, buffer.dtype);
                        initBufferFromTypedArray(buffer, flatData, usage);
                        if (persist) buffer.persistentData = flatData;
                        else pool.freeType(flatData);
                    } else if (typeof data[0] === "number") {
                        buffer.dimension = dimension;
                        var typedData = pool.allocType(buffer.dtype, data.length);
                        copyArray(typedData, data);
                        initBufferFromTypedArray(buffer, typedData, usage);
                        if (persist) buffer.persistentData = typedData;
                        else pool.freeType(typedData);
                    } else if (isTypedArray(data[0])) {
                        buffer.dimension = data[0].length;
                        buffer.dtype = dtype || typedArrayCode(data[0]) || GL_FLOAT$3;
                        flatData = arrayFlatten(data, [
                            data.length,
                            data[0].length
                        ], buffer.dtype);
                        initBufferFromTypedArray(buffer, flatData, usage);
                        if (persist) buffer.persistentData = flatData;
                        else pool.freeType(flatData);
                    } else check$1.raise("invalid buffer data");
                }
            } else if (isTypedArray(data)) {
                buffer.dtype = dtype || typedArrayCode(data);
                buffer.dimension = dimension;
                initBufferFromTypedArray(buffer, data, usage);
                if (persist) buffer.persistentData = new Uint8Array(new Uint8Array(data.buffer));
            } else if (isNDArrayLike(data)) {
                shape = data.shape;
                var stride = data.stride;
                var offset = data.offset;
                var shapeX = 0;
                var shapeY = 0;
                var strideX = 0;
                var strideY = 0;
                if (shape.length === 1) {
                    shapeX = shape[0];
                    shapeY = 1;
                    strideX = stride[0];
                    strideY = 0;
                } else if (shape.length === 2) {
                    shapeX = shape[0];
                    shapeY = shape[1];
                    strideX = stride[0];
                    strideY = stride[1];
                } else check$1.raise("invalid shape");
                buffer.dtype = dtype || typedArrayCode(data.data) || GL_FLOAT$3;
                buffer.dimension = shapeY;
                var transposeData = pool.allocType(buffer.dtype, shapeX * shapeY);
                transpose(transposeData, data.data, shapeX, shapeY, strideX, strideY, offset);
                initBufferFromTypedArray(buffer, transposeData, usage);
                if (persist) buffer.persistentData = transposeData;
                else pool.freeType(transposeData);
            } else if (data instanceof ArrayBuffer) {
                buffer.dtype = GL_UNSIGNED_BYTE$3;
                buffer.dimension = dimension;
                initBufferFromTypedArray(buffer, data, usage);
                if (persist) buffer.persistentData = new Uint8Array(new Uint8Array(data));
            } else check$1.raise("invalid buffer data");
        }
        function destroy(buffer) {
            stats.bufferCount--;
            // remove attribute link
            destroyBuffer(buffer);
            var handle = buffer.buffer;
            check$1(handle, "buffer must not be deleted already");
            gl.deleteBuffer(handle);
            buffer.buffer = null;
            delete bufferSet[buffer.id];
        }
        function createBuffer(options, type, deferInit, persistent) {
            stats.bufferCount++;
            var buffer = new REGLBuffer(type);
            bufferSet[buffer.id] = buffer;
            function reglBuffer(options) {
                var usage = GL_STATIC_DRAW;
                var data = null;
                var byteLength = 0;
                var dtype = 0;
                var dimension = 1;
                if (Array.isArray(options) || isTypedArray(options) || isNDArrayLike(options) || options instanceof ArrayBuffer) data = options;
                else if (typeof options === "number") byteLength = options | 0;
                else if (options) {
                    check$1.type(options, "object", "buffer arguments must be an object, a number or an array");
                    if ("data" in options) {
                        check$1(data === null || Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data), "invalid data for buffer");
                        data = options.data;
                    }
                    if ("usage" in options) {
                        check$1.parameter(options.usage, usageTypes, "invalid buffer usage");
                        usage = usageTypes[options.usage];
                    }
                    if ("type" in options) {
                        check$1.parameter(options.type, glTypes, "invalid buffer type");
                        dtype = glTypes[options.type];
                    }
                    if ("dimension" in options) {
                        check$1.type(options.dimension, "number", "invalid dimension");
                        dimension = options.dimension | 0;
                    }
                    if ("length" in options) {
                        check$1.nni(byteLength, "buffer length must be a nonnegative integer");
                        byteLength = options.length | 0;
                    }
                }
                buffer.bind();
                if (!data) {
                    // #475
                    if (byteLength) gl.bufferData(buffer.type, byteLength, usage);
                    buffer.dtype = dtype || GL_UNSIGNED_BYTE$3;
                    buffer.usage = usage;
                    buffer.dimension = dimension;
                    buffer.byteLength = byteLength;
                } else initBufferFromData(buffer, data, usage, dtype, dimension, persistent);
                if (config.profile) buffer.stats.size = buffer.byteLength * DTYPES_SIZES[buffer.dtype];
                return reglBuffer;
            }
            function setSubData(data, offset) {
                check$1(offset + data.byteLength <= buffer.byteLength, "invalid buffer subdata call, buffer is too small.  Can't write data of size " + data.byteLength + " starting from offset " + offset + " to a buffer of size " + buffer.byteLength);
                gl.bufferSubData(buffer.type, offset, data);
            }
            function subdata(data, offset_) {
                var offset = (offset_ || 0) | 0;
                var shape;
                buffer.bind();
                if (isTypedArray(data) || data instanceof ArrayBuffer) setSubData(data, offset);
                else if (Array.isArray(data)) {
                    if (data.length > 0) {
                        if (typeof data[0] === "number") {
                            var converted = pool.allocType(buffer.dtype, data.length);
                            copyArray(converted, data);
                            setSubData(converted, offset);
                            pool.freeType(converted);
                        } else if (Array.isArray(data[0]) || isTypedArray(data[0])) {
                            shape = arrayShape(data);
                            var flatData = arrayFlatten(data, shape, buffer.dtype);
                            setSubData(flatData, offset);
                            pool.freeType(flatData);
                        } else check$1.raise("invalid buffer data");
                    }
                } else if (isNDArrayLike(data)) {
                    shape = data.shape;
                    var stride = data.stride;
                    var shapeX = 0;
                    var shapeY = 0;
                    var strideX = 0;
                    var strideY = 0;
                    if (shape.length === 1) {
                        shapeX = shape[0];
                        shapeY = 1;
                        strideX = stride[0];
                        strideY = 0;
                    } else if (shape.length === 2) {
                        shapeX = shape[0];
                        shapeY = shape[1];
                        strideX = stride[0];
                        strideY = stride[1];
                    } else check$1.raise("invalid shape");
                    var dtype = Array.isArray(data.data) ? buffer.dtype : typedArrayCode(data.data);
                    var transposeData = pool.allocType(dtype, shapeX * shapeY);
                    transpose(transposeData, data.data, shapeX, shapeY, strideX, strideY, data.offset);
                    setSubData(transposeData, offset);
                    pool.freeType(transposeData);
                } else check$1.raise("invalid data for buffer subdata");
                return reglBuffer;
            }
            if (!deferInit) reglBuffer(options);
            reglBuffer._reglType = "buffer";
            reglBuffer._buffer = buffer;
            reglBuffer.subdata = subdata;
            if (config.profile) reglBuffer.stats = buffer.stats;
            reglBuffer.destroy = function() {
                destroy(buffer);
            };
            return reglBuffer;
        }
        function restoreBuffers() {
            values(bufferSet).forEach(function(buffer) {
                buffer.buffer = gl.createBuffer();
                gl.bindBuffer(buffer.type, buffer.buffer);
                gl.bufferData(buffer.type, buffer.persistentData || buffer.byteLength, buffer.usage);
            });
        }
        if (config.profile) stats.getTotalBufferSize = function() {
            var total = 0;
            // TODO: Right now, the streams are not part of the total count.
            Object.keys(bufferSet).forEach(function(key) {
                total += bufferSet[key].stats.size;
            });
            return total;
        };
        return {
            create: createBuffer,
            createStream: createStream,
            destroyStream: destroyStream,
            clear: function() {
                values(bufferSet).forEach(destroy);
                streamPool.forEach(destroy);
            },
            getBuffer: function(wrapper) {
                if (wrapper && wrapper._buffer instanceof REGLBuffer) return wrapper._buffer;
                return null;
            },
            restore: restoreBuffers,
            _initBuffer: initBufferFromData
        };
    }
    var points = 0;
    var point = 0;
    var lines = 1;
    var line = 1;
    var triangles = 4;
    var triangle = 4;
    var primTypes = {
        points: points,
        point: point,
        lines: lines,
        line: line,
        triangles: triangles,
        triangle: triangle,
        "line loop": 2,
        "line strip": 3,
        "triangle strip": 5,
        "triangle fan": 6
    };
    var GL_POINTS = 0;
    var GL_LINES = 1;
    var GL_TRIANGLES = 4;
    var GL_BYTE$2 = 5120;
    var GL_UNSIGNED_BYTE$4 = 5121;
    var GL_SHORT$2 = 5122;
    var GL_UNSIGNED_SHORT$2 = 5123;
    var GL_INT$2 = 5124;
    var GL_UNSIGNED_INT$2 = 5125;
    var GL_ELEMENT_ARRAY_BUFFER = 34963;
    var GL_STREAM_DRAW$1 = 0x88E0;
    var GL_STATIC_DRAW$1 = 0x88E4;
    function wrapElementsState(gl, extensions, bufferState, stats) {
        var elementSet = {};
        var elementCount = 0;
        var elementTypes = {
            "uint8": GL_UNSIGNED_BYTE$4,
            "uint16": GL_UNSIGNED_SHORT$2
        };
        if (extensions.oes_element_index_uint) elementTypes.uint32 = GL_UNSIGNED_INT$2;
        function REGLElementBuffer(buffer) {
            this.id = elementCount++;
            elementSet[this.id] = this;
            this.buffer = buffer;
            this.primType = GL_TRIANGLES;
            this.vertCount = 0;
            this.type = 0;
        }
        REGLElementBuffer.prototype.bind = function() {
            this.buffer.bind();
        };
        var bufferPool = [];
        function createElementStream(data) {
            var result = bufferPool.pop();
            if (!result) result = new REGLElementBuffer(bufferState.create(null, GL_ELEMENT_ARRAY_BUFFER, true, false)._buffer);
            initElements(result, data, GL_STREAM_DRAW$1, -1, -1, 0, 0);
            return result;
        }
        function destroyElementStream(elements) {
            bufferPool.push(elements);
        }
        function initElements(elements, data, usage, prim, count, byteLength, type) {
            elements.buffer.bind();
            var dtype;
            if (data) {
                var predictedType = type;
                if (!type && (!isTypedArray(data) || isNDArrayLike(data) && !isTypedArray(data.data))) predictedType = extensions.oes_element_index_uint ? GL_UNSIGNED_INT$2 : GL_UNSIGNED_SHORT$2;
                bufferState._initBuffer(elements.buffer, data, usage, predictedType, 3);
            } else {
                gl.bufferData(GL_ELEMENT_ARRAY_BUFFER, byteLength, usage);
                elements.buffer.dtype = dtype || GL_UNSIGNED_BYTE$4;
                elements.buffer.usage = usage;
                elements.buffer.dimension = 3;
                elements.buffer.byteLength = byteLength;
            }
            dtype = type;
            if (!type) {
                switch(elements.buffer.dtype){
                    case GL_UNSIGNED_BYTE$4:
                    case GL_BYTE$2:
                        dtype = GL_UNSIGNED_BYTE$4;
                        break;
                    case GL_UNSIGNED_SHORT$2:
                    case GL_SHORT$2:
                        dtype = GL_UNSIGNED_SHORT$2;
                        break;
                    case GL_UNSIGNED_INT$2:
                    case GL_INT$2:
                        dtype = GL_UNSIGNED_INT$2;
                        break;
                    default:
                        check$1.raise("unsupported type for element array");
                }
                elements.buffer.dtype = dtype;
            }
            elements.type = dtype;
            // Check oes_element_index_uint extension
            check$1(dtype !== GL_UNSIGNED_INT$2 || !!extensions.oes_element_index_uint, "32 bit element buffers not supported, enable oes_element_index_uint first");
            // try to guess default primitive type and arguments
            var vertCount = count;
            if (vertCount < 0) {
                vertCount = elements.buffer.byteLength;
                if (dtype === GL_UNSIGNED_SHORT$2) vertCount >>= 1;
                else if (dtype === GL_UNSIGNED_INT$2) vertCount >>= 2;
            }
            elements.vertCount = vertCount;
            // try to guess primitive type from cell dimension
            var primType = prim;
            if (prim < 0) {
                primType = GL_TRIANGLES;
                var dimension = elements.buffer.dimension;
                if (dimension === 1) primType = GL_POINTS;
                if (dimension === 2) primType = GL_LINES;
                if (dimension === 3) primType = GL_TRIANGLES;
            }
            elements.primType = primType;
        }
        function destroyElements(elements) {
            stats.elementsCount--;
            check$1(elements.buffer !== null, "must not double destroy elements");
            delete elementSet[elements.id];
            elements.buffer.destroy();
            elements.buffer = null;
        }
        function createElements(options, persistent) {
            var buffer = bufferState.create(null, GL_ELEMENT_ARRAY_BUFFER, true);
            var elements = new REGLElementBuffer(buffer._buffer);
            stats.elementsCount++;
            function reglElements(options) {
                if (!options) {
                    buffer();
                    elements.primType = GL_TRIANGLES;
                    elements.vertCount = 0;
                    elements.type = GL_UNSIGNED_BYTE$4;
                } else if (typeof options === "number") {
                    buffer(options);
                    elements.primType = GL_TRIANGLES;
                    elements.vertCount = options | 0;
                    elements.type = GL_UNSIGNED_BYTE$4;
                } else {
                    var data = null;
                    var usage = GL_STATIC_DRAW$1;
                    var primType = -1;
                    var vertCount = -1;
                    var byteLength = 0;
                    var dtype = 0;
                    if (Array.isArray(options) || isTypedArray(options) || isNDArrayLike(options)) data = options;
                    else {
                        check$1.type(options, "object", "invalid arguments for elements");
                        if ("data" in options) {
                            data = options.data;
                            check$1(Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data), "invalid data for element buffer");
                        }
                        if ("usage" in options) {
                            check$1.parameter(options.usage, usageTypes, "invalid element buffer usage");
                            usage = usageTypes[options.usage];
                        }
                        if ("primitive" in options) {
                            check$1.parameter(options.primitive, primTypes, "invalid element buffer primitive");
                            primType = primTypes[options.primitive];
                        }
                        if ("count" in options) {
                            check$1(typeof options.count === "number" && options.count >= 0, "invalid vertex count for elements");
                            vertCount = options.count | 0;
                        }
                        if ("type" in options) {
                            check$1.parameter(options.type, elementTypes, "invalid buffer type");
                            dtype = elementTypes[options.type];
                        }
                        if ("length" in options) byteLength = options.length | 0;
                        else {
                            byteLength = vertCount;
                            if (dtype === GL_UNSIGNED_SHORT$2 || dtype === GL_SHORT$2) byteLength *= 2;
                            else if (dtype === GL_UNSIGNED_INT$2 || dtype === GL_INT$2) byteLength *= 4;
                        }
                    }
                    initElements(elements, data, usage, primType, vertCount, byteLength, dtype);
                }
                return reglElements;
            }
            reglElements(options);
            reglElements._reglType = "elements";
            reglElements._elements = elements;
            reglElements.subdata = function(data, offset) {
                buffer.subdata(data, offset);
                return reglElements;
            };
            reglElements.destroy = function() {
                destroyElements(elements);
            };
            return reglElements;
        }
        return {
            create: createElements,
            createStream: createElementStream,
            destroyStream: destroyElementStream,
            getElements: function(elements) {
                if (typeof elements === "function" && elements._elements instanceof REGLElementBuffer) return elements._elements;
                return null;
            },
            clear: function() {
                values(elementSet).forEach(destroyElements);
            }
        };
    }
    var FLOAT = new Float32Array(1);
    var INT = new Uint32Array(FLOAT.buffer);
    var GL_UNSIGNED_SHORT$4 = 5123;
    function convertToHalfFloat(array) {
        var ushorts = pool.allocType(GL_UNSIGNED_SHORT$4, array.length);
        for(var i = 0; i < array.length; ++i){
            if (isNaN(array[i])) ushorts[i] = 0xffff;
            else if (array[i] === Infinity) ushorts[i] = 0x7c00;
            else if (array[i] === -Infinity) ushorts[i] = 0xfc00;
            else {
                FLOAT[0] = array[i];
                var x = INT[0];
                var sgn = x >>> 31 << 15;
                var exp = (x << 1 >>> 24) - 127;
                var frac = x >> 13 & 1023;
                if (exp < -24) // round non-representable denormals to 0
                ushorts[i] = sgn;
                else if (exp < -14) {
                    // handle denormals
                    var s = -14 - exp;
                    ushorts[i] = sgn + (frac + 1024 >> s);
                } else if (exp > 15) // round overflow to +/- Infinity
                ushorts[i] = sgn + 0x7c00;
                else // otherwise convert directly
                ushorts[i] = sgn + (exp + 15 << 10) + frac;
            }
        }
        return ushorts;
    }
    function isArrayLike(s) {
        return Array.isArray(s) || isTypedArray(s);
    }
    var isPow2$1 = function(v) {
        return !(v & v - 1) && !!v;
    };
    var GL_COMPRESSED_TEXTURE_FORMATS = 0x86A3;
    var GL_TEXTURE_2D$1 = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP$1 = 0x8513;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 = 0x8515;
    var GL_RGBA$1 = 0x1908;
    var GL_ALPHA = 0x1906;
    var GL_RGB = 0x1907;
    var GL_LUMINANCE = 0x1909;
    var GL_LUMINANCE_ALPHA = 0x190A;
    var GL_RGBA4 = 0x8056;
    var GL_RGB5_A1 = 0x8057;
    var GL_RGB565 = 0x8D62;
    var GL_UNSIGNED_SHORT_4_4_4_4$1 = 0x8033;
    var GL_UNSIGNED_SHORT_5_5_5_1$1 = 0x8034;
    var GL_UNSIGNED_SHORT_5_6_5$1 = 0x8363;
    var GL_UNSIGNED_INT_24_8_WEBGL$1 = 0x84FA;
    var GL_DEPTH_COMPONENT = 0x1902;
    var GL_DEPTH_STENCIL = 0x84F9;
    var GL_SRGB_EXT = 0x8C40;
    var GL_SRGB_ALPHA_EXT = 0x8C42;
    var GL_HALF_FLOAT_OES$1 = 0x8D61;
    var GL_COMPRESSED_RGB_S3TC_DXT1_EXT = 0x83F0;
    var GL_COMPRESSED_RGBA_S3TC_DXT1_EXT = 0x83F1;
    var GL_COMPRESSED_RGBA_S3TC_DXT3_EXT = 0x83F2;
    var GL_COMPRESSED_RGBA_S3TC_DXT5_EXT = 0x83F3;
    var GL_COMPRESSED_RGB_ATC_WEBGL = 0x8C92;
    var GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 0x8C93;
    var GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 0x87EE;
    var GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 0x8C00;
    var GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 0x8C01;
    var GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 0x8C02;
    var GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 0x8C03;
    var GL_COMPRESSED_RGB_ETC1_WEBGL = 0x8D64;
    var GL_UNSIGNED_BYTE$5 = 0x1401;
    var GL_UNSIGNED_SHORT$3 = 0x1403;
    var GL_UNSIGNED_INT$3 = 0x1405;
    var GL_FLOAT$4 = 0x1406;
    var GL_TEXTURE_WRAP_S = 0x2802;
    var GL_TEXTURE_WRAP_T = 0x2803;
    var GL_REPEAT = 0x2901;
    var GL_CLAMP_TO_EDGE$1 = 0x812F;
    var GL_MIRRORED_REPEAT = 0x8370;
    var GL_TEXTURE_MAG_FILTER = 0x2800;
    var GL_TEXTURE_MIN_FILTER = 0x2801;
    var GL_NEAREST$1 = 0x2600;
    var GL_LINEAR = 0x2601;
    var GL_NEAREST_MIPMAP_NEAREST$1 = 0x2700;
    var GL_LINEAR_MIPMAP_NEAREST$1 = 0x2701;
    var GL_NEAREST_MIPMAP_LINEAR$1 = 0x2702;
    var GL_LINEAR_MIPMAP_LINEAR$1 = 0x2703;
    var GL_GENERATE_MIPMAP_HINT = 0x8192;
    var GL_DONT_CARE = 0x1100;
    var GL_FASTEST = 0x1101;
    var GL_NICEST = 0x1102;
    var GL_TEXTURE_MAX_ANISOTROPY_EXT = 0x84FE;
    var GL_UNPACK_ALIGNMENT = 0x0CF5;
    var GL_UNPACK_FLIP_Y_WEBGL = 0x9240;
    var GL_UNPACK_PREMULTIPLY_ALPHA_WEBGL = 0x9241;
    var GL_UNPACK_COLORSPACE_CONVERSION_WEBGL = 0x9243;
    var GL_BROWSER_DEFAULT_WEBGL = 0x9244;
    var GL_TEXTURE0$1 = 0x84C0;
    var MIPMAP_FILTERS = [
        GL_NEAREST_MIPMAP_NEAREST$1,
        GL_NEAREST_MIPMAP_LINEAR$1,
        GL_LINEAR_MIPMAP_NEAREST$1,
        GL_LINEAR_MIPMAP_LINEAR$1
    ];
    var CHANNELS_FORMAT = [
        0,
        GL_LUMINANCE,
        GL_LUMINANCE_ALPHA,
        GL_RGB,
        GL_RGBA$1
    ];
    var FORMAT_CHANNELS = {};
    FORMAT_CHANNELS[GL_LUMINANCE] = FORMAT_CHANNELS[GL_ALPHA] = FORMAT_CHANNELS[GL_DEPTH_COMPONENT] = 1;
    FORMAT_CHANNELS[GL_DEPTH_STENCIL] = FORMAT_CHANNELS[GL_LUMINANCE_ALPHA] = 2;
    FORMAT_CHANNELS[GL_RGB] = FORMAT_CHANNELS[GL_SRGB_EXT] = 3;
    FORMAT_CHANNELS[GL_RGBA$1] = FORMAT_CHANNELS[GL_SRGB_ALPHA_EXT] = 4;
    function objectName(str) {
        return "[object " + str + "]";
    }
    var CANVAS_CLASS = objectName("HTMLCanvasElement");
    var OFFSCREENCANVAS_CLASS = objectName("OffscreenCanvas");
    var CONTEXT2D_CLASS = objectName("CanvasRenderingContext2D");
    var BITMAP_CLASS = objectName("ImageBitmap");
    var IMAGE_CLASS = objectName("HTMLImageElement");
    var VIDEO_CLASS = objectName("HTMLVideoElement");
    var PIXEL_CLASSES = Object.keys(arrayTypes).concat([
        CANVAS_CLASS,
        OFFSCREENCANVAS_CLASS,
        CONTEXT2D_CLASS,
        BITMAP_CLASS,
        IMAGE_CLASS,
        VIDEO_CLASS
    ]);
    // for every texture type, store
    // the size in bytes.
    var TYPE_SIZES = [];
    TYPE_SIZES[GL_UNSIGNED_BYTE$5] = 1;
    TYPE_SIZES[GL_FLOAT$4] = 4;
    TYPE_SIZES[GL_HALF_FLOAT_OES$1] = 2;
    TYPE_SIZES[GL_UNSIGNED_SHORT$3] = 2;
    TYPE_SIZES[GL_UNSIGNED_INT$3] = 4;
    var FORMAT_SIZES_SPECIAL = [];
    FORMAT_SIZES_SPECIAL[GL_RGBA4] = 2;
    FORMAT_SIZES_SPECIAL[GL_RGB5_A1] = 2;
    FORMAT_SIZES_SPECIAL[GL_RGB565] = 2;
    FORMAT_SIZES_SPECIAL[GL_DEPTH_STENCIL] = 4;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_S3TC_DXT1_EXT] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT1_EXT] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT3_EXT] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT5_EXT] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_ATC_WEBGL] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG] = 0.25;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG] = 0.25;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_ETC1_WEBGL] = 0.5;
    function isNumericArray(arr) {
        return Array.isArray(arr) && (arr.length === 0 || typeof arr[0] === "number");
    }
    function isRectArray(arr) {
        if (!Array.isArray(arr)) return false;
        var width = arr.length;
        if (width === 0 || !isArrayLike(arr[0])) return false;
        return true;
    }
    function classString(x) {
        return Object.prototype.toString.call(x);
    }
    function isCanvasElement(object) {
        return classString(object) === CANVAS_CLASS;
    }
    function isOffscreenCanvas(object) {
        return classString(object) === OFFSCREENCANVAS_CLASS;
    }
    function isContext2D(object) {
        return classString(object) === CONTEXT2D_CLASS;
    }
    function isBitmap(object) {
        return classString(object) === BITMAP_CLASS;
    }
    function isImageElement(object) {
        return classString(object) === IMAGE_CLASS;
    }
    function isVideoElement(object) {
        return classString(object) === VIDEO_CLASS;
    }
    function isPixelData(object) {
        if (!object) return false;
        var className = classString(object);
        if (PIXEL_CLASSES.indexOf(className) >= 0) return true;
        return isNumericArray(object) || isRectArray(object) || isNDArrayLike(object);
    }
    function typedArrayCode$1(data) {
        return arrayTypes[Object.prototype.toString.call(data)] | 0;
    }
    function convertData(result, data) {
        var n = data.length;
        switch(result.type){
            case GL_UNSIGNED_BYTE$5:
            case GL_UNSIGNED_SHORT$3:
            case GL_UNSIGNED_INT$3:
            case GL_FLOAT$4:
                var converted = pool.allocType(result.type, n);
                converted.set(data);
                result.data = converted;
                break;
            case GL_HALF_FLOAT_OES$1:
                result.data = convertToHalfFloat(data);
                break;
            default:
                check$1.raise("unsupported texture type, must specify a typed array");
        }
    }
    function preConvert(image, n) {
        return pool.allocType(image.type === GL_HALF_FLOAT_OES$1 ? GL_FLOAT$4 : image.type, n);
    }
    function postConvert(image, data) {
        if (image.type === GL_HALF_FLOAT_OES$1) {
            image.data = convertToHalfFloat(data);
            pool.freeType(data);
        } else image.data = data;
    }
    function transposeData(image, array, strideX, strideY, strideC, offset) {
        var w = image.width;
        var h = image.height;
        var c = image.channels;
        var n = w * h * c;
        var data = preConvert(image, n);
        var p = 0;
        for(var i = 0; i < h; ++i){
            for(var j = 0; j < w; ++j)for(var k = 0; k < c; ++k)data[p++] = array[strideX * j + strideY * i + strideC * k + offset];
        }
        postConvert(image, data);
    }
    function getTextureSize(format, type, width, height, isMipmap, isCube) {
        var s;
        if (typeof FORMAT_SIZES_SPECIAL[format] !== "undefined") // we have a special array for dealing with weird color formats such as RGB5A1
        s = FORMAT_SIZES_SPECIAL[format];
        else s = FORMAT_CHANNELS[format] * TYPE_SIZES[type];
        if (isCube) s *= 6;
        if (isMipmap) {
            // compute the total size of all the mipmaps.
            var total = 0;
            var w = width;
            while(w >= 1){
                // we can only use mipmaps on a square image,
                // so we can simply use the width and ignore the height:
                total += s * w * w;
                w /= 2;
            }
            return total;
        } else return s * width * height;
    }
    function createTextureSet(gl, extensions, limits, reglPoll, contextState, stats, config) {
        // -------------------------------------------------------
        // Initialize constants and parameter tables here
        // -------------------------------------------------------
        var mipmapHint = {
            "don't care": GL_DONT_CARE,
            "dont care": GL_DONT_CARE,
            "nice": GL_NICEST,
            "fast": GL_FASTEST
        };
        var wrapModes = {
            "repeat": GL_REPEAT,
            "clamp": GL_CLAMP_TO_EDGE$1,
            "mirror": GL_MIRRORED_REPEAT
        };
        var magFilters = {
            "nearest": GL_NEAREST$1,
            "linear": GL_LINEAR
        };
        var minFilters = extend({
            "mipmap": GL_LINEAR_MIPMAP_LINEAR$1,
            "nearest mipmap nearest": GL_NEAREST_MIPMAP_NEAREST$1,
            "linear mipmap nearest": GL_LINEAR_MIPMAP_NEAREST$1,
            "nearest mipmap linear": GL_NEAREST_MIPMAP_LINEAR$1,
            "linear mipmap linear": GL_LINEAR_MIPMAP_LINEAR$1
        }, magFilters);
        var colorSpace = {
            "none": 0,
            "browser": GL_BROWSER_DEFAULT_WEBGL
        };
        var textureTypes = {
            "uint8": GL_UNSIGNED_BYTE$5,
            "rgba4": GL_UNSIGNED_SHORT_4_4_4_4$1,
            "rgb565": GL_UNSIGNED_SHORT_5_6_5$1,
            "rgb5 a1": GL_UNSIGNED_SHORT_5_5_5_1$1
        };
        var textureFormats = {
            "alpha": GL_ALPHA,
            "luminance": GL_LUMINANCE,
            "luminance alpha": GL_LUMINANCE_ALPHA,
            "rgb": GL_RGB,
            "rgba": GL_RGBA$1,
            "rgba4": GL_RGBA4,
            "rgb5 a1": GL_RGB5_A1,
            "rgb565": GL_RGB565
        };
        var compressedTextureFormats = {};
        if (extensions.ext_srgb) {
            textureFormats.srgb = GL_SRGB_EXT;
            textureFormats.srgba = GL_SRGB_ALPHA_EXT;
        }
        if (extensions.oes_texture_float) textureTypes.float32 = textureTypes.float = GL_FLOAT$4;
        if (extensions.oes_texture_half_float) textureTypes["float16"] = textureTypes["half float"] = GL_HALF_FLOAT_OES$1;
        if (extensions.webgl_depth_texture) {
            extend(textureFormats, {
                "depth": GL_DEPTH_COMPONENT,
                "depth stencil": GL_DEPTH_STENCIL
            });
            extend(textureTypes, {
                "uint16": GL_UNSIGNED_SHORT$3,
                "uint32": GL_UNSIGNED_INT$3,
                "depth stencil": GL_UNSIGNED_INT_24_8_WEBGL$1
            });
        }
        if (extensions.webgl_compressed_texture_s3tc) extend(compressedTextureFormats, {
            "rgb s3tc dxt1": GL_COMPRESSED_RGB_S3TC_DXT1_EXT,
            "rgba s3tc dxt1": GL_COMPRESSED_RGBA_S3TC_DXT1_EXT,
            "rgba s3tc dxt3": GL_COMPRESSED_RGBA_S3TC_DXT3_EXT,
            "rgba s3tc dxt5": GL_COMPRESSED_RGBA_S3TC_DXT5_EXT
        });
        if (extensions.webgl_compressed_texture_atc) extend(compressedTextureFormats, {
            "rgb atc": GL_COMPRESSED_RGB_ATC_WEBGL,
            "rgba atc explicit alpha": GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL,
            "rgba atc interpolated alpha": GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL
        });
        if (extensions.webgl_compressed_texture_pvrtc) extend(compressedTextureFormats, {
            "rgb pvrtc 4bppv1": GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG,
            "rgb pvrtc 2bppv1": GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG,
            "rgba pvrtc 4bppv1": GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG,
            "rgba pvrtc 2bppv1": GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
        });
        if (extensions.webgl_compressed_texture_etc1) compressedTextureFormats["rgb etc1"] = GL_COMPRESSED_RGB_ETC1_WEBGL;
        // Copy over all texture formats
        var supportedCompressedFormats = Array.prototype.slice.call(gl.getParameter(GL_COMPRESSED_TEXTURE_FORMATS));
        Object.keys(compressedTextureFormats).forEach(function(name) {
            var format = compressedTextureFormats[name];
            if (supportedCompressedFormats.indexOf(format) >= 0) textureFormats[name] = format;
        });
        var supportedFormats = Object.keys(textureFormats);
        limits.textureFormats = supportedFormats;
        // associate with every format string its
        // corresponding GL-value.
        var textureFormatsInvert = [];
        Object.keys(textureFormats).forEach(function(key) {
            var val = textureFormats[key];
            textureFormatsInvert[val] = key;
        });
        // associate with every type string its
        // corresponding GL-value.
        var textureTypesInvert = [];
        Object.keys(textureTypes).forEach(function(key) {
            var val = textureTypes[key];
            textureTypesInvert[val] = key;
        });
        var magFiltersInvert = [];
        Object.keys(magFilters).forEach(function(key) {
            var val = magFilters[key];
            magFiltersInvert[val] = key;
        });
        var minFiltersInvert = [];
        Object.keys(minFilters).forEach(function(key) {
            var val = minFilters[key];
            minFiltersInvert[val] = key;
        });
        var wrapModesInvert = [];
        Object.keys(wrapModes).forEach(function(key) {
            var val = wrapModes[key];
            wrapModesInvert[val] = key;
        });
        // colorFormats[] gives the format (channels) associated to an
        // internalformat
        var colorFormats = supportedFormats.reduce(function(color, key) {
            var glenum = textureFormats[key];
            if (glenum === GL_LUMINANCE || glenum === GL_ALPHA || glenum === GL_LUMINANCE || glenum === GL_LUMINANCE_ALPHA || glenum === GL_DEPTH_COMPONENT || glenum === GL_DEPTH_STENCIL || extensions.ext_srgb && (glenum === GL_SRGB_EXT || glenum === GL_SRGB_ALPHA_EXT)) color[glenum] = glenum;
            else if (glenum === GL_RGB5_A1 || key.indexOf("rgba") >= 0) color[glenum] = GL_RGBA$1;
            else color[glenum] = GL_RGB;
            return color;
        }, {});
        function TexFlags() {
            // format info
            this.internalformat = GL_RGBA$1;
            this.format = GL_RGBA$1;
            this.type = GL_UNSIGNED_BYTE$5;
            this.compressed = false;
            // pixel storage
            this.premultiplyAlpha = false;
            this.flipY = false;
            this.unpackAlignment = 1;
            this.colorSpace = GL_BROWSER_DEFAULT_WEBGL;
            // shape info
            this.width = 0;
            this.height = 0;
            this.channels = 0;
        }
        function copyFlags(result, other) {
            result.internalformat = other.internalformat;
            result.format = other.format;
            result.type = other.type;
            result.compressed = other.compressed;
            result.premultiplyAlpha = other.premultiplyAlpha;
            result.flipY = other.flipY;
            result.unpackAlignment = other.unpackAlignment;
            result.colorSpace = other.colorSpace;
            result.width = other.width;
            result.height = other.height;
            result.channels = other.channels;
        }
        function parseFlags(flags, options) {
            if (typeof options !== "object" || !options) return;
            if ("premultiplyAlpha" in options) {
                check$1.type(options.premultiplyAlpha, "boolean", "invalid premultiplyAlpha");
                flags.premultiplyAlpha = options.premultiplyAlpha;
            }
            if ("flipY" in options) {
                check$1.type(options.flipY, "boolean", "invalid texture flip");
                flags.flipY = options.flipY;
            }
            if ("alignment" in options) {
                check$1.oneOf(options.alignment, [
                    1,
                    2,
                    4,
                    8
                ], "invalid texture unpack alignment");
                flags.unpackAlignment = options.alignment;
            }
            if ("colorSpace" in options) {
                check$1.parameter(options.colorSpace, colorSpace, "invalid colorSpace");
                flags.colorSpace = colorSpace[options.colorSpace];
            }
            if ("type" in options) {
                var type = options.type;
                check$1(extensions.oes_texture_float || !(type === "float" || type === "float32"), "you must enable the OES_texture_float extension in order to use floating point textures.");
                check$1(extensions.oes_texture_half_float || !(type === "half float" || type === "float16"), "you must enable the OES_texture_half_float extension in order to use 16-bit floating point textures.");
                check$1(extensions.webgl_depth_texture || !(type === "uint16" || type === "uint32" || type === "depth stencil"), "you must enable the WEBGL_depth_texture extension in order to use depth/stencil textures.");
                check$1.parameter(type, textureTypes, "invalid texture type");
                flags.type = textureTypes[type];
            }
            var w = flags.width;
            var h = flags.height;
            var c = flags.channels;
            var hasChannels = false;
            if ("shape" in options) {
                check$1(Array.isArray(options.shape) && options.shape.length >= 2, "shape must be an array");
                w = options.shape[0];
                h = options.shape[1];
                if (options.shape.length === 3) {
                    c = options.shape[2];
                    check$1(c > 0 && c <= 4, "invalid number of channels");
                    hasChannels = true;
                }
                check$1(w >= 0 && w <= limits.maxTextureSize, "invalid width");
                check$1(h >= 0 && h <= limits.maxTextureSize, "invalid height");
            } else {
                if ("radius" in options) {
                    w = h = options.radius;
                    check$1(w >= 0 && w <= limits.maxTextureSize, "invalid radius");
                }
                if ("width" in options) {
                    w = options.width;
                    check$1(w >= 0 && w <= limits.maxTextureSize, "invalid width");
                }
                if ("height" in options) {
                    h = options.height;
                    check$1(h >= 0 && h <= limits.maxTextureSize, "invalid height");
                }
                if ("channels" in options) {
                    c = options.channels;
                    check$1(c > 0 && c <= 4, "invalid number of channels");
                    hasChannels = true;
                }
            }
            flags.width = w | 0;
            flags.height = h | 0;
            flags.channels = c | 0;
            var hasFormat = false;
            if ("format" in options) {
                var formatStr = options.format;
                check$1(extensions.webgl_depth_texture || !(formatStr === "depth" || formatStr === "depth stencil"), "you must enable the WEBGL_depth_texture extension in order to use depth/stencil textures.");
                check$1.parameter(formatStr, textureFormats, "invalid texture format");
                var internalformat = flags.internalformat = textureFormats[formatStr];
                flags.format = colorFormats[internalformat];
                if (formatStr in textureTypes) {
                    if (!("type" in options)) flags.type = textureTypes[formatStr];
                }
                if (formatStr in compressedTextureFormats) flags.compressed = true;
                hasFormat = true;
            }
            // Reconcile channels and format
            if (!hasChannels && hasFormat) flags.channels = FORMAT_CHANNELS[flags.format];
            else if (hasChannels && !hasFormat) {
                if (flags.channels !== CHANNELS_FORMAT[flags.format]) flags.format = flags.internalformat = CHANNELS_FORMAT[flags.channels];
            } else if (hasFormat && hasChannels) check$1(flags.channels === FORMAT_CHANNELS[flags.format], "number of channels inconsistent with specified format");
        }
        function setFlags(flags) {
            gl.pixelStorei(GL_UNPACK_FLIP_Y_WEBGL, flags.flipY);
            gl.pixelStorei(GL_UNPACK_PREMULTIPLY_ALPHA_WEBGL, flags.premultiplyAlpha);
            gl.pixelStorei(GL_UNPACK_COLORSPACE_CONVERSION_WEBGL, flags.colorSpace);
            gl.pixelStorei(GL_UNPACK_ALIGNMENT, flags.unpackAlignment);
        }
        // -------------------------------------------------------
        // Tex image data
        // -------------------------------------------------------
        function TexImage() {
            TexFlags.call(this);
            this.xOffset = 0;
            this.yOffset = 0;
            // data
            this.data = null;
            this.needsFree = false;
            // html element
            this.element = null;
            // copyTexImage info
            this.needsCopy = false;
        }
        function parseImage(image, options) {
            var data = null;
            if (isPixelData(options)) data = options;
            else if (options) {
                check$1.type(options, "object", "invalid pixel data type");
                parseFlags(image, options);
                if ("x" in options) image.xOffset = options.x | 0;
                if ("y" in options) image.yOffset = options.y | 0;
                if (isPixelData(options.data)) data = options.data;
            }
            check$1(!image.compressed || data instanceof Uint8Array, "compressed texture data must be stored in a uint8array");
            if (options.copy) {
                check$1(!data, "can not specify copy and data field for the same texture");
                var viewW = contextState.viewportWidth;
                var viewH = contextState.viewportHeight;
                image.width = image.width || viewW - image.xOffset;
                image.height = image.height || viewH - image.yOffset;
                image.needsCopy = true;
                check$1(image.xOffset >= 0 && image.xOffset < viewW && image.yOffset >= 0 && image.yOffset < viewH && image.width > 0 && image.width <= viewW && image.height > 0 && image.height <= viewH, "copy texture read out of bounds");
            } else if (!data) {
                image.width = image.width || 1;
                image.height = image.height || 1;
                image.channels = image.channels || 4;
            } else if (isTypedArray(data)) {
                image.channels = image.channels || 4;
                image.data = data;
                if (!("type" in options) && image.type === GL_UNSIGNED_BYTE$5) image.type = typedArrayCode$1(data);
            } else if (isNumericArray(data)) {
                image.channels = image.channels || 4;
                convertData(image, data);
                image.alignment = 1;
                image.needsFree = true;
            } else if (isNDArrayLike(data)) {
                var array = data.data;
                if (!Array.isArray(array) && image.type === GL_UNSIGNED_BYTE$5) image.type = typedArrayCode$1(array);
                var shape = data.shape;
                var stride = data.stride;
                var shapeX, shapeY, shapeC, strideX, strideY, strideC;
                if (shape.length === 3) {
                    shapeC = shape[2];
                    strideC = stride[2];
                } else {
                    check$1(shape.length === 2, "invalid ndarray pixel data, must be 2 or 3D");
                    shapeC = 1;
                    strideC = 1;
                }
                shapeX = shape[0];
                shapeY = shape[1];
                strideX = stride[0];
                strideY = stride[1];
                image.alignment = 1;
                image.width = shapeX;
                image.height = shapeY;
                image.channels = shapeC;
                image.format = image.internalformat = CHANNELS_FORMAT[shapeC];
                image.needsFree = true;
                transposeData(image, array, strideX, strideY, strideC, data.offset);
            } else if (isCanvasElement(data) || isOffscreenCanvas(data) || isContext2D(data)) {
                if (isCanvasElement(data) || isOffscreenCanvas(data)) image.element = data;
                else image.element = data.canvas;
                image.width = image.element.width;
                image.height = image.element.height;
                image.channels = 4;
            } else if (isBitmap(data)) {
                image.element = data;
                image.width = data.width;
                image.height = data.height;
                image.channels = 4;
            } else if (isImageElement(data)) {
                image.element = data;
                image.width = data.naturalWidth;
                image.height = data.naturalHeight;
                image.channels = 4;
            } else if (isVideoElement(data)) {
                image.element = data;
                image.width = data.videoWidth;
                image.height = data.videoHeight;
                image.channels = 4;
            } else if (isRectArray(data)) {
                var w = image.width || data[0].length;
                var h = image.height || data.length;
                var c = image.channels;
                if (isArrayLike(data[0][0])) c = c || data[0][0].length;
                else c = c || 1;
                var arrayShape = flattenUtils.shape(data);
                var n = 1;
                for(var dd = 0; dd < arrayShape.length; ++dd)n *= arrayShape[dd];
                var allocData = preConvert(image, n);
                flattenUtils.flatten(data, arrayShape, "", allocData);
                postConvert(image, allocData);
                image.alignment = 1;
                image.width = w;
                image.height = h;
                image.channels = c;
                image.format = image.internalformat = CHANNELS_FORMAT[c];
                image.needsFree = true;
            }
            if (image.type === GL_FLOAT$4) check$1(limits.extensions.indexOf("oes_texture_float") >= 0, "oes_texture_float extension not enabled");
            else if (image.type === GL_HALF_FLOAT_OES$1) check$1(limits.extensions.indexOf("oes_texture_half_float") >= 0, "oes_texture_half_float extension not enabled");
        // do compressed texture  validation here.
        }
        function setImage(info, target, miplevel) {
            var element = info.element;
            var data = info.data;
            var internalformat = info.internalformat;
            var format = info.format;
            var type = info.type;
            var width = info.width;
            var height = info.height;
            setFlags(info);
            if (element) gl.texImage2D(target, miplevel, format, format, type, element);
            else if (info.compressed) gl.compressedTexImage2D(target, miplevel, internalformat, width, height, 0, data);
            else if (info.needsCopy) {
                reglPoll();
                gl.copyTexImage2D(target, miplevel, format, info.xOffset, info.yOffset, width, height, 0);
            } else gl.texImage2D(target, miplevel, format, width, height, 0, format, type, data || null);
        }
        function setSubImage(info, target, x, y, miplevel) {
            var element = info.element;
            var data = info.data;
            var internalformat = info.internalformat;
            var format = info.format;
            var type = info.type;
            var width = info.width;
            var height = info.height;
            setFlags(info);
            if (element) gl.texSubImage2D(target, miplevel, x, y, format, type, element);
            else if (info.compressed) gl.compressedTexSubImage2D(target, miplevel, x, y, internalformat, width, height, data);
            else if (info.needsCopy) {
                reglPoll();
                gl.copyTexSubImage2D(target, miplevel, x, y, info.xOffset, info.yOffset, width, height);
            } else gl.texSubImage2D(target, miplevel, x, y, width, height, format, type, data);
        }
        // texImage pool
        var imagePool = [];
        function allocImage() {
            return imagePool.pop() || new TexImage();
        }
        function freeImage(image) {
            if (image.needsFree) pool.freeType(image.data);
            TexImage.call(image);
            imagePool.push(image);
        }
        // -------------------------------------------------------
        // Mip map
        // -------------------------------------------------------
        function MipMap() {
            TexFlags.call(this);
            this.genMipmaps = false;
            this.mipmapHint = GL_DONT_CARE;
            this.mipmask = 0;
            this.images = Array(16);
        }
        function parseMipMapFromShape(mipmap, width, height) {
            var img = mipmap.images[0] = allocImage();
            mipmap.mipmask = 1;
            img.width = mipmap.width = width;
            img.height = mipmap.height = height;
            img.channels = mipmap.channels = 4;
        }
        function parseMipMapFromObject(mipmap, options) {
            var imgData = null;
            if (isPixelData(options)) {
                imgData = mipmap.images[0] = allocImage();
                copyFlags(imgData, mipmap);
                parseImage(imgData, options);
                mipmap.mipmask = 1;
            } else {
                parseFlags(mipmap, options);
                if (Array.isArray(options.mipmap)) {
                    var mipData = options.mipmap;
                    for(var i = 0; i < mipData.length; ++i){
                        imgData = mipmap.images[i] = allocImage();
                        copyFlags(imgData, mipmap);
                        imgData.width >>= i;
                        imgData.height >>= i;
                        parseImage(imgData, mipData[i]);
                        mipmap.mipmask |= 1 << i;
                    }
                } else {
                    imgData = mipmap.images[0] = allocImage();
                    copyFlags(imgData, mipmap);
                    parseImage(imgData, options);
                    mipmap.mipmask = 1;
                }
            }
            copyFlags(mipmap, mipmap.images[0]);
            // For textures of the compressed format WEBGL_compressed_texture_s3tc
            // we must have that
            //
            // "When level equals zero width and height must be a multiple of 4.
            // When level is greater than 0 width and height must be 0, 1, 2 or a multiple of 4. "
            //
            // but we do not yet support having multiple mipmap levels for compressed textures,
            // so we only test for level zero.
            if (mipmap.compressed && (mipmap.internalformat === GL_COMPRESSED_RGB_S3TC_DXT1_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT1_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT3_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT5_EXT)) check$1(mipmap.width % 4 === 0 && mipmap.height % 4 === 0, "for compressed texture formats, mipmap level 0 must have width and height that are a multiple of 4");
        }
        function setMipMap(mipmap, target) {
            var images = mipmap.images;
            for(var i = 0; i < images.length; ++i){
                if (!images[i]) return;
                setImage(images[i], target, i);
            }
        }
        var mipPool = [];
        function allocMipMap() {
            var result = mipPool.pop() || new MipMap();
            TexFlags.call(result);
            result.mipmask = 0;
            for(var i = 0; i < 16; ++i)result.images[i] = null;
            return result;
        }
        function freeMipMap(mipmap) {
            var images = mipmap.images;
            for(var i = 0; i < images.length; ++i){
                if (images[i]) freeImage(images[i]);
                images[i] = null;
            }
            mipPool.push(mipmap);
        }
        // -------------------------------------------------------
        // Tex info
        // -------------------------------------------------------
        function TexInfo() {
            this.minFilter = GL_NEAREST$1;
            this.magFilter = GL_NEAREST$1;
            this.wrapS = GL_CLAMP_TO_EDGE$1;
            this.wrapT = GL_CLAMP_TO_EDGE$1;
            this.anisotropic = 1;
            this.genMipmaps = false;
            this.mipmapHint = GL_DONT_CARE;
        }
        function parseTexInfo(info, options) {
            if ("min" in options) {
                var minFilter = options.min;
                check$1.parameter(minFilter, minFilters);
                info.minFilter = minFilters[minFilter];
                if (MIPMAP_FILTERS.indexOf(info.minFilter) >= 0 && !("faces" in options)) info.genMipmaps = true;
            }
            if ("mag" in options) {
                var magFilter = options.mag;
                check$1.parameter(magFilter, magFilters);
                info.magFilter = magFilters[magFilter];
            }
            var wrapS = info.wrapS;
            var wrapT = info.wrapT;
            if ("wrap" in options) {
                var wrap = options.wrap;
                if (typeof wrap === "string") {
                    check$1.parameter(wrap, wrapModes);
                    wrapS = wrapT = wrapModes[wrap];
                } else if (Array.isArray(wrap)) {
                    check$1.parameter(wrap[0], wrapModes);
                    check$1.parameter(wrap[1], wrapModes);
                    wrapS = wrapModes[wrap[0]];
                    wrapT = wrapModes[wrap[1]];
                }
            } else {
                if ("wrapS" in options) {
                    var optWrapS = options.wrapS;
                    check$1.parameter(optWrapS, wrapModes);
                    wrapS = wrapModes[optWrapS];
                }
                if ("wrapT" in options) {
                    var optWrapT = options.wrapT;
                    check$1.parameter(optWrapT, wrapModes);
                    wrapT = wrapModes[optWrapT];
                }
            }
            info.wrapS = wrapS;
            info.wrapT = wrapT;
            if ("anisotropic" in options) {
                var anisotropic = options.anisotropic;
                check$1(typeof anisotropic === "number" && anisotropic >= 1 && anisotropic <= limits.maxAnisotropic, "aniso samples must be between 1 and ");
                info.anisotropic = options.anisotropic;
            }
            if ("mipmap" in options) {
                var hasMipMap = false;
                switch(typeof options.mipmap){
                    case "string":
                        check$1.parameter(options.mipmap, mipmapHint, "invalid mipmap hint");
                        info.mipmapHint = mipmapHint[options.mipmap];
                        info.genMipmaps = true;
                        hasMipMap = true;
                        break;
                    case "boolean":
                        hasMipMap = info.genMipmaps = options.mipmap;
                        break;
                    case "object":
                        check$1(Array.isArray(options.mipmap), "invalid mipmap type");
                        info.genMipmaps = false;
                        hasMipMap = true;
                        break;
                    default:
                        check$1.raise("invalid mipmap type");
                }
                if (hasMipMap && !("min" in options)) info.minFilter = GL_NEAREST_MIPMAP_NEAREST$1;
            }
        }
        function setTexInfo(info, target) {
            gl.texParameteri(target, GL_TEXTURE_MIN_FILTER, info.minFilter);
            gl.texParameteri(target, GL_TEXTURE_MAG_FILTER, info.magFilter);
            gl.texParameteri(target, GL_TEXTURE_WRAP_S, info.wrapS);
            gl.texParameteri(target, GL_TEXTURE_WRAP_T, info.wrapT);
            if (extensions.ext_texture_filter_anisotropic) gl.texParameteri(target, GL_TEXTURE_MAX_ANISOTROPY_EXT, info.anisotropic);
            if (info.genMipmaps) {
                gl.hint(GL_GENERATE_MIPMAP_HINT, info.mipmapHint);
                gl.generateMipmap(target);
            }
        }
        // -------------------------------------------------------
        // Full texture object
        // -------------------------------------------------------
        var textureCount = 0;
        var textureSet = {};
        var numTexUnits = limits.maxTextureUnits;
        var textureUnits = Array(numTexUnits).map(function() {
            return null;
        });
        function REGLTexture(target) {
            TexFlags.call(this);
            this.mipmask = 0;
            this.internalformat = GL_RGBA$1;
            this.id = textureCount++;
            this.refCount = 1;
            this.target = target;
            this.texture = gl.createTexture();
            this.unit = -1;
            this.bindCount = 0;
            this.texInfo = new TexInfo();
            if (config.profile) this.stats = {
                size: 0
            };
        }
        function tempBind(texture) {
            gl.activeTexture(GL_TEXTURE0$1);
            gl.bindTexture(texture.target, texture.texture);
        }
        function tempRestore() {
            var prev = textureUnits[0];
            if (prev) gl.bindTexture(prev.target, prev.texture);
            else gl.bindTexture(GL_TEXTURE_2D$1, null);
        }
        function destroy(texture) {
            var handle = texture.texture;
            check$1(handle, "must not double destroy texture");
            var unit = texture.unit;
            var target = texture.target;
            if (unit >= 0) {
                gl.activeTexture(GL_TEXTURE0$1 + unit);
                gl.bindTexture(target, null);
                textureUnits[unit] = null;
            }
            gl.deleteTexture(handle);
            texture.texture = null;
            texture.params = null;
            texture.pixels = null;
            texture.refCount = 0;
            delete textureSet[texture.id];
            stats.textureCount--;
        }
        extend(REGLTexture.prototype, {
            bind: function() {
                var texture = this;
                texture.bindCount += 1;
                var unit = texture.unit;
                if (unit < 0) {
                    for(var i = 0; i < numTexUnits; ++i){
                        var other = textureUnits[i];
                        if (other) {
                            if (other.bindCount > 0) continue;
                            other.unit = -1;
                        }
                        textureUnits[i] = texture;
                        unit = i;
                        break;
                    }
                    if (unit >= numTexUnits) check$1.raise("insufficient number of texture units");
                    if (config.profile && stats.maxTextureUnits < unit + 1) stats.maxTextureUnits = unit + 1 // +1, since the units are zero-based
                    ;
                    texture.unit = unit;
                    gl.activeTexture(GL_TEXTURE0$1 + unit);
                    gl.bindTexture(texture.target, texture.texture);
                }
                return unit;
            },
            unbind: function() {
                this.bindCount -= 1;
            },
            decRef: function() {
                if (--this.refCount <= 0) destroy(this);
            }
        });
        function createTexture2D(a, b) {
            var texture = new REGLTexture(GL_TEXTURE_2D$1);
            textureSet[texture.id] = texture;
            stats.textureCount++;
            function reglTexture2D(a, b) {
                var texInfo = texture.texInfo;
                TexInfo.call(texInfo);
                var mipData = allocMipMap();
                if (typeof a === "number") {
                    if (typeof b === "number") parseMipMapFromShape(mipData, a | 0, b | 0);
                    else parseMipMapFromShape(mipData, a | 0, a | 0);
                } else if (a) {
                    check$1.type(a, "object", "invalid arguments to regl.texture");
                    parseTexInfo(texInfo, a);
                    parseMipMapFromObject(mipData, a);
                } else // empty textures get assigned a default shape of 1x1
                parseMipMapFromShape(mipData, 1, 1);
                if (texInfo.genMipmaps) mipData.mipmask = (mipData.width << 1) - 1;
                texture.mipmask = mipData.mipmask;
                copyFlags(texture, mipData);
                check$1.texture2D(texInfo, mipData, limits);
                texture.internalformat = mipData.internalformat;
                reglTexture2D.width = mipData.width;
                reglTexture2D.height = mipData.height;
                tempBind(texture);
                setMipMap(mipData, GL_TEXTURE_2D$1);
                setTexInfo(texInfo, GL_TEXTURE_2D$1);
                tempRestore();
                freeMipMap(mipData);
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, mipData.width, mipData.height, texInfo.genMipmaps, false);
                reglTexture2D.format = textureFormatsInvert[texture.internalformat];
                reglTexture2D.type = textureTypesInvert[texture.type];
                reglTexture2D.mag = magFiltersInvert[texInfo.magFilter];
                reglTexture2D.min = minFiltersInvert[texInfo.minFilter];
                reglTexture2D.wrapS = wrapModesInvert[texInfo.wrapS];
                reglTexture2D.wrapT = wrapModesInvert[texInfo.wrapT];
                return reglTexture2D;
            }
            function subimage(image, x_, y_, level_) {
                check$1(!!image, "must specify image data");
                var x = x_ | 0;
                var y = y_ | 0;
                var level = level_ | 0;
                var imageData = allocImage();
                copyFlags(imageData, texture);
                imageData.width = 0;
                imageData.height = 0;
                parseImage(imageData, image);
                imageData.width = imageData.width || (texture.width >> level) - x;
                imageData.height = imageData.height || (texture.height >> level) - y;
                check$1(texture.type === imageData.type && texture.format === imageData.format && texture.internalformat === imageData.internalformat, "incompatible format for texture.subimage");
                check$1(x >= 0 && y >= 0 && x + imageData.width <= texture.width && y + imageData.height <= texture.height, "texture.subimage write out of bounds");
                check$1(texture.mipmask & 1 << level, "missing mipmap data");
                check$1(imageData.data || imageData.element || imageData.needsCopy, "missing image data");
                tempBind(texture);
                setSubImage(imageData, GL_TEXTURE_2D$1, x, y, level);
                tempRestore();
                freeImage(imageData);
                return reglTexture2D;
            }
            function resize(w_, h_) {
                var w = w_ | 0;
                var h = h_ | 0 || w;
                if (w === texture.width && h === texture.height) return reglTexture2D;
                reglTexture2D.width = texture.width = w;
                reglTexture2D.height = texture.height = h;
                tempBind(texture);
                for(var i = 0; texture.mipmask >> i; ++i){
                    var _w = w >> i;
                    var _h = h >> i;
                    if (!_w || !_h) break;
                    gl.texImage2D(GL_TEXTURE_2D$1, i, texture.format, _w, _h, 0, texture.format, texture.type, null);
                }
                tempRestore();
                // also, recompute the texture size.
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, w, h, false, false);
                return reglTexture2D;
            }
            reglTexture2D(a, b);
            reglTexture2D.subimage = subimage;
            reglTexture2D.resize = resize;
            reglTexture2D._reglType = "texture2d";
            reglTexture2D._texture = texture;
            if (config.profile) reglTexture2D.stats = texture.stats;
            reglTexture2D.destroy = function() {
                texture.decRef();
            };
            return reglTexture2D;
        }
        function createTextureCube(a0, a1, a2, a3, a4, a5) {
            var texture = new REGLTexture(GL_TEXTURE_CUBE_MAP$1);
            textureSet[texture.id] = texture;
            stats.cubeCount++;
            var faces = new Array(6);
            function reglTextureCube(a0, a1, a2, a3, a4, a5) {
                var i;
                var texInfo = texture.texInfo;
                TexInfo.call(texInfo);
                for(i = 0; i < 6; ++i)faces[i] = allocMipMap();
                if (typeof a0 === "number" || !a0) {
                    var s = a0 | 0 || 1;
                    for(i = 0; i < 6; ++i)parseMipMapFromShape(faces[i], s, s);
                } else if (typeof a0 === "object") {
                    if (a1) {
                        parseMipMapFromObject(faces[0], a0);
                        parseMipMapFromObject(faces[1], a1);
                        parseMipMapFromObject(faces[2], a2);
                        parseMipMapFromObject(faces[3], a3);
                        parseMipMapFromObject(faces[4], a4);
                        parseMipMapFromObject(faces[5], a5);
                    } else {
                        parseTexInfo(texInfo, a0);
                        parseFlags(texture, a0);
                        if ("faces" in a0) {
                            var faceInput = a0.faces;
                            check$1(Array.isArray(faceInput) && faceInput.length === 6, "cube faces must be a length 6 array");
                            for(i = 0; i < 6; ++i){
                                check$1(typeof faceInput[i] === "object" && !!faceInput[i], "invalid input for cube map face");
                                copyFlags(faces[i], texture);
                                parseMipMapFromObject(faces[i], faceInput[i]);
                            }
                        } else for(i = 0; i < 6; ++i)parseMipMapFromObject(faces[i], a0);
                    }
                } else check$1.raise("invalid arguments to cube map");
                copyFlags(texture, faces[0]);
                check$1.optional(function() {
                    if (!limits.npotTextureCube) check$1(isPow2$1(texture.width) && isPow2$1(texture.height), "your browser does not support non power or two texture dimensions");
                });
                if (texInfo.genMipmaps) texture.mipmask = (faces[0].width << 1) - 1;
                else texture.mipmask = faces[0].mipmask;
                check$1.textureCube(texture, texInfo, faces, limits);
                texture.internalformat = faces[0].internalformat;
                reglTextureCube.width = faces[0].width;
                reglTextureCube.height = faces[0].height;
                tempBind(texture);
                for(i = 0; i < 6; ++i)setMipMap(faces[i], GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + i);
                setTexInfo(texInfo, GL_TEXTURE_CUBE_MAP$1);
                tempRestore();
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, reglTextureCube.width, reglTextureCube.height, texInfo.genMipmaps, true);
                reglTextureCube.format = textureFormatsInvert[texture.internalformat];
                reglTextureCube.type = textureTypesInvert[texture.type];
                reglTextureCube.mag = magFiltersInvert[texInfo.magFilter];
                reglTextureCube.min = minFiltersInvert[texInfo.minFilter];
                reglTextureCube.wrapS = wrapModesInvert[texInfo.wrapS];
                reglTextureCube.wrapT = wrapModesInvert[texInfo.wrapT];
                for(i = 0; i < 6; ++i)freeMipMap(faces[i]);
                return reglTextureCube;
            }
            function subimage(face, image, x_, y_, level_) {
                check$1(!!image, "must specify image data");
                check$1(typeof face === "number" && face === (face | 0) && face >= 0 && face < 6, "invalid face");
                var x = x_ | 0;
                var y = y_ | 0;
                var level = level_ | 0;
                var imageData = allocImage();
                copyFlags(imageData, texture);
                imageData.width = 0;
                imageData.height = 0;
                parseImage(imageData, image);
                imageData.width = imageData.width || (texture.width >> level) - x;
                imageData.height = imageData.height || (texture.height >> level) - y;
                check$1(texture.type === imageData.type && texture.format === imageData.format && texture.internalformat === imageData.internalformat, "incompatible format for texture.subimage");
                check$1(x >= 0 && y >= 0 && x + imageData.width <= texture.width && y + imageData.height <= texture.height, "texture.subimage write out of bounds");
                check$1(texture.mipmask & 1 << level, "missing mipmap data");
                check$1(imageData.data || imageData.element || imageData.needsCopy, "missing image data");
                tempBind(texture);
                setSubImage(imageData, GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + face, x, y, level);
                tempRestore();
                freeImage(imageData);
                return reglTextureCube;
            }
            function resize(radius_) {
                var radius = radius_ | 0;
                if (radius === texture.width) return;
                reglTextureCube.width = texture.width = radius;
                reglTextureCube.height = texture.height = radius;
                tempBind(texture);
                for(var i = 0; i < 6; ++i)for(var j = 0; texture.mipmask >> j; ++j)gl.texImage2D(GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + i, j, texture.format, radius >> j, radius >> j, 0, texture.format, texture.type, null);
                tempRestore();
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, reglTextureCube.width, reglTextureCube.height, false, true);
                return reglTextureCube;
            }
            reglTextureCube(a0, a1, a2, a3, a4, a5);
            reglTextureCube.subimage = subimage;
            reglTextureCube.resize = resize;
            reglTextureCube._reglType = "textureCube";
            reglTextureCube._texture = texture;
            if (config.profile) reglTextureCube.stats = texture.stats;
            reglTextureCube.destroy = function() {
                texture.decRef();
            };
            return reglTextureCube;
        }
        // Called when regl is destroyed
        function destroyTextures() {
            for(var i = 0; i < numTexUnits; ++i){
                gl.activeTexture(GL_TEXTURE0$1 + i);
                gl.bindTexture(GL_TEXTURE_2D$1, null);
                textureUnits[i] = null;
            }
            values(textureSet).forEach(destroy);
            stats.cubeCount = 0;
            stats.textureCount = 0;
        }
        if (config.profile) stats.getTotalTextureSize = function() {
            var total = 0;
            Object.keys(textureSet).forEach(function(key) {
                total += textureSet[key].stats.size;
            });
            return total;
        };
        function restoreTextures() {
            for(var i = 0; i < numTexUnits; ++i){
                var tex = textureUnits[i];
                if (tex) {
                    tex.bindCount = 0;
                    tex.unit = -1;
                    textureUnits[i] = null;
                }
            }
            values(textureSet).forEach(function(texture) {
                texture.texture = gl.createTexture();
                gl.bindTexture(texture.target, texture.texture);
                for(var i = 0; i < 32; ++i){
                    if ((texture.mipmask & 1 << i) === 0) continue;
                    if (texture.target === GL_TEXTURE_2D$1) gl.texImage2D(GL_TEXTURE_2D$1, i, texture.internalformat, texture.width >> i, texture.height >> i, 0, texture.internalformat, texture.type, null);
                    else for(var j = 0; j < 6; ++j)gl.texImage2D(GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + j, i, texture.internalformat, texture.width >> i, texture.height >> i, 0, texture.internalformat, texture.type, null);
                }
                setTexInfo(texture.texInfo, texture.target);
            });
        }
        function refreshTextures() {
            for(var i = 0; i < numTexUnits; ++i){
                var tex = textureUnits[i];
                if (tex) {
                    tex.bindCount = 0;
                    tex.unit = -1;
                    textureUnits[i] = null;
                }
                gl.activeTexture(GL_TEXTURE0$1 + i);
                gl.bindTexture(GL_TEXTURE_2D$1, null);
                gl.bindTexture(GL_TEXTURE_CUBE_MAP$1, null);
            }
        }
        return {
            create2D: createTexture2D,
            createCube: createTextureCube,
            clear: destroyTextures,
            getTexture: function(wrapper) {
                return null;
            },
            restore: restoreTextures,
            refresh: refreshTextures
        };
    }
    var GL_RENDERBUFFER = 0x8D41;
    var GL_RGBA4$1 = 0x8056;
    var GL_RGB5_A1$1 = 0x8057;
    var GL_RGB565$1 = 0x8D62;
    var GL_DEPTH_COMPONENT16 = 0x81A5;
    var GL_STENCIL_INDEX8 = 0x8D48;
    var GL_DEPTH_STENCIL$1 = 0x84F9;
    var GL_SRGB8_ALPHA8_EXT = 0x8C43;
    var GL_RGBA32F_EXT = 0x8814;
    var GL_RGBA16F_EXT = 0x881A;
    var GL_RGB16F_EXT = 0x881B;
    var FORMAT_SIZES = [];
    FORMAT_SIZES[GL_RGBA4$1] = 2;
    FORMAT_SIZES[GL_RGB5_A1$1] = 2;
    FORMAT_SIZES[GL_RGB565$1] = 2;
    FORMAT_SIZES[GL_DEPTH_COMPONENT16] = 2;
    FORMAT_SIZES[GL_STENCIL_INDEX8] = 1;
    FORMAT_SIZES[GL_DEPTH_STENCIL$1] = 4;
    FORMAT_SIZES[GL_SRGB8_ALPHA8_EXT] = 4;
    FORMAT_SIZES[GL_RGBA32F_EXT] = 16;
    FORMAT_SIZES[GL_RGBA16F_EXT] = 8;
    FORMAT_SIZES[GL_RGB16F_EXT] = 6;
    function getRenderbufferSize(format, width, height) {
        return FORMAT_SIZES[format] * width * height;
    }
    var wrapRenderbuffers = function(gl, extensions, limits, stats, config) {
        var formatTypes = {
            "rgba4": GL_RGBA4$1,
            "rgb565": GL_RGB565$1,
            "rgb5 a1": GL_RGB5_A1$1,
            "depth": GL_DEPTH_COMPONENT16,
            "stencil": GL_STENCIL_INDEX8,
            "depth stencil": GL_DEPTH_STENCIL$1
        };
        if (extensions.ext_srgb) formatTypes["srgba"] = GL_SRGB8_ALPHA8_EXT;
        if (extensions.ext_color_buffer_half_float) {
            formatTypes["rgba16f"] = GL_RGBA16F_EXT;
            formatTypes["rgb16f"] = GL_RGB16F_EXT;
        }
        if (extensions.webgl_color_buffer_float) formatTypes["rgba32f"] = GL_RGBA32F_EXT;
        var formatTypesInvert = [];
        Object.keys(formatTypes).forEach(function(key) {
            var val = formatTypes[key];
            formatTypesInvert[val] = key;
        });
        var renderbufferCount = 0;
        var renderbufferSet = {};
        function REGLRenderbuffer(renderbuffer) {
            this.id = renderbufferCount++;
            this.refCount = 1;
            this.renderbuffer = renderbuffer;
            this.format = GL_RGBA4$1;
            this.width = 0;
            this.height = 0;
            if (config.profile) this.stats = {
                size: 0
            };
        }
        REGLRenderbuffer.prototype.decRef = function() {
            if (--this.refCount <= 0) destroy(this);
        };
        function destroy(rb) {
            var handle = rb.renderbuffer;
            check$1(handle, "must not double destroy renderbuffer");
            gl.bindRenderbuffer(GL_RENDERBUFFER, null);
            gl.deleteRenderbuffer(handle);
            rb.renderbuffer = null;
            rb.refCount = 0;
            delete renderbufferSet[rb.id];
            stats.renderbufferCount--;
        }
        function createRenderbuffer(a, b) {
            var renderbuffer = new REGLRenderbuffer(gl.createRenderbuffer());
            renderbufferSet[renderbuffer.id] = renderbuffer;
            stats.renderbufferCount++;
            function reglRenderbuffer(a, b) {
                var w = 0;
                var h = 0;
                var format = GL_RGBA4$1;
                if (typeof a === "object" && a) {
                    var options = a;
                    if ("shape" in options) {
                        var shape = options.shape;
                        check$1(Array.isArray(shape) && shape.length >= 2, "invalid renderbuffer shape");
                        w = shape[0] | 0;
                        h = shape[1] | 0;
                    } else {
                        if ("radius" in options) w = h = options.radius | 0;
                        if ("width" in options) w = options.width | 0;
                        if ("height" in options) h = options.height | 0;
                    }
                    if ("format" in options) {
                        check$1.parameter(options.format, formatTypes, "invalid renderbuffer format");
                        format = formatTypes[options.format];
                    }
                } else if (typeof a === "number") {
                    w = a | 0;
                    if (typeof b === "number") h = b | 0;
                    else h = w;
                } else if (!a) w = h = 1;
                else check$1.raise("invalid arguments to renderbuffer constructor");
                // check shape
                check$1(w > 0 && h > 0 && w <= limits.maxRenderbufferSize && h <= limits.maxRenderbufferSize, "invalid renderbuffer size");
                if (w === renderbuffer.width && h === renderbuffer.height && format === renderbuffer.format) return;
                reglRenderbuffer.width = renderbuffer.width = w;
                reglRenderbuffer.height = renderbuffer.height = h;
                renderbuffer.format = format;
                gl.bindRenderbuffer(GL_RENDERBUFFER, renderbuffer.renderbuffer);
                gl.renderbufferStorage(GL_RENDERBUFFER, format, w, h);
                check$1(gl.getError() === 0, "invalid render buffer format");
                if (config.profile) renderbuffer.stats.size = getRenderbufferSize(renderbuffer.format, renderbuffer.width, renderbuffer.height);
                reglRenderbuffer.format = formatTypesInvert[renderbuffer.format];
                return reglRenderbuffer;
            }
            function resize(w_, h_) {
                var w = w_ | 0;
                var h = h_ | 0 || w;
                if (w === renderbuffer.width && h === renderbuffer.height) return reglRenderbuffer;
                // check shape
                check$1(w > 0 && h > 0 && w <= limits.maxRenderbufferSize && h <= limits.maxRenderbufferSize, "invalid renderbuffer size");
                reglRenderbuffer.width = renderbuffer.width = w;
                reglRenderbuffer.height = renderbuffer.height = h;
                gl.bindRenderbuffer(GL_RENDERBUFFER, renderbuffer.renderbuffer);
                gl.renderbufferStorage(GL_RENDERBUFFER, renderbuffer.format, w, h);
                check$1(gl.getError() === 0, "invalid render buffer format");
                // also, recompute size.
                if (config.profile) renderbuffer.stats.size = getRenderbufferSize(renderbuffer.format, renderbuffer.width, renderbuffer.height);
                return reglRenderbuffer;
            }
            reglRenderbuffer(a, b);
            reglRenderbuffer.resize = resize;
            reglRenderbuffer._reglType = "renderbuffer";
            reglRenderbuffer._renderbuffer = renderbuffer;
            if (config.profile) reglRenderbuffer.stats = renderbuffer.stats;
            reglRenderbuffer.destroy = function() {
                renderbuffer.decRef();
            };
            return reglRenderbuffer;
        }
        if (config.profile) stats.getTotalRenderbufferSize = function() {
            var total = 0;
            Object.keys(renderbufferSet).forEach(function(key) {
                total += renderbufferSet[key].stats.size;
            });
            return total;
        };
        function restoreRenderbuffers() {
            values(renderbufferSet).forEach(function(rb) {
                rb.renderbuffer = gl.createRenderbuffer();
                gl.bindRenderbuffer(GL_RENDERBUFFER, rb.renderbuffer);
                gl.renderbufferStorage(GL_RENDERBUFFER, rb.format, rb.width, rb.height);
            });
            gl.bindRenderbuffer(GL_RENDERBUFFER, null);
        }
        return {
            create: createRenderbuffer,
            clear: function() {
                values(renderbufferSet).forEach(destroy);
            },
            restore: restoreRenderbuffers
        };
    };
    // We store these constants so that the minifier can inline them
    var GL_FRAMEBUFFER$1 = 0x8D40;
    var GL_RENDERBUFFER$1 = 0x8D41;
    var GL_TEXTURE_2D$2 = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 = 0x8515;
    var GL_COLOR_ATTACHMENT0$1 = 0x8CE0;
    var GL_DEPTH_ATTACHMENT = 0x8D00;
    var GL_STENCIL_ATTACHMENT = 0x8D20;
    var GL_DEPTH_STENCIL_ATTACHMENT = 0x821A;
    var GL_FRAMEBUFFER_COMPLETE$1 = 0x8CD5;
    var GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT = 0x8CD6;
    var GL_FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT = 0x8CD7;
    var GL_FRAMEBUFFER_INCOMPLETE_DIMENSIONS = 0x8CD9;
    var GL_FRAMEBUFFER_UNSUPPORTED = 0x8CDD;
    var GL_HALF_FLOAT_OES$2 = 0x8D61;
    var GL_UNSIGNED_BYTE$6 = 0x1401;
    var GL_FLOAT$5 = 0x1406;
    var GL_RGB$1 = 0x1907;
    var GL_RGBA$2 = 0x1908;
    var GL_DEPTH_COMPONENT$1 = 0x1902;
    var colorTextureFormatEnums = [
        GL_RGB$1,
        GL_RGBA$2
    ];
    // for every texture format, store
    // the number of channels
    var textureFormatChannels = [];
    textureFormatChannels[GL_RGBA$2] = 4;
    textureFormatChannels[GL_RGB$1] = 3;
    // for every texture type, store
    // the size in bytes.
    var textureTypeSizes = [];
    textureTypeSizes[GL_UNSIGNED_BYTE$6] = 1;
    textureTypeSizes[GL_FLOAT$5] = 4;
    textureTypeSizes[GL_HALF_FLOAT_OES$2] = 2;
    var GL_RGBA4$2 = 0x8056;
    var GL_RGB5_A1$2 = 0x8057;
    var GL_RGB565$2 = 0x8D62;
    var GL_DEPTH_COMPONENT16$1 = 0x81A5;
    var GL_STENCIL_INDEX8$1 = 0x8D48;
    var GL_DEPTH_STENCIL$2 = 0x84F9;
    var GL_SRGB8_ALPHA8_EXT$1 = 0x8C43;
    var GL_RGBA32F_EXT$1 = 0x8814;
    var GL_RGBA16F_EXT$1 = 0x881A;
    var GL_RGB16F_EXT$1 = 0x881B;
    var colorRenderbufferFormatEnums = [
        GL_RGBA4$2,
        GL_RGB5_A1$2,
        GL_RGB565$2,
        GL_SRGB8_ALPHA8_EXT$1,
        GL_RGBA16F_EXT$1,
        GL_RGB16F_EXT$1,
        GL_RGBA32F_EXT$1
    ];
    var statusCode = {};
    statusCode[GL_FRAMEBUFFER_COMPLETE$1] = "complete";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT] = "incomplete attachment";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_DIMENSIONS] = "incomplete dimensions";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT] = "incomplete, missing attachment";
    statusCode[GL_FRAMEBUFFER_UNSUPPORTED] = "unsupported";
    function wrapFBOState(gl, extensions, limits, textureState, renderbufferState, stats) {
        var framebufferState = {
            cur: null,
            next: null,
            dirty: false,
            setFBO: null
        };
        var colorTextureFormats = [
            "rgba"
        ];
        var colorRenderbufferFormats = [
            "rgba4",
            "rgb565",
            "rgb5 a1"
        ];
        if (extensions.ext_srgb) colorRenderbufferFormats.push("srgba");
        if (extensions.ext_color_buffer_half_float) colorRenderbufferFormats.push("rgba16f", "rgb16f");
        if (extensions.webgl_color_buffer_float) colorRenderbufferFormats.push("rgba32f");
        var colorTypes = [
            "uint8"
        ];
        if (extensions.oes_texture_half_float) colorTypes.push("half float", "float16");
        if (extensions.oes_texture_float) colorTypes.push("float", "float32");
        function FramebufferAttachment(target, texture, renderbuffer) {
            this.target = target;
            this.texture = texture;
            this.renderbuffer = renderbuffer;
            var w = 0;
            var h = 0;
            if (texture) {
                w = texture.width;
                h = texture.height;
            } else if (renderbuffer) {
                w = renderbuffer.width;
                h = renderbuffer.height;
            }
            this.width = w;
            this.height = h;
        }
        function decRef(attachment) {
            if (attachment) {
                if (attachment.texture) attachment.texture._texture.decRef();
                if (attachment.renderbuffer) attachment.renderbuffer._renderbuffer.decRef();
            }
        }
        function incRefAndCheckShape(attachment, width, height) {
            if (!attachment) return;
            if (attachment.texture) {
                var texture = attachment.texture._texture;
                var tw = Math.max(1, texture.width);
                var th = Math.max(1, texture.height);
                check$1(tw === width && th === height, "inconsistent width/height for supplied texture");
                texture.refCount += 1;
            } else {
                var renderbuffer = attachment.renderbuffer._renderbuffer;
                check$1(renderbuffer.width === width && renderbuffer.height === height, "inconsistent width/height for renderbuffer");
                renderbuffer.refCount += 1;
            }
        }
        function attach(location, attachment) {
            if (attachment) {
                if (attachment.texture) gl.framebufferTexture2D(GL_FRAMEBUFFER$1, location, attachment.target, attachment.texture._texture.texture, 0);
                else gl.framebufferRenderbuffer(GL_FRAMEBUFFER$1, location, GL_RENDERBUFFER$1, attachment.renderbuffer._renderbuffer.renderbuffer);
            }
        }
        function parseAttachment(attachment) {
            var target = GL_TEXTURE_2D$2;
            var texture = null;
            var renderbuffer = null;
            var data = attachment;
            if (typeof attachment === "object") {
                data = attachment.data;
                if ("target" in attachment) target = attachment.target | 0;
            }
            check$1.type(data, "function", "invalid attachment data");
            var type = data._reglType;
            if (type === "texture2d") {
                texture = data;
                check$1(target === GL_TEXTURE_2D$2);
            } else if (type === "textureCube") {
                texture = data;
                check$1(target >= GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 && target < GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 + 6, "invalid cube map target");
            } else if (type === "renderbuffer") {
                renderbuffer = data;
                target = GL_RENDERBUFFER$1;
            } else check$1.raise("invalid regl object for attachment");
            return new FramebufferAttachment(target, texture, renderbuffer);
        }
        function allocAttachment(width, height, isTexture, format, type) {
            if (isTexture) {
                var texture = textureState.create2D({
                    width: width,
                    height: height,
                    format: format,
                    type: type
                });
                texture._texture.refCount = 0;
                return new FramebufferAttachment(GL_TEXTURE_2D$2, texture, null);
            } else {
                var rb = renderbufferState.create({
                    width: width,
                    height: height,
                    format: format
                });
                rb._renderbuffer.refCount = 0;
                return new FramebufferAttachment(GL_RENDERBUFFER$1, null, rb);
            }
        }
        function unwrapAttachment(attachment) {
            return attachment && (attachment.texture || attachment.renderbuffer);
        }
        function resizeAttachment(attachment, w, h) {
            if (attachment) {
                if (attachment.texture) attachment.texture.resize(w, h);
                else if (attachment.renderbuffer) attachment.renderbuffer.resize(w, h);
                attachment.width = w;
                attachment.height = h;
            }
        }
        var framebufferCount = 0;
        var framebufferSet = {};
        function REGLFramebuffer() {
            this.id = framebufferCount++;
            framebufferSet[this.id] = this;
            this.framebuffer = gl.createFramebuffer();
            this.width = 0;
            this.height = 0;
            this.colorAttachments = [];
            this.depthAttachment = null;
            this.stencilAttachment = null;
            this.depthStencilAttachment = null;
        }
        function decFBORefs(framebuffer) {
            framebuffer.colorAttachments.forEach(decRef);
            decRef(framebuffer.depthAttachment);
            decRef(framebuffer.stencilAttachment);
            decRef(framebuffer.depthStencilAttachment);
        }
        function destroy(framebuffer) {
            var handle = framebuffer.framebuffer;
            check$1(handle, "must not double destroy framebuffer");
            gl.deleteFramebuffer(handle);
            framebuffer.framebuffer = null;
            stats.framebufferCount--;
            delete framebufferSet[framebuffer.id];
        }
        function updateFramebuffer(framebuffer) {
            var i;
            gl.bindFramebuffer(GL_FRAMEBUFFER$1, framebuffer.framebuffer);
            var colorAttachments = framebuffer.colorAttachments;
            for(i = 0; i < colorAttachments.length; ++i)attach(GL_COLOR_ATTACHMENT0$1 + i, colorAttachments[i]);
            for(i = colorAttachments.length; i < limits.maxColorAttachments; ++i)gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_COLOR_ATTACHMENT0$1 + i, GL_TEXTURE_2D$2, null, 0);
            gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_DEPTH_STENCIL_ATTACHMENT, GL_TEXTURE_2D$2, null, 0);
            gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_DEPTH_ATTACHMENT, GL_TEXTURE_2D$2, null, 0);
            gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_STENCIL_ATTACHMENT, GL_TEXTURE_2D$2, null, 0);
            attach(GL_DEPTH_ATTACHMENT, framebuffer.depthAttachment);
            attach(GL_STENCIL_ATTACHMENT, framebuffer.stencilAttachment);
            attach(GL_DEPTH_STENCIL_ATTACHMENT, framebuffer.depthStencilAttachment);
            // Check status code
            var status = gl.checkFramebufferStatus(GL_FRAMEBUFFER$1);
            if (!gl.isContextLost() && status !== GL_FRAMEBUFFER_COMPLETE$1) check$1.raise("framebuffer configuration not supported, status = " + statusCode[status]);
            gl.bindFramebuffer(GL_FRAMEBUFFER$1, framebufferState.next ? framebufferState.next.framebuffer : null);
            framebufferState.cur = framebufferState.next;
            // FIXME: Clear error code here.  This is a work around for a bug in
            // headless-gl
            gl.getError();
        }
        function createFBO(a0, a1) {
            var framebuffer = new REGLFramebuffer();
            stats.framebufferCount++;
            function reglFramebuffer(a, b) {
                var i;
                check$1(framebufferState.next !== framebuffer, "can not update framebuffer which is currently in use");
                var width = 0;
                var height = 0;
                var needsDepth = true;
                var needsStencil = true;
                var colorBuffer = null;
                var colorTexture = true;
                var colorFormat = "rgba";
                var colorType = "uint8";
                var colorCount = 1;
                var depthBuffer = null;
                var stencilBuffer = null;
                var depthStencilBuffer = null;
                var depthStencilTexture = false;
                if (typeof a === "number") {
                    width = a | 0;
                    height = b | 0 || width;
                } else if (!a) width = height = 1;
                else {
                    check$1.type(a, "object", "invalid arguments for framebuffer");
                    var options = a;
                    if ("shape" in options) {
                        var shape = options.shape;
                        check$1(Array.isArray(shape) && shape.length >= 2, "invalid shape for framebuffer");
                        width = shape[0];
                        height = shape[1];
                    } else {
                        if ("radius" in options) width = height = options.radius;
                        if ("width" in options) width = options.width;
                        if ("height" in options) height = options.height;
                    }
                    if ("color" in options || "colors" in options) {
                        colorBuffer = options.color || options.colors;
                        if (Array.isArray(colorBuffer)) check$1(colorBuffer.length === 1 || extensions.webgl_draw_buffers, "multiple render targets not supported");
                    }
                    if (!colorBuffer) {
                        if ("colorCount" in options) {
                            colorCount = options.colorCount | 0;
                            check$1(colorCount > 0, "invalid color buffer count");
                        }
                        if ("colorTexture" in options) {
                            colorTexture = !!options.colorTexture;
                            colorFormat = "rgba4";
                        }
                        if ("colorType" in options) {
                            colorType = options.colorType;
                            if (!colorTexture) {
                                if (colorType === "half float" || colorType === "float16") {
                                    check$1(extensions.ext_color_buffer_half_float, "you must enable EXT_color_buffer_half_float to use 16-bit render buffers");
                                    colorFormat = "rgba16f";
                                } else if (colorType === "float" || colorType === "float32") {
                                    check$1(extensions.webgl_color_buffer_float, "you must enable WEBGL_color_buffer_float in order to use 32-bit floating point renderbuffers");
                                    colorFormat = "rgba32f";
                                }
                            } else {
                                check$1(extensions.oes_texture_float || !(colorType === "float" || colorType === "float32"), "you must enable OES_texture_float in order to use floating point framebuffer objects");
                                check$1(extensions.oes_texture_half_float || !(colorType === "half float" || colorType === "float16"), "you must enable OES_texture_half_float in order to use 16-bit floating point framebuffer objects");
                            }
                            check$1.oneOf(colorType, colorTypes, "invalid color type");
                        }
                        if ("colorFormat" in options) {
                            colorFormat = options.colorFormat;
                            if (colorTextureFormats.indexOf(colorFormat) >= 0) colorTexture = true;
                            else if (colorRenderbufferFormats.indexOf(colorFormat) >= 0) colorTexture = false;
                            else check$1.optional(function() {
                                if (colorTexture) check$1.oneOf(options.colorFormat, colorTextureFormats, "invalid color format for texture");
                                else check$1.oneOf(options.colorFormat, colorRenderbufferFormats, "invalid color format for renderbuffer");
                            });
                        }
                    }
                    if ("depthTexture" in options || "depthStencilTexture" in options) {
                        depthStencilTexture = !!(options.depthTexture || options.depthStencilTexture);
                        check$1(!depthStencilTexture || extensions.webgl_depth_texture, "webgl_depth_texture extension not supported");
                    }
                    if ("depth" in options) {
                        if (typeof options.depth === "boolean") needsDepth = options.depth;
                        else {
                            depthBuffer = options.depth;
                            needsStencil = false;
                        }
                    }
                    if ("stencil" in options) {
                        if (typeof options.stencil === "boolean") needsStencil = options.stencil;
                        else {
                            stencilBuffer = options.stencil;
                            needsDepth = false;
                        }
                    }
                    if ("depthStencil" in options) {
                        if (typeof options.depthStencil === "boolean") needsDepth = needsStencil = options.depthStencil;
                        else {
                            depthStencilBuffer = options.depthStencil;
                            needsDepth = false;
                            needsStencil = false;
                        }
                    }
                }
                // parse attachments
                var colorAttachments = null;
                var depthAttachment = null;
                var stencilAttachment = null;
                var depthStencilAttachment = null;
                // Set up color attachments
                if (Array.isArray(colorBuffer)) colorAttachments = colorBuffer.map(parseAttachment);
                else if (colorBuffer) colorAttachments = [
                    parseAttachment(colorBuffer)
                ];
                else {
                    colorAttachments = new Array(colorCount);
                    for(i = 0; i < colorCount; ++i)colorAttachments[i] = allocAttachment(width, height, colorTexture, colorFormat, colorType);
                }
                check$1(extensions.webgl_draw_buffers || colorAttachments.length <= 1, "you must enable the WEBGL_draw_buffers extension in order to use multiple color buffers.");
                check$1(colorAttachments.length <= limits.maxColorAttachments, "too many color attachments, not supported");
                width = width || colorAttachments[0].width;
                height = height || colorAttachments[0].height;
                if (depthBuffer) depthAttachment = parseAttachment(depthBuffer);
                else if (needsDepth && !needsStencil) depthAttachment = allocAttachment(width, height, depthStencilTexture, "depth", "uint32");
                if (stencilBuffer) stencilAttachment = parseAttachment(stencilBuffer);
                else if (needsStencil && !needsDepth) stencilAttachment = allocAttachment(width, height, false, "stencil", "uint8");
                if (depthStencilBuffer) depthStencilAttachment = parseAttachment(depthStencilBuffer);
                else if (!depthBuffer && !stencilBuffer && needsStencil && needsDepth) depthStencilAttachment = allocAttachment(width, height, depthStencilTexture, "depth stencil", "depth stencil");
                check$1(!!depthBuffer + !!stencilBuffer + !!depthStencilBuffer <= 1, "invalid framebuffer configuration, can specify exactly one depth/stencil attachment");
                var commonColorAttachmentSize = null;
                for(i = 0; i < colorAttachments.length; ++i){
                    incRefAndCheckShape(colorAttachments[i], width, height);
                    check$1(!colorAttachments[i] || colorAttachments[i].texture && colorTextureFormatEnums.indexOf(colorAttachments[i].texture._texture.format) >= 0 || colorAttachments[i].renderbuffer && colorRenderbufferFormatEnums.indexOf(colorAttachments[i].renderbuffer._renderbuffer.format) >= 0, "framebuffer color attachment " + i + " is invalid");
                    if (colorAttachments[i] && colorAttachments[i].texture) {
                        var colorAttachmentSize = textureFormatChannels[colorAttachments[i].texture._texture.format] * textureTypeSizes[colorAttachments[i].texture._texture.type];
                        if (commonColorAttachmentSize === null) commonColorAttachmentSize = colorAttachmentSize;
                        else // We need to make sure that all color attachments have the same number of bitplanes
                        // (that is, the same numer of bits per pixel)
                        // This is required by the GLES2.0 standard. See the beginning of Chapter 4 in that document.
                        check$1(commonColorAttachmentSize === colorAttachmentSize, "all color attachments much have the same number of bits per pixel.");
                    }
                }
                incRefAndCheckShape(depthAttachment, width, height);
                check$1(!depthAttachment || depthAttachment.texture && depthAttachment.texture._texture.format === GL_DEPTH_COMPONENT$1 || depthAttachment.renderbuffer && depthAttachment.renderbuffer._renderbuffer.format === GL_DEPTH_COMPONENT16$1, "invalid depth attachment for framebuffer object");
                incRefAndCheckShape(stencilAttachment, width, height);
                check$1(!stencilAttachment || stencilAttachment.renderbuffer && stencilAttachment.renderbuffer._renderbuffer.format === GL_STENCIL_INDEX8$1, "invalid stencil attachment for framebuffer object");
                incRefAndCheckShape(depthStencilAttachment, width, height);
                check$1(!depthStencilAttachment || depthStencilAttachment.texture && depthStencilAttachment.texture._texture.format === GL_DEPTH_STENCIL$2 || depthStencilAttachment.renderbuffer && depthStencilAttachment.renderbuffer._renderbuffer.format === GL_DEPTH_STENCIL$2, "invalid depth-stencil attachment for framebuffer object");
                // decrement references
                decFBORefs(framebuffer);
                framebuffer.width = width;
                framebuffer.height = height;
                framebuffer.colorAttachments = colorAttachments;
                framebuffer.depthAttachment = depthAttachment;
                framebuffer.stencilAttachment = stencilAttachment;
                framebuffer.depthStencilAttachment = depthStencilAttachment;
                reglFramebuffer.color = colorAttachments.map(unwrapAttachment);
                reglFramebuffer.depth = unwrapAttachment(depthAttachment);
                reglFramebuffer.stencil = unwrapAttachment(stencilAttachment);
                reglFramebuffer.depthStencil = unwrapAttachment(depthStencilAttachment);
                reglFramebuffer.width = framebuffer.width;
                reglFramebuffer.height = framebuffer.height;
                updateFramebuffer(framebuffer);
                return reglFramebuffer;
            }
            function resize(w_, h_) {
                check$1(framebufferState.next !== framebuffer, "can not resize a framebuffer which is currently in use");
                var w = Math.max(w_ | 0, 1);
                var h = Math.max(h_ | 0 || w, 1);
                if (w === framebuffer.width && h === framebuffer.height) return reglFramebuffer;
                // resize all buffers
                var colorAttachments = framebuffer.colorAttachments;
                for(var i = 0; i < colorAttachments.length; ++i)resizeAttachment(colorAttachments[i], w, h);
                resizeAttachment(framebuffer.depthAttachment, w, h);
                resizeAttachment(framebuffer.stencilAttachment, w, h);
                resizeAttachment(framebuffer.depthStencilAttachment, w, h);
                framebuffer.width = reglFramebuffer.width = w;
                framebuffer.height = reglFramebuffer.height = h;
                updateFramebuffer(framebuffer);
                return reglFramebuffer;
            }
            reglFramebuffer(a0, a1);
            return extend(reglFramebuffer, {
                resize: resize,
                _reglType: "framebuffer",
                _framebuffer: framebuffer,
                destroy: function() {
                    destroy(framebuffer);
                    decFBORefs(framebuffer);
                },
                use: function(block) {
                    framebufferState.setFBO({
                        framebuffer: reglFramebuffer
                    }, block);
                }
            });
        }
        function createCubeFBO(options) {
            var faces = Array(6);
            function reglFramebufferCube(a) {
                var i;
                check$1(faces.indexOf(framebufferState.next) < 0, "can not update framebuffer which is currently in use");
                var params = {
                    color: null
                };
                var radius = 0;
                var colorBuffer = null;
                var colorFormat = "rgba";
                var colorType = "uint8";
                var colorCount = 1;
                if (typeof a === "number") radius = a | 0;
                else if (!a) radius = 1;
                else {
                    check$1.type(a, "object", "invalid arguments for framebuffer");
                    var options = a;
                    if ("shape" in options) {
                        var shape = options.shape;
                        check$1(Array.isArray(shape) && shape.length >= 2, "invalid shape for framebuffer");
                        check$1(shape[0] === shape[1], "cube framebuffer must be square");
                        radius = shape[0];
                    } else {
                        if ("radius" in options) radius = options.radius | 0;
                        if ("width" in options) {
                            radius = options.width | 0;
                            if ("height" in options) check$1(options.height === radius, "must be square");
                        } else if ("height" in options) radius = options.height | 0;
                    }
                    if ("color" in options || "colors" in options) {
                        colorBuffer = options.color || options.colors;
                        if (Array.isArray(colorBuffer)) check$1(colorBuffer.length === 1 || extensions.webgl_draw_buffers, "multiple render targets not supported");
                    }
                    if (!colorBuffer) {
                        if ("colorCount" in options) {
                            colorCount = options.colorCount | 0;
                            check$1(colorCount > 0, "invalid color buffer count");
                        }
                        if ("colorType" in options) {
                            check$1.oneOf(options.colorType, colorTypes, "invalid color type");
                            colorType = options.colorType;
                        }
                        if ("colorFormat" in options) {
                            colorFormat = options.colorFormat;
                            check$1.oneOf(options.colorFormat, colorTextureFormats, "invalid color format for texture");
                        }
                    }
                    if ("depth" in options) params.depth = options.depth;
                    if ("stencil" in options) params.stencil = options.stencil;
                    if ("depthStencil" in options) params.depthStencil = options.depthStencil;
                }
                var colorCubes;
                if (colorBuffer) {
                    if (Array.isArray(colorBuffer)) {
                        colorCubes = [];
                        for(i = 0; i < colorBuffer.length; ++i)colorCubes[i] = colorBuffer[i];
                    } else colorCubes = [
                        colorBuffer
                    ];
                } else {
                    colorCubes = Array(colorCount);
                    var cubeMapParams = {
                        radius: radius,
                        format: colorFormat,
                        type: colorType
                    };
                    for(i = 0; i < colorCount; ++i)colorCubes[i] = textureState.createCube(cubeMapParams);
                }
                // Check color cubes
                params.color = Array(colorCubes.length);
                for(i = 0; i < colorCubes.length; ++i){
                    var cube = colorCubes[i];
                    check$1(typeof cube === "function" && cube._reglType === "textureCube", "invalid cube map");
                    radius = radius || cube.width;
                    check$1(cube.width === radius && cube.height === radius, "invalid cube map shape");
                    params.color[i] = {
                        target: GL_TEXTURE_CUBE_MAP_POSITIVE_X$2,
                        data: colorCubes[i]
                    };
                }
                for(i = 0; i < 6; ++i){
                    for(var j = 0; j < colorCubes.length; ++j)params.color[j].target = GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 + i;
                    // reuse depth-stencil attachments across all cube maps
                    if (i > 0) {
                        params.depth = faces[0].depth;
                        params.stencil = faces[0].stencil;
                        params.depthStencil = faces[0].depthStencil;
                    }
                    if (faces[i]) faces[i](params);
                    else faces[i] = createFBO(params);
                }
                return extend(reglFramebufferCube, {
                    width: radius,
                    height: radius,
                    color: colorCubes
                });
            }
            function resize(radius_) {
                var i;
                var radius = radius_ | 0;
                check$1(radius > 0 && radius <= limits.maxCubeMapSize, "invalid radius for cube fbo");
                if (radius === reglFramebufferCube.width) return reglFramebufferCube;
                var colors = reglFramebufferCube.color;
                for(i = 0; i < colors.length; ++i)colors[i].resize(radius);
                for(i = 0; i < 6; ++i)faces[i].resize(radius);
                reglFramebufferCube.width = reglFramebufferCube.height = radius;
                return reglFramebufferCube;
            }
            reglFramebufferCube(options);
            return extend(reglFramebufferCube, {
                faces: faces,
                resize: resize,
                _reglType: "framebufferCube",
                destroy: function() {
                    faces.forEach(function(f) {
                        f.destroy();
                    });
                }
            });
        }
        function restoreFramebuffers() {
            framebufferState.cur = null;
            framebufferState.next = null;
            framebufferState.dirty = true;
            values(framebufferSet).forEach(function(fb) {
                fb.framebuffer = gl.createFramebuffer();
                updateFramebuffer(fb);
            });
        }
        return extend(framebufferState, {
            getFramebuffer: function(object) {
                if (typeof object === "function" && object._reglType === "framebuffer") {
                    var fbo = object._framebuffer;
                    if (fbo instanceof REGLFramebuffer) return fbo;
                }
                return null;
            },
            create: createFBO,
            createCube: createCubeFBO,
            clear: function() {
                values(framebufferSet).forEach(destroy);
            },
            restore: restoreFramebuffers
        });
    }
    var GL_FLOAT$6 = 5126;
    var GL_ARRAY_BUFFER$1 = 34962;
    var GL_ELEMENT_ARRAY_BUFFER$1 = 34963;
    var VAO_OPTIONS = [
        "attributes",
        "elements",
        "offset",
        "count",
        "primitive",
        "instances"
    ];
    function AttributeRecord() {
        this.state = 0;
        this.x = 0.0;
        this.y = 0.0;
        this.z = 0.0;
        this.w = 0.0;
        this.buffer = null;
        this.size = 0;
        this.normalized = false;
        this.type = GL_FLOAT$6;
        this.offset = 0;
        this.stride = 0;
        this.divisor = 0;
    }
    function wrapAttributeState(gl, extensions, limits, stats, bufferState, elementState, drawState) {
        var NUM_ATTRIBUTES = limits.maxAttributes;
        var attributeBindings = new Array(NUM_ATTRIBUTES);
        for(var i = 0; i < NUM_ATTRIBUTES; ++i)attributeBindings[i] = new AttributeRecord();
        var vaoCount = 0;
        var vaoSet = {};
        var state = {
            Record: AttributeRecord,
            scope: {},
            state: attributeBindings,
            currentVAO: null,
            targetVAO: null,
            restore: extVAO() ? restoreVAO : function() {},
            createVAO: createVAO,
            getVAO: getVAO,
            destroyBuffer: destroyBuffer,
            setVAO: extVAO() ? setVAOEXT : setVAOEmulated,
            clear: extVAO() ? destroyVAOEXT : function() {}
        };
        function destroyBuffer(buffer) {
            for(var i = 0; i < attributeBindings.length; ++i){
                var record = attributeBindings[i];
                if (record.buffer === buffer) {
                    gl.disableVertexAttribArray(i);
                    record.buffer = null;
                }
            }
        }
        function extVAO() {
            return extensions.oes_vertex_array_object;
        }
        function extInstanced() {
            return extensions.angle_instanced_arrays;
        }
        function getVAO(vao) {
            if (typeof vao === "function" && vao._vao) return vao._vao;
            return null;
        }
        function setVAOEXT(vao) {
            if (vao === state.currentVAO) return;
            var ext = extVAO();
            if (vao) ext.bindVertexArrayOES(vao.vao);
            else ext.bindVertexArrayOES(null);
            state.currentVAO = vao;
        }
        function setVAOEmulated(vao) {
            if (vao === state.currentVAO) return;
            if (vao) vao.bindAttrs();
            else {
                var exti = extInstanced();
                for(var i = 0; i < attributeBindings.length; ++i){
                    var binding = attributeBindings[i];
                    if (binding.buffer) {
                        gl.enableVertexAttribArray(i);
                        binding.buffer.bind();
                        gl.vertexAttribPointer(i, binding.size, binding.type, binding.normalized, binding.stride, binding.offfset);
                        if (exti && binding.divisor) exti.vertexAttribDivisorANGLE(i, binding.divisor);
                    } else {
                        gl.disableVertexAttribArray(i);
                        gl.vertexAttrib4f(i, binding.x, binding.y, binding.z, binding.w);
                    }
                }
                if (drawState.elements) gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, drawState.elements.buffer.buffer);
                else gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, null);
            }
            state.currentVAO = vao;
        }
        function destroyVAOEXT() {
            values(vaoSet).forEach(function(vao) {
                vao.destroy();
            });
        }
        function REGLVAO() {
            this.id = ++vaoCount;
            this.attributes = [];
            this.elements = null;
            this.ownsElements = false;
            this.count = 0;
            this.offset = 0;
            this.instances = -1;
            this.primitive = 4;
            var extension = extVAO();
            if (extension) this.vao = extension.createVertexArrayOES();
            else this.vao = null;
            vaoSet[this.id] = this;
            this.buffers = [];
        }
        REGLVAO.prototype.bindAttrs = function() {
            var exti = extInstanced();
            var attributes = this.attributes;
            for(var i = 0; i < attributes.length; ++i){
                var attr = attributes[i];
                if (attr.buffer) {
                    gl.enableVertexAttribArray(i);
                    gl.bindBuffer(GL_ARRAY_BUFFER$1, attr.buffer.buffer);
                    gl.vertexAttribPointer(i, attr.size, attr.type, attr.normalized, attr.stride, attr.offset);
                    if (exti && attr.divisor) exti.vertexAttribDivisorANGLE(i, attr.divisor);
                } else {
                    gl.disableVertexAttribArray(i);
                    gl.vertexAttrib4f(i, attr.x, attr.y, attr.z, attr.w);
                }
            }
            for(var j = attributes.length; j < NUM_ATTRIBUTES; ++j)gl.disableVertexAttribArray(j);
            var elements = elementState.getElements(this.elements);
            if (elements) gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, elements.buffer.buffer);
            else gl.bindBuffer(GL_ELEMENT_ARRAY_BUFFER$1, null);
        };
        REGLVAO.prototype.refresh = function() {
            var ext = extVAO();
            if (ext) {
                ext.bindVertexArrayOES(this.vao);
                this.bindAttrs();
                state.currentVAO = null;
                ext.bindVertexArrayOES(null);
            }
        };
        REGLVAO.prototype.destroy = function() {
            if (this.vao) {
                var extension = extVAO();
                if (this === state.currentVAO) {
                    state.currentVAO = null;
                    extension.bindVertexArrayOES(null);
                }
                extension.deleteVertexArrayOES(this.vao);
                this.vao = null;
            }
            if (this.ownsElements) {
                this.elements.destroy();
                this.elements = null;
                this.ownsElements = false;
            }
            if (vaoSet[this.id]) {
                delete vaoSet[this.id];
                stats.vaoCount -= 1;
            }
        };
        function restoreVAO() {
            var ext = extVAO();
            if (ext) values(vaoSet).forEach(function(vao) {
                vao.refresh();
            });
        }
        function createVAO(_attr) {
            var vao = new REGLVAO();
            stats.vaoCount += 1;
            function updateVAO(options) {
                var attributes;
                if (Array.isArray(options)) {
                    attributes = options;
                    if (vao.elements && vao.ownsElements) vao.elements.destroy();
                    vao.elements = null;
                    vao.ownsElements = false;
                    vao.offset = 0;
                    vao.count = 0;
                    vao.instances = -1;
                    vao.primitive = 4;
                } else {
                    check$1(typeof options === "object", "invalid arguments for create vao");
                    check$1("attributes" in options, "must specify attributes for vao");
                    if (options.elements) {
                        var elements = options.elements;
                        if (vao.ownsElements) {
                            if (typeof elements === "function" && elements._reglType === "elements") {
                                vao.elements.destroy();
                                vao.ownsElements = false;
                            } else {
                                vao.elements(elements);
                                vao.ownsElements = false;
                            }
                        } else if (elementState.getElements(options.elements)) {
                            vao.elements = options.elements;
                            vao.ownsElements = false;
                        } else {
                            vao.elements = elementState.create(options.elements);
                            vao.ownsElements = true;
                        }
                    } else {
                        vao.elements = null;
                        vao.ownsElements = false;
                    }
                    attributes = options.attributes;
                    // set default vao
                    vao.offset = 0;
                    vao.count = -1;
                    vao.instances = -1;
                    vao.primitive = 4;
                    // copy element properties
                    if (vao.elements) {
                        vao.count = vao.elements._elements.vertCount;
                        vao.primitive = vao.elements._elements.primType;
                    }
                    if ("offset" in options) vao.offset = options.offset | 0;
                    if ("count" in options) vao.count = options.count | 0;
                    if ("instances" in options) vao.instances = options.instances | 0;
                    if ("primitive" in options) {
                        check$1(options.primitive in primTypes, "bad primitive type: " + options.primitive);
                        vao.primitive = primTypes[options.primitive];
                    }
                    check$1.optional(()=>{
                        var keys = Object.keys(options);
                        for(var i = 0; i < keys.length; ++i)check$1(VAO_OPTIONS.indexOf(keys[i]) >= 0, 'invalid option for vao: "' + keys[i] + '" valid options are ' + VAO_OPTIONS);
                    });
                    check$1(Array.isArray(attributes), "attributes must be an array");
                }
                check$1(attributes.length < NUM_ATTRIBUTES, "too many attributes");
                check$1(attributes.length > 0, "must specify at least one attribute");
                var bufUpdated = {};
                var nattributes = vao.attributes;
                nattributes.length = attributes.length;
                for(var i = 0; i < attributes.length; ++i){
                    var spec = attributes[i];
                    var rec = nattributes[i] = new AttributeRecord();
                    var data = spec.data || spec;
                    if (Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data)) {
                        var buf;
                        if (vao.buffers[i]) {
                            buf = vao.buffers[i];
                            if (isTypedArray(data) && buf._buffer.byteLength >= data.byteLength) buf.subdata(data);
                            else {
                                buf.destroy();
                                vao.buffers[i] = null;
                            }
                        }
                        if (!vao.buffers[i]) buf = vao.buffers[i] = bufferState.create(spec, GL_ARRAY_BUFFER$1, false, true);
                        rec.buffer = bufferState.getBuffer(buf);
                        rec.size = rec.buffer.dimension | 0;
                        rec.normalized = false;
                        rec.type = rec.buffer.dtype;
                        rec.offset = 0;
                        rec.stride = 0;
                        rec.divisor = 0;
                        rec.state = 1;
                        bufUpdated[i] = 1;
                    } else if (bufferState.getBuffer(spec)) {
                        rec.buffer = bufferState.getBuffer(spec);
                        rec.size = rec.buffer.dimension | 0;
                        rec.normalized = false;
                        rec.type = rec.buffer.dtype;
                        rec.offset = 0;
                        rec.stride = 0;
                        rec.divisor = 0;
                        rec.state = 1;
                    } else if (bufferState.getBuffer(spec.buffer)) {
                        rec.buffer = bufferState.getBuffer(spec.buffer);
                        rec.size = (+spec.size || rec.buffer.dimension) | 0;
                        rec.normalized = !!spec.normalized || false;
                        if ("type" in spec) {
                            check$1.parameter(spec.type, glTypes, "invalid buffer type");
                            rec.type = glTypes[spec.type];
                        } else rec.type = rec.buffer.dtype;
                        rec.offset = (spec.offset || 0) | 0;
                        rec.stride = (spec.stride || 0) | 0;
                        rec.divisor = (spec.divisor || 0) | 0;
                        rec.state = 1;
                        check$1(rec.size >= 1 && rec.size <= 4, "size must be between 1 and 4");
                        check$1(rec.offset >= 0, "invalid offset");
                        check$1(rec.stride >= 0 && rec.stride <= 255, "stride must be between 0 and 255");
                        check$1(rec.divisor >= 0, "divisor must be positive");
                        check$1(!rec.divisor || !!extensions.angle_instanced_arrays, "ANGLE_instanced_arrays must be enabled to use divisor");
                    } else if ("x" in spec) {
                        check$1(i > 0, "first attribute must not be a constant");
                        rec.x = +spec.x || 0;
                        rec.y = +spec.y || 0;
                        rec.z = +spec.z || 0;
                        rec.w = +spec.w || 0;
                        rec.state = 2;
                    } else check$1(false, "invalid attribute spec for location " + i);
                }
                // retire unused buffers
                for(var j = 0; j < vao.buffers.length; ++j)if (!bufUpdated[j] && vao.buffers[j]) {
                    vao.buffers[j].destroy();
                    vao.buffers[j] = null;
                }
                vao.refresh();
                return updateVAO;
            }
            updateVAO.destroy = function() {
                for(var j = 0; j < vao.buffers.length; ++j)if (vao.buffers[j]) vao.buffers[j].destroy();
                vao.buffers.length = 0;
                if (vao.ownsElements) {
                    vao.elements.destroy();
                    vao.elements = null;
                    vao.ownsElements = false;
                }
                vao.destroy();
            };
            updateVAO._vao = vao;
            updateVAO._reglType = "vao";
            return updateVAO(_attr);
        }
        return state;
    }
    var GL_FRAGMENT_SHADER = 35632;
    var GL_VERTEX_SHADER = 35633;
    var GL_ACTIVE_UNIFORMS = 0x8B86;
    var GL_ACTIVE_ATTRIBUTES = 0x8B89;
    function wrapShaderState(gl, stringStore, stats, config) {
        // ===================================================
        // glsl compilation and linking
        // ===================================================
        var fragShaders = {};
        var vertShaders = {};
        function ActiveInfo(name, id, location, info) {
            this.name = name;
            this.id = id;
            this.location = location;
            this.info = info;
        }
        function insertActiveInfo(list, info) {
            for(var i = 0; i < list.length; ++i)if (list[i].id === info.id) {
                list[i].location = info.location;
                return;
            }
            list.push(info);
        }
        function getShader(type, id, command) {
            var cache = type === GL_FRAGMENT_SHADER ? fragShaders : vertShaders;
            var shader = cache[id];
            if (!shader) {
                var source = stringStore.str(id);
                shader = gl.createShader(type);
                gl.shaderSource(shader, source);
                gl.compileShader(shader);
                check$1.shaderError(gl, shader, source, type, command);
                cache[id] = shader;
            }
            return shader;
        }
        // ===================================================
        // program linking
        // ===================================================
        var programCache = {};
        var programList = [];
        var PROGRAM_COUNTER = 0;
        function REGLProgram(fragId, vertId) {
            this.id = PROGRAM_COUNTER++;
            this.fragId = fragId;
            this.vertId = vertId;
            this.program = null;
            this.uniforms = [];
            this.attributes = [];
            this.refCount = 1;
            if (config.profile) this.stats = {
                uniformsCount: 0,
                attributesCount: 0
            };
        }
        function linkProgram(desc, command, attributeLocations) {
            var i, info;
            // -------------------------------
            // compile & link
            // -------------------------------
            var fragShader = getShader(GL_FRAGMENT_SHADER, desc.fragId);
            var vertShader = getShader(GL_VERTEX_SHADER, desc.vertId);
            var program = desc.program = gl.createProgram();
            gl.attachShader(program, fragShader);
            gl.attachShader(program, vertShader);
            if (attributeLocations) for(i = 0; i < attributeLocations.length; ++i){
                var binding = attributeLocations[i];
                gl.bindAttribLocation(program, binding[0], binding[1]);
            }
            gl.linkProgram(program);
            check$1.linkError(gl, program, stringStore.str(desc.fragId), stringStore.str(desc.vertId), command);
            // -------------------------------
            // grab uniforms
            // -------------------------------
            var numUniforms = gl.getProgramParameter(program, GL_ACTIVE_UNIFORMS);
            if (config.profile) desc.stats.uniformsCount = numUniforms;
            var uniforms = desc.uniforms;
            for(i = 0; i < numUniforms; ++i){
                info = gl.getActiveUniform(program, i);
                if (info) {
                    if (info.size > 1) for(var j = 0; j < info.size; ++j){
                        var name = info.name.replace("[0]", "[" + j + "]");
                        insertActiveInfo(uniforms, new ActiveInfo(name, stringStore.id(name), gl.getUniformLocation(program, name), info));
                    }
                    var uniName = info.name;
                    if (info.size > 1) uniName = uniName.replace("[0]", "");
                    insertActiveInfo(uniforms, new ActiveInfo(uniName, stringStore.id(uniName), gl.getUniformLocation(program, uniName), info));
                }
            }
            // -------------------------------
            // grab attributes
            // -------------------------------
            var numAttributes = gl.getProgramParameter(program, GL_ACTIVE_ATTRIBUTES);
            if (config.profile) desc.stats.attributesCount = numAttributes;
            var attributes = desc.attributes;
            for(i = 0; i < numAttributes; ++i){
                info = gl.getActiveAttrib(program, i);
                if (info) insertActiveInfo(attributes, new ActiveInfo(info.name, stringStore.id(info.name), gl.getAttribLocation(program, info.name), info));
            }
        }
        if (config.profile) {
            stats.getMaxUniformsCount = function() {
                var m = 0;
                programList.forEach(function(desc) {
                    if (desc.stats.uniformsCount > m) m = desc.stats.uniformsCount;
                });
                return m;
            };
            stats.getMaxAttributesCount = function() {
                var m = 0;
                programList.forEach(function(desc) {
                    if (desc.stats.attributesCount > m) m = desc.stats.attributesCount;
                });
                return m;
            };
        }
        function restoreShaders() {
            fragShaders = {};
            vertShaders = {};
            for(var i = 0; i < programList.length; ++i)linkProgram(programList[i], null, programList[i].attributes.map(function(info) {
                return [
                    info.location,
                    info.name
                ];
            }));
        }
        return {
            clear: function() {
                var deleteShader = gl.deleteShader.bind(gl);
                values(fragShaders).forEach(deleteShader);
                fragShaders = {};
                values(vertShaders).forEach(deleteShader);
                vertShaders = {};
                programList.forEach(function(desc) {
                    gl.deleteProgram(desc.program);
                });
                programList.length = 0;
                programCache = {};
                stats.shaderCount = 0;
            },
            program: function(vertId, fragId, command, attribLocations) {
                check$1.command(vertId >= 0, "missing vertex shader", command);
                check$1.command(fragId >= 0, "missing fragment shader", command);
                var cache = programCache[fragId];
                if (!cache) cache = programCache[fragId] = {};
                var prevProgram = cache[vertId];
                if (prevProgram) {
                    prevProgram.refCount++;
                    if (!attribLocations) return prevProgram;
                }
                var program = new REGLProgram(fragId, vertId);
                stats.shaderCount++;
                linkProgram(program, command, attribLocations);
                if (!prevProgram) cache[vertId] = program;
                programList.push(program);
                return extend(program, {
                    destroy: function() {
                        program.refCount--;
                        if (program.refCount <= 0) {
                            gl.deleteProgram(program.program);
                            var idx = programList.indexOf(program);
                            programList.splice(idx, 1);
                            stats.shaderCount--;
                        }
                        // no program is linked to this vert anymore
                        if (cache[program.vertId].refCount <= 0) {
                            gl.deleteShader(vertShaders[program.vertId]);
                            delete vertShaders[program.vertId];
                            delete programCache[program.fragId][program.vertId];
                        }
                        // no program is linked to this frag anymore
                        if (!Object.keys(programCache[program.fragId]).length) {
                            gl.deleteShader(fragShaders[program.fragId]);
                            delete fragShaders[program.fragId];
                            delete programCache[program.fragId];
                        }
                    }
                });
            },
            restore: restoreShaders,
            shader: getShader,
            frag: -1,
            vert: -1
        };
    }
    var GL_RGBA$3 = 6408;
    var GL_UNSIGNED_BYTE$7 = 5121;
    var GL_PACK_ALIGNMENT = 0x0D05;
    var GL_FLOAT$7 = 0x1406 // 5126
    ;
    function wrapReadPixels(gl, framebufferState, reglPoll, context, glAttributes, extensions, limits) {
        function readPixelsImpl(input) {
            var type;
            if (framebufferState.next === null) {
                check$1(glAttributes.preserveDrawingBuffer, 'you must create a webgl context with "preserveDrawingBuffer":true in order to read pixels from the drawing buffer');
                type = GL_UNSIGNED_BYTE$7;
            } else {
                check$1(framebufferState.next.colorAttachments[0].texture !== null, "You cannot read from a renderbuffer");
                type = framebufferState.next.colorAttachments[0].texture._texture.type;
                check$1.optional(function() {
                    if (extensions.oes_texture_float) {
                        check$1(type === GL_UNSIGNED_BYTE$7 || type === GL_FLOAT$7, "Reading from a framebuffer is only allowed for the types 'uint8' and 'float'");
                        if (type === GL_FLOAT$7) check$1(limits.readFloat, "Reading 'float' values is not permitted in your browser. For a fallback, please see: https://www.npmjs.com/package/glsl-read-float");
                    } else check$1(type === GL_UNSIGNED_BYTE$7, "Reading from a framebuffer is only allowed for the type 'uint8'");
                });
            }
            var x = 0;
            var y = 0;
            var width = context.framebufferWidth;
            var height = context.framebufferHeight;
            var data = null;
            if (isTypedArray(input)) data = input;
            else if (input) {
                check$1.type(input, "object", "invalid arguments to regl.read()");
                x = input.x | 0;
                y = input.y | 0;
                check$1(x >= 0 && x < context.framebufferWidth, "invalid x offset for regl.read");
                check$1(y >= 0 && y < context.framebufferHeight, "invalid y offset for regl.read");
                width = (input.width || context.framebufferWidth - x) | 0;
                height = (input.height || context.framebufferHeight - y) | 0;
                data = input.data || null;
            }
            // sanity check input.data
            if (data) {
                if (type === GL_UNSIGNED_BYTE$7) check$1(data instanceof Uint8Array, "buffer must be 'Uint8Array' when reading from a framebuffer of type 'uint8'");
                else if (type === GL_FLOAT$7) check$1(data instanceof Float32Array, "buffer must be 'Float32Array' when reading from a framebuffer of type 'float'");
            }
            check$1(width > 0 && width + x <= context.framebufferWidth, "invalid width for read pixels");
            check$1(height > 0 && height + y <= context.framebufferHeight, "invalid height for read pixels");
            // Update WebGL state
            reglPoll();
            // Compute size
            var size = width * height * 4;
            // Allocate data
            if (!data) {
                if (type === GL_UNSIGNED_BYTE$7) data = new Uint8Array(size);
                else if (type === GL_FLOAT$7) data = data || new Float32Array(size);
            }
            // Type check
            check$1.isTypedArray(data, "data buffer for regl.read() must be a typedarray");
            check$1(data.byteLength >= size, "data buffer for regl.read() too small");
            // Run read pixels
            gl.pixelStorei(GL_PACK_ALIGNMENT, 4);
            gl.readPixels(x, y, width, height, GL_RGBA$3, type, data);
            return data;
        }
        function readPixelsFBO(options) {
            var result;
            framebufferState.setFBO({
                framebuffer: options.framebuffer
            }, function() {
                result = readPixelsImpl(options);
            });
            return result;
        }
        function readPixels(options) {
            if (!options || !("framebuffer" in options)) return readPixelsImpl(options);
            else return readPixelsFBO(options);
        }
        return readPixels;
    }
    function slice(x) {
        return Array.prototype.slice.call(x);
    }
    function join(x) {
        return slice(x).join("");
    }
    function createEnvironment() {
        // Unique variable id counter
        var varCounter = 0;
        // Linked values are passed from this scope into the generated code block
        // Calling link() passes a value into the generated scope and returns
        // the variable name which it is bound to
        var linkedNames = [];
        var linkedValues = [];
        function link(value) {
            for(var i = 0; i < linkedValues.length; ++i){
                if (linkedValues[i] === value) return linkedNames[i];
            }
            var name = "g" + varCounter++;
            linkedNames.push(name);
            linkedValues.push(value);
            return name;
        }
        // create a code block
        function block() {
            var code = [];
            function push() {
                code.push.apply(code, slice(arguments));
            }
            var vars = [];
            function def() {
                var name = "v" + varCounter++;
                vars.push(name);
                if (arguments.length > 0) {
                    code.push(name, "=");
                    code.push.apply(code, slice(arguments));
                    code.push(";");
                }
                return name;
            }
            return extend(push, {
                def: def,
                toString: function() {
                    return join([
                        vars.length > 0 ? "var " + vars.join(",") + ";" : "",
                        join(code)
                    ]);
                }
            });
        }
        function scope() {
            var entry = block();
            var exit = block();
            var entryToString = entry.toString;
            var exitToString = exit.toString;
            function save(object, prop) {
                exit(object, prop, "=", entry.def(object, prop), ";");
            }
            return extend(function() {
                entry.apply(entry, slice(arguments));
            }, {
                def: entry.def,
                entry: entry,
                exit: exit,
                save: save,
                set: function(object, prop, value) {
                    save(object, prop);
                    entry(object, prop, "=", value, ";");
                },
                toString: function() {
                    return entryToString() + exitToString();
                }
            });
        }
        function conditional() {
            var pred = join(arguments);
            var thenBlock = scope();
            var elseBlock = scope();
            var thenToString = thenBlock.toString;
            var elseToString = elseBlock.toString;
            return extend(thenBlock, {
                then: function() {
                    thenBlock.apply(thenBlock, slice(arguments));
                    return this;
                },
                else: function() {
                    elseBlock.apply(elseBlock, slice(arguments));
                    return this;
                },
                toString: function() {
                    var elseClause = elseToString();
                    if (elseClause) elseClause = "else{" + elseClause + "}";
                    return join([
                        "if(",
                        pred,
                        "){",
                        thenToString(),
                        "}",
                        elseClause
                    ]);
                }
            });
        }
        // procedure list
        var globalBlock = block();
        var procedures = {};
        function proc(name, count) {
            var args = [];
            function arg() {
                var name = "a" + args.length;
                args.push(name);
                return name;
            }
            count = count || 0;
            for(var i = 0; i < count; ++i)arg();
            var body = scope();
            var bodyToString = body.toString;
            var result = procedures[name] = extend(body, {
                arg: arg,
                toString: function() {
                    return join([
                        "function(",
                        args.join(),
                        "){",
                        bodyToString(),
                        "}"
                    ]);
                }
            });
            return result;
        }
        function compile() {
            var code = [
                '"use strict";',
                globalBlock,
                "return {"
            ];
            Object.keys(procedures).forEach(function(name) {
                code.push('"', name, '":', procedures[name].toString(), ",");
            });
            code.push("}");
            var src = join(code).replace(/;/g, ";\n").replace(/}/g, "}\n").replace(/{/g, "{\n");
            var proc = Function.apply(null, linkedNames.concat(src));
            return proc.apply(null, linkedValues);
        }
        return {
            global: globalBlock,
            link: link,
            block: block,
            proc: proc,
            scope: scope,
            cond: conditional,
            compile: compile
        };
    }
    // "cute" names for vector components
    var CUTE_COMPONENTS = "xyzw".split("");
    var GL_UNSIGNED_BYTE$8 = 5121;
    var ATTRIB_STATE_POINTER = 1;
    var ATTRIB_STATE_CONSTANT = 2;
    var DYN_FUNC$1 = 0;
    var DYN_PROP$1 = 1;
    var DYN_CONTEXT$1 = 2;
    var DYN_STATE$1 = 3;
    var DYN_THUNK = 4;
    var DYN_CONSTANT$1 = 5;
    var DYN_ARRAY$1 = 6;
    var S_DITHER = "dither";
    var S_BLEND_ENABLE = "blend.enable";
    var S_BLEND_COLOR = "blend.color";
    var S_BLEND_EQUATION = "blend.equation";
    var S_BLEND_FUNC = "blend.func";
    var S_DEPTH_ENABLE = "depth.enable";
    var S_DEPTH_FUNC = "depth.func";
    var S_DEPTH_RANGE = "depth.range";
    var S_DEPTH_MASK = "depth.mask";
    var S_COLOR_MASK = "colorMask";
    var S_CULL_ENABLE = "cull.enable";
    var S_CULL_FACE = "cull.face";
    var S_FRONT_FACE = "frontFace";
    var S_LINE_WIDTH = "lineWidth";
    var S_POLYGON_OFFSET_ENABLE = "polygonOffset.enable";
    var S_POLYGON_OFFSET_OFFSET = "polygonOffset.offset";
    var S_SAMPLE_ALPHA = "sample.alpha";
    var S_SAMPLE_ENABLE = "sample.enable";
    var S_SAMPLE_COVERAGE = "sample.coverage";
    var S_STENCIL_ENABLE = "stencil.enable";
    var S_STENCIL_MASK = "stencil.mask";
    var S_STENCIL_FUNC = "stencil.func";
    var S_STENCIL_OPFRONT = "stencil.opFront";
    var S_STENCIL_OPBACK = "stencil.opBack";
    var S_SCISSOR_ENABLE = "scissor.enable";
    var S_SCISSOR_BOX = "scissor.box";
    var S_VIEWPORT = "viewport";
    var S_PROFILE = "profile";
    var S_FRAMEBUFFER = "framebuffer";
    var S_VERT = "vert";
    var S_FRAG = "frag";
    var S_ELEMENTS = "elements";
    var S_PRIMITIVE = "primitive";
    var S_COUNT = "count";
    var S_OFFSET = "offset";
    var S_INSTANCES = "instances";
    var S_VAO = "vao";
    var SUFFIX_WIDTH = "Width";
    var SUFFIX_HEIGHT = "Height";
    var S_FRAMEBUFFER_WIDTH = S_FRAMEBUFFER + SUFFIX_WIDTH;
    var S_FRAMEBUFFER_HEIGHT = S_FRAMEBUFFER + SUFFIX_HEIGHT;
    var S_VIEWPORT_WIDTH = S_VIEWPORT + SUFFIX_WIDTH;
    var S_VIEWPORT_HEIGHT = S_VIEWPORT + SUFFIX_HEIGHT;
    var S_DRAWINGBUFFER = "drawingBuffer";
    var S_DRAWINGBUFFER_WIDTH = S_DRAWINGBUFFER + SUFFIX_WIDTH;
    var S_DRAWINGBUFFER_HEIGHT = S_DRAWINGBUFFER + SUFFIX_HEIGHT;
    var NESTED_OPTIONS = [
        S_BLEND_FUNC,
        S_BLEND_EQUATION,
        S_STENCIL_FUNC,
        S_STENCIL_OPFRONT,
        S_STENCIL_OPBACK,
        S_SAMPLE_COVERAGE,
        S_VIEWPORT,
        S_SCISSOR_BOX,
        S_POLYGON_OFFSET_OFFSET
    ];
    var GL_ARRAY_BUFFER$2 = 34962;
    var GL_ELEMENT_ARRAY_BUFFER$2 = 34963;
    var GL_FRAGMENT_SHADER$1 = 35632;
    var GL_VERTEX_SHADER$1 = 35633;
    var GL_TEXTURE_2D$3 = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP$2 = 0x8513;
    var GL_CULL_FACE = 0x0B44;
    var GL_BLEND = 0x0BE2;
    var GL_DITHER = 0x0BD0;
    var GL_STENCIL_TEST = 0x0B90;
    var GL_DEPTH_TEST = 0x0B71;
    var GL_SCISSOR_TEST = 0x0C11;
    var GL_POLYGON_OFFSET_FILL = 0x8037;
    var GL_SAMPLE_ALPHA_TO_COVERAGE = 0x809E;
    var GL_SAMPLE_COVERAGE = 0x80A0;
    var GL_FLOAT$8 = 5126;
    var GL_FLOAT_VEC2 = 35664;
    var GL_FLOAT_VEC3 = 35665;
    var GL_FLOAT_VEC4 = 35666;
    var GL_INT$3 = 5124;
    var GL_INT_VEC2 = 35667;
    var GL_INT_VEC3 = 35668;
    var GL_INT_VEC4 = 35669;
    var GL_BOOL = 35670;
    var GL_BOOL_VEC2 = 35671;
    var GL_BOOL_VEC3 = 35672;
    var GL_BOOL_VEC4 = 35673;
    var GL_FLOAT_MAT2 = 35674;
    var GL_FLOAT_MAT3 = 35675;
    var GL_FLOAT_MAT4 = 35676;
    var GL_SAMPLER_2D = 35678;
    var GL_SAMPLER_CUBE = 35680;
    var GL_TRIANGLES$1 = 4;
    var GL_FRONT = 1028;
    var GL_BACK = 1029;
    var GL_CW = 0x0900;
    var GL_CCW = 0x0901;
    var GL_MIN_EXT = 0x8007;
    var GL_MAX_EXT = 0x8008;
    var GL_ALWAYS = 519;
    var GL_KEEP = 7680;
    var GL_ZERO = 0;
    var GL_ONE = 1;
    var GL_FUNC_ADD = 0x8006;
    var GL_LESS = 513;
    var GL_FRAMEBUFFER$2 = 0x8D40;
    var GL_COLOR_ATTACHMENT0$2 = 0x8CE0;
    var blendFuncs = {
        "0": 0,
        "1": 1,
        "zero": 0,
        "one": 1,
        "src color": 768,
        "one minus src color": 769,
        "src alpha": 770,
        "one minus src alpha": 771,
        "dst color": 774,
        "one minus dst color": 775,
        "dst alpha": 772,
        "one minus dst alpha": 773,
        "constant color": 32769,
        "one minus constant color": 32770,
        "constant alpha": 32771,
        "one minus constant alpha": 32772,
        "src alpha saturate": 776
    };
    // There are invalid values for srcRGB and dstRGB. See:
    // https://www.khronos.org/registry/webgl/specs/1.0/#6.13
    // https://github.com/KhronosGroup/WebGL/blob/0d3201f5f7ec3c0060bc1f04077461541f1987b9/conformance-suites/1.0.3/conformance/misc/webgl-specific.html#L56
    var invalidBlendCombinations = [
        "constant color, constant alpha",
        "one minus constant color, constant alpha",
        "constant color, one minus constant alpha",
        "one minus constant color, one minus constant alpha",
        "constant alpha, constant color",
        "constant alpha, one minus constant color",
        "one minus constant alpha, constant color",
        "one minus constant alpha, one minus constant color"
    ];
    var compareFuncs = {
        "never": 512,
        "less": 513,
        "<": 513,
        "equal": 514,
        "=": 514,
        "==": 514,
        "===": 514,
        "lequal": 515,
        "<=": 515,
        "greater": 516,
        ">": 516,
        "notequal": 517,
        "!=": 517,
        "!==": 517,
        "gequal": 518,
        ">=": 518,
        "always": 519
    };
    var stencilOps = {
        "0": 0,
        "zero": 0,
        "keep": 7680,
        "replace": 7681,
        "increment": 7682,
        "decrement": 7683,
        "increment wrap": 34055,
        "decrement wrap": 34056,
        "invert": 5386
    };
    var shaderType = {
        "frag": GL_FRAGMENT_SHADER$1,
        "vert": GL_VERTEX_SHADER$1
    };
    var orientationType = {
        "cw": GL_CW,
        "ccw": GL_CCW
    };
    function isBufferArgs(x) {
        return Array.isArray(x) || isTypedArray(x) || isNDArrayLike(x);
    }
    // Make sure viewport is processed first
    function sortState(state) {
        return state.sort(function(a, b) {
            if (a === S_VIEWPORT) return -1;
            else if (b === S_VIEWPORT) return 1;
            return a < b ? -1 : 1;
        });
    }
    function Declaration(thisDep, contextDep, propDep, append) {
        this.thisDep = thisDep;
        this.contextDep = contextDep;
        this.propDep = propDep;
        this.append = append;
    }
    function isStatic(decl) {
        return decl && !(decl.thisDep || decl.contextDep || decl.propDep);
    }
    function createStaticDecl(append) {
        return new Declaration(false, false, false, append);
    }
    function createDynamicDecl(dyn, append) {
        var type = dyn.type;
        if (type === DYN_FUNC$1) {
            var numArgs = dyn.data.length;
            return new Declaration(true, numArgs >= 1, numArgs >= 2, append);
        } else if (type === DYN_THUNK) {
            var data = dyn.data;
            return new Declaration(data.thisDep, data.contextDep, data.propDep, append);
        } else if (type === DYN_CONSTANT$1) return new Declaration(false, false, false, append);
        else if (type === DYN_ARRAY$1) {
            var thisDep = false;
            var contextDep = false;
            var propDep = false;
            for(var i = 0; i < dyn.data.length; ++i){
                var subDyn = dyn.data[i];
                if (subDyn.type === DYN_PROP$1) propDep = true;
                else if (subDyn.type === DYN_CONTEXT$1) contextDep = true;
                else if (subDyn.type === DYN_STATE$1) thisDep = true;
                else if (subDyn.type === DYN_FUNC$1) {
                    thisDep = true;
                    var subArgs = subDyn.data;
                    if (subArgs >= 1) contextDep = true;
                    if (subArgs >= 2) propDep = true;
                } else if (subDyn.type === DYN_THUNK) {
                    thisDep = thisDep || subDyn.data.thisDep;
                    contextDep = contextDep || subDyn.data.contextDep;
                    propDep = propDep || subDyn.data.propDep;
                }
            }
            return new Declaration(thisDep, contextDep, propDep, append);
        } else return new Declaration(type === DYN_STATE$1, type === DYN_CONTEXT$1, type === DYN_PROP$1, append);
    }
    var SCOPE_DECL = new Declaration(false, false, false, function() {});
    function reglCore(gl, stringStore, extensions, limits, bufferState, elementState, textureState, framebufferState, uniformState, attributeState, shaderState, drawState, contextState, timer, config) {
        var AttributeRecord = attributeState.Record;
        var blendEquations = {
            "add": 32774,
            "subtract": 32778,
            "reverse subtract": 32779
        };
        if (extensions.ext_blend_minmax) {
            blendEquations.min = GL_MIN_EXT;
            blendEquations.max = GL_MAX_EXT;
        }
        var extInstancing = extensions.angle_instanced_arrays;
        var extDrawBuffers = extensions.webgl_draw_buffers;
        var extVertexArrays = extensions.oes_vertex_array_object;
        // ===================================================
        // ===================================================
        // WEBGL STATE
        // ===================================================
        // ===================================================
        var currentState = {
            dirty: true,
            profile: config.profile
        };
        var nextState = {};
        var GL_STATE_NAMES = [];
        var GL_FLAGS = {};
        var GL_VARIABLES = {};
        function propName(name) {
            return name.replace(".", "_");
        }
        function stateFlag(sname, cap, init) {
            var name = propName(sname);
            GL_STATE_NAMES.push(sname);
            nextState[name] = currentState[name] = !!init;
            GL_FLAGS[name] = cap;
        }
        function stateVariable(sname, func, init) {
            var name = propName(sname);
            GL_STATE_NAMES.push(sname);
            if (Array.isArray(init)) {
                currentState[name] = init.slice();
                nextState[name] = init.slice();
            } else currentState[name] = nextState[name] = init;
            GL_VARIABLES[name] = func;
        }
        // Dithering
        stateFlag(S_DITHER, GL_DITHER);
        // Blending
        stateFlag(S_BLEND_ENABLE, GL_BLEND);
        stateVariable(S_BLEND_COLOR, "blendColor", [
            0,
            0,
            0,
            0
        ]);
        stateVariable(S_BLEND_EQUATION, "blendEquationSeparate", [
            GL_FUNC_ADD,
            GL_FUNC_ADD
        ]);
        stateVariable(S_BLEND_FUNC, "blendFuncSeparate", [
            GL_ONE,
            GL_ZERO,
            GL_ONE,
            GL_ZERO
        ]);
        // Depth
        stateFlag(S_DEPTH_ENABLE, GL_DEPTH_TEST, true);
        stateVariable(S_DEPTH_FUNC, "depthFunc", GL_LESS);
        stateVariable(S_DEPTH_RANGE, "depthRange", [
            0,
            1
        ]);
        stateVariable(S_DEPTH_MASK, "depthMask", true);
        // Color mask
        stateVariable(S_COLOR_MASK, S_COLOR_MASK, [
            true,
            true,
            true,
            true
        ]);
        // Face culling
        stateFlag(S_CULL_ENABLE, GL_CULL_FACE);
        stateVariable(S_CULL_FACE, "cullFace", GL_BACK);
        // Front face orientation
        stateVariable(S_FRONT_FACE, S_FRONT_FACE, GL_CCW);
        // Line width
        stateVariable(S_LINE_WIDTH, S_LINE_WIDTH, 1);
        // Polygon offset
        stateFlag(S_POLYGON_OFFSET_ENABLE, GL_POLYGON_OFFSET_FILL);
        stateVariable(S_POLYGON_OFFSET_OFFSET, "polygonOffset", [
            0,
            0
        ]);
        // Sample coverage
        stateFlag(S_SAMPLE_ALPHA, GL_SAMPLE_ALPHA_TO_COVERAGE);
        stateFlag(S_SAMPLE_ENABLE, GL_SAMPLE_COVERAGE);
        stateVariable(S_SAMPLE_COVERAGE, "sampleCoverage", [
            1,
            false
        ]);
        // Stencil
        stateFlag(S_STENCIL_ENABLE, GL_STENCIL_TEST);
        stateVariable(S_STENCIL_MASK, "stencilMask", -1);
        stateVariable(S_STENCIL_FUNC, "stencilFunc", [
            GL_ALWAYS,
            0,
            -1
        ]);
        stateVariable(S_STENCIL_OPFRONT, "stencilOpSeparate", [
            GL_FRONT,
            GL_KEEP,
            GL_KEEP,
            GL_KEEP
        ]);
        stateVariable(S_STENCIL_OPBACK, "stencilOpSeparate", [
            GL_BACK,
            GL_KEEP,
            GL_KEEP,
            GL_KEEP
        ]);
        // Scissor
        stateFlag(S_SCISSOR_ENABLE, GL_SCISSOR_TEST);
        stateVariable(S_SCISSOR_BOX, "scissor", [
            0,
            0,
            gl.drawingBufferWidth,
            gl.drawingBufferHeight
        ]);
        // Viewport
        stateVariable(S_VIEWPORT, S_VIEWPORT, [
            0,
            0,
            gl.drawingBufferWidth,
            gl.drawingBufferHeight
        ]);
        // ===================================================
        // ===================================================
        // ENVIRONMENT
        // ===================================================
        // ===================================================
        var sharedState = {
            gl: gl,
            context: contextState,
            strings: stringStore,
            next: nextState,
            current: currentState,
            draw: drawState,
            elements: elementState,
            buffer: bufferState,
            shader: shaderState,
            attributes: attributeState.state,
            vao: attributeState,
            uniforms: uniformState,
            framebuffer: framebufferState,
            extensions: extensions,
            timer: timer,
            isBufferArgs: isBufferArgs
        };
        var sharedConstants = {
            primTypes: primTypes,
            compareFuncs: compareFuncs,
            blendFuncs: blendFuncs,
            blendEquations: blendEquations,
            stencilOps: stencilOps,
            glTypes: glTypes,
            orientationType: orientationType
        };
        check$1.optional(function() {
            sharedState.isArrayLike = isArrayLike;
        });
        if (extDrawBuffers) {
            sharedConstants.backBuffer = [
                GL_BACK
            ];
            sharedConstants.drawBuffer = loop(limits.maxDrawbuffers, function(i) {
                if (i === 0) return [
                    0
                ];
                return loop(i, function(j) {
                    return GL_COLOR_ATTACHMENT0$2 + j;
                });
            });
        }
        var drawCallCounter = 0;
        function createREGLEnvironment() {
            var env = createEnvironment();
            var link = env.link;
            var global = env.global;
            env.id = drawCallCounter++;
            env.batchId = "0";
            // link shared state
            var SHARED = link(sharedState);
            var shared = env.shared = {
                props: "a0"
            };
            Object.keys(sharedState).forEach(function(prop) {
                shared[prop] = global.def(SHARED, ".", prop);
            });
            // Inject runtime assertion stuff for debug builds
            check$1.optional(function() {
                env.CHECK = link(check$1);
                env.commandStr = check$1.guessCommand();
                env.command = link(env.commandStr);
                env.assert = function(block, pred, message) {
                    block("if(!(", pred, "))", this.CHECK, ".commandRaise(", link(message), ",", this.command, ");");
                };
                sharedConstants.invalidBlendCombinations = invalidBlendCombinations;
            });
            // Copy GL state variables over
            var nextVars = env.next = {};
            var currentVars = env.current = {};
            Object.keys(GL_VARIABLES).forEach(function(variable) {
                if (Array.isArray(currentState[variable])) {
                    nextVars[variable] = global.def(shared.next, ".", variable);
                    currentVars[variable] = global.def(shared.current, ".", variable);
                }
            });
            // Initialize shared constants
            var constants = env.constants = {};
            Object.keys(sharedConstants).forEach(function(name) {
                constants[name] = global.def(JSON.stringify(sharedConstants[name]));
            });
            // Helper function for calling a block
            env.invoke = function(block, x) {
                switch(x.type){
                    case DYN_FUNC$1:
                        var argList = [
                            "this",
                            shared.context,
                            shared.props,
                            env.batchId
                        ];
                        return block.def(link(x.data), ".call(", argList.slice(0, Math.max(x.data.length + 1, 4)), ")");
                    case DYN_PROP$1:
                        return block.def(shared.props, x.data);
                    case DYN_CONTEXT$1:
                        return block.def(shared.context, x.data);
                    case DYN_STATE$1:
                        return block.def("this", x.data);
                    case DYN_THUNK:
                        x.data.append(env, block);
                        return x.data.ref;
                    case DYN_CONSTANT$1:
                        return x.data.toString();
                    case DYN_ARRAY$1:
                        return x.data.map(function(y) {
                            return env.invoke(block, y);
                        });
                }
            };
            env.attribCache = {};
            var scopeAttribs = {};
            env.scopeAttrib = function(name) {
                var id = stringStore.id(name);
                if (id in scopeAttribs) return scopeAttribs[id];
                var binding = attributeState.scope[id];
                if (!binding) binding = attributeState.scope[id] = new AttributeRecord();
                var result = scopeAttribs[id] = link(binding);
                return result;
            };
            return env;
        }
        // ===================================================
        // ===================================================
        // PARSING
        // ===================================================
        // ===================================================
        function parseProfile(options) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            var profileEnable;
            if (S_PROFILE in staticOptions) {
                var value = !!staticOptions[S_PROFILE];
                profileEnable = createStaticDecl(function(env, scope) {
                    return value;
                });
                profileEnable.enable = value;
            } else if (S_PROFILE in dynamicOptions) {
                var dyn = dynamicOptions[S_PROFILE];
                profileEnable = createDynamicDecl(dyn, function(env, scope) {
                    return env.invoke(scope, dyn);
                });
            }
            return profileEnable;
        }
        function parseFramebuffer(options, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            if (S_FRAMEBUFFER in staticOptions) {
                var framebuffer = staticOptions[S_FRAMEBUFFER];
                if (framebuffer) {
                    framebuffer = framebufferState.getFramebuffer(framebuffer);
                    check$1.command(framebuffer, "invalid framebuffer object");
                    return createStaticDecl(function(env, block) {
                        var FRAMEBUFFER = env.link(framebuffer);
                        var shared = env.shared;
                        block.set(shared.framebuffer, ".next", FRAMEBUFFER);
                        var CONTEXT = shared.context;
                        block.set(CONTEXT, "." + S_FRAMEBUFFER_WIDTH, FRAMEBUFFER + ".width");
                        block.set(CONTEXT, "." + S_FRAMEBUFFER_HEIGHT, FRAMEBUFFER + ".height");
                        return FRAMEBUFFER;
                    });
                } else return createStaticDecl(function(env, scope) {
                    var shared = env.shared;
                    scope.set(shared.framebuffer, ".next", "null");
                    var CONTEXT = shared.context;
                    scope.set(CONTEXT, "." + S_FRAMEBUFFER_WIDTH, CONTEXT + "." + S_DRAWINGBUFFER_WIDTH);
                    scope.set(CONTEXT, "." + S_FRAMEBUFFER_HEIGHT, CONTEXT + "." + S_DRAWINGBUFFER_HEIGHT);
                    return "null";
                });
            } else if (S_FRAMEBUFFER in dynamicOptions) {
                var dyn = dynamicOptions[S_FRAMEBUFFER];
                return createDynamicDecl(dyn, function(env, scope) {
                    var FRAMEBUFFER_FUNC = env.invoke(scope, dyn);
                    var shared = env.shared;
                    var FRAMEBUFFER_STATE = shared.framebuffer;
                    var FRAMEBUFFER = scope.def(FRAMEBUFFER_STATE, ".getFramebuffer(", FRAMEBUFFER_FUNC, ")");
                    check$1.optional(function() {
                        env.assert(scope, "!" + FRAMEBUFFER_FUNC + "||" + FRAMEBUFFER, "invalid framebuffer object");
                    });
                    scope.set(FRAMEBUFFER_STATE, ".next", FRAMEBUFFER);
                    var CONTEXT = shared.context;
                    scope.set(CONTEXT, "." + S_FRAMEBUFFER_WIDTH, FRAMEBUFFER + "?" + FRAMEBUFFER + ".width:" + CONTEXT + "." + S_DRAWINGBUFFER_WIDTH);
                    scope.set(CONTEXT, "." + S_FRAMEBUFFER_HEIGHT, FRAMEBUFFER + "?" + FRAMEBUFFER + ".height:" + CONTEXT + "." + S_DRAWINGBUFFER_HEIGHT);
                    return FRAMEBUFFER;
                });
            } else return null;
        }
        function parseViewportScissor(options, framebuffer, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            function parseBox(param) {
                if (param in staticOptions) {
                    var box = staticOptions[param];
                    check$1.commandType(box, "object", "invalid " + param, env.commandStr);
                    var isStatic = true;
                    var x = box.x | 0;
                    var y = box.y | 0;
                    var w, h;
                    if ("width" in box) {
                        w = box.width | 0;
                        check$1.command(w >= 0, "invalid " + param, env.commandStr);
                    } else isStatic = false;
                    if ("height" in box) {
                        h = box.height | 0;
                        check$1.command(h >= 0, "invalid " + param, env.commandStr);
                    } else isStatic = false;
                    return new Declaration(!isStatic && framebuffer && framebuffer.thisDep, !isStatic && framebuffer && framebuffer.contextDep, !isStatic && framebuffer && framebuffer.propDep, function(env, scope) {
                        var CONTEXT = env.shared.context;
                        var BOX_W = w;
                        if (!("width" in box)) BOX_W = scope.def(CONTEXT, ".", S_FRAMEBUFFER_WIDTH, "-", x);
                        var BOX_H = h;
                        if (!("height" in box)) BOX_H = scope.def(CONTEXT, ".", S_FRAMEBUFFER_HEIGHT, "-", y);
                        return [
                            x,
                            y,
                            BOX_W,
                            BOX_H
                        ];
                    });
                } else if (param in dynamicOptions) {
                    var dynBox = dynamicOptions[param];
                    var result = createDynamicDecl(dynBox, function(env, scope) {
                        var BOX = env.invoke(scope, dynBox);
                        check$1.optional(function() {
                            env.assert(scope, BOX + "&&typeof " + BOX + '==="object"', "invalid " + param);
                        });
                        var CONTEXT = env.shared.context;
                        var BOX_X = scope.def(BOX, ".x|0");
                        var BOX_Y = scope.def(BOX, ".y|0");
                        var BOX_W = scope.def('"width" in ', BOX, "?", BOX, ".width|0:", "(", CONTEXT, ".", S_FRAMEBUFFER_WIDTH, "-", BOX_X, ")");
                        var BOX_H = scope.def('"height" in ', BOX, "?", BOX, ".height|0:", "(", CONTEXT, ".", S_FRAMEBUFFER_HEIGHT, "-", BOX_Y, ")");
                        check$1.optional(function() {
                            env.assert(scope, BOX_W + ">=0&&" + BOX_H + ">=0", "invalid " + param);
                        });
                        return [
                            BOX_X,
                            BOX_Y,
                            BOX_W,
                            BOX_H
                        ];
                    });
                    if (framebuffer) {
                        result.thisDep = result.thisDep || framebuffer.thisDep;
                        result.contextDep = result.contextDep || framebuffer.contextDep;
                        result.propDep = result.propDep || framebuffer.propDep;
                    }
                    return result;
                } else if (framebuffer) return new Declaration(framebuffer.thisDep, framebuffer.contextDep, framebuffer.propDep, function(env, scope) {
                    var CONTEXT = env.shared.context;
                    return [
                        0,
                        0,
                        scope.def(CONTEXT, ".", S_FRAMEBUFFER_WIDTH),
                        scope.def(CONTEXT, ".", S_FRAMEBUFFER_HEIGHT)
                    ];
                });
                else return null;
            }
            var viewport = parseBox(S_VIEWPORT);
            if (viewport) {
                var prevViewport = viewport;
                viewport = new Declaration(viewport.thisDep, viewport.contextDep, viewport.propDep, function(env, scope) {
                    var VIEWPORT = prevViewport.append(env, scope);
                    var CONTEXT = env.shared.context;
                    scope.set(CONTEXT, "." + S_VIEWPORT_WIDTH, VIEWPORT[2]);
                    scope.set(CONTEXT, "." + S_VIEWPORT_HEIGHT, VIEWPORT[3]);
                    return VIEWPORT;
                });
            }
            return {
                viewport: viewport,
                scissor_box: parseBox(S_SCISSOR_BOX)
            };
        }
        function parseAttribLocations(options, attributes) {
            var staticOptions = options.static;
            var staticProgram = typeof staticOptions[S_FRAG] === "string" && typeof staticOptions[S_VERT] === "string";
            if (staticProgram) {
                if (Object.keys(attributes.dynamic).length > 0) return null;
                var staticAttributes = attributes.static;
                var sAttributes = Object.keys(staticAttributes);
                if (sAttributes.length > 0 && typeof staticAttributes[sAttributes[0]] === "number") {
                    var bindings = [];
                    for(var i = 0; i < sAttributes.length; ++i){
                        check$1(typeof staticAttributes[sAttributes[i]] === "number", "must specify all vertex attribute locations when using vaos");
                        bindings.push([
                            staticAttributes[sAttributes[i]] | 0,
                            sAttributes[i]
                        ]);
                    }
                    return bindings;
                }
            }
            return null;
        }
        function parseProgram(options, env, attribLocations) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            function parseShader(name) {
                if (name in staticOptions) {
                    var id = stringStore.id(staticOptions[name]);
                    check$1.optional(function() {
                        shaderState.shader(shaderType[name], id, check$1.guessCommand());
                    });
                    var result = createStaticDecl(function() {
                        return id;
                    });
                    result.id = id;
                    return result;
                } else if (name in dynamicOptions) {
                    var dyn = dynamicOptions[name];
                    return createDynamicDecl(dyn, function(env, scope) {
                        var str = env.invoke(scope, dyn);
                        var id = scope.def(env.shared.strings, ".id(", str, ")");
                        check$1.optional(function() {
                            scope(env.shared.shader, ".shader(", shaderType[name], ",", id, ",", env.command, ");");
                        });
                        return id;
                    });
                }
                return null;
            }
            var frag = parseShader(S_FRAG);
            var vert = parseShader(S_VERT);
            var program = null;
            var progVar;
            if (isStatic(frag) && isStatic(vert)) {
                program = shaderState.program(vert.id, frag.id, null, attribLocations);
                progVar = createStaticDecl(function(env, scope) {
                    return env.link(program);
                });
            } else progVar = new Declaration(frag && frag.thisDep || vert && vert.thisDep, frag && frag.contextDep || vert && vert.contextDep, frag && frag.propDep || vert && vert.propDep, function(env, scope) {
                var SHADER_STATE = env.shared.shader;
                var fragId;
                if (frag) fragId = frag.append(env, scope);
                else fragId = scope.def(SHADER_STATE, ".", S_FRAG);
                var vertId;
                if (vert) vertId = vert.append(env, scope);
                else vertId = scope.def(SHADER_STATE, ".", S_VERT);
                var progDef = SHADER_STATE + ".program(" + vertId + "," + fragId;
                check$1.optional(function() {
                    progDef += "," + env.command;
                });
                return scope.def(progDef + ")");
            });
            return {
                frag: frag,
                vert: vert,
                progVar: progVar,
                program: program
            };
        }
        function parseDraw(options, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            // TODO: should use VAO to get default values for offset properties
            // should move vao parse into here and out of the old stuff
            var staticDraw = {};
            var vaoActive = false;
            function parseVAO() {
                if (S_VAO in staticOptions) {
                    var vao = staticOptions[S_VAO];
                    if (vao !== null && attributeState.getVAO(vao) === null) vao = attributeState.createVAO(vao);
                    vaoActive = true;
                    staticDraw.vao = vao;
                    return createStaticDecl(function(env) {
                        var vaoRef = attributeState.getVAO(vao);
                        if (vaoRef) return env.link(vaoRef);
                        else return "null";
                    });
                } else if (S_VAO in dynamicOptions) {
                    vaoActive = true;
                    var dyn = dynamicOptions[S_VAO];
                    return createDynamicDecl(dyn, function(env, scope) {
                        var vaoRef = env.invoke(scope, dyn);
                        return scope.def(env.shared.vao + ".getVAO(" + vaoRef + ")");
                    });
                }
                return null;
            }
            var vao = parseVAO();
            var elementsActive = false;
            function parseElements() {
                if (S_ELEMENTS in staticOptions) {
                    var elements = staticOptions[S_ELEMENTS];
                    staticDraw.elements = elements;
                    if (isBufferArgs(elements)) {
                        var e = staticDraw.elements = elementState.create(elements, true);
                        elements = elementState.getElements(e);
                        elementsActive = true;
                    } else if (elements) {
                        elements = elementState.getElements(elements);
                        elementsActive = true;
                        check$1.command(elements, "invalid elements", env.commandStr);
                    }
                    var result = createStaticDecl(function(env, scope) {
                        if (elements) {
                            var result = env.link(elements);
                            env.ELEMENTS = result;
                            return result;
                        }
                        env.ELEMENTS = null;
                        return null;
                    });
                    result.value = elements;
                    return result;
                } else if (S_ELEMENTS in dynamicOptions) {
                    elementsActive = true;
                    var dyn = dynamicOptions[S_ELEMENTS];
                    return createDynamicDecl(dyn, function(env, scope) {
                        var shared = env.shared;
                        var IS_BUFFER_ARGS = shared.isBufferArgs;
                        var ELEMENT_STATE = shared.elements;
                        var elementDefn = env.invoke(scope, dyn);
                        var elements = scope.def("null");
                        var elementStream = scope.def(IS_BUFFER_ARGS, "(", elementDefn, ")");
                        var ifte = env.cond(elementStream).then(elements, "=", ELEMENT_STATE, ".createStream(", elementDefn, ");").else(elements, "=", ELEMENT_STATE, ".getElements(", elementDefn, ");");
                        check$1.optional(function() {
                            env.assert(ifte.else, "!" + elementDefn + "||" + elements, "invalid elements");
                        });
                        scope.entry(ifte);
                        scope.exit(env.cond(elementStream).then(ELEMENT_STATE, ".destroyStream(", elements, ");"));
                        env.ELEMENTS = elements;
                        return elements;
                    });
                } else if (vaoActive) return new Declaration(vao.thisDep, vao.contextDep, vao.propDep, function(env, scope) {
                    return scope.def(env.shared.vao + ".currentVAO?" + env.shared.elements + ".getElements(" + env.shared.vao + ".currentVAO.elements):null");
                });
                return null;
            }
            var elements = parseElements();
            function parsePrimitive() {
                if (S_PRIMITIVE in staticOptions) {
                    var primitive = staticOptions[S_PRIMITIVE];
                    staticDraw.primitive = primitive;
                    check$1.commandParameter(primitive, primTypes, "invalid primitve", env.commandStr);
                    return createStaticDecl(function(env, scope) {
                        return primTypes[primitive];
                    });
                } else if (S_PRIMITIVE in dynamicOptions) {
                    var dynPrimitive = dynamicOptions[S_PRIMITIVE];
                    return createDynamicDecl(dynPrimitive, function(env, scope) {
                        var PRIM_TYPES = env.constants.primTypes;
                        var prim = env.invoke(scope, dynPrimitive);
                        check$1.optional(function() {
                            env.assert(scope, prim + " in " + PRIM_TYPES, "invalid primitive, must be one of " + Object.keys(primTypes));
                        });
                        return scope.def(PRIM_TYPES, "[", prim, "]");
                    });
                } else if (elementsActive) {
                    if (isStatic(elements)) {
                        if (elements.value) return createStaticDecl(function(env, scope) {
                            return scope.def(env.ELEMENTS, ".primType");
                        });
                        else return createStaticDecl(function() {
                            return GL_TRIANGLES$1;
                        });
                    } else return new Declaration(elements.thisDep, elements.contextDep, elements.propDep, function(env, scope) {
                        var elements = env.ELEMENTS;
                        return scope.def(elements, "?", elements, ".primType:", GL_TRIANGLES$1);
                    });
                } else if (vaoActive) return new Declaration(vao.thisDep, vao.contextDep, vao.propDep, function(env, scope) {
                    return scope.def(env.shared.vao + ".currentVAO?" + env.shared.vao + ".currentVAO.primitive:" + GL_TRIANGLES$1);
                });
                return null;
            }
            function parseParam(param, isOffset) {
                if (param in staticOptions) {
                    var value = staticOptions[param] | 0;
                    if (isOffset) staticDraw.offset = value;
                    else staticDraw.instances = value;
                    check$1.command(!isOffset || value >= 0, "invalid " + param, env.commandStr);
                    return createStaticDecl(function(env, scope) {
                        if (isOffset) env.OFFSET = value;
                        return value;
                    });
                } else if (param in dynamicOptions) {
                    var dynValue = dynamicOptions[param];
                    return createDynamicDecl(dynValue, function(env, scope) {
                        var result = env.invoke(scope, dynValue);
                        if (isOffset) {
                            env.OFFSET = result;
                            check$1.optional(function() {
                                env.assert(scope, result + ">=0", "invalid " + param);
                            });
                        }
                        return result;
                    });
                } else if (isOffset) {
                    if (elementsActive) return createStaticDecl(function(env, scope) {
                        env.OFFSET = 0;
                        return 0;
                    });
                    else if (vaoActive) return new Declaration(vao.thisDep, vao.contextDep, vao.propDep, function(env, scope) {
                        return scope.def(env.shared.vao + ".currentVAO?" + env.shared.vao + ".currentVAO.offset:0");
                    });
                } else if (vaoActive) return new Declaration(vao.thisDep, vao.contextDep, vao.propDep, function(env, scope) {
                    return scope.def(env.shared.vao + ".currentVAO?" + env.shared.vao + ".currentVAO.instances:-1");
                });
                return null;
            }
            var OFFSET = parseParam(S_OFFSET, true);
            function parseVertCount() {
                if (S_COUNT in staticOptions) {
                    var count = staticOptions[S_COUNT] | 0;
                    staticDraw.count = count;
                    check$1.command(typeof count === "number" && count >= 0, "invalid vertex count", env.commandStr);
                    return createStaticDecl(function() {
                        return count;
                    });
                } else if (S_COUNT in dynamicOptions) {
                    var dynCount = dynamicOptions[S_COUNT];
                    return createDynamicDecl(dynCount, function(env, scope) {
                        var result = env.invoke(scope, dynCount);
                        check$1.optional(function() {
                            env.assert(scope, "typeof " + result + '==="number"&&' + result + ">=0&&" + result + "===(" + result + "|0)", "invalid vertex count");
                        });
                        return result;
                    });
                } else if (elementsActive) {
                    if (isStatic(elements)) {
                        if (elements) {
                            if (OFFSET) return new Declaration(OFFSET.thisDep, OFFSET.contextDep, OFFSET.propDep, function(env, scope) {
                                var result = scope.def(env.ELEMENTS, ".vertCount-", env.OFFSET);
                                check$1.optional(function() {
                                    env.assert(scope, result + ">=0", "invalid vertex offset/element buffer too small");
                                });
                                return result;
                            });
                            else return createStaticDecl(function(env, scope) {
                                return scope.def(env.ELEMENTS, ".vertCount");
                            });
                        } else {
                            var result = createStaticDecl(function() {
                                return -1;
                            });
                            check$1.optional(function() {
                                result.MISSING = true;
                            });
                            return result;
                        }
                    } else {
                        var variable = new Declaration(elements.thisDep || OFFSET.thisDep, elements.contextDep || OFFSET.contextDep, elements.propDep || OFFSET.propDep, function(env, scope) {
                            var elements = env.ELEMENTS;
                            if (env.OFFSET) return scope.def(elements, "?", elements, ".vertCount-", env.OFFSET, ":-1");
                            return scope.def(elements, "?", elements, ".vertCount:-1");
                        });
                        check$1.optional(function() {
                            variable.DYNAMIC = true;
                        });
                        return variable;
                    }
                } else if (vaoActive) {
                    var countVariable = new Declaration(vao.thisDep, vao.contextDep, vao.propDep, function(env, scope) {
                        return scope.def(env.shared.vao, ".currentVAO?", env.shared.vao, ".currentVAO.count:-1");
                    });
                    return countVariable;
                }
                return null;
            }
            var primitive = parsePrimitive();
            var count = parseVertCount();
            var instances = parseParam(S_INSTANCES, false);
            return {
                elements: elements,
                primitive: primitive,
                count: count,
                instances: instances,
                offset: OFFSET,
                vao: vao,
                vaoActive: vaoActive,
                elementsActive: elementsActive,
                // static draw props
                static: staticDraw
            };
        }
        function parseGLState(options, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            var STATE = {};
            GL_STATE_NAMES.forEach(function(prop) {
                var param = propName(prop);
                function parseParam(parseStatic, parseDynamic) {
                    if (prop in staticOptions) {
                        var value = parseStatic(staticOptions[prop]);
                        STATE[param] = createStaticDecl(function() {
                            return value;
                        });
                    } else if (prop in dynamicOptions) {
                        var dyn = dynamicOptions[prop];
                        STATE[param] = createDynamicDecl(dyn, function(env, scope) {
                            return parseDynamic(env, scope, env.invoke(scope, dyn));
                        });
                    }
                }
                switch(prop){
                    case S_CULL_ENABLE:
                    case S_BLEND_ENABLE:
                    case S_DITHER:
                    case S_STENCIL_ENABLE:
                    case S_DEPTH_ENABLE:
                    case S_SCISSOR_ENABLE:
                    case S_POLYGON_OFFSET_ENABLE:
                    case S_SAMPLE_ALPHA:
                    case S_SAMPLE_ENABLE:
                    case S_DEPTH_MASK:
                        return parseParam(function(value) {
                            check$1.commandType(value, "boolean", prop, env.commandStr);
                            return value;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, "typeof " + value + '==="boolean"', "invalid flag " + prop, env.commandStr);
                            });
                            return value;
                        });
                    case S_DEPTH_FUNC:
                        return parseParam(function(value) {
                            check$1.commandParameter(value, compareFuncs, "invalid " + prop, env.commandStr);
                            return compareFuncs[value];
                        }, function(env, scope, value) {
                            var COMPARE_FUNCS = env.constants.compareFuncs;
                            check$1.optional(function() {
                                env.assert(scope, value + " in " + COMPARE_FUNCS, "invalid " + prop + ", must be one of " + Object.keys(compareFuncs));
                            });
                            return scope.def(COMPARE_FUNCS, "[", value, "]");
                        });
                    case S_DEPTH_RANGE:
                        return parseParam(function(value) {
                            check$1.command(isArrayLike(value) && value.length === 2 && typeof value[0] === "number" && typeof value[1] === "number" && value[0] <= value[1], "depth range is 2d array", env.commandStr);
                            return value;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, env.shared.isArrayLike + "(" + value + ")&&" + value + ".length===2&&" + "typeof " + value + '[0]==="number"&&' + "typeof " + value + '[1]==="number"&&' + value + "[0]<=" + value + "[1]", "depth range must be a 2d array");
                            });
                            var Z_NEAR = scope.def("+", value, "[0]");
                            var Z_FAR = scope.def("+", value, "[1]");
                            return [
                                Z_NEAR,
                                Z_FAR
                            ];
                        });
                    case S_BLEND_FUNC:
                        return parseParam(function(value) {
                            check$1.commandType(value, "object", "blend.func", env.commandStr);
                            var srcRGB = "srcRGB" in value ? value.srcRGB : value.src;
                            var srcAlpha = "srcAlpha" in value ? value.srcAlpha : value.src;
                            var dstRGB = "dstRGB" in value ? value.dstRGB : value.dst;
                            var dstAlpha = "dstAlpha" in value ? value.dstAlpha : value.dst;
                            check$1.commandParameter(srcRGB, blendFuncs, param + ".srcRGB", env.commandStr);
                            check$1.commandParameter(srcAlpha, blendFuncs, param + ".srcAlpha", env.commandStr);
                            check$1.commandParameter(dstRGB, blendFuncs, param + ".dstRGB", env.commandStr);
                            check$1.commandParameter(dstAlpha, blendFuncs, param + ".dstAlpha", env.commandStr);
                            check$1.command(invalidBlendCombinations.indexOf(srcRGB + ", " + dstRGB) === -1, "unallowed blending combination (srcRGB, dstRGB) = (" + srcRGB + ", " + dstRGB + ")", env.commandStr);
                            return [
                                blendFuncs[srcRGB],
                                blendFuncs[dstRGB],
                                blendFuncs[srcAlpha],
                                blendFuncs[dstAlpha]
                            ];
                        }, function(env, scope, value) {
                            var BLEND_FUNCS = env.constants.blendFuncs;
                            check$1.optional(function() {
                                env.assert(scope, value + "&&typeof " + value + '==="object"', "invalid blend func, must be an object");
                            });
                            function read(prefix, suffix) {
                                var func = scope.def('"', prefix, suffix, '" in ', value, "?", value, ".", prefix, suffix, ":", value, ".", prefix);
                                check$1.optional(function() {
                                    env.assert(scope, func + " in " + BLEND_FUNCS, "invalid " + prop + "." + prefix + suffix + ", must be one of " + Object.keys(blendFuncs));
                                });
                                return func;
                            }
                            var srcRGB = read("src", "RGB");
                            var dstRGB = read("dst", "RGB");
                            check$1.optional(function() {
                                var INVALID_BLEND_COMBINATIONS = env.constants.invalidBlendCombinations;
                                env.assert(scope, INVALID_BLEND_COMBINATIONS + ".indexOf(" + srcRGB + '+", "+' + dstRGB + ") === -1 ", "unallowed blending combination for (srcRGB, dstRGB)");
                            });
                            var SRC_RGB = scope.def(BLEND_FUNCS, "[", srcRGB, "]");
                            var SRC_ALPHA = scope.def(BLEND_FUNCS, "[", read("src", "Alpha"), "]");
                            var DST_RGB = scope.def(BLEND_FUNCS, "[", dstRGB, "]");
                            var DST_ALPHA = scope.def(BLEND_FUNCS, "[", read("dst", "Alpha"), "]");
                            return [
                                SRC_RGB,
                                DST_RGB,
                                SRC_ALPHA,
                                DST_ALPHA
                            ];
                        });
                    case S_BLEND_EQUATION:
                        return parseParam(function(value) {
                            if (typeof value === "string") {
                                check$1.commandParameter(value, blendEquations, "invalid " + prop, env.commandStr);
                                return [
                                    blendEquations[value],
                                    blendEquations[value]
                                ];
                            } else if (typeof value === "object") {
                                check$1.commandParameter(value.rgb, blendEquations, prop + ".rgb", env.commandStr);
                                check$1.commandParameter(value.alpha, blendEquations, prop + ".alpha", env.commandStr);
                                return [
                                    blendEquations[value.rgb],
                                    blendEquations[value.alpha]
                                ];
                            } else check$1.commandRaise("invalid blend.equation", env.commandStr);
                        }, function(env, scope, value) {
                            var BLEND_EQUATIONS = env.constants.blendEquations;
                            var RGB = scope.def();
                            var ALPHA = scope.def();
                            var ifte = env.cond("typeof ", value, '==="string"');
                            check$1.optional(function() {
                                function checkProp(block, name, value) {
                                    env.assert(block, value + " in " + BLEND_EQUATIONS, "invalid " + name + ", must be one of " + Object.keys(blendEquations));
                                }
                                checkProp(ifte.then, prop, value);
                                env.assert(ifte.else, value + "&&typeof " + value + '==="object"', "invalid " + prop);
                                checkProp(ifte.else, prop + ".rgb", value + ".rgb");
                                checkProp(ifte.else, prop + ".alpha", value + ".alpha");
                            });
                            ifte.then(RGB, "=", ALPHA, "=", BLEND_EQUATIONS, "[", value, "];");
                            ifte.else(RGB, "=", BLEND_EQUATIONS, "[", value, ".rgb];", ALPHA, "=", BLEND_EQUATIONS, "[", value, ".alpha];");
                            scope(ifte);
                            return [
                                RGB,
                                ALPHA
                            ];
                        });
                    case S_BLEND_COLOR:
                        return parseParam(function(value) {
                            check$1.command(isArrayLike(value) && value.length === 4, "blend.color must be a 4d array", env.commandStr);
                            return loop(4, function(i) {
                                return +value[i];
                            });
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, env.shared.isArrayLike + "(" + value + ")&&" + value + ".length===4", "blend.color must be a 4d array");
                            });
                            return loop(4, function(i) {
                                return scope.def("+", value, "[", i, "]");
                            });
                        });
                    case S_STENCIL_MASK:
                        return parseParam(function(value) {
                            check$1.commandType(value, "number", param, env.commandStr);
                            return value | 0;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, "typeof " + value + '==="number"', "invalid stencil.mask");
                            });
                            return scope.def(value, "|0");
                        });
                    case S_STENCIL_FUNC:
                        return parseParam(function(value) {
                            check$1.commandType(value, "object", param, env.commandStr);
                            var cmp = value.cmp || "keep";
                            var ref = value.ref || 0;
                            var mask = "mask" in value ? value.mask : -1;
                            check$1.commandParameter(cmp, compareFuncs, prop + ".cmp", env.commandStr);
                            check$1.commandType(ref, "number", prop + ".ref", env.commandStr);
                            check$1.commandType(mask, "number", prop + ".mask", env.commandStr);
                            return [
                                compareFuncs[cmp],
                                ref,
                                mask
                            ];
                        }, function(env, scope, value) {
                            var COMPARE_FUNCS = env.constants.compareFuncs;
                            check$1.optional(function() {
                                function assert() {
                                    env.assert(scope, Array.prototype.join.call(arguments, ""), "invalid stencil.func");
                                }
                                assert(value + "&&typeof ", value, '==="object"');
                                assert('!("cmp" in ', value, ")||(", value, ".cmp in ", COMPARE_FUNCS, ")");
                            });
                            var cmp = scope.def('"cmp" in ', value, "?", COMPARE_FUNCS, "[", value, ".cmp]", ":", GL_KEEP);
                            var ref = scope.def(value, ".ref|0");
                            var mask = scope.def('"mask" in ', value, "?", value, ".mask|0:-1");
                            return [
                                cmp,
                                ref,
                                mask
                            ];
                        });
                    case S_STENCIL_OPFRONT:
                    case S_STENCIL_OPBACK:
                        return parseParam(function(value) {
                            check$1.commandType(value, "object", param, env.commandStr);
                            var fail = value.fail || "keep";
                            var zfail = value.zfail || "keep";
                            var zpass = value.zpass || "keep";
                            check$1.commandParameter(fail, stencilOps, prop + ".fail", env.commandStr);
                            check$1.commandParameter(zfail, stencilOps, prop + ".zfail", env.commandStr);
                            check$1.commandParameter(zpass, stencilOps, prop + ".zpass", env.commandStr);
                            return [
                                prop === S_STENCIL_OPBACK ? GL_BACK : GL_FRONT,
                                stencilOps[fail],
                                stencilOps[zfail],
                                stencilOps[zpass]
                            ];
                        }, function(env, scope, value) {
                            var STENCIL_OPS = env.constants.stencilOps;
                            check$1.optional(function() {
                                env.assert(scope, value + "&&typeof " + value + '==="object"', "invalid " + prop);
                            });
                            function read(name) {
                                check$1.optional(function() {
                                    env.assert(scope, '!("' + name + '" in ' + value + ")||" + "(" + value + "." + name + " in " + STENCIL_OPS + ")", "invalid " + prop + "." + name + ", must be one of " + Object.keys(stencilOps));
                                });
                                return scope.def('"', name, '" in ', value, "?", STENCIL_OPS, "[", value, ".", name, "]:", GL_KEEP);
                            }
                            return [
                                prop === S_STENCIL_OPBACK ? GL_BACK : GL_FRONT,
                                read("fail"),
                                read("zfail"),
                                read("zpass")
                            ];
                        });
                    case S_POLYGON_OFFSET_OFFSET:
                        return parseParam(function(value) {
                            check$1.commandType(value, "object", param, env.commandStr);
                            var factor = value.factor | 0;
                            var units = value.units | 0;
                            check$1.commandType(factor, "number", param + ".factor", env.commandStr);
                            check$1.commandType(units, "number", param + ".units", env.commandStr);
                            return [
                                factor,
                                units
                            ];
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + "&&typeof " + value + '==="object"', "invalid " + prop);
                            });
                            var FACTOR = scope.def(value, ".factor|0");
                            var UNITS = scope.def(value, ".units|0");
                            return [
                                FACTOR,
                                UNITS
                            ];
                        });
                    case S_CULL_FACE:
                        return parseParam(function(value) {
                            var face = 0;
                            if (value === "front") face = GL_FRONT;
                            else if (value === "back") face = GL_BACK;
                            check$1.command(!!face, param, env.commandStr);
                            return face;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + '==="front"||' + value + '==="back"', "invalid cull.face");
                            });
                            return scope.def(value, '==="front"?', GL_FRONT, ":", GL_BACK);
                        });
                    case S_LINE_WIDTH:
                        return parseParam(function(value) {
                            check$1.command(typeof value === "number" && value >= limits.lineWidthDims[0] && value <= limits.lineWidthDims[1], "invalid line width, must be a positive number between " + limits.lineWidthDims[0] + " and " + limits.lineWidthDims[1], env.commandStr);
                            return value;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, "typeof " + value + '==="number"&&' + value + ">=" + limits.lineWidthDims[0] + "&&" + value + "<=" + limits.lineWidthDims[1], "invalid line width");
                            });
                            return value;
                        });
                    case S_FRONT_FACE:
                        return parseParam(function(value) {
                            check$1.commandParameter(value, orientationType, param, env.commandStr);
                            return orientationType[value];
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + '==="cw"||' + value + '==="ccw"', "invalid frontFace, must be one of cw,ccw");
                            });
                            return scope.def(value + '==="cw"?' + GL_CW + ":" + GL_CCW);
                        });
                    case S_COLOR_MASK:
                        return parseParam(function(value) {
                            check$1.command(isArrayLike(value) && value.length === 4, "color.mask must be length 4 array", env.commandStr);
                            return value.map(function(v) {
                                return !!v;
                            });
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, env.shared.isArrayLike + "(" + value + ")&&" + value + ".length===4", "invalid color.mask");
                            });
                            return loop(4, function(i) {
                                return "!!" + value + "[" + i + "]";
                            });
                        });
                    case S_SAMPLE_COVERAGE:
                        return parseParam(function(value) {
                            check$1.command(typeof value === "object" && value, param, env.commandStr);
                            var sampleValue = "value" in value ? value.value : 1;
                            var sampleInvert = !!value.invert;
                            check$1.command(typeof sampleValue === "number" && sampleValue >= 0 && sampleValue <= 1, "sample.coverage.value must be a number between 0 and 1", env.commandStr);
                            return [
                                sampleValue,
                                sampleInvert
                            ];
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + "&&typeof " + value + '==="object"', "invalid sample.coverage");
                            });
                            var VALUE = scope.def('"value" in ', value, "?+", value, ".value:1");
                            var INVERT = scope.def("!!", value, ".invert");
                            return [
                                VALUE,
                                INVERT
                            ];
                        });
                }
            });
            return STATE;
        }
        function parseUniforms(uniforms, env) {
            var staticUniforms = uniforms.static;
            var dynamicUniforms = uniforms.dynamic;
            var UNIFORMS = {};
            Object.keys(staticUniforms).forEach(function(name) {
                var value = staticUniforms[name];
                var result;
                if (typeof value === "number" || typeof value === "boolean") result = createStaticDecl(function() {
                    return value;
                });
                else if (typeof value === "function") {
                    var reglType = value._reglType;
                    if (reglType === "texture2d" || reglType === "textureCube") result = createStaticDecl(function(env) {
                        return env.link(value);
                    });
                    else if (reglType === "framebuffer" || reglType === "framebufferCube") {
                        check$1.command(value.color.length > 0, 'missing color attachment for framebuffer sent to uniform "' + name + '"', env.commandStr);
                        result = createStaticDecl(function(env) {
                            return env.link(value.color[0]);
                        });
                    } else check$1.commandRaise('invalid data for uniform "' + name + '"', env.commandStr);
                } else if (isArrayLike(value)) result = createStaticDecl(function(env) {
                    var ITEM = env.global.def("[", loop(value.length, function(i) {
                        check$1.command(typeof value[i] === "number" || typeof value[i] === "boolean", "invalid uniform " + name, env.commandStr);
                        return value[i];
                    }), "]");
                    return ITEM;
                });
                else check$1.commandRaise('invalid or missing data for uniform "' + name + '"', env.commandStr);
                result.value = value;
                UNIFORMS[name] = result;
            });
            Object.keys(dynamicUniforms).forEach(function(key) {
                var dyn = dynamicUniforms[key];
                UNIFORMS[key] = createDynamicDecl(dyn, function(env, scope) {
                    return env.invoke(scope, dyn);
                });
            });
            return UNIFORMS;
        }
        function parseAttributes(attributes, env) {
            var staticAttributes = attributes.static;
            var dynamicAttributes = attributes.dynamic;
            var attributeDefs = {};
            Object.keys(staticAttributes).forEach(function(attribute) {
                var value = staticAttributes[attribute];
                var id = stringStore.id(attribute);
                var record = new AttributeRecord();
                if (isBufferArgs(value)) {
                    record.state = ATTRIB_STATE_POINTER;
                    record.buffer = bufferState.getBuffer(bufferState.create(value, GL_ARRAY_BUFFER$2, false, true));
                    record.type = 0;
                } else {
                    var buffer = bufferState.getBuffer(value);
                    if (buffer) {
                        record.state = ATTRIB_STATE_POINTER;
                        record.buffer = buffer;
                        record.type = 0;
                    } else {
                        check$1.command(typeof value === "object" && value, "invalid data for attribute " + attribute, env.commandStr);
                        if ("constant" in value) {
                            var constant = value.constant;
                            record.buffer = "null";
                            record.state = ATTRIB_STATE_CONSTANT;
                            if (typeof constant === "number") record.x = constant;
                            else {
                                check$1.command(isArrayLike(constant) && constant.length > 0 && constant.length <= 4, "invalid constant for attribute " + attribute, env.commandStr);
                                CUTE_COMPONENTS.forEach(function(c, i) {
                                    if (i < constant.length) record[c] = constant[i];
                                });
                            }
                        } else {
                            if (isBufferArgs(value.buffer)) buffer = bufferState.getBuffer(bufferState.create(value.buffer, GL_ARRAY_BUFFER$2, false, true));
                            else buffer = bufferState.getBuffer(value.buffer);
                            check$1.command(!!buffer, 'missing buffer for attribute "' + attribute + '"', env.commandStr);
                            var offset = value.offset | 0;
                            check$1.command(offset >= 0, 'invalid offset for attribute "' + attribute + '"', env.commandStr);
                            var stride = value.stride | 0;
                            check$1.command(stride >= 0 && stride < 256, 'invalid stride for attribute "' + attribute + '", must be integer betweeen [0, 255]', env.commandStr);
                            var size = value.size | 0;
                            check$1.command(!("size" in value) || size > 0 && size <= 4, 'invalid size for attribute "' + attribute + '", must be 1,2,3,4', env.commandStr);
                            var normalized = !!value.normalized;
                            var type = 0;
                            if ("type" in value) {
                                check$1.commandParameter(value.type, glTypes, "invalid type for attribute " + attribute, env.commandStr);
                                type = glTypes[value.type];
                            }
                            var divisor = value.divisor | 0;
                            check$1.optional(function() {
                                if ("divisor" in value) {
                                    check$1.command(divisor === 0 || extInstancing, 'cannot specify divisor for attribute "' + attribute + '", instancing not supported', env.commandStr);
                                    check$1.command(divisor >= 0, 'invalid divisor for attribute "' + attribute + '"', env.commandStr);
                                }
                                var command = env.commandStr;
                                var VALID_KEYS = [
                                    "buffer",
                                    "offset",
                                    "divisor",
                                    "normalized",
                                    "type",
                                    "size",
                                    "stride"
                                ];
                                Object.keys(value).forEach(function(prop) {
                                    check$1.command(VALID_KEYS.indexOf(prop) >= 0, 'unknown parameter "' + prop + '" for attribute pointer "' + attribute + '" (valid parameters are ' + VALID_KEYS + ")", command);
                                });
                            });
                            record.buffer = buffer;
                            record.state = ATTRIB_STATE_POINTER;
                            record.size = size;
                            record.normalized = normalized;
                            record.type = type || buffer.dtype;
                            record.offset = offset;
                            record.stride = stride;
                            record.divisor = divisor;
                        }
                    }
                }
                attributeDefs[attribute] = createStaticDecl(function(env, scope) {
                    var cache = env.attribCache;
                    if (id in cache) return cache[id];
                    var result = {
                        isStream: false
                    };
                    Object.keys(record).forEach(function(key) {
                        result[key] = record[key];
                    });
                    if (record.buffer) {
                        result.buffer = env.link(record.buffer);
                        result.type = result.type || result.buffer + ".dtype";
                    }
                    cache[id] = result;
                    return result;
                });
            });
            Object.keys(dynamicAttributes).forEach(function(attribute) {
                var dyn = dynamicAttributes[attribute];
                function appendAttributeCode(env, block) {
                    var VALUE = env.invoke(block, dyn);
                    var shared = env.shared;
                    var constants = env.constants;
                    var IS_BUFFER_ARGS = shared.isBufferArgs;
                    var BUFFER_STATE = shared.buffer;
                    // Perform validation on attribute
                    check$1.optional(function() {
                        env.assert(block, VALUE + "&&(typeof " + VALUE + '==="object"||typeof ' + VALUE + '==="function")&&(' + IS_BUFFER_ARGS + "(" + VALUE + ")||" + BUFFER_STATE + ".getBuffer(" + VALUE + ")||" + BUFFER_STATE + ".getBuffer(" + VALUE + ".buffer)||" + IS_BUFFER_ARGS + "(" + VALUE + ".buffer)||" + '("constant" in ' + VALUE + "&&(typeof " + VALUE + '.constant==="number"||' + shared.isArrayLike + "(" + VALUE + ".constant))))", 'invalid dynamic attribute "' + attribute + '"');
                    });
                    // allocate names for result
                    var result = {
                        isStream: block.def(false)
                    };
                    var defaultRecord = new AttributeRecord();
                    defaultRecord.state = ATTRIB_STATE_POINTER;
                    Object.keys(defaultRecord).forEach(function(key) {
                        result[key] = block.def("" + defaultRecord[key]);
                    });
                    var BUFFER = result.buffer;
                    var TYPE = result.type;
                    block("if(", IS_BUFFER_ARGS, "(", VALUE, ")){", result.isStream, "=true;", BUFFER, "=", BUFFER_STATE, ".createStream(", GL_ARRAY_BUFFER$2, ",", VALUE, ");", TYPE, "=", BUFFER, ".dtype;", "}else{", BUFFER, "=", BUFFER_STATE, ".getBuffer(", VALUE, ");", "if(", BUFFER, "){", TYPE, "=", BUFFER, ".dtype;", '}else if("constant" in ', VALUE, "){", result.state, "=", ATTRIB_STATE_CONSTANT, ";", "if(typeof " + VALUE + '.constant === "number"){', result[CUTE_COMPONENTS[0]], "=", VALUE, ".constant;", CUTE_COMPONENTS.slice(1).map(function(n) {
                        return result[n];
                    }).join("="), "=0;", "}else{", CUTE_COMPONENTS.map(function(name, i) {
                        return result[name] + "=" + VALUE + ".constant.length>" + i + "?" + VALUE + ".constant[" + i + "]:0;";
                    }).join(""), "}}else{", "if(", IS_BUFFER_ARGS, "(", VALUE, ".buffer)){", BUFFER, "=", BUFFER_STATE, ".createStream(", GL_ARRAY_BUFFER$2, ",", VALUE, ".buffer);", "}else{", BUFFER, "=", BUFFER_STATE, ".getBuffer(", VALUE, ".buffer);", "}", TYPE, '="type" in ', VALUE, "?", constants.glTypes, "[", VALUE, ".type]:", BUFFER, ".dtype;", result.normalized, "=!!", VALUE, ".normalized;");
                    function emitReadRecord(name) {
                        block(result[name], "=", VALUE, ".", name, "|0;");
                    }
                    emitReadRecord("size");
                    emitReadRecord("offset");
                    emitReadRecord("stride");
                    emitReadRecord("divisor");
                    block("}}");
                    block.exit("if(", result.isStream, "){", BUFFER_STATE, ".destroyStream(", BUFFER, ");", "}");
                    return result;
                }
                attributeDefs[attribute] = createDynamicDecl(dyn, appendAttributeCode);
            });
            return attributeDefs;
        }
        function parseContext(context) {
            var staticContext = context.static;
            var dynamicContext = context.dynamic;
            var result = {};
            Object.keys(staticContext).forEach(function(name) {
                var value = staticContext[name];
                result[name] = createStaticDecl(function(env, scope) {
                    if (typeof value === "number" || typeof value === "boolean") return "" + value;
                    else return env.link(value);
                });
            });
            Object.keys(dynamicContext).forEach(function(name) {
                var dyn = dynamicContext[name];
                result[name] = createDynamicDecl(dyn, function(env, scope) {
                    return env.invoke(scope, dyn);
                });
            });
            return result;
        }
        function parseArguments(options, attributes, uniforms, context, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            check$1.optional(function() {
                var KEY_NAMES = [
                    S_FRAMEBUFFER,
                    S_VERT,
                    S_FRAG,
                    S_ELEMENTS,
                    S_PRIMITIVE,
                    S_OFFSET,
                    S_COUNT,
                    S_INSTANCES,
                    S_PROFILE,
                    S_VAO
                ].concat(GL_STATE_NAMES);
                function checkKeys(dict) {
                    Object.keys(dict).forEach(function(key) {
                        check$1.command(KEY_NAMES.indexOf(key) >= 0, 'unknown parameter "' + key + '"', env.commandStr);
                    });
                }
                checkKeys(staticOptions);
                checkKeys(dynamicOptions);
            });
            var attribLocations = parseAttribLocations(options, attributes);
            var framebuffer = parseFramebuffer(options, env);
            var viewportAndScissor = parseViewportScissor(options, framebuffer, env);
            var draw = parseDraw(options, env);
            var state = parseGLState(options, env);
            var shader = parseProgram(options, env, attribLocations);
            function copyBox(name) {
                var defn = viewportAndScissor[name];
                if (defn) state[name] = defn;
            }
            copyBox(S_VIEWPORT);
            copyBox(propName(S_SCISSOR_BOX));
            var dirty = Object.keys(state).length > 0;
            var result = {
                framebuffer: framebuffer,
                draw: draw,
                shader: shader,
                state: state,
                dirty: dirty,
                scopeVAO: null,
                drawVAO: null,
                useVAO: false,
                attributes: {}
            };
            result.profile = parseProfile(options, env);
            result.uniforms = parseUniforms(uniforms, env);
            result.drawVAO = result.scopeVAO = draw.vao;
            // special case: check if we can statically allocate a vertex array object for this program
            if (!result.drawVAO && shader.program && !attribLocations && extensions.angle_instanced_arrays && draw.static.elements) {
                var useVAO = true;
                var staticBindings = shader.program.attributes.map(function(attr) {
                    var binding = attributes.static[attr];
                    useVAO = useVAO && !!binding;
                    return binding;
                });
                if (useVAO && staticBindings.length > 0) {
                    var vao = attributeState.getVAO(attributeState.createVAO({
                        attributes: staticBindings,
                        elements: draw.static.elements
                    }));
                    result.drawVAO = new Declaration(null, null, null, function(env, scope) {
                        return env.link(vao);
                    });
                    result.useVAO = true;
                }
            }
            if (attribLocations) result.useVAO = true;
            else result.attributes = parseAttributes(attributes, env);
            result.context = parseContext(context, env);
            return result;
        }
        // ===================================================
        // ===================================================
        // COMMON UPDATE FUNCTIONS
        // ===================================================
        // ===================================================
        function emitContext(env, scope, context) {
            var shared = env.shared;
            var CONTEXT = shared.context;
            var contextEnter = env.scope();
            Object.keys(context).forEach(function(name) {
                scope.save(CONTEXT, "." + name);
                var defn = context[name];
                var value = defn.append(env, scope);
                if (Array.isArray(value)) contextEnter(CONTEXT, ".", name, "=[", value.join(), "];");
                else contextEnter(CONTEXT, ".", name, "=", value, ";");
            });
            scope(contextEnter);
        }
        // ===================================================
        // ===================================================
        // COMMON DRAWING FUNCTIONS
        // ===================================================
        // ===================================================
        function emitPollFramebuffer(env, scope, framebuffer, skipCheck) {
            var shared = env.shared;
            var GL = shared.gl;
            var FRAMEBUFFER_STATE = shared.framebuffer;
            var EXT_DRAW_BUFFERS;
            if (extDrawBuffers) EXT_DRAW_BUFFERS = scope.def(shared.extensions, ".webgl_draw_buffers");
            var constants = env.constants;
            var DRAW_BUFFERS = constants.drawBuffer;
            var BACK_BUFFER = constants.backBuffer;
            var NEXT;
            if (framebuffer) NEXT = framebuffer.append(env, scope);
            else NEXT = scope.def(FRAMEBUFFER_STATE, ".next");
            if (!skipCheck) scope("if(", NEXT, "!==", FRAMEBUFFER_STATE, ".cur){");
            scope("if(", NEXT, "){", GL, ".bindFramebuffer(", GL_FRAMEBUFFER$2, ",", NEXT, ".framebuffer);");
            if (extDrawBuffers) scope(EXT_DRAW_BUFFERS, ".drawBuffersWEBGL(", DRAW_BUFFERS, "[", NEXT, ".colorAttachments.length]);");
            scope("}else{", GL, ".bindFramebuffer(", GL_FRAMEBUFFER$2, ",null);");
            if (extDrawBuffers) scope(EXT_DRAW_BUFFERS, ".drawBuffersWEBGL(", BACK_BUFFER, ");");
            scope("}", FRAMEBUFFER_STATE, ".cur=", NEXT, ";");
            if (!skipCheck) scope("}");
        }
        function emitPollState(env, scope, args) {
            var shared = env.shared;
            var GL = shared.gl;
            var CURRENT_VARS = env.current;
            var NEXT_VARS = env.next;
            var CURRENT_STATE = shared.current;
            var NEXT_STATE = shared.next;
            var block = env.cond(CURRENT_STATE, ".dirty");
            GL_STATE_NAMES.forEach(function(prop) {
                var param = propName(prop);
                if (param in args.state) return;
                var NEXT, CURRENT;
                if (param in NEXT_VARS) {
                    NEXT = NEXT_VARS[param];
                    CURRENT = CURRENT_VARS[param];
                    var parts = loop(currentState[param].length, function(i) {
                        return block.def(NEXT, "[", i, "]");
                    });
                    block(env.cond(parts.map(function(p, i) {
                        return p + "!==" + CURRENT + "[" + i + "]";
                    }).join("||")).then(GL, ".", GL_VARIABLES[param], "(", parts, ");", parts.map(function(p, i) {
                        return CURRENT + "[" + i + "]=" + p;
                    }).join(";"), ";"));
                } else {
                    NEXT = block.def(NEXT_STATE, ".", param);
                    var ifte = env.cond(NEXT, "!==", CURRENT_STATE, ".", param);
                    block(ifte);
                    if (param in GL_FLAGS) ifte(env.cond(NEXT).then(GL, ".enable(", GL_FLAGS[param], ");").else(GL, ".disable(", GL_FLAGS[param], ");"), CURRENT_STATE, ".", param, "=", NEXT, ";");
                    else ifte(GL, ".", GL_VARIABLES[param], "(", NEXT, ");", CURRENT_STATE, ".", param, "=", NEXT, ";");
                }
            });
            if (Object.keys(args.state).length === 0) block(CURRENT_STATE, ".dirty=false;");
            scope(block);
        }
        function emitSetOptions(env, scope, options, filter) {
            var shared = env.shared;
            var CURRENT_VARS = env.current;
            var CURRENT_STATE = shared.current;
            var GL = shared.gl;
            sortState(Object.keys(options)).forEach(function(param) {
                var defn = options[param];
                if (filter && !filter(defn)) return;
                var variable = defn.append(env, scope);
                if (GL_FLAGS[param]) {
                    var flag = GL_FLAGS[param];
                    if (isStatic(defn)) {
                        if (variable) scope(GL, ".enable(", flag, ");");
                        else scope(GL, ".disable(", flag, ");");
                    } else scope(env.cond(variable).then(GL, ".enable(", flag, ");").else(GL, ".disable(", flag, ");"));
                    scope(CURRENT_STATE, ".", param, "=", variable, ";");
                } else if (isArrayLike(variable)) {
                    var CURRENT = CURRENT_VARS[param];
                    scope(GL, ".", GL_VARIABLES[param], "(", variable, ");", variable.map(function(v, i) {
                        return CURRENT + "[" + i + "]=" + v;
                    }).join(";"), ";");
                } else scope(GL, ".", GL_VARIABLES[param], "(", variable, ");", CURRENT_STATE, ".", param, "=", variable, ";");
            });
        }
        function injectExtensions(env, scope) {
            if (extInstancing) env.instancing = scope.def(env.shared.extensions, ".angle_instanced_arrays");
        }
        function emitProfile(env, scope, args, useScope, incrementCounter) {
            var shared = env.shared;
            var STATS = env.stats;
            var CURRENT_STATE = shared.current;
            var TIMER = shared.timer;
            var profileArg = args.profile;
            function perfCounter() {
                if (typeof performance === "undefined") return "Date.now()";
                else return "performance.now()";
            }
            var CPU_START, QUERY_COUNTER;
            function emitProfileStart(block) {
                CPU_START = scope.def();
                block(CPU_START, "=", perfCounter(), ";");
                if (typeof incrementCounter === "string") block(STATS, ".count+=", incrementCounter, ";");
                else block(STATS, ".count++;");
                if (timer) {
                    if (useScope) {
                        QUERY_COUNTER = scope.def();
                        block(QUERY_COUNTER, "=", TIMER, ".getNumPendingQueries();");
                    } else block(TIMER, ".beginQuery(", STATS, ");");
                }
            }
            function emitProfileEnd(block) {
                block(STATS, ".cpuTime+=", perfCounter(), "-", CPU_START, ";");
                if (timer) {
                    if (useScope) block(TIMER, ".pushScopeStats(", QUERY_COUNTER, ",", TIMER, ".getNumPendingQueries(),", STATS, ");");
                    else block(TIMER, ".endQuery();");
                }
            }
            function scopeProfile(value) {
                var prev = scope.def(CURRENT_STATE, ".profile");
                scope(CURRENT_STATE, ".profile=", value, ";");
                scope.exit(CURRENT_STATE, ".profile=", prev, ";");
            }
            var USE_PROFILE;
            if (profileArg) {
                if (isStatic(profileArg)) {
                    if (profileArg.enable) {
                        emitProfileStart(scope);
                        emitProfileEnd(scope.exit);
                        scopeProfile("true");
                    } else scopeProfile("false");
                    return;
                }
                USE_PROFILE = profileArg.append(env, scope);
                scopeProfile(USE_PROFILE);
            } else USE_PROFILE = scope.def(CURRENT_STATE, ".profile");
            var start = env.block();
            emitProfileStart(start);
            scope("if(", USE_PROFILE, "){", start, "}");
            var end = env.block();
            emitProfileEnd(end);
            scope.exit("if(", USE_PROFILE, "){", end, "}");
        }
        function emitAttributes(env, scope, args, attributes, filter) {
            var shared = env.shared;
            function typeLength(x) {
                switch(x){
                    case GL_FLOAT_VEC2:
                    case GL_INT_VEC2:
                    case GL_BOOL_VEC2:
                        return 2;
                    case GL_FLOAT_VEC3:
                    case GL_INT_VEC3:
                    case GL_BOOL_VEC3:
                        return 3;
                    case GL_FLOAT_VEC4:
                    case GL_INT_VEC4:
                    case GL_BOOL_VEC4:
                        return 4;
                    default:
                        return 1;
                }
            }
            function emitBindAttribute(ATTRIBUTE, size, record) {
                var GL = shared.gl;
                var LOCATION = scope.def(ATTRIBUTE, ".location");
                var BINDING = scope.def(shared.attributes, "[", LOCATION, "]");
                var STATE = record.state;
                var BUFFER = record.buffer;
                var CONST_COMPONENTS = [
                    record.x,
                    record.y,
                    record.z,
                    record.w
                ];
                var COMMON_KEYS = [
                    "buffer",
                    "normalized",
                    "offset",
                    "stride"
                ];
                function emitBuffer() {
                    scope("if(!", BINDING, ".buffer){", GL, ".enableVertexAttribArray(", LOCATION, ");}");
                    var TYPE = record.type;
                    var SIZE;
                    if (!record.size) SIZE = size;
                    else SIZE = scope.def(record.size, "||", size);
                    scope("if(", BINDING, ".type!==", TYPE, "||", BINDING, ".size!==", SIZE, "||", COMMON_KEYS.map(function(key) {
                        return BINDING + "." + key + "!==" + record[key];
                    }).join("||"), "){", GL, ".bindBuffer(", GL_ARRAY_BUFFER$2, ",", BUFFER, ".buffer);", GL, ".vertexAttribPointer(", [
                        LOCATION,
                        SIZE,
                        TYPE,
                        record.normalized,
                        record.stride,
                        record.offset
                    ], ");", BINDING, ".type=", TYPE, ";", BINDING, ".size=", SIZE, ";", COMMON_KEYS.map(function(key) {
                        return BINDING + "." + key + "=" + record[key] + ";";
                    }).join(""), "}");
                    if (extInstancing) {
                        var DIVISOR = record.divisor;
                        scope("if(", BINDING, ".divisor!==", DIVISOR, "){", env.instancing, ".vertexAttribDivisorANGLE(", [
                            LOCATION,
                            DIVISOR
                        ], ");", BINDING, ".divisor=", DIVISOR, ";}");
                    }
                }
                function emitConstant() {
                    scope("if(", BINDING, ".buffer){", GL, ".disableVertexAttribArray(", LOCATION, ");", BINDING, ".buffer=null;", "}if(", CUTE_COMPONENTS.map(function(c, i) {
                        return BINDING + "." + c + "!==" + CONST_COMPONENTS[i];
                    }).join("||"), "){", GL, ".vertexAttrib4f(", LOCATION, ",", CONST_COMPONENTS, ");", CUTE_COMPONENTS.map(function(c, i) {
                        return BINDING + "." + c + "=" + CONST_COMPONENTS[i] + ";";
                    }).join(""), "}");
                }
                if (STATE === ATTRIB_STATE_POINTER) emitBuffer();
                else if (STATE === ATTRIB_STATE_CONSTANT) emitConstant();
                else {
                    scope("if(", STATE, "===", ATTRIB_STATE_POINTER, "){");
                    emitBuffer();
                    scope("}else{");
                    emitConstant();
                    scope("}");
                }
            }
            attributes.forEach(function(attribute) {
                var name = attribute.name;
                var arg = args.attributes[name];
                var record;
                if (arg) {
                    if (!filter(arg)) return;
                    record = arg.append(env, scope);
                } else {
                    if (!filter(SCOPE_DECL)) return;
                    var scopeAttrib = env.scopeAttrib(name);
                    check$1.optional(function() {
                        env.assert(scope, scopeAttrib + ".state", "missing attribute " + name);
                    });
                    record = {};
                    Object.keys(new AttributeRecord()).forEach(function(key) {
                        record[key] = scope.def(scopeAttrib, ".", key);
                    });
                }
                emitBindAttribute(env.link(attribute), typeLength(attribute.info.type), record);
            });
        }
        function emitUniforms(env, scope, args, uniforms, filter, isBatchInnerLoop) {
            var shared = env.shared;
            var GL = shared.gl;
            var definedArrUniforms = {};
            var infix;
            for(var i = 0; i < uniforms.length; ++i){
                var uniform = uniforms[i];
                var name = uniform.name;
                var type = uniform.info.type;
                var size = uniform.info.size;
                var arg = args.uniforms[name];
                if (size > 1) {
                    // either foo[n] or foos, avoid define both
                    if (!arg) continue;
                    var arrUniformName = name.replace("[0]", "");
                    if (definedArrUniforms[arrUniformName]) continue;
                    definedArrUniforms[arrUniformName] = 1;
                }
                var UNIFORM = env.link(uniform);
                var LOCATION = UNIFORM + ".location";
                var VALUE;
                if (arg) {
                    if (!filter(arg)) continue;
                    if (isStatic(arg)) {
                        var value = arg.value;
                        check$1.command(value !== null && typeof value !== "undefined", 'missing uniform "' + name + '"', env.commandStr);
                        if (type === GL_SAMPLER_2D || type === GL_SAMPLER_CUBE) {
                            check$1.command(typeof value === "function" && (type === GL_SAMPLER_2D && (value._reglType === "texture2d" || value._reglType === "framebuffer") || type === GL_SAMPLER_CUBE && (value._reglType === "textureCube" || value._reglType === "framebufferCube")), "invalid texture for uniform " + name, env.commandStr);
                            var TEX_VALUE = env.link(value._texture || value.color[0]._texture);
                            scope(GL, ".uniform1i(", LOCATION, ",", TEX_VALUE + ".bind());");
                            scope.exit(TEX_VALUE, ".unbind();");
                        } else if (type === GL_FLOAT_MAT2 || type === GL_FLOAT_MAT3 || type === GL_FLOAT_MAT4) {
                            check$1.optional(function() {
                                check$1.command(isArrayLike(value), "invalid matrix for uniform " + name, env.commandStr);
                                check$1.command(type === GL_FLOAT_MAT2 && value.length === 4 || type === GL_FLOAT_MAT3 && value.length === 9 || type === GL_FLOAT_MAT4 && value.length === 16, "invalid length for matrix uniform " + name, env.commandStr);
                            });
                            var MAT_VALUE = env.global.def("new Float32Array([" + Array.prototype.slice.call(value) + "])");
                            var dim = 2;
                            if (type === GL_FLOAT_MAT3) dim = 3;
                            else if (type === GL_FLOAT_MAT4) dim = 4;
                            scope(GL, ".uniformMatrix", dim, "fv(", LOCATION, ",false,", MAT_VALUE, ");");
                        } else {
                            switch(type){
                                case GL_FLOAT$8:
                                    if (size === 1) check$1.commandType(value, "number", "uniform " + name, env.commandStr);
                                    else check$1.command(isArrayLike(value) && value.length === size, "uniform " + name, env.commandStr);
                                    infix = "1f";
                                    break;
                                case GL_FLOAT_VEC2:
                                    check$1.command(isArrayLike(value) && value.length && value.length % 2 === 0 && value.length <= size * 2, "uniform " + name, env.commandStr);
                                    infix = "2f";
                                    break;
                                case GL_FLOAT_VEC3:
                                    check$1.command(isArrayLike(value) && value.length && value.length % 3 === 0 && value.length <= size * 3, "uniform " + name, env.commandStr);
                                    infix = "3f";
                                    break;
                                case GL_FLOAT_VEC4:
                                    check$1.command(isArrayLike(value) && value.length && value.length % 4 === 0 && value.length <= size * 4, "uniform " + name, env.commandStr);
                                    infix = "4f";
                                    break;
                                case GL_BOOL:
                                    if (size === 1) check$1.commandType(value, "boolean", "uniform " + name, env.commandStr);
                                    else check$1.command(isArrayLike(value) && value.length === size, "uniform " + name, env.commandStr);
                                    infix = "1i";
                                    break;
                                case GL_INT$3:
                                    if (size === 1) check$1.commandType(value, "number", "uniform " + name, env.commandStr);
                                    else check$1.command(isArrayLike(value) && value.length === size, "uniform " + name, env.commandStr);
                                    infix = "1i";
                                    break;
                                case GL_BOOL_VEC2:
                                    check$1.command(isArrayLike(value) && value.length && value.length % 2 === 0 && value.length <= size * 2, "uniform " + name, env.commandStr);
                                    infix = "2i";
                                    break;
                                case GL_INT_VEC2:
                                    check$1.command(isArrayLike(value) && value.length && value.length % 2 === 0 && value.length <= size * 2, "uniform " + name, env.commandStr);
                                    infix = "2i";
                                    break;
                                case GL_BOOL_VEC3:
                                    check$1.command(isArrayLike(value) && value.length && value.length % 3 === 0 && value.length <= size * 3, "uniform " + name, env.commandStr);
                                    infix = "3i";
                                    break;
                                case GL_INT_VEC3:
                                    check$1.command(isArrayLike(value) && value.length && value.length % 3 === 0 && value.length <= size * 3, "uniform " + name, env.commandStr);
                                    infix = "3i";
                                    break;
                                case GL_BOOL_VEC4:
                                    check$1.command(isArrayLike(value) && value.length && value.length % 4 === 0 && value.length <= size * 4, "uniform " + name, env.commandStr);
                                    infix = "4i";
                                    break;
                                case GL_INT_VEC4:
                                    check$1.command(isArrayLike(value) && value.length && value.length % 4 === 0 && value.length <= size * 4, "uniform " + name, env.commandStr);
                                    infix = "4i";
                                    break;
                            }
                            if (size > 1) {
                                infix += "v";
                                value = env.global.def("[" + Array.prototype.slice.call(value) + "]");
                            } else value = isArrayLike(value) ? Array.prototype.slice.call(value) : value;
                            scope(GL, ".uniform", infix, "(", LOCATION, ",", value, ");");
                        }
                        continue;
                    } else VALUE = arg.append(env, scope);
                } else {
                    if (!filter(SCOPE_DECL)) continue;
                    VALUE = scope.def(shared.uniforms, "[", stringStore.id(name), "]");
                }
                if (type === GL_SAMPLER_2D) {
                    check$1(!Array.isArray(VALUE), "must specify a scalar prop for textures");
                    scope("if(", VALUE, "&&", VALUE, '._reglType==="framebuffer"){', VALUE, "=", VALUE, ".color[0];", "}");
                } else if (type === GL_SAMPLER_CUBE) {
                    check$1(!Array.isArray(VALUE), "must specify a scalar prop for cube maps");
                    scope("if(", VALUE, "&&", VALUE, '._reglType==="framebufferCube"){', VALUE, "=", VALUE, ".color[0];", "}");
                }
                // perform type validation
                check$1.optional(function() {
                    function emitCheck(pred, message) {
                        env.assert(scope, pred, 'bad data or missing for uniform "' + name + '".  ' + message);
                    }
                    function checkType(type, size) {
                        if (size === 1) check$1(!Array.isArray(VALUE), "must not specify an array type for uniform");
                        emitCheck("Array.isArray(" + VALUE + ") && typeof " + VALUE + '[0]===" ' + type + '"' + " || typeof " + VALUE + '==="' + type + '"', "invalid type, expected " + type);
                    }
                    function checkVector(n, type, size) {
                        if (Array.isArray(VALUE)) check$1(VALUE.length && VALUE.length % n === 0 && VALUE.length <= n * size, "must have length of " + (size === 1 ? "" : "n * ") + n);
                        else emitCheck(shared.isArrayLike + "(" + VALUE + ")&&" + VALUE + ".length && " + VALUE + ".length % " + n + " === 0" + " && " + VALUE + ".length<=" + n * size, "invalid vector, should have length of " + (size === 1 ? "" : "n * ") + n, env.commandStr);
                    }
                    function checkTexture(target) {
                        check$1(!Array.isArray(VALUE), "must not specify a value type");
                        emitCheck("typeof " + VALUE + '==="function"&&' + VALUE + '._reglType==="texture' + (target === GL_TEXTURE_2D$3 ? "2d" : "Cube") + '"', "invalid texture type", env.commandStr);
                    }
                    switch(type){
                        case GL_INT$3:
                            checkType("number", size);
                            break;
                        case GL_INT_VEC2:
                            checkVector(2, "number", size);
                            break;
                        case GL_INT_VEC3:
                            checkVector(3, "number", size);
                            break;
                        case GL_INT_VEC4:
                            checkVector(4, "number", size);
                            break;
                        case GL_FLOAT$8:
                            checkType("number", size);
                            break;
                        case GL_FLOAT_VEC2:
                            checkVector(2, "number", size);
                            break;
                        case GL_FLOAT_VEC3:
                            checkVector(3, "number", size);
                            break;
                        case GL_FLOAT_VEC4:
                            checkVector(4, "number", size);
                            break;
                        case GL_BOOL:
                            checkType("boolean", size);
                            break;
                        case GL_BOOL_VEC2:
                            checkVector(2, "boolean", size);
                            break;
                        case GL_BOOL_VEC3:
                            checkVector(3, "boolean", size);
                            break;
                        case GL_BOOL_VEC4:
                            checkVector(4, "boolean", size);
                            break;
                        case GL_FLOAT_MAT2:
                            checkVector(4, "number", size);
                            break;
                        case GL_FLOAT_MAT3:
                            checkVector(9, "number", size);
                            break;
                        case GL_FLOAT_MAT4:
                            checkVector(16, "number", size);
                            break;
                        case GL_SAMPLER_2D:
                            checkTexture(GL_TEXTURE_2D$3);
                            break;
                        case GL_SAMPLER_CUBE:
                            checkTexture(GL_TEXTURE_CUBE_MAP$2);
                            break;
                    }
                });
                var unroll = 1;
                switch(type){
                    case GL_SAMPLER_2D:
                    case GL_SAMPLER_CUBE:
                        var TEX = scope.def(VALUE, "._texture");
                        scope(GL, ".uniform1i(", LOCATION, ",", TEX, ".bind());");
                        scope.exit(TEX, ".unbind();");
                        continue;
                    case GL_INT$3:
                    case GL_BOOL:
                        infix = "1i";
                        break;
                    case GL_INT_VEC2:
                    case GL_BOOL_VEC2:
                        infix = "2i";
                        unroll = 2;
                        break;
                    case GL_INT_VEC3:
                    case GL_BOOL_VEC3:
                        infix = "3i";
                        unroll = 3;
                        break;
                    case GL_INT_VEC4:
                    case GL_BOOL_VEC4:
                        infix = "4i";
                        unroll = 4;
                        break;
                    case GL_FLOAT$8:
                        infix = "1f";
                        break;
                    case GL_FLOAT_VEC2:
                        infix = "2f";
                        unroll = 2;
                        break;
                    case GL_FLOAT_VEC3:
                        infix = "3f";
                        unroll = 3;
                        break;
                    case GL_FLOAT_VEC4:
                        infix = "4f";
                        unroll = 4;
                        break;
                    case GL_FLOAT_MAT2:
                        infix = "Matrix2fv";
                        break;
                    case GL_FLOAT_MAT3:
                        infix = "Matrix3fv";
                        break;
                    case GL_FLOAT_MAT4:
                        infix = "Matrix4fv";
                        break;
                }
                if (infix.indexOf("Matrix") === -1 && size > 1) {
                    infix += "v";
                    unroll = 1;
                }
                if (infix.charAt(0) === "M") {
                    scope(GL, ".uniform", infix, "(", LOCATION, ",");
                    var matSize = Math.pow(type - GL_FLOAT_MAT2 + 2, 2);
                    var STORAGE = env.global.def("new Float32Array(", matSize, ")");
                    if (Array.isArray(VALUE)) scope("false,(", loop(matSize, function(i) {
                        return STORAGE + "[" + i + "]=" + VALUE[i];
                    }), ",", STORAGE, ")");
                    else scope("false,(Array.isArray(", VALUE, ")||", VALUE, " instanceof Float32Array)?", VALUE, ":(", loop(matSize, function(i) {
                        return STORAGE + "[" + i + "]=" + VALUE + "[" + i + "]";
                    }), ",", STORAGE, ")");
                    scope(");");
                } else if (unroll > 1) {
                    var prev = [];
                    var cur = [];
                    for(var j = 0; j < unroll; ++j){
                        if (Array.isArray(VALUE)) cur.push(VALUE[j]);
                        else cur.push(scope.def(VALUE + "[" + j + "]"));
                        if (isBatchInnerLoop) prev.push(scope.def());
                    }
                    if (isBatchInnerLoop) scope("if(!", env.batchId, "||", prev.map(function(p, i) {
                        return p + "!==" + cur[i];
                    }).join("||"), "){", prev.map(function(p, i) {
                        return p + "=" + cur[i] + ";";
                    }).join(""));
                    scope(GL, ".uniform", infix, "(", LOCATION, ",", cur.join(","), ");");
                    if (isBatchInnerLoop) scope("}");
                } else {
                    check$1(!Array.isArray(VALUE), "uniform value must not be an array");
                    if (isBatchInnerLoop) {
                        var prevS = scope.def();
                        scope("if(!", env.batchId, "||", prevS, "!==", VALUE, "){", prevS, "=", VALUE, ";");
                    }
                    scope(GL, ".uniform", infix, "(", LOCATION, ",", VALUE, ");");
                    if (isBatchInnerLoop) scope("}");
                }
            }
        }
        function emitDraw(env, outer, inner, args) {
            var shared = env.shared;
            var GL = shared.gl;
            var DRAW_STATE = shared.draw;
            var drawOptions = args.draw;
            function emitElements() {
                var defn = drawOptions.elements;
                var ELEMENTS;
                var scope = outer;
                if (defn) {
                    if (defn.contextDep && args.contextDynamic || defn.propDep) scope = inner;
                    ELEMENTS = defn.append(env, scope);
                    if (drawOptions.elementsActive) scope("if(" + ELEMENTS + ")" + GL + ".bindBuffer(" + GL_ELEMENT_ARRAY_BUFFER$2 + "," + ELEMENTS + ".buffer.buffer);");
                } else {
                    ELEMENTS = scope.def();
                    scope(ELEMENTS, "=", DRAW_STATE, ".", S_ELEMENTS, ";", "if(", ELEMENTS, "){", GL, ".bindBuffer(", GL_ELEMENT_ARRAY_BUFFER$2, ",", ELEMENTS, ".buffer.buffer);}", "else if(", shared.vao, ".currentVAO){", ELEMENTS, "=", env.shared.elements + ".getElements(" + shared.vao, ".currentVAO.elements);", !extVertexArrays ? "if(" + ELEMENTS + ")" + GL + ".bindBuffer(" + GL_ELEMENT_ARRAY_BUFFER$2 + "," + ELEMENTS + ".buffer.buffer);" : "", "}");
                }
                return ELEMENTS;
            }
            function emitCount() {
                var defn = drawOptions.count;
                var COUNT;
                var scope = outer;
                if (defn) {
                    if (defn.contextDep && args.contextDynamic || defn.propDep) scope = inner;
                    COUNT = defn.append(env, scope);
                    check$1.optional(function() {
                        if (defn.MISSING) env.assert(outer, "false", "missing vertex count");
                        if (defn.DYNAMIC) env.assert(scope, COUNT + ">=0", "missing vertex count");
                    });
                } else {
                    COUNT = scope.def(DRAW_STATE, ".", S_COUNT);
                    check$1.optional(function() {
                        env.assert(scope, COUNT + ">=0", "missing vertex count");
                    });
                }
                return COUNT;
            }
            var ELEMENTS = emitElements();
            function emitValue(name) {
                var defn = drawOptions[name];
                if (defn) {
                    if (defn.contextDep && args.contextDynamic || defn.propDep) return defn.append(env, inner);
                    else return defn.append(env, outer);
                } else return outer.def(DRAW_STATE, ".", name);
            }
            var PRIMITIVE = emitValue(S_PRIMITIVE);
            var OFFSET = emitValue(S_OFFSET);
            var COUNT = emitCount();
            if (typeof COUNT === "number") {
                if (COUNT === 0) return;
            } else {
                inner("if(", COUNT, "){");
                inner.exit("}");
            }
            var INSTANCES, EXT_INSTANCING;
            if (extInstancing) {
                INSTANCES = emitValue(S_INSTANCES);
                EXT_INSTANCING = env.instancing;
            }
            var ELEMENT_TYPE = ELEMENTS + ".type";
            var elementsStatic = drawOptions.elements && isStatic(drawOptions.elements) && !drawOptions.vaoActive;
            function emitInstancing() {
                function drawElements() {
                    inner(EXT_INSTANCING, ".drawElementsInstancedANGLE(", [
                        PRIMITIVE,
                        COUNT,
                        ELEMENT_TYPE,
                        OFFSET + "<<((" + ELEMENT_TYPE + "-" + GL_UNSIGNED_BYTE$8 + ")>>1)",
                        INSTANCES
                    ], ");");
                }
                function drawArrays() {
                    inner(EXT_INSTANCING, ".drawArraysInstancedANGLE(", [
                        PRIMITIVE,
                        OFFSET,
                        COUNT,
                        INSTANCES
                    ], ");");
                }
                if (ELEMENTS && ELEMENTS !== "null") {
                    if (!elementsStatic) {
                        inner("if(", ELEMENTS, "){");
                        drawElements();
                        inner("}else{");
                        drawArrays();
                        inner("}");
                    } else drawElements();
                } else drawArrays();
            }
            function emitRegular() {
                function drawElements() {
                    inner(GL + ".drawElements(" + [
                        PRIMITIVE,
                        COUNT,
                        ELEMENT_TYPE,
                        OFFSET + "<<((" + ELEMENT_TYPE + "-" + GL_UNSIGNED_BYTE$8 + ")>>1)"
                    ] + ");");
                }
                function drawArrays() {
                    inner(GL + ".drawArrays(" + [
                        PRIMITIVE,
                        OFFSET,
                        COUNT
                    ] + ");");
                }
                if (ELEMENTS && ELEMENTS !== "null") {
                    if (!elementsStatic) {
                        inner("if(", ELEMENTS, "){");
                        drawElements();
                        inner("}else{");
                        drawArrays();
                        inner("}");
                    } else drawElements();
                } else drawArrays();
            }
            if (extInstancing && (typeof INSTANCES !== "number" || INSTANCES >= 0)) {
                if (typeof INSTANCES === "string") {
                    inner("if(", INSTANCES, ">0){");
                    emitInstancing();
                    inner("}else if(", INSTANCES, "<0){");
                    emitRegular();
                    inner("}");
                } else emitInstancing();
            } else emitRegular();
        }
        function createBody(emitBody, parentEnv, args, program, count) {
            var env = createREGLEnvironment();
            var scope = env.proc("body", count);
            check$1.optional(function() {
                env.commandStr = parentEnv.commandStr;
                env.command = env.link(parentEnv.commandStr);
            });
            if (extInstancing) env.instancing = scope.def(env.shared.extensions, ".angle_instanced_arrays");
            emitBody(env, scope, args, program);
            return env.compile().body;
        }
        // ===================================================
        // ===================================================
        // DRAW PROC
        // ===================================================
        // ===================================================
        function emitDrawBody(env, draw, args, program) {
            injectExtensions(env, draw);
            if (args.useVAO) {
                if (args.drawVAO) draw(env.shared.vao, ".setVAO(", args.drawVAO.append(env, draw), ");");
                else draw(env.shared.vao, ".setVAO(", env.shared.vao, ".targetVAO);");
            } else {
                draw(env.shared.vao, ".setVAO(null);");
                emitAttributes(env, draw, args, program.attributes, function() {
                    return true;
                });
            }
            emitUniforms(env, draw, args, program.uniforms, function() {
                return true;
            }, false);
            emitDraw(env, draw, draw, args);
        }
        function emitDrawProc(env, args) {
            var draw = env.proc("draw", 1);
            injectExtensions(env, draw);
            emitContext(env, draw, args.context);
            emitPollFramebuffer(env, draw, args.framebuffer);
            emitPollState(env, draw, args);
            emitSetOptions(env, draw, args.state);
            emitProfile(env, draw, args, false, true);
            var program = args.shader.progVar.append(env, draw);
            draw(env.shared.gl, ".useProgram(", program, ".program);");
            if (args.shader.program) emitDrawBody(env, draw, args, args.shader.program);
            else {
                draw(env.shared.vao, ".setVAO(null);");
                var drawCache = env.global.def("{}");
                var PROG_ID = draw.def(program, ".id");
                var CACHED_PROC = draw.def(drawCache, "[", PROG_ID, "]");
                draw(env.cond(CACHED_PROC).then(CACHED_PROC, ".call(this,a0);").else(CACHED_PROC, "=", drawCache, "[", PROG_ID, "]=", env.link(function(program) {
                    return createBody(emitDrawBody, env, args, program, 1);
                }), "(", program, ");", CACHED_PROC, ".call(this,a0);"));
            }
            if (Object.keys(args.state).length > 0) draw(env.shared.current, ".dirty=true;");
            if (env.shared.vao) draw(env.shared.vao, ".setVAO(null);");
        }
        // ===================================================
        // ===================================================
        // BATCH PROC
        // ===================================================
        // ===================================================
        function emitBatchDynamicShaderBody(env, scope, args, program) {
            env.batchId = "a1";
            injectExtensions(env, scope);
            function all() {
                return true;
            }
            emitAttributes(env, scope, args, program.attributes, all);
            emitUniforms(env, scope, args, program.uniforms, all, false);
            emitDraw(env, scope, scope, args);
        }
        function emitBatchBody(env, scope, args, program) {
            injectExtensions(env, scope);
            var contextDynamic = args.contextDep;
            var BATCH_ID = scope.def();
            var PROP_LIST = "a0";
            var NUM_PROPS = "a1";
            var PROPS = scope.def();
            env.shared.props = PROPS;
            env.batchId = BATCH_ID;
            var outer = env.scope();
            var inner = env.scope();
            scope(outer.entry, "for(", BATCH_ID, "=0;", BATCH_ID, "<", NUM_PROPS, ";++", BATCH_ID, "){", PROPS, "=", PROP_LIST, "[", BATCH_ID, "];", inner, "}", outer.exit);
            function isInnerDefn(defn) {
                return defn.contextDep && contextDynamic || defn.propDep;
            }
            function isOuterDefn(defn) {
                return !isInnerDefn(defn);
            }
            if (args.needsContext) emitContext(env, inner, args.context);
            if (args.needsFramebuffer) emitPollFramebuffer(env, inner, args.framebuffer);
            emitSetOptions(env, inner, args.state, isInnerDefn);
            if (args.profile && isInnerDefn(args.profile)) emitProfile(env, inner, args, false, true);
            if (!program) {
                var progCache = env.global.def("{}");
                var PROGRAM = args.shader.progVar.append(env, inner);
                var PROG_ID = inner.def(PROGRAM, ".id");
                var CACHED_PROC = inner.def(progCache, "[", PROG_ID, "]");
                inner(env.shared.gl, ".useProgram(", PROGRAM, ".program);", "if(!", CACHED_PROC, "){", CACHED_PROC, "=", progCache, "[", PROG_ID, "]=", env.link(function(program) {
                    return createBody(emitBatchDynamicShaderBody, env, args, program, 2);
                }), "(", PROGRAM, ");}", CACHED_PROC, ".call(this,a0[", BATCH_ID, "],", BATCH_ID, ");");
            } else {
                if (args.useVAO) {
                    if (args.drawVAO) {
                        if (isInnerDefn(args.drawVAO)) // vao is a prop
                        inner(env.shared.vao, ".setVAO(", args.drawVAO.append(env, inner), ");");
                        else // vao is invariant
                        outer(env.shared.vao, ".setVAO(", args.drawVAO.append(env, outer), ");");
                    } else // scoped vao binding
                    outer(env.shared.vao, ".setVAO(", env.shared.vao, ".targetVAO);");
                } else {
                    outer(env.shared.vao, ".setVAO(null);");
                    emitAttributes(env, outer, args, program.attributes, isOuterDefn);
                    emitAttributes(env, inner, args, program.attributes, isInnerDefn);
                }
                emitUniforms(env, outer, args, program.uniforms, isOuterDefn, false);
                emitUniforms(env, inner, args, program.uniforms, isInnerDefn, true);
                emitDraw(env, outer, inner, args);
            }
        }
        function emitBatchProc(env, args) {
            var batch = env.proc("batch", 2);
            env.batchId = "0";
            injectExtensions(env, batch);
            // Check if any context variables depend on props
            var contextDynamic = false;
            var needsContext = true;
            Object.keys(args.context).forEach(function(name) {
                contextDynamic = contextDynamic || args.context[name].propDep;
            });
            if (!contextDynamic) {
                emitContext(env, batch, args.context);
                needsContext = false;
            }
            // framebuffer state affects framebufferWidth/height context vars
            var framebuffer = args.framebuffer;
            var needsFramebuffer = false;
            if (framebuffer) {
                if (framebuffer.propDep) contextDynamic = needsFramebuffer = true;
                else if (framebuffer.contextDep && contextDynamic) needsFramebuffer = true;
                if (!needsFramebuffer) emitPollFramebuffer(env, batch, framebuffer);
            } else emitPollFramebuffer(env, batch, null);
            // viewport is weird because it can affect context vars
            if (args.state.viewport && args.state.viewport.propDep) contextDynamic = true;
            function isInnerDefn(defn) {
                return defn.contextDep && contextDynamic || defn.propDep;
            }
            // set webgl options
            emitPollState(env, batch, args);
            emitSetOptions(env, batch, args.state, function(defn) {
                return !isInnerDefn(defn);
            });
            if (!args.profile || !isInnerDefn(args.profile)) emitProfile(env, batch, args, false, "a1");
            // Save these values to args so that the batch body routine can use them
            args.contextDep = contextDynamic;
            args.needsContext = needsContext;
            args.needsFramebuffer = needsFramebuffer;
            // determine if shader is dynamic
            var progDefn = args.shader.progVar;
            if (progDefn.contextDep && contextDynamic || progDefn.propDep) emitBatchBody(env, batch, args, null);
            else {
                var PROGRAM = progDefn.append(env, batch);
                batch(env.shared.gl, ".useProgram(", PROGRAM, ".program);");
                if (args.shader.program) emitBatchBody(env, batch, args, args.shader.program);
                else {
                    batch(env.shared.vao, ".setVAO(null);");
                    var batchCache = env.global.def("{}");
                    var PROG_ID = batch.def(PROGRAM, ".id");
                    var CACHED_PROC = batch.def(batchCache, "[", PROG_ID, "]");
                    batch(env.cond(CACHED_PROC).then(CACHED_PROC, ".call(this,a0,a1);").else(CACHED_PROC, "=", batchCache, "[", PROG_ID, "]=", env.link(function(program) {
                        return createBody(emitBatchBody, env, args, program, 2);
                    }), "(", PROGRAM, ");", CACHED_PROC, ".call(this,a0,a1);"));
                }
            }
            if (Object.keys(args.state).length > 0) batch(env.shared.current, ".dirty=true;");
            if (env.shared.vao) batch(env.shared.vao, ".setVAO(null);");
        }
        // ===================================================
        // ===================================================
        // SCOPE COMMAND
        // ===================================================
        // ===================================================
        function emitScopeProc(env, args) {
            var scope = env.proc("scope", 3);
            env.batchId = "a2";
            var shared = env.shared;
            var CURRENT_STATE = shared.current;
            emitContext(env, scope, args.context);
            if (args.framebuffer) args.framebuffer.append(env, scope);
            sortState(Object.keys(args.state)).forEach(function(name) {
                var defn = args.state[name];
                var value = defn.append(env, scope);
                if (isArrayLike(value)) value.forEach(function(v, i) {
                    scope.set(env.next[name], "[" + i + "]", v);
                });
                else scope.set(shared.next, "." + name, value);
            });
            emitProfile(env, scope, args, true, true);
            [
                S_ELEMENTS,
                S_OFFSET,
                S_COUNT,
                S_INSTANCES,
                S_PRIMITIVE
            ].forEach(function(opt) {
                var variable = args.draw[opt];
                if (!variable) return;
                scope.set(shared.draw, "." + opt, "" + variable.append(env, scope));
            });
            Object.keys(args.uniforms).forEach(function(opt) {
                var value = args.uniforms[opt].append(env, scope);
                if (Array.isArray(value)) value = "[" + value.join() + "]";
                scope.set(shared.uniforms, "[" + stringStore.id(opt) + "]", value);
            });
            Object.keys(args.attributes).forEach(function(name) {
                var record = args.attributes[name].append(env, scope);
                var scopeAttrib = env.scopeAttrib(name);
                Object.keys(new AttributeRecord()).forEach(function(prop) {
                    scope.set(scopeAttrib, "." + prop, record[prop]);
                });
            });
            if (args.scopeVAO) scope.set(shared.vao, ".targetVAO", args.scopeVAO.append(env, scope));
            function saveShader(name) {
                var shader = args.shader[name];
                if (shader) scope.set(shared.shader, "." + name, shader.append(env, scope));
            }
            saveShader(S_VERT);
            saveShader(S_FRAG);
            if (Object.keys(args.state).length > 0) {
                scope(CURRENT_STATE, ".dirty=true;");
                scope.exit(CURRENT_STATE, ".dirty=true;");
            }
            scope("a1(", env.shared.context, ",a0,", env.batchId, ");");
        }
        function isDynamicObject(object) {
            if (typeof object !== "object" || isArrayLike(object)) return;
            var props = Object.keys(object);
            for(var i = 0; i < props.length; ++i){
                if (dynamic.isDynamic(object[props[i]])) return true;
            }
            return false;
        }
        function splatObject(env, options, name) {
            var object = options.static[name];
            if (!object || !isDynamicObject(object)) return;
            var globals = env.global;
            var keys = Object.keys(object);
            var thisDep = false;
            var contextDep = false;
            var propDep = false;
            var objectRef = env.global.def("{}");
            keys.forEach(function(key) {
                var value = object[key];
                if (dynamic.isDynamic(value)) {
                    if (typeof value === "function") value = object[key] = dynamic.unbox(value);
                    var deps = createDynamicDecl(value, null);
                    thisDep = thisDep || deps.thisDep;
                    propDep = propDep || deps.propDep;
                    contextDep = contextDep || deps.contextDep;
                } else {
                    globals(objectRef, ".", key, "=");
                    switch(typeof value){
                        case "number":
                            globals(value);
                            break;
                        case "string":
                            globals('"', value, '"');
                            break;
                        case "object":
                            if (Array.isArray(value)) globals("[", value.join(), "]");
                            break;
                        default:
                            globals(env.link(value));
                            break;
                    }
                    globals(";");
                }
            });
            function appendBlock(env, block) {
                keys.forEach(function(key) {
                    var value = object[key];
                    if (!dynamic.isDynamic(value)) return;
                    var ref = env.invoke(block, value);
                    block(objectRef, ".", key, "=", ref, ";");
                });
            }
            options.dynamic[name] = new dynamic.DynamicVariable(DYN_THUNK, {
                thisDep: thisDep,
                contextDep: contextDep,
                propDep: propDep,
                ref: objectRef,
                append: appendBlock
            });
            delete options.static[name];
        }
        // ===========================================================================
        // ===========================================================================
        // MAIN DRAW COMMAND
        // ===========================================================================
        // ===========================================================================
        function compileCommand(options, attributes, uniforms, context, stats) {
            var env = createREGLEnvironment();
            // link stats, so that we can easily access it in the program.
            env.stats = env.link(stats);
            // splat options and attributes to allow for dynamic nested properties
            Object.keys(attributes.static).forEach(function(key) {
                splatObject(env, attributes, key);
            });
            NESTED_OPTIONS.forEach(function(name) {
                splatObject(env, options, name);
            });
            var args = parseArguments(options, attributes, uniforms, context, env);
            emitDrawProc(env, args);
            emitScopeProc(env, args);
            emitBatchProc(env, args);
            return extend(env.compile(), {
                destroy: function() {
                    args.shader.program.destroy();
                }
            });
        }
        // ===========================================================================
        // ===========================================================================
        // POLL / REFRESH
        // ===========================================================================
        // ===========================================================================
        return {
            next: nextState,
            current: currentState,
            procs: function() {
                var env = createREGLEnvironment();
                var poll = env.proc("poll");
                var refresh = env.proc("refresh");
                var common = env.block();
                poll(common);
                refresh(common);
                var shared = env.shared;
                var GL = shared.gl;
                var NEXT_STATE = shared.next;
                var CURRENT_STATE = shared.current;
                common(CURRENT_STATE, ".dirty=false;");
                emitPollFramebuffer(env, poll);
                emitPollFramebuffer(env, refresh, null, true);
                // Refresh updates all attribute state changes
                var INSTANCING;
                if (extInstancing) INSTANCING = env.link(extInstancing);
                // update vertex array bindings
                if (extensions.oes_vertex_array_object) refresh(env.link(extensions.oes_vertex_array_object), ".bindVertexArrayOES(null);");
                for(var i = 0; i < limits.maxAttributes; ++i){
                    var BINDING = refresh.def(shared.attributes, "[", i, "]");
                    var ifte = env.cond(BINDING, ".buffer");
                    ifte.then(GL, ".enableVertexAttribArray(", i, ");", GL, ".bindBuffer(", GL_ARRAY_BUFFER$2, ",", BINDING, ".buffer.buffer);", GL, ".vertexAttribPointer(", i, ",", BINDING, ".size,", BINDING, ".type,", BINDING, ".normalized,", BINDING, ".stride,", BINDING, ".offset);").else(GL, ".disableVertexAttribArray(", i, ");", GL, ".vertexAttrib4f(", i, ",", BINDING, ".x,", BINDING, ".y,", BINDING, ".z,", BINDING, ".w);", BINDING, ".buffer=null;");
                    refresh(ifte);
                    if (extInstancing) refresh(INSTANCING, ".vertexAttribDivisorANGLE(", i, ",", BINDING, ".divisor);");
                }
                refresh(env.shared.vao, ".currentVAO=null;", env.shared.vao, ".setVAO(", env.shared.vao, ".targetVAO);");
                Object.keys(GL_FLAGS).forEach(function(flag) {
                    var cap = GL_FLAGS[flag];
                    var NEXT = common.def(NEXT_STATE, ".", flag);
                    var block = env.block();
                    block("if(", NEXT, "){", GL, ".enable(", cap, ")}else{", GL, ".disable(", cap, ")}", CURRENT_STATE, ".", flag, "=", NEXT, ";");
                    refresh(block);
                    poll("if(", NEXT, "!==", CURRENT_STATE, ".", flag, "){", block, "}");
                });
                Object.keys(GL_VARIABLES).forEach(function(name) {
                    var func = GL_VARIABLES[name];
                    var init = currentState[name];
                    var NEXT, CURRENT;
                    var block = env.block();
                    block(GL, ".", func, "(");
                    if (isArrayLike(init)) {
                        var n = init.length;
                        NEXT = env.global.def(NEXT_STATE, ".", name);
                        CURRENT = env.global.def(CURRENT_STATE, ".", name);
                        block(loop(n, function(i) {
                            return NEXT + "[" + i + "]";
                        }), ");", loop(n, function(i) {
                            return CURRENT + "[" + i + "]=" + NEXT + "[" + i + "];";
                        }).join(""));
                        poll("if(", loop(n, function(i) {
                            return NEXT + "[" + i + "]!==" + CURRENT + "[" + i + "]";
                        }).join("||"), "){", block, "}");
                    } else {
                        NEXT = common.def(NEXT_STATE, ".", name);
                        CURRENT = common.def(CURRENT_STATE, ".", name);
                        block(NEXT, ");", CURRENT_STATE, ".", name, "=", NEXT, ";");
                        poll("if(", NEXT, "!==", CURRENT, "){", block, "}");
                    }
                    refresh(block);
                });
                return env.compile();
            }(),
            compile: compileCommand
        };
    }
    function stats() {
        return {
            vaoCount: 0,
            bufferCount: 0,
            elementsCount: 0,
            framebufferCount: 0,
            shaderCount: 0,
            textureCount: 0,
            cubeCount: 0,
            renderbufferCount: 0,
            maxTextureUnits: 0
        };
    }
    var GL_QUERY_RESULT_EXT = 0x8866;
    var GL_QUERY_RESULT_AVAILABLE_EXT = 0x8867;
    var GL_TIME_ELAPSED_EXT = 0x88BF;
    var createTimer = function(gl, extensions) {
        if (!extensions.ext_disjoint_timer_query) return null;
        // QUERY POOL BEGIN
        var queryPool = [];
        function allocQuery() {
            return queryPool.pop() || extensions.ext_disjoint_timer_query.createQueryEXT();
        }
        function freeQuery(query) {
            queryPool.push(query);
        }
        // QUERY POOL END
        var pendingQueries = [];
        function beginQuery(stats) {
            var query = allocQuery();
            extensions.ext_disjoint_timer_query.beginQueryEXT(GL_TIME_ELAPSED_EXT, query);
            pendingQueries.push(query);
            pushScopeStats(pendingQueries.length - 1, pendingQueries.length, stats);
        }
        function endQuery() {
            extensions.ext_disjoint_timer_query.endQueryEXT(GL_TIME_ELAPSED_EXT);
        }
        //
        // Pending stats pool.
        //
        function PendingStats() {
            this.startQueryIndex = -1;
            this.endQueryIndex = -1;
            this.sum = 0;
            this.stats = null;
        }
        var pendingStatsPool = [];
        function allocPendingStats() {
            return pendingStatsPool.pop() || new PendingStats();
        }
        function freePendingStats(pendingStats) {
            pendingStatsPool.push(pendingStats);
        }
        // Pending stats pool end
        var pendingStats = [];
        function pushScopeStats(start, end, stats) {
            var ps = allocPendingStats();
            ps.startQueryIndex = start;
            ps.endQueryIndex = end;
            ps.sum = 0;
            ps.stats = stats;
            pendingStats.push(ps);
        }
        // we should call this at the beginning of the frame,
        // in order to update gpuTime
        var timeSum = [];
        var queryPtr = [];
        function update() {
            var ptr, i;
            var n = pendingQueries.length;
            if (n === 0) return;
            // Reserve space
            queryPtr.length = Math.max(queryPtr.length, n + 1);
            timeSum.length = Math.max(timeSum.length, n + 1);
            timeSum[0] = 0;
            queryPtr[0] = 0;
            // Update all pending timer queries
            var queryTime = 0;
            ptr = 0;
            for(i = 0; i < pendingQueries.length; ++i){
                var query = pendingQueries[i];
                if (extensions.ext_disjoint_timer_query.getQueryObjectEXT(query, GL_QUERY_RESULT_AVAILABLE_EXT)) {
                    queryTime += extensions.ext_disjoint_timer_query.getQueryObjectEXT(query, GL_QUERY_RESULT_EXT);
                    freeQuery(query);
                } else pendingQueries[ptr++] = query;
                timeSum[i + 1] = queryTime;
                queryPtr[i + 1] = ptr;
            }
            pendingQueries.length = ptr;
            // Update all pending stat queries
            ptr = 0;
            for(i = 0; i < pendingStats.length; ++i){
                var stats = pendingStats[i];
                var start = stats.startQueryIndex;
                var end = stats.endQueryIndex;
                stats.sum += timeSum[end] - timeSum[start];
                var startPtr = queryPtr[start];
                var endPtr = queryPtr[end];
                if (endPtr === startPtr) {
                    stats.stats.gpuTime += stats.sum / 1e6;
                    freePendingStats(stats);
                } else {
                    stats.startQueryIndex = startPtr;
                    stats.endQueryIndex = endPtr;
                    pendingStats[ptr++] = stats;
                }
            }
            pendingStats.length = ptr;
        }
        return {
            beginQuery: beginQuery,
            endQuery: endQuery,
            pushScopeStats: pushScopeStats,
            update: update,
            getNumPendingQueries: function() {
                return pendingQueries.length;
            },
            clear: function() {
                queryPool.push.apply(queryPool, pendingQueries);
                for(var i = 0; i < queryPool.length; i++)extensions.ext_disjoint_timer_query.deleteQueryEXT(queryPool[i]);
                pendingQueries.length = 0;
                queryPool.length = 0;
            },
            restore: function() {
                pendingQueries.length = 0;
                queryPool.length = 0;
            }
        };
    };
    var GL_COLOR_BUFFER_BIT = 16384;
    var GL_DEPTH_BUFFER_BIT = 256;
    var GL_STENCIL_BUFFER_BIT = 1024;
    var GL_ARRAY_BUFFER = 34962;
    var CONTEXT_LOST_EVENT = "webglcontextlost";
    var CONTEXT_RESTORED_EVENT = "webglcontextrestored";
    var DYN_PROP = 1;
    var DYN_CONTEXT = 2;
    var DYN_STATE = 3;
    function find(haystack, needle) {
        for(var i = 0; i < haystack.length; ++i){
            if (haystack[i] === needle) return i;
        }
        return -1;
    }
    function wrapREGL(args) {
        var config = parseArgs(args);
        if (!config) return null;
        var gl = config.gl;
        var glAttributes = gl.getContextAttributes();
        var contextLost = gl.isContextLost();
        var extensionState = createExtensionCache(gl, config);
        if (!extensionState) return null;
        var stringStore = createStringStore();
        var stats$$1 = stats();
        var extensions = extensionState.extensions;
        var timer = createTimer(gl, extensions);
        var START_TIME = clock();
        var WIDTH = gl.drawingBufferWidth;
        var HEIGHT = gl.drawingBufferHeight;
        var contextState = {
            tick: 0,
            time: 0,
            viewportWidth: WIDTH,
            viewportHeight: HEIGHT,
            framebufferWidth: WIDTH,
            framebufferHeight: HEIGHT,
            drawingBufferWidth: WIDTH,
            drawingBufferHeight: HEIGHT,
            pixelRatio: config.pixelRatio
        };
        var uniformState = {};
        var drawState = {
            elements: null,
            primitive: 4,
            count: -1,
            offset: 0,
            instances: -1
        };
        var limits = wrapLimits(gl, extensions);
        var bufferState = wrapBufferState(gl, stats$$1, config, destroyBuffer);
        var elementState = wrapElementsState(gl, extensions, bufferState, stats$$1);
        var attributeState = wrapAttributeState(gl, extensions, limits, stats$$1, bufferState, elementState, drawState);
        function destroyBuffer(buffer) {
            return attributeState.destroyBuffer(buffer);
        }
        var shaderState = wrapShaderState(gl, stringStore, stats$$1, config);
        var textureState = createTextureSet(gl, extensions, limits, function() {
            core.procs.poll();
        }, contextState, stats$$1, config);
        var renderbufferState = wrapRenderbuffers(gl, extensions, limits, stats$$1, config);
        var framebufferState = wrapFBOState(gl, extensions, limits, textureState, renderbufferState, stats$$1);
        var core = reglCore(gl, stringStore, extensions, limits, bufferState, elementState, textureState, framebufferState, uniformState, attributeState, shaderState, drawState, contextState, timer, config);
        var readPixels = wrapReadPixels(gl, framebufferState, core.procs.poll, contextState, glAttributes, extensions, limits);
        var nextState = core.next;
        var canvas = gl.canvas;
        var rafCallbacks = [];
        var lossCallbacks = [];
        var restoreCallbacks = [];
        var destroyCallbacks = [
            config.onDestroy
        ];
        var activeRAF = null;
        function handleRAF() {
            if (rafCallbacks.length === 0) {
                if (timer) timer.update();
                activeRAF = null;
                return;
            }
            // schedule next animation frame
            activeRAF = raf.next(handleRAF);
            // poll for changes
            poll();
            // fire a callback for all pending rafs
            for(var i = rafCallbacks.length - 1; i >= 0; --i){
                var cb = rafCallbacks[i];
                if (cb) cb(contextState, null, 0);
            }
            // flush all pending webgl calls
            gl.flush();
            // poll GPU timers *after* gl.flush so we don't delay command dispatch
            if (timer) timer.update();
        }
        function startRAF() {
            if (!activeRAF && rafCallbacks.length > 0) activeRAF = raf.next(handleRAF);
        }
        function stopRAF() {
            if (activeRAF) {
                raf.cancel(handleRAF);
                activeRAF = null;
            }
        }
        function handleContextLoss(event) {
            event.preventDefault();
            // set context lost flag
            contextLost = true;
            // pause request animation frame
            stopRAF();
            // lose context
            lossCallbacks.forEach(function(cb) {
                cb();
            });
        }
        function handleContextRestored(event) {
            // clear error code
            gl.getError();
            // clear context lost flag
            contextLost = false;
            // refresh state
            extensionState.restore();
            shaderState.restore();
            bufferState.restore();
            textureState.restore();
            renderbufferState.restore();
            framebufferState.restore();
            attributeState.restore();
            if (timer) timer.restore();
            // refresh state
            core.procs.refresh();
            // restart RAF
            startRAF();
            // restore context
            restoreCallbacks.forEach(function(cb) {
                cb();
            });
        }
        if (canvas) {
            canvas.addEventListener(CONTEXT_LOST_EVENT, handleContextLoss, false);
            canvas.addEventListener(CONTEXT_RESTORED_EVENT, handleContextRestored, false);
        }
        function destroy() {
            rafCallbacks.length = 0;
            stopRAF();
            if (canvas) {
                canvas.removeEventListener(CONTEXT_LOST_EVENT, handleContextLoss);
                canvas.removeEventListener(CONTEXT_RESTORED_EVENT, handleContextRestored);
            }
            shaderState.clear();
            framebufferState.clear();
            renderbufferState.clear();
            attributeState.clear();
            textureState.clear();
            elementState.clear();
            bufferState.clear();
            if (timer) timer.clear();
            destroyCallbacks.forEach(function(cb) {
                cb();
            });
        }
        function compileProcedure(options) {
            check$1(!!options, "invalid args to regl({...})");
            check$1.type(options, "object", "invalid args to regl({...})");
            function flattenNestedOptions(options) {
                var result = extend({}, options);
                delete result.uniforms;
                delete result.attributes;
                delete result.context;
                delete result.vao;
                if ("stencil" in result && result.stencil.op) {
                    result.stencil.opBack = result.stencil.opFront = result.stencil.op;
                    delete result.stencil.op;
                }
                function merge(name) {
                    if (name in result) {
                        var child = result[name];
                        delete result[name];
                        Object.keys(child).forEach(function(prop) {
                            result[name + "." + prop] = child[prop];
                        });
                    }
                }
                merge("blend");
                merge("depth");
                merge("cull");
                merge("stencil");
                merge("polygonOffset");
                merge("scissor");
                merge("sample");
                if ("vao" in options) result.vao = options.vao;
                return result;
            }
            function separateDynamic(object, useArrays) {
                var staticItems = {};
                var dynamicItems = {};
                Object.keys(object).forEach(function(option) {
                    var value = object[option];
                    if (dynamic.isDynamic(value)) {
                        dynamicItems[option] = dynamic.unbox(value, option);
                        return;
                    } else if (useArrays && Array.isArray(value)) {
                        for(var i = 0; i < value.length; ++i)if (dynamic.isDynamic(value[i])) {
                            dynamicItems[option] = dynamic.unbox(value, option);
                            return;
                        }
                    }
                    staticItems[option] = value;
                });
                return {
                    dynamic: dynamicItems,
                    static: staticItems
                };
            }
            // Treat context variables separate from other dynamic variables
            var context = separateDynamic(options.context || {}, true);
            var uniforms = separateDynamic(options.uniforms || {}, true);
            var attributes = separateDynamic(options.attributes || {}, false);
            var opts = separateDynamic(flattenNestedOptions(options), false);
            var stats$$1 = {
                gpuTime: 0.0,
                cpuTime: 0.0,
                count: 0
            };
            var compiled = core.compile(opts, attributes, uniforms, context, stats$$1);
            var draw = compiled.draw;
            var batch = compiled.batch;
            var scope = compiled.scope;
            // FIXME: we should modify code generation for batch commands so this
            // isn't necessary
            var EMPTY_ARRAY = [];
            function reserve(count) {
                while(EMPTY_ARRAY.length < count)EMPTY_ARRAY.push(null);
                return EMPTY_ARRAY;
            }
            function REGLCommand(args, body) {
                var i;
                if (contextLost) check$1.raise("context lost");
                if (typeof args === "function") return scope.call(this, null, args, 0);
                else if (typeof body === "function") {
                    if (typeof args === "number") for(i = 0; i < args; ++i)scope.call(this, null, body, i);
                    else if (Array.isArray(args)) for(i = 0; i < args.length; ++i)scope.call(this, args[i], body, i);
                    else return scope.call(this, args, body, 0);
                } else if (typeof args === "number") {
                    if (args > 0) return batch.call(this, reserve(args | 0), args | 0);
                } else if (Array.isArray(args)) {
                    if (args.length) return batch.call(this, args, args.length);
                } else return draw.call(this, args);
            }
            return extend(REGLCommand, {
                stats: stats$$1,
                destroy: function() {
                    compiled.destroy();
                }
            });
        }
        var setFBO = framebufferState.setFBO = compileProcedure({
            framebuffer: dynamic.define.call(null, DYN_PROP, "framebuffer")
        });
        function clearImpl(_, options) {
            var clearFlags = 0;
            core.procs.poll();
            var c = options.color;
            if (c) {
                gl.clearColor(+c[0] || 0, +c[1] || 0, +c[2] || 0, +c[3] || 0);
                clearFlags |= GL_COLOR_BUFFER_BIT;
            }
            if ("depth" in options) {
                gl.clearDepth(+options.depth);
                clearFlags |= GL_DEPTH_BUFFER_BIT;
            }
            if ("stencil" in options) {
                gl.clearStencil(options.stencil | 0);
                clearFlags |= GL_STENCIL_BUFFER_BIT;
            }
            check$1(!!clearFlags, "called regl.clear with no buffer specified");
            gl.clear(clearFlags);
        }
        function clear(options) {
            check$1(typeof options === "object" && options, "regl.clear() takes an object as input");
            if ("framebuffer" in options) {
                if (options.framebuffer && options.framebuffer_reglType === "framebufferCube") for(var i = 0; i < 6; ++i)setFBO(extend({
                    framebuffer: options.framebuffer.faces[i]
                }, options), clearImpl);
                else setFBO(options, clearImpl);
            } else clearImpl(null, options);
        }
        function frame(cb) {
            check$1.type(cb, "function", "regl.frame() callback must be a function");
            rafCallbacks.push(cb);
            function cancel() {
                // FIXME:  should we check something other than equals cb here?
                // what if a user calls frame twice with the same callback...
                //
                var i = find(rafCallbacks, cb);
                check$1(i >= 0, "cannot cancel a frame twice");
                function pendingCancel() {
                    var index = find(rafCallbacks, pendingCancel);
                    rafCallbacks[index] = rafCallbacks[rafCallbacks.length - 1];
                    rafCallbacks.length -= 1;
                    if (rafCallbacks.length <= 0) stopRAF();
                }
                rafCallbacks[i] = pendingCancel;
            }
            startRAF();
            return {
                cancel: cancel
            };
        }
        // poll viewport
        function pollViewport() {
            var viewport = nextState.viewport;
            var scissorBox = nextState.scissor_box;
            viewport[0] = viewport[1] = scissorBox[0] = scissorBox[1] = 0;
            contextState.viewportWidth = contextState.framebufferWidth = contextState.drawingBufferWidth = viewport[2] = scissorBox[2] = gl.drawingBufferWidth;
            contextState.viewportHeight = contextState.framebufferHeight = contextState.drawingBufferHeight = viewport[3] = scissorBox[3] = gl.drawingBufferHeight;
        }
        function poll() {
            contextState.tick += 1;
            contextState.time = now();
            pollViewport();
            core.procs.poll();
        }
        function refresh() {
            textureState.refresh();
            pollViewport();
            core.procs.refresh();
            if (timer) timer.update();
        }
        function now() {
            return (clock() - START_TIME) / 1000.0;
        }
        refresh();
        function addListener(event, callback) {
            check$1.type(callback, "function", "listener callback must be a function");
            var callbacks;
            switch(event){
                case "frame":
                    return frame(callback);
                case "lost":
                    callbacks = lossCallbacks;
                    break;
                case "restore":
                    callbacks = restoreCallbacks;
                    break;
                case "destroy":
                    callbacks = destroyCallbacks;
                    break;
                default:
                    check$1.raise("invalid event, must be one of frame,lost,restore,destroy");
            }
            callbacks.push(callback);
            return {
                cancel: function() {
                    for(var i = 0; i < callbacks.length; ++i)if (callbacks[i] === callback) {
                        callbacks[i] = callbacks[callbacks.length - 1];
                        callbacks.pop();
                        return;
                    }
                }
            };
        }
        var regl = extend(compileProcedure, {
            // Clear current FBO
            clear: clear,
            // Short cuts for dynamic variables
            prop: dynamic.define.bind(null, DYN_PROP),
            context: dynamic.define.bind(null, DYN_CONTEXT),
            this: dynamic.define.bind(null, DYN_STATE),
            // executes an empty draw command
            draw: compileProcedure({}),
            // Resources
            buffer: function(options) {
                return bufferState.create(options, GL_ARRAY_BUFFER, false, false);
            },
            elements: function(options) {
                return elementState.create(options, false);
            },
            texture: textureState.create2D,
            cube: textureState.createCube,
            renderbuffer: renderbufferState.create,
            framebuffer: framebufferState.create,
            framebufferCube: framebufferState.createCube,
            vao: attributeState.createVAO,
            // Expose context attributes
            attributes: glAttributes,
            // Frame rendering
            frame: frame,
            on: addListener,
            // System limits
            limits: limits,
            hasExtension: function(name) {
                return limits.extensions.indexOf(name.toLowerCase()) >= 0;
            },
            // Read pixels
            read: readPixels,
            // Destroy regl and all associated resources
            destroy: destroy,
            // Direct GL state manipulation
            _gl: gl,
            _refresh: refresh,
            poll: function() {
                poll();
                if (timer) timer.update();
            },
            // Current time
            now: now,
            // regl Statistics Information
            stats: stats$$1
        });
        config.onDone(null, regl);
        return regl;
    }
    return wrapREGL;
});


const $745f5a1412ccd482$export$7d15b64cf5a3a4c4 = (x, min, max)=>x < min ? min : x > max ? max : x;
const $745f5a1412ccd482$export$ed542a978b878ee8 = (x)=>x > 0 ? x : 0;
const $745f5a1412ccd482$export$5c5ee632c52bc4a2 = (x)=>x < 0 ? 0 : x > 1 ? 1 : x;
const $745f5a1412ccd482$export$2cacbc8823b89e46 = (x)=>x < -1 ? -1 : x > 1 ? 1 : x;
const $745f5a1412ccd482$export$b45a0c02a3a6bd55 = (x)=>x < 0 ? 0 : x > 0.5 ? 0.5 : x;
const $745f5a1412ccd482$export$6fb785c609d82593 = (x, y)=>x < y ? [
        x,
        y
    ] : [
        y,
        x
    ];
const $745f5a1412ccd482$export$4997ffc0176396a6 = (x, min, max)=>{
    if (min === max) return min;
    if (x > max) {
        const d = max - min;
        x -= d;
        if (x > max) x -= d * ((x - min) / d | 0);
    } else if (x < min) {
        const d = max - min;
        x += d;
        if (x < min) x += d * ((min - x) / d + 1 | 0);
    }
    return x;
};
const $745f5a1412ccd482$export$a7a8c8bedec7ce92 = (x, min, max)=>x < min ? x - min + max : x > max ? x - max + min : x;
const $745f5a1412ccd482$export$69033939f8eff985 = (x)=>x < 0 ? x + 1 : x > 1 ? x - 1 : x;
const $745f5a1412ccd482$export$3b9374f2e8d1b471 = (x)=>x < -1 ? x + 2 : x > 1 ? x - 2 : x;
const $745f5a1412ccd482$export$412b6e2a7fbdce18 = (a, b)=>a <= b ? 0 : 1;
const $745f5a1412ccd482$export$5c7e4265f4166803 = (a, b, c)=>a <= b ? a <= c ? 0 : 2 : b <= c ? 1 : 2;
const $745f5a1412ccd482$export$abbc992e2f7a03ed = (a, b, c, d)=>a <= b ? a <= c ? a <= d ? 0 : 3 : c <= d ? 2 : 3 : b <= c ? b <= d ? 1 : 3 : c <= d ? 2 : 3;
const $745f5a1412ccd482$export$2e1916403c690d8e = (a, b)=>a >= b ? 0 : 1;
const $745f5a1412ccd482$export$530accaa463743fc = (a, b, c)=>a >= b ? a >= c ? 0 : 2 : b >= c ? 1 : 2;
const $745f5a1412ccd482$export$997ba4008db6478c = (a, b, c, d)=>a >= b ? a >= c ? a >= d ? 0 : 3 : c >= d ? 2 : 3 : b >= c ? b >= d ? 1 : 3 : c >= d ? 2 : 3;
const $745f5a1412ccd482$export$f77ef1d37ede6ae4 = (a, b)=>a !== 0 ? b !== 0 ? Math.min(a, b) : a : b;
const $745f5a1412ccd482$export$f930aa2517ecab05 = (a, b, c)=>$745f5a1412ccd482$export$f77ef1d37ede6ae4($745f5a1412ccd482$export$f77ef1d37ede6ae4(a, b), c);
const $745f5a1412ccd482$export$c64430f6ae3a9584 = (a, b, k)=>$745f5a1412ccd482$export$ae3040c47ea664a9(a, b, -k);
const $745f5a1412ccd482$export$ae3040c47ea664a9 = (a, b, k)=>{
    const ea = Math.exp(a * k);
    const eb = Math.exp(b * k);
    return (a * ea + b * eb) / (ea + eb);
};
const $745f5a1412ccd482$export$467571aff7e617ce = (x, min, max, k)=>$745f5a1412ccd482$export$c64430f6ae3a9584($745f5a1412ccd482$export$ae3040c47ea664a9(x, min, k), max, k);
const $745f5a1412ccd482$export$1f6feacb0939c1e9 = (a, b)=>Math.abs(a) < Math.abs(b) ? a : b;
const $745f5a1412ccd482$export$bb8a7d60274b5fc6 = (a, b)=>Math.abs(a) > Math.abs(b) ? a : b;
const $745f5a1412ccd482$export$f6826ccc4238a19 = (e, x)=>x < -e || x > e ? Math.abs(Math.abs((x - e) % (4 * e)) - 2 * e) - e : x;
const $745f5a1412ccd482$export$3d9f3a2fc40f5212 = (x)=>(x = Math.abs(x) % 2) > 1 ? 2 - x : x;
const $745f5a1412ccd482$export$ddf89a9c5af38f94 = (x, min, max)=>x >= min && x <= max;
const $745f5a1412ccd482$export$cc91a22e8d440ab2 = (x, min, max)=>x > min && x < max;



const $937d5a0bb1da012a$export$1991ecd29cc92c6b = (x, a, b)=>b !== a ? (x - a) / (b - a) : 0;
const $937d5a0bb1da012a$export$1e044b7877db048c = (x, a, b, c, d)=>c + (d - c) * $937d5a0bb1da012a$export$1991ecd29cc92c6b(x, a, b);
const $937d5a0bb1da012a$export$a896d6add2646fd2 = (x, a, b, c, d)=>c + (d - c) * (0, $745f5a1412ccd482$export$5c5ee632c52bc4a2)($937d5a0bb1da012a$export$1991ecd29cc92c6b(x, a, b));
const $937d5a0bb1da012a$export$327eb7d98ee125d5 = (x, a, b)=>a + (b - a) * (0, $745f5a1412ccd482$export$5c5ee632c52bc4a2)(x);
const $937d5a0bb1da012a$export$40f716fb91932333 = (x, a, b)=>b + (a - b) * (0, $745f5a1412ccd482$export$5c5ee632c52bc4a2)(x);
const $937d5a0bb1da012a$export$aa1505756b9c7cc9 = (x, a, b)=>a + (b - a) * (0.5 + 0.5 * (0, $745f5a1412ccd482$export$2cacbc8823b89e46)(x));


const $521e1c7ef76e7879$export$651a6eb01ea522f3 = (prefix, suffix = (msg)=>msg !== void 0 ? ": " + msg : "")=>class extends Error {
        origMessage;
        constructor(msg){
            super(prefix(msg) + suffix(msg));
            this.origMessage = msg !== void 0 ? String(msg) : "";
        }
    };


const $cd82484a6bd637f5$export$ab59e00737fb22e6 = (0, $521e1c7ef76e7879$export$651a6eb01ea522f3)(()=>"unsupported operation");
const $cd82484a6bd637f5$export$98e633703a635f = (msg)=>{
    throw new $cd82484a6bd637f5$export$ab59e00737fb22e6(msg);
};


const $ce0f4130aecaba84$export$c37d18c23b2ea60c = (dispatch = 0)=>{
    const impls = new Array(5);
    let fallback;
    const fn = (...args)=>{
        const g = impls[args[dispatch].length] || fallback;
        return g ? g(...args) : (0, $cd82484a6bd637f5$export$98e633703a635f)(`no impl for vec size ${args[dispatch].length}`);
    };
    fn.add = (dim, fn2)=>impls[dim] = fn2;
    fn.default = (fn2)=>fallback = fn2;
    fn.impl = (dim)=>impls[dim] || fallback;
    return fn;
};


const $e7044fd814a3a5d2$export$64da3195d9348dc4 = Object.freeze([
    1,
    0,
    0,
    1
]);
const $e7044fd814a3a5d2$export$74d08f64010bdae6 = Object.freeze([
    1,
    0,
    0,
    1,
    0,
    0
]);
const $e7044fd814a3a5d2$export$fd634c4b89e45776 = Object.freeze([
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1
]);
const $e7044fd814a3a5d2$export$80c2f4851e95e22e = Object.freeze([
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1
]);



const $3fde5d9792041b7b$export$772aa0961a81b065 = (0, $521e1c7ef76e7879$export$651a6eb01ea522f3)(()=>"illegal arity");
const $3fde5d9792041b7b$export$9f1b9fbfe882200d = (n)=>{
    throw new $3fde5d9792041b7b$export$772aa0961a81b065(n);
};


function $5c3fbc053132fc95$export$1af3c925c49f37a2(...fns) {
    let [a, b, c, d, e, f, g, h, i, j] = fns;
    switch(fns.length){
        case 0:
            (0, $3fde5d9792041b7b$export$9f1b9fbfe882200d)(0);
        case 1:
            return a;
        case 2:
            return (...args)=>a(b(...args));
        case 3:
            return (...args)=>a(b(c(...args)));
        case 4:
            return (...args)=>a(b(c(d(...args))));
        case 5:
            return (...args)=>a(b(c(d(e(...args)))));
        case 6:
            return (...args)=>a(b(c(d(e(f(...args))))));
        case 7:
            return (...args)=>a(b(c(d(e(f(g(...args)))))));
        case 8:
            return (...args)=>a(b(c(d(e(f(g(h(...args))))))));
        case 9:
            return (...args)=>a(b(c(d(e(f(g(h(i(...args)))))))));
        case 10:
        default:
            const fn = (...args)=>a(b(c(d(e(f(g(h(i(j(...args))))))))));
            return fns.length === 10 ? fn : $5c3fbc053132fc95$export$1af3c925c49f37a2(fn, ...fns.slice(10));
    }
}
function $5c3fbc053132fc95$export$83fc47c523588c98(...fns) {
    return $5c3fbc053132fc95$export$1af3c925c49f37a2.apply(null, fns.reverse());
}
const $5c3fbc053132fc95$export$fd785a9ec61dece = $5c3fbc053132fc95$export$83fc47c523588c98;
function $5c3fbc053132fc95$export$8679f38bd904e883(...fns) {
    return async (...args)=>{
        let n = fns.length - 1;
        let res = fns[n](...args);
        while(n-- > 0)res = await fns[n](res);
        return res;
    };
}


const $08bc73d2ebc432f9$export$c915e14294a7d06f = (x, fn)=>x != null && typeof x[fn] === "function";


const $ccf36540745cb062$export$eca2c7e8e95bbf0a = (x)=>(0, $08bc73d2ebc432f9$export$c915e14294a7d06f)(x, "xform") ? x.xform() : x;


function $b8979e7ade677472$export$1af3c925c49f37a2(...fns) {
    fns = fns.map((0, $ccf36540745cb062$export$eca2c7e8e95bbf0a));
    return (0, $5c3fbc053132fc95$export$1af3c925c49f37a2).apply(null, fns);
}


const $64d9aca3aee8e4b9$export$9652023d9040757 = (x)=>x != null && typeof x[Symbol.iterator] === "function";


const $31cc7fc06d902fae$export$5adef4befe47917 = (rfn, fn)=>[
        rfn[0],
        rfn[1],
        fn
    ];


const $275a54c6911d414f$export$47f9e8d3c41dafbd = 1e-6;
const $275a54c6911d414f$export$a7d1fa727cb10b0e = Symbol();
const $275a54c6911d414f$export$ca96bc7645ad7951 = ()=>{};
const $275a54c6911d414f$export$d97419887230d749 = "*";
const $275a54c6911d414f$export$ee2dc6a4697cf5e9 = "enable";
const $275a54c6911d414f$export$f631a292dd99edd2 = "disable";




const $bb8f9ef971ac0265$export$f0954fd7d5368655 = (x)=>x;
const $bb8f9ef971ac0265$export$ba9e5d519bc326ca = ()=>true;
const $bb8f9ef971ac0265$export$b3e22bcfd64c1022 = ()=>false;



const $1d9f7833d6adebd1$export$1e2f57719e155213 = (x)=>x != null && typeof x !== "function" && x.length !== void 0;




class $24420068dae7719b$export$ce266a425291df6c {
    value;
    constructor(val){
        this.value = val;
    }
    deref() {
        return this.value;
    }
}
const $24420068dae7719b$export$447808b60b7559bd = (x)=>new $24420068dae7719b$export$ce266a425291df6c(x);
const $24420068dae7719b$export$ebab785f9ea33473 = (x)=>x instanceof $24420068dae7719b$export$ce266a425291df6c;
const $24420068dae7719b$export$f2412ace46b7b087 = (x)=>x instanceof $24420068dae7719b$export$ce266a425291df6c ? x : new $24420068dae7719b$export$ce266a425291df6c(x);
const $24420068dae7719b$export$7ca7c14b24aa137b = (x)=>x instanceof $24420068dae7719b$export$ce266a425291df6c ? x.deref() : x;


const $e67d235236fef648$var$__parseArgs = (args)=>args.length === 2 ? [
        void 0,
        args[1]
    ] : args.length === 3 ? [
        args[1],
        args[2]
    ] : (0, $3fde5d9792041b7b$export$9f1b9fbfe882200d)(args.length);
function $e67d235236fef648$export$533b26079ad0b4b(...args) {
    const rfn = args[0];
    const init = rfn[0];
    const complete = rfn[1];
    const reduce2 = rfn[2];
    args = $e67d235236fef648$var$__parseArgs(args);
    const acc = args[0] == null ? init() : args[0];
    const src = args[1];
    return (0, $24420068dae7719b$export$7ca7c14b24aa137b)(complete((0, $08bc73d2ebc432f9$export$c915e14294a7d06f)(src, "$reduce") ? src.$reduce(reduce2, acc) : (0, $1d9f7833d6adebd1$export$1e2f57719e155213)(src) ? $e67d235236fef648$var$__reduceArray(reduce2, acc, src) : $e67d235236fef648$var$__reduceIterable(reduce2, acc, src)));
}
function $e67d235236fef648$export$7fef8bcdbb34f435(...args) {
    const [init, complete, reduce2] = args[0];
    args = $e67d235236fef648$var$__parseArgs(args);
    let acc = args[0] == null ? init() : args[0];
    const src = args[1];
    for(let i = src.length; i-- > 0;){
        acc = reduce2(acc, src[i]);
        if ((0, $24420068dae7719b$export$ebab785f9ea33473)(acc)) {
            acc = acc.deref();
            break;
        }
    }
    return (0, $24420068dae7719b$export$7ca7c14b24aa137b)(complete(acc));
}
const $e67d235236fef648$var$__reduceArray = (rfn, acc, src)=>{
    for(let i = 0, n = src.length; i < n; i++){
        acc = rfn(acc, src[i]);
        if ((0, $24420068dae7719b$export$ebab785f9ea33473)(acc)) {
            acc = acc.deref();
            break;
        }
    }
    return acc;
};
const $e67d235236fef648$var$__reduceIterable = (rfn, acc, src)=>{
    for (let x of src){
        acc = rfn(acc, x);
        if ((0, $24420068dae7719b$export$ebab785f9ea33473)(acc)) {
            acc = acc.deref();
            break;
        }
    }
    return acc;
};
const $e67d235236fef648$export$1650419e431d3ba3 = (init, rfn)=>[
        init,
        (0, $bb8f9ef971ac0265$export$f0954fd7d5368655),
        rfn
    ];
const $e67d235236fef648$export$8073770d92ccea36 = (rfn, args)=>{
    const n = args.length - 1;
    return (0, $64d9aca3aee8e4b9$export$9652023d9040757)(args[n]) ? args.length > 1 ? $e67d235236fef648$export$533b26079ad0b4b(rfn.apply(null, args.slice(0, n)), args[n]) : $e67d235236fef648$export$533b26079ad0b4b(rfn(), args[0]) : void 0;
};


function $bc042af5b33632ea$export$4cbf152802aa238(src) {
    return src ? [
        ...src
    ] : (0, $e67d235236fef648$export$1650419e431d3ba3)(()=>[], (acc, x)=>(acc.push(x), acc));
}



function* $1a329c38e8331817$export$6f58e2338da23f4d(xform, src) {
    const rfn = (0, $ccf36540745cb062$export$eca2c7e8e95bbf0a)(xform)((0, $bc042af5b33632ea$export$4cbf152802aa238)());
    const complete = rfn[1];
    const reduce = rfn[2];
    for (let x of src){
        const y = reduce([], x);
        if ((0, $24420068dae7719b$export$ebab785f9ea33473)(y)) {
            yield* (0, $24420068dae7719b$export$7ca7c14b24aa137b)(complete(y.deref()));
            return;
        }
        if (y.length) yield* y;
    }
    yield* (0, $24420068dae7719b$export$7ca7c14b24aa137b)(complete([]));
}
function* $1a329c38e8331817$export$a6bff14a9cefe0e8(xform, src) {
    const reduce = (0, $ccf36540745cb062$export$eca2c7e8e95bbf0a)(xform)([
        (0, $275a54c6911d414f$export$ca96bc7645ad7951),
        (0, $275a54c6911d414f$export$ca96bc7645ad7951),
        (_, x)=>x
    ])[2];
    for (let x of src){
        let y = reduce((0, $275a54c6911d414f$export$a7d1fa727cb10b0e), x);
        if ((0, $24420068dae7719b$export$ebab785f9ea33473)(y)) {
            y = (0, $24420068dae7719b$export$7ca7c14b24aa137b)(y.deref());
            if (y !== (0, $275a54c6911d414f$export$a7d1fa727cb10b0e)) yield y;
            return;
        }
        if (y !== (0, $275a54c6911d414f$export$a7d1fa727cb10b0e)) yield y;
    }
}
const $1a329c38e8331817$export$9b6eac2a13c3d07 = (xform, args, impl = $1a329c38e8331817$export$a6bff14a9cefe0e8)=>{
    const n = args.length - 1;
    return (0, $64d9aca3aee8e4b9$export$9652023d9040757)(args[n]) ? args.length > 1 ? impl(xform.apply(null, args.slice(0, n)), args[n]) : impl(xform(), args[0]) : void 0;
};


function $144ea14b4b25c10f$export$871de8747c9eaa88(fn, src) {
    return (0, $64d9aca3aee8e4b9$export$9652023d9040757)(src) ? (0, $1a329c38e8331817$export$a6bff14a9cefe0e8)($144ea14b4b25c10f$export$871de8747c9eaa88(fn), src) : (rfn)=>{
        const r = rfn[2];
        return (0, $31cc7fc06d902fae$export$5adef4befe47917)(rfn, (acc, x)=>r(acc, fn(x)));
    };
}
const $144ea14b4b25c10f$export$b876a215b1634849 = (fn, src)=>[
        ...$144ea14b4b25c10f$export$871de8747c9eaa88(fn, src)
    ];




function $f05f937702c6b261$export$e5bd5b3b105c2a71(...args) {
    return (0, $1a329c38e8331817$export$9b6eac2a13c3d07)($f05f937702c6b261$export$e5bd5b3b105c2a71, args) || ((rfn)=>{
        const r = rfn[2];
        const fn = args[0];
        let i = args[1] || 0;
        return (0, $31cc7fc06d902fae$export$5adef4befe47917)(rfn, (acc, x)=>r(acc, fn(i++, x)));
    });
}



function $8544cb43681d73a4$export$d02631cccf789723(from, to, step) {
    return new $8544cb43681d73a4$export$9a58ef0d7ad3278c(from, to, step);
}
class $8544cb43681d73a4$export$9a58ef0d7ad3278c {
    from;
    to;
    step;
    constructor(from, to, step){
        if (from === void 0) {
            from = 0;
            to = Infinity;
        } else if (to === void 0) {
            to = from;
            from = 0;
        }
        step = step === void 0 ? from < to ? 1 : -1 : step;
        this.from = from;
        this.to = to;
        this.step = step;
    }
    *[Symbol.iterator]() {
        let { from: from, to: to, step: step } = this;
        if (step > 0) while(from < to){
            yield from;
            from += step;
        }
        else if (step < 0) while(from > to){
            yield from;
            from += step;
        }
    }
    $reduce(rfn, acc) {
        const step = this.step;
        if (step > 0) for(let i = this.from, n = this.to; i < n && !(0, $24420068dae7719b$export$ebab785f9ea33473)(acc); i += step)acc = rfn(acc, i);
        else for(let i = this.from, n = this.to; i > n && !(0, $24420068dae7719b$export$ebab785f9ea33473)(acc); i += step)acc = rfn(acc, i);
        return acc;
    }
}



function $728f324fb171f2ec$export$42d51816ce590c93(sep, src) {
    sep = sep || "";
    let first = true;
    return src ? [
        ...src
    ].join(sep) : (0, $e67d235236fef648$export$1650419e431d3ba3)(()=>"", (acc, x)=>(acc = first ? acc + x : acc + sep + x, first = false, acc));
}






function $459c890b81fb29c3$export$b7df5d561049483a(n, src) {
    return (0, $64d9aca3aee8e4b9$export$9652023d9040757)(src) ? (0, $1a329c38e8331817$export$6f58e2338da23f4d)($459c890b81fb29c3$export$b7df5d561049483a(n), src) : (rfn)=>{
        const r = rfn[2];
        let m = n;
        return (0, $31cc7fc06d902fae$export$5adef4befe47917)(rfn, (acc, x)=>--m > 0 ? r(acc, x) : m === 0 ? (0, $24420068dae7719b$export$f2412ace46b7b087)(r(acc, x)) : (0, $24420068dae7719b$export$447808b60b7559bd)(acc));
    };
}






function $9bbb065ff197413d$export$9608d0eacffd6284(...args) {
    return $9bbb065ff197413d$var$$transduce($9bbb065ff197413d$export$9608d0eacffd6284, (0, $e67d235236fef648$export$533b26079ad0b4b), args);
}
function $9bbb065ff197413d$export$9127dcda72bf6aca(...args) {
    return $9bbb065ff197413d$var$$transduce($9bbb065ff197413d$export$9127dcda72bf6aca, (0, $e67d235236fef648$export$7fef8bcdbb34f435), args);
}
const $9bbb065ff197413d$var$$transduce = (tfn, rfn, args)=>{
    let acc, src;
    switch(args.length){
        case 4:
            src = args[3];
            acc = args[2];
            break;
        case 3:
            src = args[2];
            break;
        case 2:
            return (0, $144ea14b4b25c10f$export$871de8747c9eaa88)((x)=>tfn(args[0], args[1], x));
        default:
            (0, $3fde5d9792041b7b$export$9f1b9fbfe882200d)(args.length);
    }
    return rfn((0, $ccf36540745cb062$export$eca2c7e8e95bbf0a)(args[0])(args[1]), acc, src);
};


function* $0c4974ac081f3d26$export$8901015135f2fb22(...src) {
    const iters = src.map((s)=>s[Symbol.iterator]());
    while(true){
        const tuple = [];
        for (let i of iters){
            let v = i.next();
            if (v.done) return;
            tuple.push(v.value);
        }
        yield tuple;
    }
}



const $e0168624d1423262$export$19dc841295b49698 = "o,a";
const $e0168624d1423262$export$ccd27f3e7091205c = "o,a,b";
const $e0168624d1423262$export$eddecb323783c21c = "o,a,b,c";
const $e0168624d1423262$export$9e772ae751f37666 = "o,a,n";
const $e0168624d1423262$export$1b218a0354f287 = "o,a,n,b";
const $e0168624d1423262$export$df3e578f53e12bf2 = "o,a,b,n";
const $e0168624d1423262$export$8443f1c33458c80b = "io=0,ia=0,so=1,sa=1";
const $e0168624d1423262$export$ff73a40106eb353 = "io=0,ia=0,ib=0,so=1,sa=1,sb=1";
const $e0168624d1423262$export$bdb0d4b72a85649d = "io=0,ia=0,ib=0,ic=0,so=1,sa=1,sb=1,sc=1";
const $e0168624d1423262$export$381b62756f034f68 = "!o&&(o=a);";
const $e0168624d1423262$export$51277e3ac6690f26 = "!o&&(o=[]);";
const $e0168624d1423262$export$8c51af9235380b8e = "!a&&(a=[]);";
const $e0168624d1423262$export$da5c1e34018ecc43 = (op)=>([o, a, b])=>`${o}=${a}${op}${b};`;
const $e0168624d1423262$export$6ab71ad6f57b0093 = (op)=>([o, a])=>`${o}=${a}${op}n;`;
const $e0168624d1423262$export$124a2d9669280971 = (op1, op2)=>([o, a, b, c])=>`${o}=(${a}${op1}${b})${op2}${c};`;
const $e0168624d1423262$export$db7c5d9768fee3d9 = (op1, op2)=>([o, a, b])=>`${o}=(${a}${op1}${b})${op2}n;`;
const $e0168624d1423262$export$524378831b80c0aa = (op1, op2)=>([o, a, b])=>`${o}=(${a}${op1}n)${op2}${b};`;
const $e0168624d1423262$export$f160d69d51fe9b08 = (op)=>([o, a, b])=>`${o}=(${a}${op}${b})|0;`;
const $e0168624d1423262$export$6a70b64fb8d54a06 = (op)=>([o, a, b])=>`${o}=(${a}${op}${b})>>>0;`;
const $e0168624d1423262$export$b4ea1049a5419b4f = (op)=>([o, a])=>`${o}=(${a}${op}n)|0;`;
const $e0168624d1423262$export$9de9c213a2a487cd = (op)=>([o, a])=>`${o}=(${a}${op}n)>>>0;`;
const $e0168624d1423262$export$9092249dcc75f1af = (op = "op")=>([o, a])=>`${o}=${op}(${a});`;
const $e0168624d1423262$export$7b4ffff4916264f8 = (op = "op")=>([o, a, b])=>`${o}=${op}(${a},${b});`;
const $e0168624d1423262$export$a0a1b70ab8c960e8 = (op = "op")=>([o, a, b, c])=>`${o}=${op}(${a},${b},${c});`;
const $e0168624d1423262$export$a674f282bc507c82 = (op = "op")=>([o, a, b, c, d, e])=>`${o}=${op}(${a},${b},${c},${d},${e});`;
const $e0168624d1423262$export$feb62a864ec0d6e5 = (op = "op")=>([o, a])=>`${o}=${op}(${a},n);`;
const $e0168624d1423262$export$4061f92b6da4a345 = ([a, b])=>`${a}*${b}`;
const $e0168624d1423262$export$15e237ef180bd438 = ([a, b])=>`s+=${a}*${b};`;
const $e0168624d1423262$export$5e8f180ef0142226 = ([o, a])=>`${o}=${a};`;
const $e0168624d1423262$export$76aa35f56db04732 = ([a])=>`${a}=n;`;
const $e0168624d1423262$export$edd47d1eb2bf4a2e = ([o, a, b, c])=>`${o}=${a}+(${b}-${a})*${c};`;
const $e0168624d1423262$export$e6a01c2ca00499b1 = ([o, a, b])=>`${o}=${a}+(${b}-${a})*n;`;


const $8547a8b0e5e715cd$var$__lookup = (sym)=>(i)=>i > 1 ? `${sym}[i${sym}+${i}*s${sym}]` : i == 1 ? `${sym}[i${sym}+s${sym}]` : `${sym}[i${sym}]`;
const $8547a8b0e5e715cd$var$__indicesStrided = (sym)=>(0, $144ea14b4b25c10f$export$871de8747c9eaa88)($8547a8b0e5e715cd$var$__lookup(sym), (0, $8544cb43681d73a4$export$d02631cccf789723)());
const $8547a8b0e5e715cd$var$__indices = (sym)=>(0, $144ea14b4b25c10f$export$871de8747c9eaa88)((i)=>`${sym}[${i}]`, (0, $8544cb43681d73a4$export$d02631cccf789723)());
const $8547a8b0e5e715cd$var$__assemble = (dim, tpl, syms, ret = "a", opJoin = "", pre = "", post = "", strided = false)=>[
        pre,
        (0, $9bbb065ff197413d$export$9608d0eacffd6284)((0, $b8979e7ade677472$export$1af3c925c49f37a2)((0, $459c890b81fb29c3$export$b7df5d561049483a)(dim), (0, $f05f937702c6b261$export$e5bd5b3b105c2a71)((i, x)=>tpl(x, i))), (0, $728f324fb171f2ec$export$42d51816ce590c93)(opJoin), (0, $0c4974ac081f3d26$export$8901015135f2fb22).apply(null, syms.split(",").map(strided ? $8547a8b0e5e715cd$var$__indicesStrided : $8547a8b0e5e715cd$var$__indices))),
        post,
        ret !== "" ? `return ${ret};` : ""
    ];
const $8547a8b0e5e715cd$var$__assembleG = (tpl, syms, ret = "a", pre, post, strided = false)=>[
        pre,
        "for(let i=a.length;--i>=0;) {",
        tpl(syms.split(",").map(strided ? (x)=>`${x}[i${x}+i*s${x}]` : (x)=>`${x}[i]`)),
        "}",
        post,
        ret !== null ? `return ${ret};` : ""
    ];
const $8547a8b0e5e715cd$var$__assembleS = (tpl, syms = (0, $e0168624d1423262$export$ccd27f3e7091205c), ret = "o", pre = (0, $e0168624d1423262$export$381b62756f034f68), post)=>[
        pre,
        "while(k-->0) {",
        tpl(syms.split(",").map((x)=>`${x}[i${x}+k*s${x}]`)),
        "}",
        post,
        ret !== null ? `return ${ret};` : ""
    ];
const $8547a8b0e5e715cd$export$326bc8646b307e15 = (o, args)=>`!${o} && (${o}=${args.split(",")[1]});`;
const $8547a8b0e5e715cd$export$ef7acd7185315e22 = (dim, tpl, args, syms = args, ret = "a", opJoin, pre, post, strided = false)=>new Function(args, $8547a8b0e5e715cd$var$__assemble(dim, tpl, syms, ret, opJoin, pre, post, strided).join(""));
const $8547a8b0e5e715cd$export$419c6ef64208ae82 = (dim, fns, tpl, hofArgs, args, syms = args, ret = "a", opJoin = "", pre, post, strided = false)=>{
    return new Function(hofArgs, `return (${args})=>{${$8547a8b0e5e715cd$var$__assemble(dim, tpl, syms, ret, opJoin, pre, post, strided).join("")}}`)(...fns);
};
const $8547a8b0e5e715cd$export$aeba7862bf0c66c4 = (tpl, args, syms = args, ret = "a", pre, post, strided = false)=>new Function(args, $8547a8b0e5e715cd$var$__assembleG(tpl, syms, ret, pre, post, strided).join(""));
const $8547a8b0e5e715cd$export$6c4e26942fd16e7 = (tpl, args, syms = args, ret, pre, post)=>new Function(args, $8547a8b0e5e715cd$var$__assembleS(tpl, syms, ret, pre, post).join(""));
const $8547a8b0e5e715cd$export$a0e9b27d920ed100 = (fns, tpl, hofArgs, args, syms = args, ret = "a", pre, post, strided = false)=>new Function(hofArgs, `return (${args})=>{${$8547a8b0e5e715cd$var$__assembleG(tpl, syms, ret, pre, post, strided).join("")}}`)(...fns);
const $8547a8b0e5e715cd$export$e40cf5ce9a490533 = (tpl, args = (0, $e0168624d1423262$export$ccd27f3e7091205c), syms, ret = "o", dispatch = 1, pre)=>{
    syms = syms || args;
    pre = pre != null ? pre : $8547a8b0e5e715cd$export$326bc8646b307e15(ret, args);
    const fn = (0, $ce0f4130aecaba84$export$c37d18c23b2ea60c)(dispatch);
    const $ = (dim)=>fn.add(dim, $8547a8b0e5e715cd$export$ef7acd7185315e22(dim, tpl, args, syms, ret, "", pre));
    fn.default($8547a8b0e5e715cd$export$aeba7862bf0c66c4(tpl, args, syms, ret, pre));
    return [
        fn,
        $(2),
        $(3),
        $(4)
    ];
};
const $8547a8b0e5e715cd$export$a913b214497a4223 = (op)=>$8547a8b0e5e715cd$export$e40cf5ce9a490533((0, $e0168624d1423262$export$9092249dcc75f1af)(op), (0, $e0168624d1423262$export$19dc841295b49698));
const $8547a8b0e5e715cd$export$baa6c46b014ab275 = (op, tpl, args = (0, $e0168624d1423262$export$19dc841295b49698), syms, ret = "o", dispatch = 1, pre)=>{
    const _tpl = tpl || (0, $e0168624d1423262$export$9092249dcc75f1af)("op");
    syms = syms || args;
    pre = pre != null ? pre : $8547a8b0e5e715cd$export$326bc8646b307e15(ret, args);
    const fn = (0, $ce0f4130aecaba84$export$c37d18c23b2ea60c)(dispatch);
    const $ = (dim)=>fn.add(dim, $8547a8b0e5e715cd$export$419c6ef64208ae82(dim, [
            op
        ], _tpl, "op", args, syms, ret, "", pre));
    fn.default($8547a8b0e5e715cd$export$a0e9b27d920ed100([
        op
    ], _tpl, "op", args, syms, ret, pre));
    return [
        fn,
        $(2),
        $(3),
        $(4)
    ];
};
const $8547a8b0e5e715cd$export$503c6222d3c48f54 = (tpl, args = (0, $e0168624d1423262$export$ccd27f3e7091205c), idxArgs = (0, $e0168624d1423262$export$ff73a40106eb353), syms = (0, $e0168624d1423262$export$ccd27f3e7091205c), ret = "o", pre, sizes = [
    2,
    3,
    4
])=>[
        $8547a8b0e5e715cd$export$6c4e26942fd16e7(tpl, `${args},k,${idxArgs}`, syms, ret, pre),
        ...sizes.map((dim)=>$8547a8b0e5e715cd$export$ef7acd7185315e22(dim, tpl, `${args},${idxArgs}`, syms, ret, "", pre != null ? pre : $8547a8b0e5e715cd$export$326bc8646b307e15(ret, args), "", true))
    ];
const $8547a8b0e5e715cd$export$e2ee6e441c8b1312 = (op, tpl, args = (0, $e0168624d1423262$export$ccd27f3e7091205c), idxArgs = (0, $e0168624d1423262$export$ff73a40106eb353), syms = (0, $e0168624d1423262$export$ccd27f3e7091205c), ret = "o", pre, sizes = [
    2,
    3,
    4
])=>[
        new Function("op", `return (${args},k,${idxArgs})=>{${$8547a8b0e5e715cd$var$__assembleS(tpl, syms, ret, pre).join("")}}`)(op),
        ...sizes.map((dim)=>$8547a8b0e5e715cd$export$419c6ef64208ae82(dim, [
                op
            ], tpl, "op", `${args},${idxArgs}`, syms, ret, "", pre != null ? pre : $8547a8b0e5e715cd$export$326bc8646b307e15(ret, args), "", true))
    ];
const $8547a8b0e5e715cd$export$5d7f662452a819b3 = (op)=>$8547a8b0e5e715cd$export$e40cf5ce9a490533((0, $e0168624d1423262$export$da5c1e34018ecc43)(op));
const $8547a8b0e5e715cd$export$24ecd06eea36a882 = (op)=>$8547a8b0e5e715cd$export$e40cf5ce9a490533((0, $e0168624d1423262$export$6ab71ad6f57b0093)(op), (0, $e0168624d1423262$export$9e772ae751f37666));
const $8547a8b0e5e715cd$export$b74d4e1014d0409f = (op, signed = false)=>$8547a8b0e5e715cd$export$e40cf5ce9a490533((signed ? (0, $e0168624d1423262$export$f160d69d51fe9b08) : (0, $e0168624d1423262$export$6a70b64fb8d54a06))(op));
const $8547a8b0e5e715cd$export$e6949cab8a813996 = (op, signed = false)=>$8547a8b0e5e715cd$export$e40cf5ce9a490533((signed ? (0, $e0168624d1423262$export$b4ea1049a5419b4f) : (0, $e0168624d1423262$export$9de9c213a2a487cd))(op), (0, $e0168624d1423262$export$9e772ae751f37666));





const [$ac09487d499868c0$export$adaa4cf7ef1b65be, $ac09487d499868c0$export$55640438a4edf3d6, $ac09487d499868c0$export$9cbac02f28c9a9a9, $ac09487d499868c0$export$a7c139a4194832bf] = (0, $8547a8b0e5e715cd$export$e40cf5ce9a490533)((0, $e0168624d1423262$export$5e8f180ef0142226), "o,a", void 0, "o", 1, (0, $e0168624d1423262$export$51277e3ac6690f26));


const $f113437f833c8631$var$$ = (dim)=>(0, $ac09487d499868c0$export$adaa4cf7ef1b65be).add(dim, (0, $8547a8b0e5e715cd$export$ef7acd7185315e22)(dim, (0, $e0168624d1423262$export$5e8f180ef0142226), "o,a", void 0, "o"));
const $f113437f833c8631$export$adaa4cf7ef1b65be = (0, $ac09487d499868c0$export$adaa4cf7ef1b65be);
const $f113437f833c8631$export$d379fc4c87b9acab = (0, $ac09487d499868c0$export$a7c139a4194832bf);
const $f113437f833c8631$export$77ec42a105d94c7e = $f113437f833c8631$var$$(6);
const $f113437f833c8631$export$d42f9a6a7a8c83dc = $f113437f833c8631$var$$(9);
const $f113437f833c8631$export$aeecb9dad46c4519 = $f113437f833c8631$var$$(16);


const $2fbfcdfe1b5736bc$export$f0954fd7d5368655 = (0, $ce0f4130aecaba84$export$c37d18c23b2ea60c)();
const $2fbfcdfe1b5736bc$export$ea7cb2bbc85ece30 = $2fbfcdfe1b5736bc$export$f0954fd7d5368655.add(4, (m)=>(0, $f113437f833c8631$export$adaa4cf7ef1b65be)(m, (0, $e7044fd814a3a5d2$export$64da3195d9348dc4)));
const $2fbfcdfe1b5736bc$export$8ae60a66a11ed70f = $2fbfcdfe1b5736bc$export$f0954fd7d5368655.add(6, (m)=>(0, $f113437f833c8631$export$adaa4cf7ef1b65be)(m, (0, $e7044fd814a3a5d2$export$74d08f64010bdae6)));
const $2fbfcdfe1b5736bc$export$4c06ac0d3af2b36d = $2fbfcdfe1b5736bc$export$f0954fd7d5368655.add(9, (m)=>(0, $f113437f833c8631$export$adaa4cf7ef1b65be)(m, (0, $e7044fd814a3a5d2$export$fd634c4b89e45776)));
const $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5 = $2fbfcdfe1b5736bc$export$f0954fd7d5368655.add(16, (m)=>(0, $f113437f833c8631$export$adaa4cf7ef1b65be)(m, (0, $e7044fd814a3a5d2$export$80c2f4851e95e22e)));


const $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3 = Math.PI;
const $eedf3d90282d0b7e$export$ad5b0b9ab7d48f58 = $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3 * 2;
const $eedf3d90282d0b7e$export$f504979d7e0a75c7 = $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3 / 2;
const $eedf3d90282d0b7e$export$b1eb83e43ef0f9f8 = $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3 / 3;
const $eedf3d90282d0b7e$export$cfa25d10e00ab635 = $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3 / 4;
const $eedf3d90282d0b7e$export$4b53cc5148232136 = $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3 / 6;
const $eedf3d90282d0b7e$export$588dca789ffa0fd0 = 1 / $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3;
const $eedf3d90282d0b7e$export$3a7bf289cac70393 = 1 / $eedf3d90282d0b7e$export$ad5b0b9ab7d48f58;
const $eedf3d90282d0b7e$export$24b096bfbaf849b7 = 1 / $eedf3d90282d0b7e$export$f504979d7e0a75c7;
const $eedf3d90282d0b7e$export$460c4029b1a54a2e = $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3 / 180;
const $eedf3d90282d0b7e$export$914076c8150813e5 = 180 / $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3;
const $eedf3d90282d0b7e$export$ed904dc4011d96f7 = (1 + Math.sqrt(5)) / 2;
const $eedf3d90282d0b7e$export$3681641e15b6e2c3 = Math.SQRT2;
const $eedf3d90282d0b7e$export$1b2407b91ae96221 = Math.sqrt(3);
const $eedf3d90282d0b7e$export$2bfcf97b5c0e010 = $eedf3d90282d0b7e$export$3681641e15b6e2c3 / 2;
const $eedf3d90282d0b7e$export$d98365b4d5f896cf = $eedf3d90282d0b7e$export$1b2407b91ae96221 / 2;
const $eedf3d90282d0b7e$export$f76cf7896cad0d31 = 1 / 3;
const $eedf3d90282d0b7e$export$2ff8b3422c5a9edf = 2 / 3;
const $eedf3d90282d0b7e$export$d7977f56a0faa834 = 1 / 6;
let $eedf3d90282d0b7e$export$56469a43a57ad8b6 = 1e-6;


const $3b8164dc7437bdac$export$7d5e3328550ce0cd = (theta, n = 1)=>[
        Math.sin(theta) * n,
        Math.cos(theta) * n
    ];
const $3b8164dc7437bdac$export$5dceb76539a08116 = (theta, n = 1)=>[
        Math.cos(theta) * n,
        Math.sin(theta) * n
    ];
const $3b8164dc7437bdac$export$8e3badfd6976e5c = (theta)=>(theta %= (0, $eedf3d90282d0b7e$export$ad5b0b9ab7d48f58), theta < 0 ? (0, $eedf3d90282d0b7e$export$ad5b0b9ab7d48f58) + theta : theta);
const $3b8164dc7437bdac$export$bc9a8c093c36a624 = (theta)=>(theta = Math.abs(theta), theta > (0, $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3) ? (0, $eedf3d90282d0b7e$export$ad5b0b9ab7d48f58) - theta : theta);
const $3b8164dc7437bdac$export$28d974ff8f7517ed = (a, b)=>$3b8164dc7437bdac$export$bc9a8c093c36a624($3b8164dc7437bdac$export$8e3badfd6976e5c(b % (0, $eedf3d90282d0b7e$export$ad5b0b9ab7d48f58) - a % (0, $eedf3d90282d0b7e$export$ad5b0b9ab7d48f58)));
const $3b8164dc7437bdac$export$64813598e5fb2450 = (y, x)=>$3b8164dc7437bdac$export$8e3badfd6976e5c(Math.atan2(y, x));
const $3b8164dc7437bdac$export$2332ba17bcdd284d = (theta)=>$3b8164dc7437bdac$export$8e3badfd6976e5c(theta) * (0, $eedf3d90282d0b7e$export$24b096bfbaf849b7) | 0;
const $3b8164dc7437bdac$export$61ddd819c68acdd = (theta)=>theta * (0, $eedf3d90282d0b7e$export$914076c8150813e5);
const $3b8164dc7437bdac$export$29e4e862bebba87f = (theta)=>theta * (0, $eedf3d90282d0b7e$export$460c4029b1a54a2e);
const $3b8164dc7437bdac$export$a830b5ed334924be = (theta)=>1 / Math.sin(theta);
const $3b8164dc7437bdac$export$e17a63917e2ebf0f = (theta)=>1 / Math.cos(theta);
const $3b8164dc7437bdac$export$ef569ec50496610c = (theta)=>1 / Math.tan(theta);
const $3b8164dc7437bdac$export$ebcbd32ce8d4cff = (a, b, gamma)=>Math.sqrt(a * a + b * b - 2 * a * b * Math.cos(gamma));
const $3b8164dc7437bdac$export$c0a907f067762f6e = (x)=>{
    const x2 = x * x;
    return 1 + x2 * (-4 + 2 * x2);
};
const $3b8164dc7437bdac$var$__fastCos = (x)=>{
    const x2 = x * x;
    return 0.99940307 + x2 * (-0.49558072 + 0.03679168 * x2);
};
const $3b8164dc7437bdac$export$3c8033b41bb9b535 = (theta)=>{
    theta %= (0, $eedf3d90282d0b7e$export$ad5b0b9ab7d48f58);
    theta < 0 && (theta = -theta);
    switch(theta * (0, $eedf3d90282d0b7e$export$24b096bfbaf849b7) | 0){
        case 0:
            return $3b8164dc7437bdac$var$__fastCos(theta);
        case 1:
            return -$3b8164dc7437bdac$var$__fastCos((0, $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3) - theta);
        case 2:
            return -$3b8164dc7437bdac$var$__fastCos(theta - (0, $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3));
        default:
            return $3b8164dc7437bdac$var$__fastCos((0, $eedf3d90282d0b7e$export$ad5b0b9ab7d48f58) - theta);
    }
};
const $3b8164dc7437bdac$export$5a59657e318cc2cf = (theta)=>$3b8164dc7437bdac$export$3c8033b41bb9b535((0, $eedf3d90282d0b7e$export$f504979d7e0a75c7) - theta);
const $3b8164dc7437bdac$export$8019a7ebe7afe6d9 = (deg2, min, sec2)=>deg2 + min / 60 + sec2 / 3600;
const $3b8164dc7437bdac$export$6804273a91971333 = (theta)=>{
    const sign = Math.sign(theta);
    theta = Math.abs(theta);
    const deg2 = Math.trunc(theta);
    theta = (theta - deg2) * 60;
    const min = Math.trunc(theta);
    return [
        deg2 * sign,
        min,
        (theta - min) * 60
    ];
};





const $ffcd9b5535f0b297$var$$ = (dim)=>$ffcd9b5535f0b297$export$57ce51e080b800.add(dim, (0, $8547a8b0e5e715cd$export$ef7acd7185315e22)(dim, ([a])=>`${a}*${a}`, "a", "a", "", "+", "return ", ";"));
const $ffcd9b5535f0b297$export$57ce51e080b800 = (0, $ce0f4130aecaba84$export$c37d18c23b2ea60c)();
$ffcd9b5535f0b297$export$57ce51e080b800.default((0, $8547a8b0e5e715cd$export$aeba7862bf0c66c4)(([a])=>`sum+=${a}*${a};`, "a", void 0, "sum", "let sum=0;"));
const $ffcd9b5535f0b297$export$52e6e29c5689a25f = $ffcd9b5535f0b297$var$$(2);
const $ffcd9b5535f0b297$export$9bdeebc943bb634d = $ffcd9b5535f0b297$var$$(3);
const $ffcd9b5535f0b297$export$af0b3789fa343fbd = $ffcd9b5535f0b297$var$$(4);


const $1d4ecc6718be3f21$export$1b9bab504faa9305 = (v)=>Math.sqrt((0, $ffcd9b5535f0b297$export$57ce51e080b800)(v));
const $1d4ecc6718be3f21$export$a3e8187e04b23f9d = (v)=>Math.sqrt((0, $ffcd9b5535f0b297$export$52e6e29c5689a25f)(v));
const $1d4ecc6718be3f21$export$d5377aec8e8e1831 = (v)=>Math.sqrt((0, $ffcd9b5535f0b297$export$9bdeebc943bb634d)(v));
const $1d4ecc6718be3f21$export$a346c4a3bf827372 = (v)=>Math.sqrt((0, $ffcd9b5535f0b297$export$af0b3789fa343fbd)(v));




const [$86721001f8014b70$export$523c9d3eb3d8d990, $86721001f8014b70$export$b54ddf06b57709b1, $86721001f8014b70$export$1c0ad2738a5ae4b0, $86721001f8014b70$export$1f214a01989f466a] = (0, $8547a8b0e5e715cd$export$24ecd06eea36a882)("*");



const $8778c839920652eb$export$a3295358bff77e = (out, v, n = 1)=>{
    !out && (out = v);
    const m = (0, $1d4ecc6718be3f21$export$1b9bab504faa9305)(v);
    return m >= (0, $eedf3d90282d0b7e$export$56469a43a57ad8b6) ? (0, $86721001f8014b70$export$523c9d3eb3d8d990)(out, v, n / m) : out !== v ? (0, $ac09487d499868c0$export$adaa4cf7ef1b65be)(out, v) : out;
};
const $8778c839920652eb$export$cb6730ea375ab516 = (out, v, n = 1)=>{
    !out && (out = v);
    const m = Math.sqrt((0, $ffcd9b5535f0b297$export$52e6e29c5689a25f)(v));
    return m >= (0, $eedf3d90282d0b7e$export$56469a43a57ad8b6) ? (0, $86721001f8014b70$export$b54ddf06b57709b1)(out, v, n / m) : out !== v ? (0, $ac09487d499868c0$export$55640438a4edf3d6)(out, v) : out;
};
const $8778c839920652eb$export$6feaa6aa9769ce13 = (out, v, n = 1)=>{
    !out && (out = v);
    const m = Math.sqrt((0, $ffcd9b5535f0b297$export$9bdeebc943bb634d)(v));
    return m >= (0, $eedf3d90282d0b7e$export$56469a43a57ad8b6) ? (0, $86721001f8014b70$export$1c0ad2738a5ae4b0)(out, v, n / m) : out !== v ? (0, $ac09487d499868c0$export$9cbac02f28c9a9a9)(out, v) : out;
};
const $8778c839920652eb$export$e630f428d5718f7b = (out, v, n = 1)=>{
    !out && (out = v);
    const m = Math.sqrt((0, $ffcd9b5535f0b297$export$af0b3789fa343fbd)(v));
    return m >= (0, $eedf3d90282d0b7e$export$56469a43a57ad8b6) ? (0, $86721001f8014b70$export$1f214a01989f466a)(out, v, n / m) : out !== v ? (0, $ac09487d499868c0$export$a7c139a4194832bf)(out, v) : out;
};


const $5d21eae0771d5dbf$export$dcfbb7940cfb3a48 = (out, x, y)=>(!out && (out = []), out[0] = x, out[1] = y, out);
const $5d21eae0771d5dbf$export$ba8c70ce75474f8d = (out, x, y, z)=>(!out && (out = []), out[0] = x, out[1] = y, out[2] = z, out);
const $5d21eae0771d5dbf$export$abee0037e1db715 = (out, x, y, z, w)=>(!out && (out = []), out[0] = x, out[1] = y, out[2] = z, out[3] = w, out);
const $5d21eae0771d5dbf$export$d58a46c754825a51 = (out, a, b, c, d, e, f)=>(!out && (out = []), out[0] = a, out[1] = b, out[2] = c, out[3] = d, out[4] = e, out[5] = f, out);
const $5d21eae0771d5dbf$export$644e79245f7d24b5 = (out, ...values)=>{
    if (!out) return values;
    for(let i = 0, n = values.length; i < n; i++)out[i] = values[i];
    return out;
};



const $e445da8cc2d7ba13$export$c3d49302a4b760b2 = (out, m33)=>(0, $5d21eae0771d5dbf$export$644e79245f7d24b5)(out || [], // x
    m33[0], m33[1], m33[2], 0, // y
    m33[3], m33[4], m33[5], 0, // z
    m33[6], m33[7], m33[8], 0, // w
    0, 0, 0, 1);


const $9245048e660b6c56$export$91ef8150045801d7 = (out, axis, theta, normalize = false)=>{
    const [x, y, z] = normalize ? (0, $8778c839920652eb$export$6feaa6aa9769ce13)([], axis) : axis;
    const [s, c] = (0, $3b8164dc7437bdac$export$7d5e3328550ce0cd)(theta);
    const t = 1 - c;
    const xs = x * s;
    const ys = y * s;
    const zs = z * s;
    const xt = x * t;
    const yt = y * t;
    const zt = z * t;
    return (0, $5d21eae0771d5dbf$export$644e79245f7d24b5)(out || [], x * xt + c, y * xt + zs, z * xt - ys, x * yt - zs, y * yt + c, z * yt + xs, x * zt + ys, y * zt - xs, z * zt + c);
};
const $9245048e660b6c56$export$6af315cc92b6bcce = (out, axis, theta, normalize = false)=>(0, $e445da8cc2d7ba13$export$c3d49302a4b760b2)(out, $9245048e660b6c56$export$91ef8150045801d7([], axis, theta, normalize));




const $0b50ab5713b0cab7$export$89b5708c387cac6c = (out, left, right, bottom, top, near, far)=>{
    const dx = 1 / (right - left);
    const dy = 1 / (top - bottom);
    const dz = 1 / (far - near);
    return (0, $5d21eae0771d5dbf$export$644e79245f7d24b5)(out || [], near * 2 * dx, 0, 0, 0, 0, near * 2 * dy, 0, 0, (right + left) * dx, (top + bottom) * dy, -(far + near) * dz, -1, 0, 0, -(far * near * 2) * dz, 0);
};
const $0b50ab5713b0cab7$export$afe7eeb07fe5f7b2 = (fovy, aspect, near, far)=>{
    const top = near * Math.tan(fovy * (0, $eedf3d90282d0b7e$export$460c4029b1a54a2e) / 2);
    const right = top * aspect;
    return {
        left: -right,
        right: right,
        bottom: -top,
        top: top,
        near: near,
        far: far
    };
};


const $2aa49d03cb7ea07e$export$541149539f3a4684 = (out, fov, aspect, near, far)=>{
    const f = (0, $0b50ab5713b0cab7$export$afe7eeb07fe5f7b2)(fov, aspect, near, far);
    return (0, $0b50ab5713b0cab7$export$89b5708c387cac6c)(out, f.left, f.right, f.bottom, f.top, f.near, f.far);
};



const $748f7c848266c563$export$78421b6cc4d5c0fa = (a, b)=>a[0] * b[1] - a[1] * b[0];
const $748f7c848266c563$export$ea0ef2e80b79c3dc = (out, a, b)=>(0, $5d21eae0771d5dbf$export$ba8c70ce75474f8d)(out || a, a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]);





const $e745c28ee96bfee5$var$$ = (dim)=>$e745c28ee96bfee5$export$94132a0e348806d4.add(dim, (0, $8547a8b0e5e715cd$export$ef7acd7185315e22)(dim, (0, $e0168624d1423262$export$4061f92b6da4a345), "a,b", void 0, "", "+", "return ", ";"));
const $e745c28ee96bfee5$export$94132a0e348806d4 = (0, $ce0f4130aecaba84$export$c37d18c23b2ea60c)();
$e745c28ee96bfee5$export$94132a0e348806d4.default((0, $8547a8b0e5e715cd$export$aeba7862bf0c66c4)((0, $e0168624d1423262$export$15e237ef180bd438), "a,b", void 0, "s", "let s=0;"));
const $e745c28ee96bfee5$export$fe6a5064d53faf98 = $e745c28ee96bfee5$var$$(2);
const $e745c28ee96bfee5$export$6f9aa2c904053c13 = $e745c28ee96bfee5$var$$(3);
const $e745c28ee96bfee5$export$2e1971da4e839d07 = $e745c28ee96bfee5$var$$(4);





const [$fd7187d8c34fec7e$export$f93b5905241a7cca, $fd7187d8c34fec7e$export$27409c384c4283a, $fd7187d8c34fec7e$export$4d77c846ee8dc708, $fd7187d8c34fec7e$export$317805a8a51cab87] = (0, $8547a8b0e5e715cd$export$5d7f662452a819b3)("-");


const $c89cf6c34e6d5f69$export$d924e14fd6d9aa66 = (out, eye, target, up)=>{
    const z = (0, $8778c839920652eb$export$6feaa6aa9769ce13)(null, (0, $fd7187d8c34fec7e$export$4d77c846ee8dc708)([], eye, target));
    const x = (0, $8778c839920652eb$export$6feaa6aa9769ce13)(null, (0, $748f7c848266c563$export$ea0ef2e80b79c3dc)([], up, z));
    const y = (0, $8778c839920652eb$export$6feaa6aa9769ce13)(null, (0, $748f7c848266c563$export$ea0ef2e80b79c3dc)([], z, x));
    return (0, $5d21eae0771d5dbf$export$644e79245f7d24b5)(out || [], x[0], y[0], z[0], 0, x[1], y[1], z[1], 0, x[2], y[2], z[2], 0, -(0, $e745c28ee96bfee5$export$6f9aa2c904053c13)(eye, x), -(0, $e745c28ee96bfee5$export$6f9aa2c904053c13)(eye, y), -(0, $e745c28ee96bfee5$export$6f9aa2c904053c13)(eye, z), 1);
};




const $39c25606322173b2$export$d1abfbcc2687ddc4 = (a, b, n, ia = 0, ib = 0, sa = 1, sb = 1)=>{
    let sum = 0;
    for(; n-- > 0; ia += sa, ib += sb)sum += a[ia] * b[ib];
    return sum;
};
const $39c25606322173b2$var$$ = (dim)=>(0, $8547a8b0e5e715cd$export$ef7acd7185315e22)(dim, (0, $e0168624d1423262$export$4061f92b6da4a345), `o,a,${(0, $e0168624d1423262$export$8443f1c33458c80b)}`, "o,a", "", "+", "return ", ";", true);
const $39c25606322173b2$export$cf66b157879064b6 = $39c25606322173b2$var$$(2);
const $39c25606322173b2$export$78ae608fdbee4899 = $39c25606322173b2$var$$(3);
const $39c25606322173b2$export$7cff64c0e2ba076b = $39c25606322173b2$var$$(4);




const $6d7c0a538c53a7fd$export$be747b9875ee8d57 = (0, $ce0f4130aecaba84$export$c37d18c23b2ea60c)(1);
const $6d7c0a538c53a7fd$export$de5af41c80c52aa8 = $6d7c0a538c53a7fd$export$be747b9875ee8d57.add(4, (out, a, b)=>(0, $5d21eae0771d5dbf$export$abee0037e1db715)(out || a, (0, $39c25606322173b2$export$cf66b157879064b6)(a, b, 0, 0, 2), (0, $39c25606322173b2$export$cf66b157879064b6)(a, b, 1, 0, 2), (0, $39c25606322173b2$export$cf66b157879064b6)(a, b, 0, 2, 2), (0, $39c25606322173b2$export$cf66b157879064b6)(a, b, 1, 2, 2)));
const $6d7c0a538c53a7fd$export$5f0e2c1a57f7d606 = $6d7c0a538c53a7fd$export$be747b9875ee8d57.add(6, (out, a, b)=>(0, $5d21eae0771d5dbf$export$d58a46c754825a51)(out || a, (0, $39c25606322173b2$export$cf66b157879064b6)(a, b, 0, 0, 2), (0, $39c25606322173b2$export$cf66b157879064b6)(a, b, 1, 0, 2), (0, $39c25606322173b2$export$cf66b157879064b6)(a, b, 0, 2, 2), (0, $39c25606322173b2$export$cf66b157879064b6)(a, b, 1, 2, 2), (0, $39c25606322173b2$export$cf66b157879064b6)(a, b, 0, 4, 2) + a[4], (0, $39c25606322173b2$export$cf66b157879064b6)(a, b, 1, 4, 2) + a[5]));
const $6d7c0a538c53a7fd$export$3dc99354cf2f3904 = $6d7c0a538c53a7fd$export$be747b9875ee8d57.add(9, (out, a, b)=>(0, $5d21eae0771d5dbf$export$644e79245f7d24b5)(out || a, (0, $39c25606322173b2$export$78ae608fdbee4899)(a, b, 0, 0, 3), (0, $39c25606322173b2$export$78ae608fdbee4899)(a, b, 1, 0, 3), (0, $39c25606322173b2$export$78ae608fdbee4899)(a, b, 2, 0, 3), (0, $39c25606322173b2$export$78ae608fdbee4899)(a, b, 0, 3, 3), (0, $39c25606322173b2$export$78ae608fdbee4899)(a, b, 1, 3, 3), (0, $39c25606322173b2$export$78ae608fdbee4899)(a, b, 2, 3, 3), (0, $39c25606322173b2$export$78ae608fdbee4899)(a, b, 0, 6, 3), (0, $39c25606322173b2$export$78ae608fdbee4899)(a, b, 1, 6, 3), (0, $39c25606322173b2$export$78ae608fdbee4899)(a, b, 2, 6, 3)));
const $6d7c0a538c53a7fd$export$d012f6a5572fd758 = $6d7c0a538c53a7fd$export$be747b9875ee8d57.add(16, (out, a, b)=>(0, $5d21eae0771d5dbf$export$644e79245f7d24b5)(out || a, (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 0, 0, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 1, 0, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 2, 0, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 3, 0, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 0, 4, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 1, 4, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 2, 4, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 3, 4, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 0, 8, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 1, 8, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 2, 8, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 3, 8, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 0, 12, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 1, 12, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 2, 12, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(a, b, 3, 12, 4)));


const $f53b42fca9402ef8$export$ee1b3e54f0441b22 = (out, a, b, ...rest)=>rest.reduce((acc, x)=>(0, $6d7c0a538c53a7fd$export$be747b9875ee8d57)(acc, acc, x), (0, $6d7c0a538c53a7fd$export$be747b9875ee8d57)(out, a, b));






const $38addd61b75018c2$export$8eba860695d17007 = (0, $ce0f4130aecaba84$export$c37d18c23b2ea60c)(1);
const $38addd61b75018c2$export$24a22303e458dfa5 = $38addd61b75018c2$export$8eba860695d17007.add(4, (out, m, v)=>(0, $5d21eae0771d5dbf$export$dcfbb7940cfb3a48)(out || v, (0, $39c25606322173b2$export$cf66b157879064b6)(m, v, 0, 0, 2), (0, $39c25606322173b2$export$cf66b157879064b6)(m, v, 1, 0, 2)));
const $38addd61b75018c2$export$8c33b88dbbbc7fc1 = $38addd61b75018c2$export$8eba860695d17007.add(6, (out, m, v)=>(0, $5d21eae0771d5dbf$export$dcfbb7940cfb3a48)(out || v, (0, $39c25606322173b2$export$cf66b157879064b6)(m, v, 0, 0, 2) + m[4], (0, $39c25606322173b2$export$cf66b157879064b6)(m, v, 1, 0, 2) + m[5]));
const $38addd61b75018c2$export$9ed1ae91fe0a393f = $38addd61b75018c2$export$8eba860695d17007.add(9, (out, m, v)=>(0, $5d21eae0771d5dbf$export$ba8c70ce75474f8d)(out || v, (0, $39c25606322173b2$export$78ae608fdbee4899)(m, v, 0, 0, 3), (0, $39c25606322173b2$export$78ae608fdbee4899)(m, v, 1, 0, 3), (0, $39c25606322173b2$export$78ae608fdbee4899)(m, v, 2, 0, 3)));
const $38addd61b75018c2$export$607e6da9929de1fa = $38addd61b75018c2$export$8eba860695d17007.add(16, (out, m, v)=>(0, $5d21eae0771d5dbf$export$abee0037e1db715)(out || v, (0, $39c25606322173b2$export$7cff64c0e2ba076b)(m, v, 0, 0, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(m, v, 1, 0, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(m, v, 2, 0, 4), (0, $39c25606322173b2$export$7cff64c0e2ba076b)(m, v, 3, 0, 4)));
const $38addd61b75018c2$export$1c6c7bbb3c786559 = (out, m, v)=>{
    const w = (0, $39c25606322173b2$export$78ae608fdbee4899)(m, v, 3, 0, 4) + m[15];
    return w !== 0 ? (0, $5d21eae0771d5dbf$export$ba8c70ce75474f8d)(out || v, ((0, $39c25606322173b2$export$78ae608fdbee4899)(m, v, 0, 0, 4) + m[12]) / w, ((0, $39c25606322173b2$export$78ae608fdbee4899)(m, v, 1, 0, 4) + m[13]) / w, ((0, $39c25606322173b2$export$78ae608fdbee4899)(m, v, 2, 0, 4) + m[14]) / w) : void 0;
};
const $38addd61b75018c2$export$1ea65f64de352f09 = (out, q, v)=>{
    const { 0: px, 1: py, 2: pz } = v;
    const { 0: qx, 1: qy, 2: qz, 3: qw } = q;
    const ix = qw * px + qy * pz - qz * py;
    const iy = qw * py + qz * px - qx * pz;
    const iz = qw * pz + qx * py - qy * px;
    const iw = -qx * px - qy * py - qz * pz;
    return (0, $5d21eae0771d5dbf$export$ba8c70ce75474f8d)(out || v, ix * qw + iw * -qx + iy * -qz - iz * -qy, iy * qw + iw * -qy + iz * -qx - ix * -qz, iz * qw + iw * -qz + ix * -qy - iy * -qx);
};


const $0dbe2504618934b1$export$ec923e38fabc9186 = (a, b, c, d)=>a * b + c * d;
const $0dbe2504618934b1$export$52f3cc8bf1fcf271 = (a, b, c, d, e, f)=>a * b + c * d + e * f;
const $0dbe2504618934b1$export$390177a139e12221 = (a, b, c, d, e, f, g, h)=>a * b + c * d + e * f + g * h;






const $705e24d680e38de6$export$c221de3ea42d0e66 = (m)=>(0, $0dbe2504618934b1$export$ec923e38fabc9186)(m[0], m[3], -m[1], m[2]);
const $705e24d680e38de6$export$64723d9752e9f9d = $705e24d680e38de6$export$c221de3ea42d0e66;
const $705e24d680e38de6$export$88b26a3d851d321f = (m)=>{
    const [m00, m01, m02, m10, m11, m12, m20, m21, m22] = m;
    const d01 = (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m22, m11, -m12, m21);
    const d11 = (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m12, m20, -m22, m10);
    const d21 = (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m21, m10, -m11, m20);
    return (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(m00, d01, m01, d11, m02, d21);
};
const $705e24d680e38de6$export$7b7ad19b83443ac6 = (m)=>{
    const [m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33] = m;
    return [
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m00, m11, -m01, m10),
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m00, m12, -m02, m10),
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m00, m13, -m03, m10),
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m01, m12, -m02, m11),
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m01, m13, -m03, m11),
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m02, m13, -m03, m12),
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m20, m31, -m21, m30),
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m20, m32, -m22, m30),
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m20, m33, -m23, m30),
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m21, m32, -m22, m31),
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m21, m33, -m23, m31),
        (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m22, m33, -m23, m32)
    ];
};
const $705e24d680e38de6$export$ea9ce22bf01d0ac = (d)=>(0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(d[0], d[11], -d[1], d[10], d[2], d[9]) + (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(d[3], d[8], -d[4], d[7], d[5], d[6]);
const $705e24d680e38de6$export$e17f93ef7d621350 = (m)=>$705e24d680e38de6$export$ea9ce22bf01d0ac($705e24d680e38de6$export$7b7ad19b83443ac6(m));


const $10e45118cd110752$export$6897c284b6f9f4dc = (0, $ce0f4130aecaba84$export$c37d18c23b2ea60c)(1);
const $10e45118cd110752$export$2ab1c02520f0d244 = $10e45118cd110752$export$6897c284b6f9f4dc.add(4, (out, m)=>{
    const [m00, m01, m10, m11] = m;
    let det = (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m00, m11, -m01, m10);
    if (det === 0) return;
    det = 1 / det;
    return (0, $5d21eae0771d5dbf$export$abee0037e1db715)(out || m, m11 * det, -m01 * det, -m10 * det, m00 * det);
});
const $10e45118cd110752$export$2392dec6ee7ad275 = $10e45118cd110752$export$6897c284b6f9f4dc.add(6, (out, m)=>{
    const [m00, m01, m10, m11, m20, m21] = m;
    let det = (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m00, m11, -m01, m10);
    if (det === 0) return;
    det = 1 / det;
    return (0, $5d21eae0771d5dbf$export$d58a46c754825a51)(out || m, m11 * det, -m01 * det, -m10 * det, m00 * det, (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m10, m21, -m11, m20) * det, (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m01, m20, -m00, m21) * det);
});
const $10e45118cd110752$export$a48d4501dfd597fa = $10e45118cd110752$export$6897c284b6f9f4dc.add(9, (out, m)=>{
    const [m00, m01, m02, m10, m11, m12, m20, m21, m22] = m;
    const d01 = (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m22, m11, -m12, m21);
    const d11 = (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m12, m20, -m22, m10);
    const d21 = (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m21, m10, -m11, m20);
    let det = (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(m00, d01, m01, d11, m02, d21);
    if (det === 0) return;
    det = 1 / det;
    return (0, $5d21eae0771d5dbf$export$644e79245f7d24b5)(out || m, d01 * det, (0, $0dbe2504618934b1$export$ec923e38fabc9186)(-m22, m01, m02, m21) * det, (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m12, m01, -m02, m11) * det, d11 * det, (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m22, m00, -m02, m20) * det, (0, $0dbe2504618934b1$export$ec923e38fabc9186)(-m12, m00, m02, m10) * det, d21 * det, (0, $0dbe2504618934b1$export$ec923e38fabc9186)(-m21, m00, m01, m20) * det, (0, $0dbe2504618934b1$export$ec923e38fabc9186)(m11, m00, -m01, m10) * det);
});
const $10e45118cd110752$export$f3d3af87b23e55b9 = $10e45118cd110752$export$6897c284b6f9f4dc.add(16, (out, m)=>{
    const coeffs = (0, $705e24d680e38de6$export$7b7ad19b83443ac6)(m);
    let det = (0, $705e24d680e38de6$export$ea9ce22bf01d0ac)(coeffs);
    if (det === 0) return;
    det = 1 / det;
    const [m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33] = m;
    const [d00, d01, d02, d03, d04, d05, d06, d07, d08, d09, d10, d11] = coeffs;
    return (0, $5d21eae0771d5dbf$export$644e79245f7d24b5)(out || m, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(m11, d11, -m12, d10, m13, d09) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(-m01, d11, m02, d10, -m03, d09) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(m31, d05, -m32, d04, m33, d03) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(-m21, d05, m22, d04, -m23, d03) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(-m10, d11, m12, d08, -m13, d07) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(m00, d11, -m02, d08, m03, d07) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(-m30, d05, m32, d02, -m33, d01) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(m20, d05, -m22, d02, m23, d01) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(m10, d10, -m11, d08, m13, d06) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(-m00, d10, m01, d08, -m03, d06) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(m30, d04, -m31, d02, m33, d00) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(-m20, d04, m21, d02, -m23, d00) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(-m10, d09, m11, d07, -m12, d06) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(m00, d09, -m01, d07, m02, d06) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(-m30, d03, m31, d01, -m32, d00) * det, (0, $0dbe2504618934b1$export$52f3cc8bf1fcf271)(m20, d03, -m21, d01, m22, d00) * det);
});
const $10e45118cd110752$export$5ef3fe74de468496 = (out, a)=>{
    let d = (0, $ffcd9b5535f0b297$export$af0b3789fa343fbd)(a);
    d = d > 0 ? -1 / d : 0;
    return (0, $5d21eae0771d5dbf$export$abee0037e1db715)(out || a, a[0] * d, a[1] * d, a[2] * d, -a[3] * d);
};




const [$36a238e94b0bc796$export$159d9494db57879b, $36a238e94b0bc796$export$87ee28508e334108, $36a238e94b0bc796$export$515c756757bc7dd6, $36a238e94b0bc796$export$1610da4f4fb6074f] = (0, $8547a8b0e5e715cd$export$5d7f662452a819b3)("/");



const [$b047c4fd650d33dd$export$6747e444d0e25f8e, $b047c4fd650d33dd$export$c8a0e366d15bb712, $b047c4fd650d33dd$export$cb6d410f870ee721, $b047c4fd650d33dd$export$9e7986c53a12814a] = (0, $8547a8b0e5e715cd$export$24ecd06eea36a882)("/");




const [$0af0502c9d4a179a$export$e16d8520af44a096, $0af0502c9d4a179a$export$363c2f72629e4a7f, $0af0502c9d4a179a$export$287691874d09163a, $0af0502c9d4a179a$export$81b475958bcba316] = (0, $8547a8b0e5e715cd$export$5d7f662452a819b3)("+");



const [$14b7c6a934cee185$export$6897c284b6f9f4dc, $14b7c6a934cee185$export$eb08a4e6e8934de4, $14b7c6a934cee185$export$2f6df6f9964c34d8, $14b7c6a934cee185$export$2cac2c285d867dd] = (0, $8547a8b0e5e715cd$export$e40cf5ce9a490533)(([o, a])=>`${o}=1/${a};`);





const $8539b144fc2a79f8$var$tpl = ([a, b])=>`t=${a}-${b};s+=t*t;`;
const $8539b144fc2a79f8$var$pre = "let t,s=0;";
const $8539b144fc2a79f8$var$$ = (dim)=>$8539b144fc2a79f8$export$1717f45d0ace7417.add(dim, (0, $8547a8b0e5e715cd$export$ef7acd7185315e22)(dim, $8539b144fc2a79f8$var$tpl, "a,b", void 0, "s", "", $8539b144fc2a79f8$var$pre));
const $8539b144fc2a79f8$export$1717f45d0ace7417 = (0, $ce0f4130aecaba84$export$c37d18c23b2ea60c)();
$8539b144fc2a79f8$export$1717f45d0ace7417.default((0, $8547a8b0e5e715cd$export$aeba7862bf0c66c4)($8539b144fc2a79f8$var$tpl, "a,b", void 0, "s", $8539b144fc2a79f8$var$pre));
const $8539b144fc2a79f8$export$f5e9931e7fc73125 = $8539b144fc2a79f8$var$$(2);
const $8539b144fc2a79f8$export$8ad5a30d17ee2508 = $8539b144fc2a79f8$var$$(3);
const $8539b144fc2a79f8$export$e447d87a37e96faa = $8539b144fc2a79f8$var$$(4);


const $582a8b5bf10e06ee$export$6c4a311cc157c764 = (a, b)=>Math.sqrt((0, $8539b144fc2a79f8$export$1717f45d0ace7417)(a, b));
const $582a8b5bf10e06ee$export$af8b29ece75f5c37 = (a, b)=>Math.sqrt((0, $8539b144fc2a79f8$export$f5e9931e7fc73125)(a, b));
const $582a8b5bf10e06ee$export$49f8ee6768bb070e = (a, b)=>Math.sqrt((0, $8539b144fc2a79f8$export$8ad5a30d17ee2508)(a, b));
const $582a8b5bf10e06ee$export$e32442804e9a2292 = (a, b)=>Math.sqrt((0, $8539b144fc2a79f8$export$e447d87a37e96faa)(a, b));



var $f39fdf036bba3609$exports = {};
var $f39fdf036bba3609$var$gsl_const = {};
$f39fdf036bba3609$var$gsl_const.CGS = {};
$f39fdf036bba3609$var$gsl_const.CGS.SPEED_OF_LIGHT = 2.99792458e+10; /* cm / s */ 
$f39fdf036bba3609$var$gsl_const.CGS.GRAVITATIONAL_CONSTANT = 6.673e-8; /* cm^3 / g s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.PLANCKS_CONSTANT_H = 6.62606896e-27; /* g cm^2 / s */ 
$f39fdf036bba3609$var$gsl_const.CGS.PLANCKS_CONSTANT_HBAR = 1.05457162825e-27; /* g cm^2 / s */ 
$f39fdf036bba3609$var$gsl_const.CGS.ASTRONOMICAL_UNIT = 1.49597870691e+13; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.LIGHT_YEAR = 9.46053620707e+17; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.PARSEC = 3.08567758135e+18; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.GRAV_ACCEL = 9.80665e+2; /* cm / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.ELECTRON_VOLT = 1.602176487e-12; /* g cm^2 / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.MASS_ELECTRON = 9.10938188e-28; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.MASS_MUON = 1.88353109e-25; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.MASS_PROTON = 1.67262158e-24; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.MASS_NEUTRON = 1.67492716e-24; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.RYDBERG = 2.17987196968e-11; /* g cm^2 / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.BOLTZMANN = 1.3806504e-16; /* g cm^2 / K s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.MOLAR_GAS = 8.314472e7; /* g cm^2 / K mol s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.STANDARD_GAS_VOLUME = 2.2710981e4; /* cm^3 / mol */ 
$f39fdf036bba3609$var$gsl_const.CGS.MINUTE = 6e1; /* s */ 
$f39fdf036bba3609$var$gsl_const.CGS.HOUR = 3.6e3; /* s */ 
$f39fdf036bba3609$var$gsl_const.CGS.DAY = 8.64e4; /* s */ 
$f39fdf036bba3609$var$gsl_const.CGS.WEEK = 6.048e5; /* s */ 
$f39fdf036bba3609$var$gsl_const.CGS.INCH = 2.54e0; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.FOOT = 3.048e1; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.YARD = 9.144e1; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.MILE = 1.609344e5; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.NAUTICAL_MILE = 1.852e5; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.FATHOM = 1.8288e2; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.MIL = 2.54e-3; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.POINT = 3.52777777778e-2; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.TEXPOINT = 3.51459803515e-2; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.MICRON = 1e-4; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.ANGSTROM = 1e-8; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.HECTARE = 1e8; /* cm^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.ACRE = 4.04685642241e7; /* cm^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.BARN = 1e-24; /* cm^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.LITER = 1e3; /* cm^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.US_GALLON = 3.78541178402e3; /* cm^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.QUART = 9.46352946004e2; /* cm^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.PINT = 4.73176473002e2; /* cm^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.CUP = 2.36588236501e2; /* cm^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.FLUID_OUNCE = 2.95735295626e1; /* cm^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.TABLESPOON = 1.47867647813e1; /* cm^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.TEASPOON = 4.92892159375e0; /* cm^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.CANADIAN_GALLON = 4.54609e3; /* cm^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.UK_GALLON = 4.546092e3; /* cm^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.MILES_PER_HOUR = 4.4704e1; /* cm / s */ 
$f39fdf036bba3609$var$gsl_const.CGS.KILOMETERS_PER_HOUR = 2.77777777778e1; /* cm / s */ 
$f39fdf036bba3609$var$gsl_const.CGS.KNOT = 5.14444444444e1; /* cm / s */ 
$f39fdf036bba3609$var$gsl_const.CGS.POUND_MASS = 4.5359237e2; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.OUNCE_MASS = 2.8349523125e1; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.TON = 9.0718474e5; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.METRIC_TON = 1e6; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.UK_TON = 1.0160469088e6; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.TROY_OUNCE = 3.1103475e1; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.CARAT = 2e-1; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.UNIFIED_ATOMIC_MASS = 1.660538782e-24; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.GRAM_FORCE = 9.80665e2; /* cm g / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.POUND_FORCE = 4.44822161526e5; /* cm g / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.KILOPOUND_FORCE = 4.44822161526e8; /* cm g / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.POUNDAL = 1.38255e4; /* cm g / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.CALORIE = 4.1868e7; /* g cm^2 / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.BTU = 1.05505585262e10; /* g cm^2 / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.THERM = 1.05506e15; /* g cm^2 / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.HORSEPOWER = 7.457e9; /* g cm^2 / s^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.BAR = 1e6; /* g / cm s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.STD_ATMOSPHERE = 1.01325e6; /* g / cm s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.TORR = 1.33322368421e3; /* g / cm s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.METER_OF_MERCURY = 1.33322368421e6; /* g / cm s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.INCH_OF_MERCURY = 3.38638815789e4; /* g / cm s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.INCH_OF_WATER = 2.490889e3; /* g / cm s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.PSI = 6.89475729317e4; /* g / cm s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.POISE = 1e0; /* g / cm s */ 
$f39fdf036bba3609$var$gsl_const.CGS.STOKES = 1e0; /* cm^2 / s */ 
$f39fdf036bba3609$var$gsl_const.CGS.STILB = 1e0; /* cd / cm^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.LUMEN = 1e0; /* cd sr */ 
$f39fdf036bba3609$var$gsl_const.CGS.LUX = 1e-4; /* cd sr / cm^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.PHOT = 1e0; /* cd sr / cm^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.FOOTCANDLE = 1.076e-3; /* cd sr / cm^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.LAMBERT = 1e0; /* cd sr / cm^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.FOOTLAMBERT = 1.07639104e-3; /* cd sr / cm^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.CURIE = 3.7e10; /* 1 / s */ 
$f39fdf036bba3609$var$gsl_const.CGS.ROENTGEN = 2.58e-7; /* A s / g */ 
$f39fdf036bba3609$var$gsl_const.CGS.RAD = 1e2; /* cm^2 / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.SOLAR_MASS = 1.98892e33; /* g */ 
$f39fdf036bba3609$var$gsl_const.CGS.BOHR_RADIUS = 5.291772083e-9; /* cm */ 
$f39fdf036bba3609$var$gsl_const.CGS.NEWTON = 1e5; /* cm g / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.DYNE = 1e0; /* cm g / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.JOULE = 1e7; /* g cm^2 / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.ERG = 1e0; /* g cm^2 / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGS.STEFAN_BOLTZMANN_CONSTANT = 5.67040047374e-5; /* g / K^4 s^3 */ 
$f39fdf036bba3609$var$gsl_const.CGS.THOMSON_CROSS_SECTION = 6.65245893699e-25; /* cm^2 */ 
$f39fdf036bba3609$var$gsl_const.CGSM = {};
$f39fdf036bba3609$var$gsl_const.CGSM.SPEED_OF_LIGHT = 2.99792458e10 /* cm / s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.GRAVITATIONAL_CONSTANT = 6.673e-8 /* cm^3 / g s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.PLANCKS_CONSTANT_H = 6.62606896e-27 /* g cm^2 / s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.PLANCKS_CONSTANT_HBAR = 1.05457162825e-27 /* g cm^2 / s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.ASTRONOMICAL_UNIT = 1.49597870691e13 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.LIGHT_YEAR = 9.46053620707e17 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.PARSEC = 3.08567758135e18 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.GRAV_ACCEL = 9.80665e2 /* cm / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.ELECTRON_VOLT = 1.602176487e-12 /* g cm^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.MASS_ELECTRON = 9.10938188e-28 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.MASS_MUON = 1.88353109e-25 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.MASS_PROTON = 1.67262158e-24 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.MASS_NEUTRON = 1.67492716e-24 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.RYDBERG = 2.17987196968e-11 /* g cm^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.BOLTZMANN = 1.3806504e-16 /* g cm^2 / K s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.MOLAR_GAS = 8.314472e7 /* g cm^2 / K mol s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.STANDARD_GAS_VOLUME = 2.2710981e4 /* cm^3 / mol */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.MINUTE = 6e1 /* s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.HOUR = 3.6e3 /* s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.DAY = 8.64e4 /* s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.WEEK = 6.048e5 /* s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.INCH = 2.54e0 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.FOOT = 3.048e1 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.YARD = 9.144e1 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.MILE = 1.609344e5 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.NAUTICAL_MILE = 1.852e5 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.FATHOM = 1.8288e2 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.MIL = 2.54e-3 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.POINT = 3.52777777778e-2 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.TEXPOINT = 3.51459803515e-2 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.MICRON = 1e-4 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.ANGSTROM = 1e-8 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.HECTARE = 1e8 /* cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.ACRE = 4.04685642241e7 /* cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.BARN = 1e-24 /* cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.LITER = 1e3 /* cm^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.US_GALLON = 3.78541178402e3 /* cm^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.QUART = 9.46352946004e2 /* cm^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.PINT = 4.73176473002e2 /* cm^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.CUP = 2.36588236501e2 /* cm^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.FLUID_OUNCE = 2.95735295626e1 /* cm^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.TABLESPOON = 1.47867647813e1 /* cm^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.TEASPOON = 4.92892159375e0 /* cm^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.CANADIAN_GALLON = 4.54609e3 /* cm^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.UK_GALLON = 4.546092e3 /* cm^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.MILES_PER_HOUR = 4.4704e1 /* cm / s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.KILOMETERS_PER_HOUR = 2.77777777778e1 /* cm / s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.KNOT = 5.14444444444e1 /* cm / s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.POUND_MASS = 4.5359237e2 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.OUNCE_MASS = 2.8349523125e1 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.TON = 9.0718474e5 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.METRIC_TON = 1e6 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.UK_TON = 1.0160469088e6 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.TROY_OUNCE = 3.1103475e1 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.CARAT = 2e-1 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.UNIFIED_ATOMIC_MASS = 1.660538782e-24 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.GRAM_FORCE = 9.80665e2 /* cm g / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.POUND_FORCE = 4.44822161526e5 /* cm g / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.KILOPOUND_FORCE = 4.44822161526e8 /* cm g / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.POUNDAL = 1.38255e4 /* cm g / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.CALORIE = 4.1868e7 /* g cm^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.BTU = 1.05505585262e10; /* g cm^2 / s^2 */ 
$f39fdf036bba3609$var$gsl_const.CGSM.THERM = 1.05506e15 /* g cm^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.HORSEPOWER = 7.457e9 /* g cm^2 / s^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.BAR = 1e6 /* g / cm s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.STD_ATMOSPHERE = 1.01325e6 /* g / cm s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.TORR = 1.33322368421e3 /* g / cm s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.METER_OF_MERCURY = 1.33322368421e6 /* g / cm s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.INCH_OF_MERCURY = 3.38638815789e4 /* g / cm s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.INCH_OF_WATER = 2.490889e3 /* g / cm s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.PSI = 6.89475729317e4 /* g / cm s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.POISE = 1e0 /* g / cm s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.STOKES = 1e0 /* cm^2 / s */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.STILB = 1e0 /* cd / cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.LUMEN = 1e0 /* cd sr */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.LUX = 1e-4 /* cd sr / cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.PHOT = 1e0 /* cd sr / cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.FOOTCANDLE = 1.076e-3 /* cd sr / cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.LAMBERT = 1e0 /* cd sr / cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.FOOTLAMBERT = 1.07639104e-3 /* cd sr / cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.CURIE = 3.7e10; /* 1 / s */ 
$f39fdf036bba3609$var$gsl_const.CGSM.ROENTGEN = 2.58e-8 /* abamp s / g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.RAD = 1e2 /* cm^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.SOLAR_MASS = 1.98892e33 /* g */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.BOHR_RADIUS = 5.291772083e-9 /* cm */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.NEWTON = 1e5 /* cm g / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.DYNE = 1e0 /* cm g / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.JOULE = 1e7 /* g cm^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.ERG = 1e0 /* g cm^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.STEFAN_BOLTZMANN_CONSTANT = 5.67040047374e-5 /* g / K^4 s^3 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.THOMSON_CROSS_SECTION = 6.65245893699e-25 /* cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.BOHR_MAGNETON = 9.27400899e-21 /* abamp cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.NUCLEAR_MAGNETON = 5.05078317e-24 /* abamp cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.ELECTRON_MAGNETIC_MOMENT = 9.28476362e-21 /* abamp cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.PROTON_MAGNETIC_MOMENT = 1.410606633e-23 /* abamp cm^2 */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.FARADAY = 9.64853429775e3 /* abamp s / mol */ ;
$f39fdf036bba3609$var$gsl_const.CGSM.ELECTRON_CHARGE = 1.602176487e-20 /* abamp s */ ;
$f39fdf036bba3609$var$gsl_const.MKS = {};
$f39fdf036bba3609$var$gsl_const.MKS.SPEED_OF_LIGHT = 2.99792458e8 /* m / s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.GRAVITATIONAL_CONSTANT = 6.673e-11 /* m^3 / kg s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.PLANCKS_CONSTANT_H = 6.62606896e-34 /* kg m^2 / s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.PLANCKS_CONSTANT_HBAR = 1.05457162825e-34 /* kg m^2 / s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.ASTRONOMICAL_UNIT = 1.49597870691e11 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.LIGHT_YEAR = 9.46053620707e15 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.PARSEC = 3.08567758135e16 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.GRAV_ACCEL = 9.80665e0 /* m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.ELECTRON_VOLT = 1.602176487e-19 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.MASS_ELECTRON = 9.10938188e-31 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.MASS_MUON = 1.88353109e-28 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.MASS_PROTON = 1.67262158e-27 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.MASS_NEUTRON = 1.67492716e-27 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.RYDBERG = 2.17987196968e-18 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.BOLTZMANN = 1.3806504e-23 /* kg m^2 / K s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.MOLAR_GAS = 8.314472e0 /* kg m^2 / K mol s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.STANDARD_GAS_VOLUME = 2.2710981e-2 /* m^3 / mol */ ;
$f39fdf036bba3609$var$gsl_const.MKS.MINUTE = 6e1 /* s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.HOUR = 3.6e3 /* s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.DAY = 8.64e4 /* s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.WEEK = 6.048e5 /* s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.INCH = 2.54e-2 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.FOOT = 3.048e-1 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.YARD = 9.144e-1 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.MILE = 1.609344e3 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.NAUTICAL_MILE = 1.852e3 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.FATHOM = 1.8288e0 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.MIL = 2.54e-5 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.POINT = 3.52777777778e-4 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.TEXPOINT = 3.51459803515e-4 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.MICRON = 1e-6 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.ANGSTROM = 1e-10 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.HECTARE = 1e4 /* m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.ACRE = 4.04685642241e3 /* m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.BARN = 1e-28 /* m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.LITER = 1e-3 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.US_GALLON = 3.78541178402e-3 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.QUART = 9.46352946004e-4 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.PINT = 4.73176473002e-4 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.CUP = 2.36588236501e-4 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.FLUID_OUNCE = 2.95735295626e-5 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.TABLESPOON = 1.47867647813e-5 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.TEASPOON = 4.92892159375e-6 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.CANADIAN_GALLON = 4.54609e-3 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.UK_GALLON = 4.546092e-3 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.MILES_PER_HOUR = 4.4704e-1 /* m / s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.KILOMETERS_PER_HOUR = 2.77777777778e-1 /* m / s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.KNOT = 5.14444444444e-1 /* m / s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.POUND_MASS = 4.5359237e-1 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.OUNCE_MASS = 2.8349523125e-2 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.TON = 9.0718474e2 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.METRIC_TON = 1e3 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.UK_TON = 1.0160469088e3 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.TROY_OUNCE = 3.1103475e-2 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.CARAT = 2e-4 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.UNIFIED_ATOMIC_MASS = 1.660538782e-27 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.GRAM_FORCE = 9.80665e-3 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.POUND_FORCE = 4.44822161526e0 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.KILOPOUND_FORCE = 4.44822161526e3 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.POUNDAL = 1.38255e-1 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.CALORIE = 4.1868e0 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.BTU = 1.05505585262e3 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.THERM = 1.05506e8 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.HORSEPOWER = 7.457e2 /* kg m^2 / s^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.BAR = 1e5 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.STD_ATMOSPHERE = 1.01325e5 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.TORR = 1.33322368421e2 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.METER_OF_MERCURY = 1.33322368421e5 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.INCH_OF_MERCURY = 3.38638815789e3 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.INCH_OF_WATER = 2.490889e2 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.PSI = 6.89475729317e3 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.POISE = 1e-1 /* kg m^-1 s^-1 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.STOKES = 1e-4 /* m^2 / s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.STILB = 1e4 /* cd / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.LUMEN = 1e0 /* cd sr */ ;
$f39fdf036bba3609$var$gsl_const.MKS.LUX = 1e0 /* cd sr / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.PHOT = 1e4 /* cd sr / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.FOOTCANDLE = 1.076e1 /* cd sr / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.LAMBERT = 1e4 /* cd sr / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.FOOTLAMBERT = 1.07639104e1 /* cd sr / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.CURIE = 3.7e10 /* 1 / s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.ROENTGEN = 2.58e-4 /* A s / kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.RAD = 1e-2 /* m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.SOLAR_MASS = 1.98892e30 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKS.BOHR_RADIUS = 5.291772083e-11 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKS.NEWTON = 1e0 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.DYNE = 1e-5 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.JOULE = 1e0 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.ERG = 1e-7 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.STEFAN_BOLTZMANN_CONSTANT = 5.67040047374e-8 /* kg / K^4 s^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.THOMSON_CROSS_SECTION = 6.65245893699e-29 /* m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.BOHR_MAGNETON = 9.27400899e-24 /* A m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.NUCLEAR_MAGNETON = 5.05078317e-27 /* A m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.ELECTRON_MAGNETIC_MOMENT = 9.28476362e-24 /* A m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.PROTON_MAGNETIC_MOMENT = 1.410606633e-26 /* A m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.FARADAY = 9.64853429775e4 /* A s / mol */ ;
$f39fdf036bba3609$var$gsl_const.MKS.ELECTRON_CHARGE = 1.602176487e-19 /* A s */ ;
$f39fdf036bba3609$var$gsl_const.MKS.VACUUM_PERMITTIVITY = 8.854187817e-12 /* A^2 s^4 / kg m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.VACUUM_PERMEABILITY = 1.25663706144e-6 /* kg m / A^2 s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.DEBYE = 3.33564095198e-30 /* A s^2 / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKS.GAUSS = 1e-4 /* kg / A s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA = {};
$f39fdf036bba3609$var$gsl_const.MKSA.SPEED_OF_LIGHT = 2.99792458e8 /* m / s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.GRAVITATIONAL_CONSTANT = 6.673e-11 /* m^3 / kg s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.PLANCKS_CONSTANT_H = 6.62606896e-34 /* kg m^2 / s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.PLANCKS_CONSTANT_HBAR = 1.05457162825e-34 /* kg m^2 / s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.ASTRONOMICAL_UNIT = 1.49597870691e11 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.LIGHT_YEAR = 9.46053620707e15 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.PARSEC = 3.08567758135e16 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.GRAV_ACCEL = 9.80665e0 /* m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.ELECTRON_VOLT = 1.602176487e-19 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.MASS_ELECTRON = 9.10938188e-31 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.MASS_MUON = 1.88353109e-28 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.MASS_PROTON = 1.67262158e-27 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.MASS_NEUTRON = 1.67492716e-27 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.RYDBERG = 2.17987196968e-18 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.BOLTZMANN = 1.3806504e-23 /* kg m^2 / K s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.MOLAR_GAS = 8.314472e0 /* kg m^2 / K mol s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.STANDARD_GAS_VOLUME = 2.2710981e-2 /* m^3 / mol */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.MINUTE = 6e1 /* s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.HOUR = 3.6e3 /* s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.DAY = 8.64e4 /* s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.WEEK = 6.048e5 /* s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.INCH = 2.54e-2 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.FOOT = 3.048e-1 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.YARD = 9.144e-1 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.MILE = 1.609344e3 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.NAUTICAL_MILE = 1.852e3 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.FATHOM = 1.8288e0 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.MIL = 2.54e-5 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.POINT = 3.52777777778e-4 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.TEXPOINT = 3.51459803515e-4 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.MICRON = 1e-6 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.ANGSTROM = 1e-10 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.HECTARE = 1e4 /* m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.ACRE = 4.04685642241e3 /* m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.BARN = 1e-28 /* m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.LITER = 1e-3 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.US_GALLON = 3.78541178402e-3 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.QUART = 9.46352946004e-4 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.PINT = 4.73176473002e-4 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.CUP = 2.36588236501e-4 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.FLUID_OUNCE = 2.95735295626e-5 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.TABLESPOON = 1.47867647813e-5 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.TEASPOON = 4.92892159375e-6 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.CANADIAN_GALLON = 4.54609e-3 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.UK_GALLON = 4.546092e-3 /* m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.MILES_PER_HOUR = 4.4704e-1 /* m / s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.KILOMETERS_PER_HOUR = 2.77777777778e-1 /* m / s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.KNOT = 5.14444444444e-1 /* m / s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.POUND_MASS = 4.5359237e-1 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.OUNCE_MASS = 2.8349523125e-2 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.TON = 9.0718474e2 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.METRIC_TON = 1e3 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.UK_TON = 1.0160469088e3 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.TROY_OUNCE = 3.1103475e-2 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.CARAT = 2e-4 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.UNIFIED_ATOMIC_MASS = 1.660538782e-27 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.GRAM_FORCE = 9.80665e-3 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.POUND_FORCE = 4.44822161526e0 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.KILOPOUND_FORCE = 4.44822161526e3 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.POUNDAL = 1.38255e-1 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.CALORIE = 4.1868e0 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.BTU = 1.05505585262e3 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.THERM = 1.05506e8 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.HORSEPOWER = 7.457e2 /* kg m^2 / s^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.BAR = 1e5 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.STD_ATMOSPHERE = 1.01325e5 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.TORR = 1.33322368421e2 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.METER_OF_MERCURY = 1.33322368421e5 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.INCH_OF_MERCURY = 3.38638815789e3 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.INCH_OF_WATER = 2.490889e2 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.PSI = 6.89475729317e3 /* kg / m s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.POISE = 1e-1 /* kg m^-1 s^-1 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.STOKES = 1e-4 /* m^2 / s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.STILB = 1e4 /* cd / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.LUMEN = 1e0 /* cd sr */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.LUX = 1e0 /* cd sr / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.PHOT = 1e4 /* cd sr / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.FOOTCANDLE = 1.076e1 /* cd sr / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.LAMBERT = 1e4 /* cd sr / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.FOOTLAMBERT = 1.07639104e1 /* cd sr / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.CURIE = 3.7e10 /* 1 / s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.ROENTGEN = 2.58e-4 /* A s / kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.RAD = 1e-2 /* m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.SOLAR_MASS = 1.98892e30 /* kg */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.BOHR_RADIUS = 5.291772083e-11 /* m */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.NEWTON = 1e0 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.DYNE = 1e-5 /* kg m / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.JOULE = 1e0 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.ERG = 1e-7 /* kg m^2 / s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.STEFAN_BOLTZMANN_CONSTANT = 5.67040047374e-8 /* kg / K^4 s^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.THOMSON_CROSS_SECTION = 6.65245893699e-29 /* m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.BOHR_MAGNETON = 9.27400899e-24 /* A m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.NUCLEAR_MAGNETON = 5.05078317e-27 /* A m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.ELECTRON_MAGNETIC_MOMENT = 9.28476362e-24 /* A m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.PROTON_MAGNETIC_MOMENT = 1.410606633e-26 /* A m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.FARADAY = 9.64853429775e4 /* A s / mol */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.ELECTRON_CHARGE = 1.602176487e-19 /* A s */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.VACUUM_PERMITTIVITY = 8.854187817e-12 /* A^2 s^4 / kg m^3 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.VACUUM_PERMEABILITY = 1.25663706144e-6 /* kg m / A^2 s^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.DEBYE = 3.33564095198e-30 /* A s^2 / m^2 */ ;
$f39fdf036bba3609$var$gsl_const.MKSA.GAUSS = 1e-4 /* kg / A s^2 */ ;
$f39fdf036bba3609$var$gsl_const.NUM = {};
$f39fdf036bba3609$var$gsl_const.NUM.FINE_STRUCTURE = 7.297352533e-3 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.AVOGADRO = 6.02214199e23 /* 1 / mol */ ;
$f39fdf036bba3609$var$gsl_const.NUM.YOTTA = 1e24 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.ZETTA = 1e21 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.EXA = 1e18 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.PETA = 1e15 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.TERA = 1e12 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.GIGA = 1e9 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.MEGA = 1e6 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.KILO = 1e3 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.MILLI = 1e-3 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.MICRO = 1e-6 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.NANO = 1e-9 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.PICO = 1e-12 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.FEMTO = 1e-15 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.ATTO = 1e-18 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.ZEPTO = 1e-21 /* 1 */ ;
$f39fdf036bba3609$var$gsl_const.NUM.YOCTO = 1e-24 /* 1 */ ;
$f39fdf036bba3609$exports = $f39fdf036bba3609$var$gsl_const;


const $aa3af7eb13cf442c$export$be3f796aed065412 = {
    diff: "-",
    dt: "-",
    "\u23F3": "-",
    pause: 0,
    "\u23F8": 0,
    add: "+",
    "\u23ED": "+"
};
const $aa3af7eb13cf442c$export$7548f4bc1b09ff22 = $aa3af7eb13cf442c$export$be3f796aed065412.diff;
const $aa3af7eb13cf442c$export$85b884786400d38f = 0;
const $aa3af7eb13cf442c$export$eb8a9b7a1ebec59a = {
    [$aa3af7eb13cf442c$export$be3f796aed065412.diff]: Date.now,
    [$aa3af7eb13cf442c$export$be3f796aed065412.add]: 1000 / 60
};
function $aa3af7eb13cf442c$export$9dc4ecf953986f04(state, now, out = state) {
    // Get the initial time and step-step.
    const { time: t0 = $aa3af7eb13cf442c$export$85b884786400d38f, step: step = $aa3af7eb13cf442c$export$7548f4bc1b09ff22, now: n } = state;
    var _step;
    // Get the step mode - from a key into `steps` or a numerical value.
    const s = (_step = $aa3af7eb13cf442c$export$be3f796aed065412[step]) !== null && _step !== void 0 ? _step : step;
    const diff = s === $aa3af7eb13cf442c$export$be3f796aed065412.diff;
    var ref, ref1;
    const t = (ref1 = (ref = now !== null && now !== void 0 ? now : n) !== null && ref !== void 0 ? ref : $aa3af7eb13cf442c$export$eb8a9b7a1ebec59a[s]) !== null && ref1 !== void 0 ? ref1 : s;
    // Step by `s`:
    // - `0` or falsey to `pause`
    // - `steps.diff` for difference since last `time`
    // - `steps.add` or a number to add a `time` step
    const t1 = !s ? t0 : (diff ? 0 : t0) + (isNaN(t) ? t() : t);
    const dt = t1 - t0;
    // If only returning a value, return the relevant calculated unknown.
    if (!out) return diff ? dt : t1;
    out.time = t1;
    out.dt = dt;
    out.step = step;
    return out;
}
var $aa3af7eb13cf442c$export$2e2bcd8739ae039 = $aa3af7eb13cf442c$export$9dc4ecf953986f04;


const $338b36538fe76dc4$var$r = Array.prototype.reduce;
const $338b36538fe76dc4$export$533b26079ad0b4b = (f, a, to)=>// Needs separate `call` because native detects even `undefined` parameter.
    to === undefined ? $338b36538fe76dc4$var$r.call(a, f) : $338b36538fe76dc4$var$r.call(a, f, to);
var $338b36538fe76dc4$export$2e2bcd8739ae039 = $338b36538fe76dc4$export$533b26079ad0b4b;



const $ea53246f0372c42f$export$871de8747c9eaa88 = (f, a, to = [])=>(0, $338b36538fe76dc4$export$533b26079ad0b4b)((to, v, i)=>{
        to[i] = f(v, i, a, to);
        return to;
    }, a, to || a);
var $ea53246f0372c42f$export$2e2bcd8739ae039 = $ea53246f0372c42f$export$871de8747c9eaa88;


const $b1bee206b7624e4c$var$e = Array.prototype.forEach;
const $b1bee206b7624e4c$export$79b2f7037acddd43 = (f, a)=>{
    $b1bee206b7624e4c$var$e.call(a, f);
    return a;
};
var $b1bee206b7624e4c$export$2e2bcd8739ae039 = $b1bee206b7624e4c$export$79b2f7037acddd43;


const { fill: $2ba8e5839a6e0a10$var$fill } = Array.prototype;
const { isFinite: $2ba8e5839a6e0a10$var$isFinite } = Number;
const { floor: $2ba8e5839a6e0a10$var$floor } = Math;
const $2ba8e5839a6e0a10$export$d02631cccf789723 = (l = 0, value, start, end)=>$2ba8e5839a6e0a10$var$fill.call($2ba8e5839a6e0a10$var$isFinite(l) ? Array($2ba8e5839a6e0a10$var$floor(l)) : l, value, start, end);
var $2ba8e5839a6e0a10$export$2e2bcd8739ae039 = $2ba8e5839a6e0a10$export$d02631cccf789723;


/**
 * Wraps an index over a given length, so that indexes greater than the length
 * loop back past `0`, and indexes less than `0` loop backward from the length.
 * Similar to the indexing behaviour of `Array`'s `slice`.
 * Indexing is the equivalent of a true _modulo_ operator, where JavaScript's
 * `%` operator is actually a _remainder_ operator.
 *
 * @see Array.prototpye.slice
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder
 *
 * @param {number} i Index to wrap.
 * @param {number} l Length to wrap the index over.
 *
 * @returns {number} The index wrapped over the length.
 */ const $9a62e9ffb6a463f3$export$acb6ab09ed1b7b8b = (i, l)=>(i % l + l) % l;
var $9a62e9ffb6a463f3$export$2e2bcd8739ae039 = $9a62e9ffb6a463f3$export$acb6ab09ed1b7b8b;


const $e2f6bbbfbdb75d47$export$4997ffc0176396a6 = (i, l, end = l.length)=>end || end === 0 ? l[(0, $9a62e9ffb6a463f3$export$2e2bcd8739ae039)(i, end)] : (0, $9a62e9ffb6a463f3$export$2e2bcd8739ae039)(i, l);
var $e2f6bbbfbdb75d47$export$2e2bcd8739ae039 = $e2f6bbbfbdb75d47$export$4997ffc0176396a6;


/**
 * **Main `index.js` - see [`readme`](..)**
 *
 * [![`gl-gpgpu` particles demo](media://demo-particles-regl-frames.png)](..)
 *
 * [GPGPU](https://en.wikipedia.org/wiki/General-purpose_computing_on_graphics_processing_units)
 * state-stepping - declaratively maps optimal draw passes, shaders, `GL`
 * resources, inputs, outputs - lets you focus on your logic, BYO-renderer.
 *
 * Decouples logic from rendering approach/engine.
 * Each module and hook may be used as given, or piecemeal, or overridden.
 *
 * @module (root)
 * @category Root
 * @category JS
 *
 * @todo Add a way to look up values from previous passes in the current step:
 *   - We have `past` state inputs and the `next` state outputs, so adjacent
 *     states in the current pass can be called `got` states.
 *   - All states are already accessible in the shader, just need a way to
 *     declare the lookup is desired; maybe a negative index in `derives` should
 *     signify that, and be handled in the `tapStates` macros?
 * @todo Add a way to resize all `gpgpu` resources in one convenient function.
 * @todo Handle values with more channels than `channelsMax`...
 */ /**
 * Description of the `api` hooks for `gpgpu`, to interact with `GL` resources.
 *
 * Not implemented within the `gpgpu` library.
 *
 * Based on [`regl`](https://github.com/regl-project/regl/)'s API; but can be
 * use any `GL` renderer, given hooks matching these implementations.
 *
 * @module
 * @category API Hooks
 *
 * @todo [Fix `@callback`/`@typedef`](https://github.com/TypeStrong/typedoc/issues/1896):
 *   nested `@param`; omits `@return`/`@see`/`@this`
 */ /**
 * @callback getFramebuffer
 * A `function` to create or update a `GL` `framebuffer`; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link framebuffer}
 * - {@link data.toData}
 *
 * **This**
 *
 * Updates any `this` value's `framebuffer` in-place (or similar handling);
 * otherwise if `null`ish, returns a new `framebuffer`.
 *
 * **Returns**
 *
 * A `GL` `framebuffer` created or updated by any given `options`, or an
 * `object` serving that purpose.
 *
 * @param {{
 *     depth?:object,
 *     stencil?:object,
 *     width?:number,
 *     height?:number,
 *     color?:texture[]
 *   }} options Options to create or update a `GL` `framebuffer`; with:
 *   - `depth`: Any `framebuffer` depth attachment, or a flag for whether it
 *     should be created.
 *   - `stencil`: Any `framebuffer` stencil attachment, or a flag for whether it
 *     should be created.
 *   - `width`: The width of the `framebuffer`.
 *   - `height`: The height of the `framebuffer`.
 *   - `color`: The `texture` attachments to use.
 *
 * @returns {framebuffer}
 */ /**
 * @callback useFramebuffer
 * Bind a `GL` `framebuffer` while calling a given `function`; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link framebuffer}
 * - {@link step.toStep}
 *
 * **This**
 *
 * Uses any `this` value's `framebuffer` (or similar handling).
 *
 * @param {()=>void} hook A `function` to call while the `framebuffer` is bound.
 */ /**
 * @typedef {object} framebuffer
 * A `GL` `framebuffer`, or an `object` serving that purpose; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link getFramebuffer}
 * - {@link data.toData}
 *
 * @prop {getFramebuffer} call Update this `framebuffer` in-place.
 * @prop {useFramebuffer} use Bind this `framebuffer` for the given `function`.
 */ /**
 * @callback getTexture
 * A `function` hook to create or update a `GL` `texture`; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link api}
 * - {@link texture}
 * - {@link data.toData}
 *
 * **Returns**
 *
 * A `GL` `texture`, or an `object` serving that purpose.
 *
 * @param {string} type Any `texture` data type value.
 * @param {string} min Any `texture` minification filter value.
 * @param {string} mag Any `texture` magnification filter value.
 * @param {string} wrap Any `texture` wrap mode value.
 * @param {number} width The width of the `texture`.
 * @param {number} height The height of the `texture`.
 * @param {number} channels The number of channels of the `texture`.
 *
 * @returns {texture}
 */ /**
 * @callback subimage
 * Copy from a given source `texture` to part of `this` output `texture`; via
 * a `GL` `api`.
 *
 * **See**
 *
 * - {@link api}
 * - {@link texture}
 * - {@link getTexture}
 * - {@link step.toStep}
 *
 * **Returns**
 *
 * The output `texture`, `this`; the source `texture` copied to part of it.
 *
 * **This**
 *
 * Uses any `this` value's `texture` as the output to copy into.
 *
 * @param {texture} source A `texture` to copy to part of the output `texture`.
 * @param {number} [x=0] Offset along the output `texture`'s x-axis.
 * @param {number} [y=0] Offset along the output `texture`'s y-axis.
 *
 * @returns {texture}
 */ /**
 * @typedef {object} texture
 * A `GL` `texture`, or an `object` serving that purpose; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link getTexture}
 * - {@link data.toData}
 *
 * @prop {getTexture} call Update this `texture` in-place.
 * @prop {subimage} subimage Copy from a source `texture` into part of `this`
 *   destination `texture`.
 */ /**
 * @callback getBuffer
 * A `function` to set up a `GL` buffer; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link buffer}
 * - {@link attributes.getAttributes}
 *
 * @param {number[]|{[k:string|number]:number}|buffer} data Data to create a new
 *   `buffer`; or an existing `buffer` to use as-is.
 *
 * @returns {buffer}
 */ /**
 * @typedef {object} buffer
 * A `GL` `buffer` for vertex `attribute`s, or an `object` serving that purpose;
 * via a `GL` `api`.
 */ /**
 * @callback clear
 * A `function` to clear `GL` output view or `framebuffer`; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link framebuffer}
 * - {@link step.toStep}
 *
 * @param {{
 *     color?:number[],
 *     depth?:number,
 *     stencil?:number,
 *     framebuffer?:framebuffer
 *   }} options Options to clear `GL`; with:
 *   - `color`: The values to clear any color buffers with.
 *   - `depth`: The value to clear any depth buffer with.
 *   - `stencil`: The value to clear any stencil buffer with.
 *   - `framebuffer`: Any `framebuffer` to clear; if not given, clears any
 *     `framebuffer` already bound, or the view if none are bound.
 */ /**
 * @callback command
 * A `function` to create a `GL` render pass execution `function`, to be called
 * later, given options, for a render pass; via a `GL` `api`.
 *
 * **See**
 *
 * - {@link buffer}
 * - {@link attributes}
 * - {@link framebuffer}
 * - {@link step.toStep}
 * - {@link uniforms.toUniforms}
 * - {@link uniforms.getUniform}
 *
 * **Returns**
 *
 * A `function` to execute a `GL` render pass, given options.
 *
 * @param {{
 *     vert?:(context,state)=>string,
 *     frag?:(context,state)=>string,
 *     count?:number,
 *     attributes?:{[k:string]:buffer},
 *     uniforms?:{[k:string]:getUniform},
 *     depth?:{[k:string]:boolean|{}},
 *     framebuffer?:(context,state)=>framebuffer
 *   }} options Options to create a `GL` render pass `function`; with:
 *   - `vert`: Hook to get any `GLSL` vertex shader `string`.
 *   - `frag`: Hook to get any `GLSL` fragment shader `string`.
 *   - `count`: Any `number` of elements to render.
 *   - `attributes`: Map of any `GL` `attribute` `buffer`s.
 *     See `attributes`, `buffer`, `toStep`.
 *   - `uniforms`: Map of any `GL` `uniform` hooks.
 *     See `uniforms`, `toUniforms`, and `getUniform`.
 *   - `depth`: Any `GL` depth settings (e.g: `options.depth.enable`).
 *   - `framebuffer`: Hook to get any `framebuffer` to render into.
 *     See `framebuffer`.
 *
 * @returns {(context,state)=>void}
 */ /**
 * @typedef {{
 *     framebuffer:getFramebuffer,
 *     texture:getTexture,
 *     buffer:getBuffer,
 *     clear:clear,
 *     command:command,
 *     call:command
 *   }} api
 * An API `object` given to `gpgpu`, to interact with `GL` resources.
 *
 * Based on [`regl`](https://github.com/regl-project/regl/)'s API; but can be
 * use any `GL` renderer, given hooks matching these implementations.
 */ /** @ignore */ var $a5f2d3b3d41d3e18$export$2e2bcd8739ae039 = null;


/**
 * Default properties for `gpgpu` and `GL` capabilities and resources.
 *
 * @module
 * @category JS
 */ const $9ed6a95226cb701c$export$ba60520149d1328e = [
    [
        -1,
        -1
    ],
    [
        -1,
        4
    ],
    [
        4,
        -1
    ]
];
const $9ed6a95226cb701c$export$85b9a36db797e02b = $9ed6a95226cb701c$export$ba60520149d1328e.length;
const $9ed6a95226cb701c$export$c96e90b4bcb7d4ca = 2;
const $9ed6a95226cb701c$export$878041e1e4cd4218 = $9ed6a95226cb701c$export$ba60520149d1328e.flat();
var $9ed6a95226cb701c$export$2e2bcd8739ae039 = $9ed6a95226cb701c$export$878041e1e4cd4218;


var $22f7bd62c855d458$exports = {};
$22f7bd62c855d458$exports = "/**\n * Default `gpgpu` vertex shader.\n *\n * @see [@epok.tech/gl-screen-triangle/uv-texture.vert.glsl](https://github.com/keeffEoghan/gl-screen-triangle/tree/master/uv-texture.vert.glsl)\n */\n\nprecision highp float;\n#define GLSLIFY 1\n\n/**\n * Uses the default prefix namespace; replaced with any given prefix if this\n * shader's used during `toStep`.\n *\n * @see {@link const.preDef}\n * @see {@link step.toStep}\n */\nattribute vec2 gpgpu_position;\n\nvarying vec2 gpgpu_uv;\n\nvoid main() {\n  // Texture coordinates, range `[0, 1]`, y-axis points upwards.\n  gpgpu_uv = (gpgpu_position*0.5)+0.5;\n  gl_Position = vec4(gpgpu_position, 0, 1);\n}\n";


const $bc78d1a683d7cfc1$export$dc207adda608f979 = (0, (/*@__PURE__*/$parcel$interopDefault($22f7bd62c855d458$exports)));
const $bc78d1a683d7cfc1$export$cfdc3a7c4cb854c6 = ()=>[
        ...(0, $9ed6a95226cb701c$export$878041e1e4cd4218)
    ];
const $bc78d1a683d7cfc1$export$832d88422d279bbc = (0, $9ed6a95226cb701c$export$85b9a36db797e02b);
const $bc78d1a683d7cfc1$export$ac0cd3cc21f80dfc = ()=>[
        "oes_texture_float",
        "webgl_color_buffer_float"
    ];
const $bc78d1a683d7cfc1$export$5d97924d29f48e83 = ()=>[
        "oes_texture_half_float",
        "ext_color_buffer_half_float"
    ];
const $bc78d1a683d7cfc1$export$fdb75c5ac32869de = ()=>[
        "webgl_draw_buffers"
    ];
const $bc78d1a683d7cfc1$export$cc3e2d3244e01b7f = ()=>[];
const $bc78d1a683d7cfc1$export$4bceda1224fc5ab8 = $bc78d1a683d7cfc1$export$fdb75c5ac32869de;
const $bc78d1a683d7cfc1$export$918e5821fc7288cd = $bc78d1a683d7cfc1$export$4bceda1224fc5ab8;
const $bc78d1a683d7cfc1$export$b4781c2237bde956 = "gpgpu_";
const $bc78d1a683d7cfc1$export$26945b8c914b7fc = 4;
const $bc78d1a683d7cfc1$export$154f256b9eac9103 = 4;
const $bc78d1a683d7cfc1$export$b6267c3f91c57c78 = 1;
const $bc78d1a683d7cfc1$export$b029aceb5666f022 = 1;
const $bc78d1a683d7cfc1$export$71c6d8e332d66a75 = 0;
const $bc78d1a683d7cfc1$export$c4175b5828221aa7 = 2 ** $bc78d1a683d7cfc1$export$71c6d8e332d66a75;
const $bc78d1a683d7cfc1$export$bffb644e7dc52e91 = 2 ** $bc78d1a683d7cfc1$export$71c6d8e332d66a75;
const $bc78d1a683d7cfc1$export$617a37502ff8853 = 2;
const $bc78d1a683d7cfc1$export$ff01eb58fe4e69 = ()=>[
        $bc78d1a683d7cfc1$export$154f256b9eac9103
    ];
const $bc78d1a683d7cfc1$export$27fb0dad99ae5dd2 = "float";
const $bc78d1a683d7cfc1$export$47b10f415de592b1 = "nearest";
const $bc78d1a683d7cfc1$export$1fb689c67b965bff = "nearest";
const $bc78d1a683d7cfc1$export$8d7f4a48e1f2b2a = "clamp";
const $bc78d1a683d7cfc1$export$a211ab2c8ecded9a = false;
const $bc78d1a683d7cfc1$export$a1b7c201e9365814 = false;
const $bc78d1a683d7cfc1$export$5544d416ac8224f1 = /[0-9\.]+/;
const $bc78d1a683d7cfc1$export$2902d6d00b7c2bce = 8192;
const $bc78d1a683d7cfc1$export$2fcc13103217f9a3 = ()=>({
        color: [
            0,
            0,
            0,
            0
        ],
        depth: 1,
        stencil: 0
    });
const $bc78d1a683d7cfc1$export$72e520e6a70b780c = ()=>({
        copy: true
    });


/**
 * The `gpgpu` maps of data for optimal inputs/outputs on a platform.
 *
 * These maps show how to make optimal use of a platform's supported features,
 * how to pack/unpack their data from `framebuffer`s/`texture`s, perform minimal
 * needed samples to retrieve any past values they must derive from, etc.
 *
 * Shaders may declare values they output, values they derive from, groupings of
 * in/dependent values - without handling how these concerns map to the
 * particular platform resources they're using.
 *
 * Platform limits/features/extensions are accounted for, to produce the most
 * efficient mappings available with the least I/O when it comes to drawing
 * (draw passes, `texture` samples, etc).
 *
 * @module
 * @category JS
 *
 * @todo Allow passes within/across `texture`s; separate data/`texture` shapes.
 */ 



const { isInteger: $bbb23253d9fa3113$var$isInteger } = Number;
const { isArray: $bbb23253d9fa3113$var$isArray } = Array;
const $bbb23253d9fa3113$export$5ca26c99531348ec = (value, channelsMax = (0, $bc78d1a683d7cfc1$export$154f256b9eac9103))=>1 <= value || value <= channelsMax || !!console.error(`\`gl-gpgpu\`: the given value (${value}) exceeds the ` + `range of channels available, \`[1, ${channelsMax}]\` inclusive.`, value, channelsMax);
const $bbb23253d9fa3113$export$f5edbc631dafdbf = (buffersMax)=>$bbb23253d9fa3113$var$isInteger(buffersMax) && 0 < buffersMax && buffersMax < Infinity;
function $bbb23253d9fa3113$export$9d1d9285bd6d8c57(values, channelsMax = (0, $bc78d1a683d7cfc1$export$154f256b9eac9103), to = []) {
    // Fill `to` with indexes of `values`, and ensure it's the same length.
    (0, $ea53246f0372c42f$export$2e2bcd8739ae039)((_, i)=>i, values, to).length = values.length;
    /** Counts the number of empty channels in the current group. */ let channels = channelsMax;
    /** How many values have already been packed. */ let packed = 0;
    /** Tracks the value that best fits the free channels (fills it tightest). */ let fitIndex = 0;
    let fitSize = Infinity;
    for(let i = 0; packed < values.length;){
        const v = packed + i;
        const value = values[to[v]];
        if (!$bbb23253d9fa3113$export$5ca26c99531348ec(value, channelsMax)) return to;
        // Check how value fits the channels - valid is >= 0, perfect is 0.
        const fit = channels - value;
        if (fit >= 0 && fit < fitSize) {
            fitSize = fit;
            fitIndex = v;
        }
        // Not a perfect fit and can keep searching for better fits - continue.
        if (fitSize !== 0 && v < values.length - 1) ++i;
        else {
            // Got a perfect fit or the search ended - swap in best fit value.
            const pack = to[fitIndex];
            to[fitIndex] = to[packed];
            to[packed] = pack;
            (channels -= values[pack]) > 0 || (channels = channelsMax);
            // Start the search again over the remaining unpacked entries.
            fitIndex = ++packed;
            fitSize = Infinity;
            i = 0;
        }
    }
    return to;
}
function $bbb23253d9fa3113$export$96707a1f51900f3d(maps = {}, to = maps) {
    const { values: values = (0, $bc78d1a683d7cfc1$export$ff01eb58fe4e69)(), buffersMax: buffersMax = (0, $bc78d1a683d7cfc1$export$b6267c3f91c57c78), channelsMax: channelsMax = (0, $bc78d1a683d7cfc1$export$154f256b9eac9103), packed: // Pack `values` into blocks of `channelsMax` to minimise resources.
    packed = $bbb23253d9fa3113$export$9d1d9285bd6d8c57(values, channelsMax) } = maps;
    // Ensure any properties changed are included.
    to.values = values;
    to.buffersMax = buffersMax;
    to.channelsMax = channelsMax;
    to.packed = packed;
    const passes = to.passes = [
        []
    ];
    const textures = to.textures = [
        []
    ];
    const valueToTexture = to.valueToTexture = [];
    const valueToPass = to.valueToPass = [];
    const textureToPass = to.textureToPass = [];
    /** Whether to use output buffers in passes, or no buffers in one pass. */ const output = !!buffersMax;
    /** Counts the number of channels written in a single draw pass. */ let channels = 0;
    /** Get the index, via any `packed`, from `values`. */ const getIndex = packed ? (i)=>packed[i] : (i)=>i;
    /** Get the value, via any `packed`, from `values`. */ const getValue = packed ? (_, i)=>values[i] : (v)=>v;
    return (0, $338b36538fe76dc4$export$2e2bcd8739ae039)((to, v, i)=>{
        const index = getIndex(i);
        const value = getValue(v, index);
        if (!$bbb23253d9fa3113$export$5ca26c99531348ec(value, channelsMax)) return to;
        let p = passes.length - 1;
        let pass = passes[p];
        let t = textures.length - 1;
        let texture = textures[t];
        if ((channels += value) > channelsMax) {
            channels = value;
            t = textures.push(texture = []) - 1;
            output && pass.length >= buffersMax && (p = passes.push(pass = []) - 1);
            pass.push(t);
            textureToPass.push(p);
        } else if (pass.length === 0) {
            pass.push(t);
            textureToPass.push(p);
        }
        texture.push(index);
        valueToTexture[index] = t;
        valueToPass[index] = p;
        return to;
    }, values, to);
}
function $bbb23253d9fa3113$export$574963e692b662ec(maps = {}, to = maps) {
    const { derives: derives, passes: passes, textures: textures, valueToTexture: valueToTexture } = maps;
    if (!derives && derives !== 0) return to;
    const reads = to.reads = [];
    const readsToValue = to.readsToValue = [];
    const cache = {};
    const allStepSamples = (step)=>cache[step] ??= (0, $ea53246f0372c42f$export$2e2bcd8739ae039)((t, value)=>({
                step: step,
                value: value
            }), valueToTexture);
    const getAddSample = (pass, valueNext)=>function add(set, derive, d) {
            /** The past step to derive from. */ let step = 0;
            /** The past value to derive from. */ let dp = derive;
            // Derive from any specified `value` and `step` nested properties.
            derives !== true && !$bbb23253d9fa3113$var$isInteger(derives) && ({ value: dp = dp, step: step = step } = derive);
            // Derive from all samples at the given or most recent step if given `true`.
            if (dp === true) return (0, $338b36538fe76dc4$export$2e2bcd8739ae039)(add, allStepSamples(step), set);
            // Derive from the given sample.
            const texture = valueToTexture[dp];
            if (!($bbb23253d9fa3113$var$isInteger(step) && $bbb23253d9fa3113$var$isInteger(texture))) return console.error("`mapSamples`: invalid map for sample", derives, maps, pass, valueNext, derive, d, step, texture, dp);
            // Create the set if not already created.
            const to = set || [];
            // Check for any existing matching step/texture read in the set.
            const i = to.findIndex(([s, t])=>s === step && t === texture);
            // Add the read for this next value in this pass; creating any needed maps.
            ((reads[pass] ??= [])[valueNext] ??= [])// A new read as needed, or any existing matching read.
            .push(i < 0 ? to.push([
                step,
                texture
            ]) - 1 : i);
            // Add a reverse lookup from read index to value index.
            ((readsToValue[pass] ??= [])[valueNext] ??= []).push(dp);
            return to;
        };
    const getAddSamples = (pass)=>(set, valueNext)=>{
            /** Derive next output value from any given past input values. */ const dn = $bbb23253d9fa3113$var$isArray(derives) ? derives[valueNext] : derives;
            return !dn && dn !== 0 ? set : dn !== derives && $bbb23253d9fa3113$var$isArray(dn) ? (0, $338b36538fe76dc4$export$2e2bcd8739ae039)(getAddSample(pass, valueNext), dn, set) : getAddSample(pass, valueNext)(set, dn);
        };
    to.samples = (0, $ea53246f0372c42f$export$2e2bcd8739ae039)((pass, p)=>(0, $338b36538fe76dc4$export$2e2bcd8739ae039)((set, texture)=>(0, $338b36538fe76dc4$export$2e2bcd8739ae039)(getAddSamples(p), textures[texture], set), pass, null), passes, []);
    return to;
}
const $bbb23253d9fa3113$export$798cdecdcbbf9755 = (maps, to = maps)=>$bbb23253d9fa3113$export$574963e692b662ec($bbb23253d9fa3113$export$96707a1f51900f3d(maps, to), to);
var /**
 * @typedef {derive|array.<derive|array.<derive>>>} derives
 * Denotes how next output `values` derive from any past input `values`.
 *
 * A nested hierarchy of the form
 * `all-next-from-past[any-next-from-past[any-next-from-any-past]]`; each
 * nesting level denotes how to derive:
 * 0. `all-next-from-past`: to all next `values`, from one/all past `value`/s.
 * 1. `any-next-from-past`: to any given next `values` (by sparse `array`
 *   indexes in `values` order), from one/all past `value`/s.
 * 2. `any-next-from-any-past`: to any given next `values` (by its `array` index
 *   in parent level 1), from any past `value`/s in this level 2 `array`.
 *
 * The `array`s are sparse, with empty or `false`y-non-integer entries ignored.
 *
 * See `derive` for how to denote past input `values`.
 *
 * **See**
 *
 * - {@link derive}
 */ /**
 * @typedef {true|number|{value:true|number,step?:number}} derive
 * Denotes any past input `values` (and optional past `step`), that next output
 * `values` derive from.
 *
 * A nested hierarchy of the form `any-value-past[any-value-step-past]`,
 * indexing `values`, each nesting level denotes how to derive from:
 * 0. `any-value-past`: any/all past input `value`/s, at 1st `step` past.
 * 1. `any-value-step-past`: any/all past input `value`/s, at any given `step`
 *   past.
 *
 * The `value`/s to derive from may be given as:
 * - `true`: derives from all `values`.
 * - `number`: derives from the given `values` index.
 *
 * If given a `true` or `number` (denoting `value`/s but no `step`), the next
 * output `value` derives from the given `values` at the 1st `step` past.
 *
 * To specify a different `step`, pass an `object` denoting both the `value` (as
 * above) along with a `step`; in the form `{value:true|number,step?:number}`,
 * to derive from the `value` at any given `step` past (or the 1st `step` past
 * if not given).
 *
 * Any omitted `values` are ignored.
 *
 * See `derives` for more on how these are derived by the next output `values`.
 *
 * **See**
 *
 * - {@link derives}
 */ $bbb23253d9fa3113$export$2e2bcd8739ae039 = $bbb23253d9fa3113$export$798cdecdcbbf9755;


/**
 * The `gpgpu` state and `GL` data resources.
 *
 * Handles `framebuffer`s, `texture`s; and the main meta info.
 *
 * @module
 * @category JS
 *
 * @todo Allow passes into or across `texture`s; separate shapes of data and
 *   `texture`s.
 * @todo In-place updates of complex resources and meta info.
 */ 



/**
 * @module
 * @category JS
 */ 


const { floor: $590beef2a696b8fd$var$floor } = Math;
const { isFinite: $590beef2a696b8fd$var$isFinite, isInteger: $590beef2a696b8fd$var$isInteger } = Number;
function $590beef2a696b8fd$export$3c49c185de0c2bfc(value) {
    const { width: width, w: w, x: x, shape: shape, size: size, side: side, 0: v0 } = value;
    return (size && $590beef2a696b8fd$export$3c49c185de0c2bfc(size)) ?? width ?? w ?? x ?? (shape && $590beef2a696b8fd$export$3c49c185de0c2bfc(shape)) ?? side ?? v0 ?? ($590beef2a696b8fd$var$isFinite(value) ? value : null);
}
function $590beef2a696b8fd$export$c08559766941f856(value) {
    const { height: height, h: h, y: y, shape: shape, size: size, side: side, 1: v1 } = value;
    return (size && $590beef2a696b8fd$export$c08559766941f856(size)) ?? height ?? h ?? y ?? (shape && $590beef2a696b8fd$export$c08559766941f856(shape)) ?? side ?? v1 ?? ($590beef2a696b8fd$var$isFinite(value) ? value : null);
}
const $590beef2a696b8fd$export$2815acae70277c92 = (size = 1, height = 1)=>size?.entries ?? ($590beef2a696b8fd$export$3c49c185de0c2bfc(size) ?? 1) * ($590beef2a696b8fd$export$c08559766941f856(height) ?? 1);
const $590beef2a696b8fd$export$87ed20f81f3c66ff = (size)=>(0, $ea53246f0372c42f$export$2e2bcd8739ae039)((_, i)=>i, (0, $2ba8e5839a6e0a10$export$2e2bcd8739ae039)($590beef2a696b8fd$var$isInteger(size) ? size : $590beef2a696b8fd$export$2815acae70277c92(size)), 0);
const $590beef2a696b8fd$export$19cc39c76123d7db = (scale)=>$590beef2a696b8fd$var$isFinite(scale) ? 2 ** scale : null;
function $590beef2a696b8fd$export$6574bcda6112260a(value, to = []) {
    let s;
    to[0] = $590beef2a696b8fd$var$floor($590beef2a696b8fd$export$3c49c185de0c2bfc(value) ?? (s ??= $590beef2a696b8fd$export$19cc39c76123d7db(value.scale)) ?? (0, $bc78d1a683d7cfc1$export$c4175b5828221aa7));
    to[1] = $590beef2a696b8fd$var$floor($590beef2a696b8fd$export$c08559766941f856(value) ?? (s ??= $590beef2a696b8fd$export$19cc39c76123d7db(value.scale)) ?? (0, $bc78d1a683d7cfc1$export$bffb644e7dc52e91));
    return to;
}



const { max: $db5eb7ff43e44c77$var$max } = Math;
const { isInteger: $db5eb7ff43e44c77$var$isInteger } = Number;
/**
 * Whether all states merge into one data-`texture` or remain separate by
 * default, according to the number of `steps` and `textures` to be tracked.
 *
 * Uses separate data-`texture`s when the `steps` and `textures` are few enough
 * to allow it without issue on all platforms; otherwise merges data-`texture`s.
 *
 * @param {number} [steps] How many `steps` of state to track.
 * @param {number} [textures] How many data-`textures` to track per-step.
 *
 * @returns {boolean} Whether to merge states to one data-`texture` by default.
 */ const $db5eb7ff43e44c77$var$mergeDef = (steps, textures)=>steps > 2 && textures > 1;
function $db5eb7ff43e44c77$export$24a6b176bdc41ce5({ texture: texture, framebuffer: framebuffer }, state = {}, to = state) {
    const { maps: maps, steps: steps = (0, $bc78d1a683d7cfc1$export$617a37502ff8853), type: // Resource format settings.
    type = (0, $bc78d1a683d7cfc1$export$27fb0dad99ae5dd2), min: min = (0, $bc78d1a683d7cfc1$export$47b10f415de592b1), mag: mag = (0, $bc78d1a683d7cfc1$export$1fb689c67b965bff), wrap: wrap = (0, $bc78d1a683d7cfc1$export$8d7f4a48e1f2b2a), depth: depth = (0, $bc78d1a683d7cfc1$export$a211ab2c8ecded9a), stencil: stencil = (0, $bc78d1a683d7cfc1$export$a1b7c201e9365814) } = state;
    const shape = (0, $590beef2a696b8fd$export$6574bcda6112260a)(state);
    const [width, height] = shape;
    const { values: values = maps.values = (0, $bc78d1a683d7cfc1$export$ff01eb58fe4e69)(), channelsMin: channelsMin = maps.channelsMin = (0, $bc78d1a683d7cfc1$export$26945b8c914b7fc), buffersMax: buffersMax = maps.buffersMax = (0, $bc78d1a683d7cfc1$export$b6267c3f91c57c78), textures: texturesMap, passes: passesMap } = maps;
    const stepsL = steps.length ?? steps;
    const { merge: merge = $db5eb7ff43e44c77$var$mergeDef(stepsL, texturesMap.length) } = state;
    // Ensure any properties changed are included.
    to.steps = steps;
    to.merge = merge;
    to.type = type;
    to.min = min;
    to.mag = mag;
    to.wrap = wrap;
    to.depth = depth;
    to.stencil = stencil;
    to.width = width;
    to.height = height;
    /** Whether to use output buffers in passes, or no buffers in one pass. */ const output = buffersMax || null;
    /**
   * All `framebuffer` attachments need the same number of channels; enough to
   * hold all values a pass holds, or all passes hold if merging and reusing.
   */ const passChannels = (pass, min)=>(0, $338b36538fe76dc4$export$2e2bcd8739ae039)((min, t)=>$db5eb7ff43e44c77$var$max(min, (0, $338b36538fe76dc4$export$2e2bcd8739ae039)((sum, v)=>sum + values[v], texturesMap[t], 0)), pass, min);
    /**
   * If merging past `texture`s and reusing `texture` attachments in each pass's
   * `framebuffer`, pre-compute the minimum channels for a reusable pool of
   * `texture` attachments that can hold any pass's values; since all a
   * `framebuffer`'s attachments also need the same number of channels, this is
   * also the same number of channels across all passes.
   */ const mergeChannels = !merge ? null : (0, $338b36538fe76dc4$export$2e2bcd8739ae039)((min, p)=>passChannels(p, min), passesMap, channelsMin);
    /** Size of the created resources. */ const size = to.size ??= {};
    size.shape ??= shape;
    size.entries ??= (size.width ??= width) * (size.height ??= height);
    size.type ??= type;
    size.channelsMin ??= mergeChannels ?? channelsMin;
    size.steps ??= stepsL;
    size.passes ??= 0;
    size.framebuffers ??= 0;
    size.textures ??= 0;
    size.colors ??= 0;
    /** The `texture`s created for the `step`/`pass` render flow. */ const textures = to.textures = [];
    /** The passes created for the `step`/`pass` render flow. */ const passes = to.passes = [];
    /** The `texture`s bound to the next pass; reused if merging. */ let colorPool;
    /**
   * Add a `texture` attachment and meta info to `texture`s if applicable; to
   * return its new `texture` or a reused one to bind to a pass in `passes`.
   */ const addTexture = (channels, w, h, step, pass)=>(index, c, _, color)=>{
            /** Properties passed for `texture` creation, then meta info. */ const to = {
                channels: channels,
                width: w,
                height: h,
                type: type,
                min: min,
                mag: mag,
                wrap: wrap
            };
            // Resources.
            /**
     * Add/reuse `texture` color attachments as needed; add minimal `texture`s.
     * If merging, passes may reuse any pass's existing `texture` attachments;
     * otherwise, each pass has its own dedicated `texture` attachments.
     */ let entry = c;
            let t = color?.[entry];
            // Only create new `texture`s if existing ones can't be reused.
            if (!t) {
                t = texture?.(to);
                entry = size.textures++;
            }
            // Add meta info.
            /** Check if this is bound to a pass. */ const s = $db5eb7ff43e44c77$var$isInteger(step);
            const p = $db5eb7ff43e44c77$var$isInteger(pass);
            const i = $db5eb7ff43e44c77$var$isInteger(index);
            /** Denotes attached `texture`; if merging, `texture`s are reused. */ to.texture = t;
            /** Denotes attached `texture` entry; if merging, `texture`s are reused. */ to.entry = entry;
            s && (to.step = step);
            if (p) {
                /** Denotes `framebuffer` attachments; may reuse underlying `texture`s. */ to.color = size.colors++;
                to.pass = pass;
            }
            i && (to.map = texturesMap[to.index = index]);
            // Check whether this `texture` is part of the `step`/`pass` render flow.
            // If so, add to `textures`, return its `texture` to bind to a pass.
            // If not, return the entire object.
            return s && p && i ? ((textures[step] ??= [])[index] = to).texture : to;
        };
    /**
   * Add a pass to `passes`, with its `texture`s bound; to return its
   * `framebuffer` to one of `steps`.
   */ const addPass = (step, color)=>(pass, index)=>{
            /**
     * All a `framebuffer`'s attachments need the same number of channels;
     * superseded by any given `color`'s value.
     */ const channels = color != null ? 0 : mergeChannels ?? (pass ? passChannels(pass, channelsMin) : channelsMin);
            // Resources.
            /** Properties passed for `framebuffer` creation, then meta info. */ const to = {
                depth: depth,
                stencil: stencil,
                width: width,
                height: height,
                /** Map the pass's `texture` color attachments and their meta info. */ color: color ?? (pass ? (0, $ea53246f0372c42f$export$2e2bcd8739ae039)(addTexture(channels, width, height, step, index), pass, // Reuse any existing color attachments if merging; otherwise make
                // dedicated color attachments for each pass.
                merge ? colorPool ??= [] : []) : [])
            };
            /**
     * The `framebuffer` for this pass; don't create or bind if `buffersMax`
     * is `false`y.
     */ to.framebuffer = output && framebuffer?.(to);
            // Add meta info.
            /** Denotes any attached `framebuffer` entry. */ to.entry = output && size.framebuffers++;
            if (pass) {
                to.map = pass;
                to.pass = size.passes++;
            }
            const s = $db5eb7ff43e44c77$var$isInteger(step);
            const i = $db5eb7ff43e44c77$var$isInteger(index);
            s && (to.step = step);
            i && (to.index = index);
            // Check whether this pass is part of the `step`/`pass` render flow.
            // If so, add to `passes`, return its `framebuffer` for its step.
            return pass && s && i ? ((passes[step] ??= [])[index] = to).framebuffer : to;
        };
    /**
   * Set up resources needed to store data per-`texture` per-pass per-step.
   * Use any given steps/passes or create new ones.
   */ to.steps = (0, $ea53246f0372c42f$export$2e2bcd8739ae039)((passes, step)=>passes || (0, $ea53246f0372c42f$export$2e2bcd8739ae039)(addPass(step), passesMap), $db5eb7ff43e44c77$var$isInteger(steps) ? (0, $2ba8e5839a6e0a10$export$2e2bcd8739ae039)(steps) : steps, 0);
    /** Resize `texture`s, `framebuffer`s, and update `size`. */ to.resize = (value = to, state = to)=>{
        const { size: size, passes: passes, textures: textures, merge: merge } = state;
        const [w, h] = (0, $590beef2a696b8fd$export$6574bcda6112260a)(value ?? state, size.shape ??= []);
        size.entries = (size.width = w) * (size.height = h);
        (0, $b1bee206b7624e4c$export$2e2bcd8739ae039)((s)=>(0, $b1bee206b7624e4c$export$2e2bcd8739ae039)((p)=>p.framebuffer.resize(p.width = w, p.height = h), s), passes);
        (0, $b1bee206b7624e4c$export$2e2bcd8739ae039)((p)=>(0, $b1bee206b7624e4c$export$2e2bcd8739ae039)((t)=>t.texture.resize(t.width = w, t.height = h), p), textures);
        return merge?.resize?.(value, state) ?? state;
    };
    // Finish here if merge is disabled.
    if (!merge) return to;
    // Set up the `texture` for states to be merged into.
    const m = to.merge = {
        ...merge
    };
    const { all: mAll, next: mNext } = m;
    const ms = size.merge = m.size ??= {};
    /** Use any given size info, or merge along `[texture, step]` axes. */ ms.width ??= texturesMap.length * width;
    ms.height ??= stepsL * height;
    const [mw, mh] = (0, $590beef2a696b8fd$export$6574bcda6112260a)(m, ms.shape ??= []);
    ms.entries ??= (ms.width = mw) * (ms.height = mh);
    /** New merge `texture` and info, or use any given merge `texture`. */ m.all = mAll ?? addTexture(mergeChannels, mw, mh)();
    /** Empty `framebuffer`, to copy data from each `texture` of each pass. */ m.next = mNext ?? addPass(null, colorPool[0])();
    /** Resize `texture`s, `framebuffer`s, and update `size`. */ m.resize = (value = to, state = to)=>{
        const { merge: merge, size: size, maps: maps } = state;
        const { size: ms = size.merge = {}, all: all, next: next } = merge;
        const { textures: texturesMap } = maps;
        const shape = (0, $590beef2a696b8fd$export$6574bcda6112260a)(value ?? state, ms.shape ??= []);
        const [w, h] = shape;
        next.framebuffer.resize(next.width = w, next.height = h);
        ms.width = texturesMap.length * w;
        ms.height = size.steps * h;
        const [mw, mh] = (0, $590beef2a696b8fd$export$6574bcda6112260a)(ms, shape);
        ms.entries = (ms.width = mw) * (ms.height = mh);
        all.texture.resize(all.width = mw, all.height = mh);
        return state;
    };
    return to;
}
var $db5eb7ff43e44c77$export$2e2bcd8739ae039 = $db5eb7ff43e44c77$export$24a6b176bdc41ce5;


/**
 * The `gpgpu` inputs for `GL` `uniform`s.
 *
 * @module
 * @category JS
 */ 



function $42d53ffb3630b5df$export$1aad3af825e3305b(state = {}, to = state.uniforms ??= {}) {
    const { steps: steps, maps: maps, pre: n = (0, $bc78d1a683d7cfc1$export$b4781c2237bde956), bound: bound = (0, $bc78d1a683d7cfc1$export$b029aceb5666f022) } = state;
    const { textures: textures } = maps;
    const stepsL = steps.length ?? steps;
    const texturesL = textures.length;
    // Local caches.
    const stateShape = [];
    const viewShape = [];
    /** Gives any current step. */ to[n + "stepNow"] = (_, s)=>s.stepNow;
    /** Gives any shape of `state` and any merged `states` data-`texture`s. */ to[n + "stateShape"] = (_, { size: { shape: s, merge: m } })=>s ? (0, $5d21eae0771d5dbf$export$abee0037e1db715)(stateShape, ...s, ...m?.shape ?? s) : (0, $5d21eae0771d5dbf$export$abee0037e1db715)(stateShape);
    /** Gives the shape of the `GL` viewport. */ to[n + "viewShape"] = ({ drawingBufferWidth: w, drawingBufferHeight: h })=>(0, $5d21eae0771d5dbf$export$dcfbb7940cfb3a48)(viewShape, w, h);
    /**
   * Gives all `states` merged in one `texture`, if using `merge`;
   * otherwise gives `null`.
   */ to[n + "states"] = (_, s)=>s.merge?.all?.texture ?? null;
    /**
   * Past steps, each some steps `ago`, from the current active step at `0`, as
   * `[0,... stepsL-1-bound]`.
   */ const addTextures = (ago)=>/**
     * Hooks to pull a given `texture` by the active pass `state`; lets `GLSL`
     * access the `array` of `texture`s by constant index (steps ago).
     * Only returns a value if not using a `merge`d `texture`; otherwise `null`.
     */ (0, $b1bee206b7624e4c$export$2e2bcd8739ae039)((_, t)=>to[n + `states[${ago * texturesL + t}]`] = (_, { merge: m, stepNow: s = 0, bound: b = bound, textures: ts })=>m ? null : (0, $e2f6bbbfbdb75d47$export$2e2bcd8739ae039)(s - b - ago, ts)?.[t]?.texture, textures);
    /** Flatten all input `texture`s, as `uniform`s are kept in flat `array`s. */ for(let ago = 0, pl = stepsL - bound; ago < pl; ++ago)addTextures(ago);
    return to;
} /**
 * @todo [Fix `@callback`/`@typedef`](https://github.com/TypeStrong/typedoc/issues/1896):
 *   nested `@param`; omits `@return`/`@see`/`@this`
 *
 * @callback getUniform
 * A `function` hook to update a `GL` `uniform` value for a render pass.
 *
 * **See**
 * - {@link toUniforms}
 * - {@link data.toData}
 * - {@link api.texture}
 *
 * **Returns**
 * A `GL` uniform to be bound via a `GL` API.
 *
 * @param {{
 *     drawingBufferWidth:number,
 *     drawingBufferHeight:number
 *   }} context General or global properties; with:
 *   - `drawingBufferWidth`: Current `GL` viewport width in pixels.
 *   - `drawingBufferHeight`: Current `GL` viewport height in pixels.
 *
 * @param {{
 *     stepNow?:number,
 *     bound?:number,
 *     merge?:{texture:object},
 *     textures:{texture:object}[][]
 *   }} state Local properties (the `gpgpu` state); with:
 *   - `stepNow`: The current step of the `gpgpu` state.
 *   - `bound`: Number of steps bound to output; can't be bound as inputs.
 *   - `merge`: Any `object` containing merged data-`texture`.
 *     - `texture`: Any merged data-`texture`.
 *   - `textures`: Textures per-step, as `array`s of `object`s with a `texture`
 *     property. See `toData`.
 *
 * @returns {number|number[]|texture|object}
 */ 


/**
 * The `gpgpu` update step.
 *
 * Connects inputs to the `GL` state and renders an update step.
 *
 * @module
 * @category JS
 *
 * @todo [Fix `@callback`/`@typedef`](https://github.com/TypeStrong/typedoc/issues/1896):
 *   nested `@param`; omits `@return`/`@see`/`@this`
 */ 

/**
 * The `GLSL` preprocessor macros for working with the `gpgpu` state and maps.
 *
 * Each set of different macros will result in new shader compilations - for
 * optimal performance, the fewest macros possible should be created, one per
 * each given set of inputs, ideally; caches here can be used for efficiency.
 *
 * @module
 * @category JS
 *
 * @todo Redo examples, especially `macroTaps` and `macroPass`.
 * @todo Ensure the `output_N` in `macroOutput` can work with `WebGL2`; look at
 *   using `layout(location=attach_N) out data_N`, not `gl_FragData[attach_N]`.
 *   - [SO: Multiple output textures from the same program](https://stackoverflow.com/questions/51793336/multiple-output-textures-from-the-same-program)
 *   - [SO: GL FragData must be constant zero](https://stackoverflow.com/questions/46740817/gl-fragdata-must-be-constant-zero)
 *   - [SO: How are layout qualifiers better than getAttribLocation in WebGL2](https://stackoverflow.com/questions/50258822/how-are-layout-qualifiers-better-than-getattriblocation-in-webgl2)
 */ 

const [{ length: $df3b87fcf9aa46e0$var$start }, { length: $df3b87fcf9aa46e0$var$end }] = "[object {type}]".split("{type}");
const $df3b87fcf9aa46e0$export$bf9fb029d174d554 = (x)=>toString.call(x).slice($df3b87fcf9aa46e0$var$start, -$df3b87fcf9aa46e0$var$end);
var $df3b87fcf9aa46e0$export$2e2bcd8739ae039 = $df3b87fcf9aa46e0$export$bf9fb029d174d554;



const $5bb6ca9eea4b6017$export$36a518e2013de1bd = " \\\n";
const $5bb6ca9eea4b6017$var$lf = $5bb6ca9eea4b6017$export$36a518e2013de1bd;
const $5bb6ca9eea4b6017$export$4e46ac54fc82cf3b = "rgba";
const $5bb6ca9eea4b6017$export$497faa7f0daf9da = {};
/** Gives cache keys from simple plain `object` inputs. */ const $5bb6ca9eea4b6017$var$id = JSON.stringify;
const $5bb6ca9eea4b6017$export$11949c6f5fba7dcd = {
    /** The full set of macros. */ macroPass: "",
    /** Each part of the set of macros. */ macroValues: "values",
    macroOutput: "output",
    macroSamples: "samples",
    macroTaps: "taps"
};
function $5bb6ca9eea4b6017$export$feaf5ffc92c2af94(state, key, on = "", macros = state?.macros) {
    if ((macros ?? true) === true) return null;
    else if (!macros) return "";
    const t = (0, $df3b87fcf9aa46e0$export$bf9fb029d174d554)(macros);
    return t === "String" ? macros : t === "Function" ? $5bb6ca9eea4b6017$export$feaf5ffc92c2af94(state, key, on, macros(state, key, on, macros)) : macros instanceof Object && key in macros ? $5bb6ca9eea4b6017$export$feaf5ffc92c2af94(state, key, on, macros[key]) : on ? $5bb6ca9eea4b6017$export$feaf5ffc92c2af94(state, key ? key + "_" + on : on, "", macros) : null;
}
const $5bb6ca9eea4b6017$export$83d01c7b88bc16d5 = (type, name, a, qualify = "", init = type)=>`const int ${name}_l = ${a.length};` + (0, $338b36538fe76dc4$export$2e2bcd8739ae039)((s, v, i)=>s + $5bb6ca9eea4b6017$var$lf + (qualify && qualify + " ") + type + ` ${name}_${i} = ${init}(${v.join?.(", ") ?? v});`, a, "");
const $5bb6ca9eea4b6017$export$45db4de6da38aa8d = (type, name, a, qualify = "", init = type)=>$5bb6ca9eea4b6017$export$83d01c7b88bc16d5(type, name, a, qualify, init) + "\n\n" + // @todo Would ideally use the concatenation macro, but can't in GLSL 1.
    // `#define ${name}_i(i) ${name}_##i`;
    `/**\n` + ` * Index function \`${name}_i\` (e.g: \`${name}_i(0)\`) may be slow.\n` + ` * Use name (e.g: \`${name}_0\`) if possible.\n` + ` */\n` + `#define ${name}_i(i) ${(0, $338b36538fe76dc4$export$2e2bcd8739ae039)((s, v, i)=>i ? `((i == ${i})? ${name}_${i} : ${s})` : `${name}_${i}`, a, "")}\n`;
const $5bb6ca9eea4b6017$export$3df19e70a88cb8cd = (type, name, a, qualify = "", init = type)=>$5bb6ca9eea4b6017$export$83d01c7b88bc16d5(type, name, a, qualify, init) + $5bb6ca9eea4b6017$var$lf + (qualify && qualify + " ") + type + ` ${name}[${name}_l];` + (0, $338b36538fe76dc4$export$2e2bcd8739ae039)((s, _, i)=>s + $5bb6ca9eea4b6017$var$lf + name + `[${i}] = ${name}_${i};`, a, "") + "\n" + `#define ${name}_i(i) ${name}[i]\n`;
const $5bb6ca9eea4b6017$export$1c7039c93eddfba = (type, name, a, qualify = "", init = type)=>$5bb6ca9eea4b6017$export$83d01c7b88bc16d5(type, name, a, qualify, init) + $5bb6ca9eea4b6017$var$lf + (qualify && qualify + " ") + type + ` ${name}[${name}_l] = ${init}[${name}_l](${(0, $338b36538fe76dc4$export$2e2bcd8739ae039)((s, _, i)=>(s && s + ", ") + name + "_" + i, a, "")});\n` + `#define ${name}_i(i) ${name}[i]\n`;
const $5bb6ca9eea4b6017$export$c346962e7dd3191 = (type, name, a, qualify = "", glsl = 1, init)=>(glsl >= 3 ? $5bb6ca9eea4b6017$export$1c7039c93eddfba : qualify.trim() === "const" ? $5bb6ca9eea4b6017$export$45db4de6da38aa8d : $5bb6ca9eea4b6017$export$3df19e70a88cb8cd)(type, name, a, qualify, init);
function $5bb6ca9eea4b6017$export$84186522bf5a7d4d(state, on) {
    const key = $5bb6ca9eea4b6017$export$11949c6f5fba7dcd.macroValues;
    let to = $5bb6ca9eea4b6017$export$feaf5ffc92c2af94(state, key, on);
    if (to != null) return to;
    const { maps: maps, steps: steps, bound: bound = (0, $bc78d1a683d7cfc1$export$b029aceb5666f022), merge: merge, size: size, pre: n = (0, $bc78d1a683d7cfc1$export$b4781c2237bde956), cache: cache = $5bb6ca9eea4b6017$export$497faa7f0daf9da } = state;
    const { values: values, textures: textures, passes: { length: passesL }, alias: alias } = maps;
    const stepsL = steps.length ?? steps;
    const entries = size?.entries;
    const split = !merge;
    const c = cache && `macro@${key}@${n}|${bound}|${$5bb6ca9eea4b6017$var$id(values)}|${$5bb6ca9eea4b6017$var$id(textures)}|${stepsL}|${passesL}|${entries}|${split}|${$5bb6ca9eea4b6017$var$id(alias)}`;
    if ((to = cache?.[c]) != null) return to;
    const texturesL = textures.length;
    const stepsPast = stepsL - bound;
    to = (0, $338b36538fe76dc4$export$2e2bcd8739ae039)((s, texture, t, _, i = 0)=>(0, $338b36538fe76dc4$export$2e2bcd8739ae039)((s, v)=>{
            const to = s + `#define ${n}texture_${v} ${t}\n` + `#define ${n}channels_${v} ${$5bb6ca9eea4b6017$export$4e46ac54fc82cf3b.slice(i, i += values[v])}\n\n`;
            if (!alias) return to;
            const a = alias[v];
            return to + `#define ${n}texture_${a} ${n}texture_${v}\n` + `#define ${n}channels_${a} ${n}channels_${v}\n\n`;
        }, texture, s), textures, "") + (entries || entries === 0 ? `#define ${n}entries ${entries}\n` : "") + `#define ${n}textures ${texturesL}\n` + `#define ${n}passes ${passesL}\n` + `#define ${n}bound ${bound}\n` + `#define ${n}steps ${stepsL}\n` + `#define ${n}stepsPast ${stepsPast}\n` + `#define ${n}${split ? `splits` : `merged`} ${texturesL * stepsPast}\n\n`;
    return cache ? cache[c] = to : to;
}
function $5bb6ca9eea4b6017$export$49873e279ff642c0(state, on) {
    const key = $5bb6ca9eea4b6017$export$11949c6f5fba7dcd.macroOutput;
    let to = $5bb6ca9eea4b6017$export$feaf5ffc92c2af94(state, key, on);
    if (to != null) return to;
    const { passNow: p, maps: maps, pre: n = (0, $bc78d1a683d7cfc1$export$b4781c2237bde956), cache: cache = $5bb6ca9eea4b6017$export$497faa7f0daf9da } = state;
    const { values: values, textures: textures, passes: passes, alias: alias } = maps;
    const pass = passes[p];
    const c = cache && `macro@${key}@${n}|${p}|${$5bb6ca9eea4b6017$var$id(values)}|${$5bb6ca9eea4b6017$var$id(textures)}|${$5bb6ca9eea4b6017$var$id(passes)}|${$5bb6ca9eea4b6017$var$id(alias)}`;
    to = cache?.[c] ?? `#define ${n}passNow ${p}\n${(0, $338b36538fe76dc4$export$2e2bcd8739ae039)((s, texture, bound, _, i = 0)=>(0, $338b36538fe76dc4$export$2e2bcd8739ae039)((s, v)=>{
            const to = s + "\n" + `#define ${n}bound_${v} ${texture}\n` + `#define ${n}attach_${v} ${bound}\n` + `#define ${n}output_${v} gl_FragData[${n}attach_${v}].${$5bb6ca9eea4b6017$export$4e46ac54fc82cf3b.slice(i, i += values[v])}\n`;
            if (!alias) return to;
            const a = alias[v];
            return to + "\n" + `#define ${n}bound_${a} ${n}bound_${v}\n` + `#define ${n}attach_${a} ${n}attach_${v}\n` + `#define ${n}output_${a} ${n}output_${v}\n`;
        }, textures[texture], s), pass, "")}\n`;
    return cache ? cache[c] = to : to;
}
function $5bb6ca9eea4b6017$export$9cb6037fa2a40c2e(state, on) {
    const key = $5bb6ca9eea4b6017$export$11949c6f5fba7dcd.macroSamples;
    let to = $5bb6ca9eea4b6017$export$feaf5ffc92c2af94(state, key, on);
    if (to != null) return to;
    const { passNow: p = 0, maps: maps, steps: steps, bound: bound = (0, $bc78d1a683d7cfc1$export$b029aceb5666f022), glsl: glsl, pre: n = (0, $bc78d1a683d7cfc1$export$b4781c2237bde956), cache: cache = $5bb6ca9eea4b6017$export$497faa7f0daf9da } = state;
    const { samples: samples, reads: reads, readsToValue: readsToValue, alias: alias } = maps;
    const passSamples = samples?.[p];
    const passReads = reads?.[p];
    const passReadsToValue = readsToValue?.[p];
    const stepsPast = alias ? (steps.length ?? steps) - bound : null;
    const c = cache && `macro@${key}@${n}|${p}|${$5bb6ca9eea4b6017$var$id(passSamples)}|${$5bb6ca9eea4b6017$var$id(passReads)}|${$5bb6ca9eea4b6017$var$id(passReadsToValue)}|${$5bb6ca9eea4b6017$var$id(alias)}|${stepsPast}|${glsl}`;
    to = cache?.[c] ?? (!passSamples ? "" : `#define ${n}useSamples${$5bb6ca9eea4b6017$var$lf + $5bb6ca9eea4b6017$export$c346962e7dd3191("ivec2", n + "samples", passSamples, "const", glsl)}\n`) + (!passReads ? "" : (0, $338b36538fe76dc4$export$2e2bcd8739ae039)((s, reads, v)=>{
        const to = `${s}#define ${n}useReads_${v}${$5bb6ca9eea4b6017$var$lf + $5bb6ca9eea4b6017$export$c346962e7dd3191("int", n + "reads_" + v, reads, "const", glsl)}\n`;
        if (!alias) return to;
        const valueReadsToValue = passReadsToValue[v];
        const aliasAt = alias[v];
        const readAlias = `${n}reads_${aliasAt}`;
        const readIndex = `${n}reads_${v}`;
        return to + `/**\n` + ` * Alias reads, depends on index reads \`${n}useReads_${v}\`.\n` + ` * If using both alias and index reads, only use this not both.\n` + ` */\n` + `#define ${n}useReads_${aliasAt}${$5bb6ca9eea4b6017$var$lf}${n}useReads_${v}${(0, $338b36538fe76dc4$export$2e2bcd8739ae039)((s, read, r)=>{
            const aliasTo = alias[valueReadsToValue[r]];
            /** How many steps into the past is the sample being read. */ const past = passSamples[read][0];
            /** How many steps from the last is the sample being read. */ const last = stepsPast - past - 1;
            const note = `Alias for \`${aliasAt}\` reads \`${aliasTo}\` at `;
            const noteNew = `${note + past} step${past === 1 ? "" : "s"} into the past; `;
            const noteOld = `${note + last} step${last === 1 ? "" : "s"} from the last; `;
            /** Base of assignment. */ const base = `${$5bb6ca9eea4b6017$var$lf}const int ${readAlias}_${aliasTo}`;
            /** Right side of assignment. */ const right = `${readIndex}_${r};${$5bb6ca9eea4b6017$var$lf}`;
            /** Left side of assignment. */ let left;
            return s + $5bb6ca9eea4b6017$var$lf + (past || s.indexOf(left = `${base} = `) >= 0 ? "" : `/** ${noteNew}implied newest, bare. */${left + right}`) + (past || s.indexOf(left = `${base}_new = `) >= 0 ? "" : `/** ${noteNew}implied newest. */${left + right}`) + (last || s.indexOf(left = `${base}_old = `) >= 0 ? "" : `/** ${noteOld}implied oldest. */${left + right}`) + (s.indexOf(left = `${base}_new_${past} = `) >= 0 ? "" : `/** ${noteNew}counted newest-to-oldest. */${left + right}`) + (s.indexOf(left = `${base}_old_${last} = `) >= 0 ? "" : `/** ${noteOld}counted oldest-to-newest. */${left + right}`);
        }, reads, reads.length ? $5bb6ca9eea4b6017$var$lf : "")}${$5bb6ca9eea4b6017$var$lf}const int ${readAlias}_l = ${readIndex}_l;${$5bb6ca9eea4b6017$var$lf}int ${readAlias}_i(int i) { return ${readIndex}_i(i); }\n\n`;
    }, passReads, ""));
    return cache ? cache[c] = to : to;
}
function $5bb6ca9eea4b6017$export$562ddd36066ad650(state, on) {
    const key = $5bb6ca9eea4b6017$export$11949c6f5fba7dcd.macroTaps;
    let to = $5bb6ca9eea4b6017$export$feaf5ffc92c2af94(state, key, on);
    if (to != null) return to;
    const { passNow: p = 0, maps: maps, merge: merge, glsl: glsl, pre: n = (0, $bc78d1a683d7cfc1$export$b4781c2237bde956), cache: cache = $5bb6ca9eea4b6017$export$497faa7f0daf9da } = state;
    const passSamples = maps.samples?.[p];
    const split = !merge;
    const c = cache && `macro@${key}@${n}|${p}|${$5bb6ca9eea4b6017$var$id(passSamples)}|${split}|${glsl}`;
    if ((to = cache?.[c]) != null) return to;
    const glsl3 = glsl >= 3;
    /** Which texture sampling function is available. */ const texture = "texture" + (glsl3 ? "" : "2D");
    /** Short and common names for functions and parameters. */ const f = n + "tapState";
    const def = "#define " + f;
    /** Common parameters, passed as `(..., stepBy, textureBy)` */ const bs = "stepBy";
    const bt = "textureBy";
    const by = `${bs}, ${bt}`;
    /** Aliases default names for brevity, main functions offer more control. */ const aka = `#define ${f}(uv)` + $5bb6ca9eea4b6017$var$lf + f;
    const akaBy = `#define ${f}By(uv, ${by})` + $5bb6ca9eea4b6017$var$lf + f;
    /** The current `sample`, as `[step, texture]`. */ const st = n + "samples_";
    /** Prefix for private temporary variables. */ const t = "_" + n;
    /** A temporary `array` to pass to `getGLSLList`. */ const tapsSamples = cache[key + ":tapsSamples"] ??= [];
    const tapsL = tapsSamples.length = passSamples?.length ?? 0;
    /** The main `texture`-sampling logic. */ to = !tapsL ? "" : (split ? /** Split un-merged `texture`s accessed by constant index. */ `/**\n` + ` * States in a \`sampler2D[]\`; looks up 1D index and 2D \`uv\`.\n` + ` * Past steps go later in the list.\n` + ` * States may also be sampled by shifted step/texture.\n` + ` * Pass constant array index values; \`textures, ${by}\`.\n` + ` * Use \`${n}data\` list; ignore temporary \`${t}\` names.\n` + ` */\n` + def + `sBy(uv, states, textures, ${by})` + $5bb6ca9eea4b6017$var$lf + // Compute before the loop for lighter work.
    `const int ${t}tl = int(textures);` + $5bb6ca9eea4b6017$var$lf + `vec2 ${t}uv = vec2(uv);` + $5bb6ca9eea4b6017$var$lf + // Sample into the `data` output list.
    $5bb6ca9eea4b6017$export$c346962e7dd3191("vec4", n + "data", (0, $ea53246f0372c42f$export$2e2bcd8739ae039)((_, i)=>texture + "(states[" + // Offset step.
        `((int(${st + i}.s)+int(${bs}))*${t}tl)+` + // Offset `texture`.
        `int(${st + i}.t)+int(${bt})` + `], ${t}uv)`, passSamples, tapsSamples), "", glsl) + "\n" + `/** Sample the states as given without shifting by any offsets. */\n` + def + `s(uv, states, textures)` + $5bb6ca9eea4b6017$var$lf + f + `sBy(uv, states, textures, 0, 0)\n\n` + `/** Preferred aliases: index suits states array constant access. */\n` + aka + `s(uv, ${n}states, ${n}textures)\n` + akaBy + `sBy(uv, ${n}states, ${n}textures, ${by})\n` : /** Merged 2D `texture`. */ `/**\n` + ` * States merged in a \`sampler2D\`.\n` + ` * Scales the 2D \`uv\` lookup over \`[textures, steps]\`.\n` + ` * Step from now into the past going upwards in the texture.\n` + ` * States may also be sampled by shifted step/texture.\n` + ` * Use \`${n}data\` list; ignore temporary \`${t}\` names.\n` + ` */\n` + def + `2By(uv, states, stepNow, steps, textures, ${by})` + $5bb6ca9eea4b6017$var$lf + // Compute before the loop for lighter work.
    `vec2 ${t}l = vec2(textures, steps);` + $5bb6ca9eea4b6017$var$lf + `vec2 ${t}uv = vec2(uv)/${t}l;` + $5bb6ca9eea4b6017$var$lf + // Steps advance in reverse, top-to-bottom.
    `vec2 ${t}s = vec2(1, -1)/${t}l;` + $5bb6ca9eea4b6017$var$lf + // Offset `texture`, step.
    // Each step stored in `texture` top downward at `-stepNow`.
    // Most recent step to look up is at `-stepNow+1`.
    `vec2 ${t}i = (vec2(${by}).ts+vec2(0, 1))-vec2(0, stepNow);` + $5bb6ca9eea4b6017$var$lf + // Sample into the `data` output list.
    $5bb6ca9eea4b6017$export$c346962e7dd3191("vec4", n + "data", // Would repeat wrap; but `WebGL1` needs power-of-2.
    (0, $ea53246f0372c42f$export$2e2bcd8739ae039)((_, i)=>texture + `(states, ` + // Offset `texture`, step.
        `fract(${t}uv+fract((vec2(${st + i}).ts+${t}i)*${t}s)))`, passSamples, tapsSamples), "", glsl) + "\n" + `/** Sample the states as given without shifting by any offsets. */\n` + def + `2(uv, states, stepNow, steps, textures)` + $5bb6ca9eea4b6017$var$lf + f + `2By(uv, states, stepNow, steps, textures, 0, 0)\n\n` + (!glsl3 ? `/** Preferred aliases: 2D suits merged texture in \`GLSL\` < 1. */\n` + aka + `2(uv, ${n}states, ${n}stepNow, ${n}steps, ${n}textures)\n` + akaBy + `2By(uv, ${n}states, ${n}stepNow, ${n}steps, ${n}textures, ${by})\n` : /**
         * Merged 3D `texture` types, supported from `GLSL3`.
         * @todo Check and finish this.
         */ `/**\n` + ` * States merged to \`sampler3D\` or \`sampler2DArray\`.\n` + ` * 2D \`uv\` to 3D.\n` + ` * Scales \`x\` over \`textures\`, \`z\` over \`steps\` as:\n` + ` * - \`sampler3D\`: the number of steps; depth, \`[0, 1]\`.\n` + ` * - \`sampler2DArray\`: \`1\` or less; layer, \`[0, steps-1]\`.\n` + ` * States may also be sampled by shifted step/texture.\n` + ` * Use \`${n}data\` list; ignore temporary \`${t}\` names.\n` + ` */\n` + def + `3By(uv, states, stepNow, steps, textures, ${by})` + $5bb6ca9eea4b6017$var$lf + /** @see `...2By()` above. */ // Compute before the loop for lighter work.
    `vec2 ${t}l = vec2(textures, steps);` + $5bb6ca9eea4b6017$var$lf + `vec2 ${t}uv = (vec2(uv)+vec2(textureBy, 0))/${t}l;` + $5bb6ca9eea4b6017$var$lf + // Offset `texture`.
    `float ${t}sx = 1.0/${t}l.x;` + $5bb6ca9eea4b6017$var$lf + // Offset step.
    `float ${t}s = float(stepBy)-float(stepNow);` + $5bb6ca9eea4b6017$var$lf + `float ${t}sz = -1.0/${t}l;` + $5bb6ca9eea4b6017$var$lf + // Sample into the `data` output list.
    $5bb6ca9eea4b6017$export$c346962e7dd3191("vec4", n + "data", // Would repeat wrap; but `sampler2DArray` layer can't.
    (0, $ea53246f0372c42f$export$2e2bcd8739ae039)((_, i)=>texture + "(states, fract(vec3(" + // Offset `texture`.
        `${t}uv.x+(float(${st + i}.t)*${t}sx), ${t}uv.y, ` + // Offset step: `sampler3D` depth, `[0, 1]`;
        // `sampler2DArray` layer, `[0, steps-1]`.
        `(float(${st + i}.s)+${t}s)*${t}sz)))`, passSamples, tapsSamples), "", glsl) + "\n" + `/** Sample the states as given without shifting by any offsets. */\n` + def + `3(uv, states, stepNow, steps, textures)` + $5bb6ca9eea4b6017$var$lf + f + `3(uv, states, stepNow, steps, textures)\n\n` + `/** Preferred aliases: 3D suits merged texture in \`GLSL\` 3+. */\n` + aka + `3(uv, ${n}states, ${n}stepNow, ${n}steps, ${n}textures)\n` + akaBy + `3By(uv, ${n}states, ${n}stepNow, ${n}steps, ${n}textures, ${by})\n`)) + "\n";
    return cache ? cache[c] = to : to;
}
const $5bb6ca9eea4b6017$export$d38b14fb9031108e = (state, on)=>$5bb6ca9eea4b6017$export$feaf5ffc92c2af94(state, $5bb6ca9eea4b6017$export$11949c6f5fba7dcd.macroPass, on) ?? $5bb6ca9eea4b6017$export$84186522bf5a7d4d(state, on) + $5bb6ca9eea4b6017$export$49873e279ff642c0(state, on) + $5bb6ca9eea4b6017$export$9cb6037fa2a40c2e(state, on) + $5bb6ca9eea4b6017$export$562ddd36066ad650(state, on);
var $5bb6ca9eea4b6017$export$2e2bcd8739ae039 = $5bb6ca9eea4b6017$export$d38b14fb9031108e;



const { call: $dca3c1826e5966d7$var$call } = Function;
const $dca3c1826e5966d7$export$d86e3abd7686c23f = ({ passes: ps, stepNow: s, passNow: p })=>(0, $e2f6bbbfbdb75d47$export$2e2bcd8739ae039)(s, ps)?.[p];
const $dca3c1826e5966d7$export$95b2c9ea2de43ebb = (shader, context, state)=>shader.call === $dca3c1826e5966d7$var$call ? shader(context, state) : shader;
function $dca3c1826e5966d7$export$12661000d11a17d2(state) {
    const { merge: merge, stepNow: s, size: size, copyImage: ci = state.copyImage = (0, $bc78d1a683d7cfc1$export$72e520e6a70b780c)() } = state;
    const { color: cs, map: pass } = $dca3c1826e5966d7$export$d86e3abd7686c23f(state);
    const { all: { texture: t }, next: next } = merge;
    const sub = t?.subimage;
    const { color: nc } = next;
    let f = next.framebuffer;
    /** Handle `object`s or `regl`-like extended `function`s. */ f?.call !== Function.call && (f = f?.call);
    // Silent exit if there's not enough info ready now to perform the update.
    if (!(sub && f && cs && pass && (s || s === 0))) return t;
    const { steps: sl, width: w, height: h } = size;
    /** Start at the top of the `texture`, move down row-per-step and wrap. */ const y = (0, $e2f6bbbfbdb75d47$export$2e2bcd8739ae039)(s, sl) * h;
    /**
   * Reusable `framebuffer` binds and copies each of the pass `texture`s along
   * the merged `texture`.
   */ (0, $b1bee206b7624e4c$export$2e2bcd8739ae039)((c, i)=>(next.color = c) && f.call(f, next).use.call(f, ()=>sub.call(t, ci, pass[i] * w, y)), cs);
    /** Reset any changed properties. */ next.color = nc;
    f.call(f, next);
    return t;
}
function $dca3c1826e5966d7$export$ca14b6cb1bf101d2(state) {
    const { merge: merge, clearPass: c = state.clearPass = (0, $bc78d1a683d7cfc1$export$2fcc13103217f9a3)() } = state;
    const { all: { texture: t }, next: next } = merge;
    const { color: nc } = next;
    let f = next.framebuffer;
    /** Handle `object`s or `regl`-like extended `function`s. */ f?.call !== Function.call && (f = f?.call);
    if (!c || !f) return t;
    const cf = c.framebuffer;
    (next.color = t) && (c.framebuffer = f.call(f, next)) && clear(c);
    /** Reset any changed properties. */ c.framebuffer = cf;
    next.color = nc;
    f.call(f, next);
    return t;
}
function $dca3c1826e5966d7$export$d89197afac86b993(api, state = {}, to = state) {
    /** Handle `object`s or `regl`-like extended `function`s, for `command`. */ const { buffer: buffer, clear: clear1, command: command = api } = api;
    const { merge: merge, pipeline: pipeline, verts: verts, frag: frag, frags: frags, uniforms: uniforms, attributes: attributes, maps: maps, // Update any default vertex `shader` to use the given `pre`.
    pre: n = (0, $bc78d1a683d7cfc1$export$b4781c2237bde956), vert: vert = (0, $bc78d1a683d7cfc1$export$dc207adda608f979).replaceAll((0, $bc78d1a683d7cfc1$export$b4781c2237bde956), n || ""), count: // Any vertex `count`, and `positions` to be passed to `buffer`.
    count = (0, $bc78d1a683d7cfc1$export$832d88422d279bbc), positions: positions = (0, $bc78d1a683d7cfc1$export$cfdc3a7c4cb854c6)() } = state;
    let { clearPass: clearPass = null } = state;
    // Ensure any properties changed are included.
    to.pre = n;
    to.vert = vert;
    to.count = count;
    to.positions = buffer(positions);
    to.clearPass = clearPass === true ? clearPass = undefined : clearPass;
    // May pre-process and keep the `shader`s for all passes in advance.
    if (verts || frags) {
        // Keep the current pass.
        const { passNow: passNow } = state;
        verts && (to.verts = verts);
        frags && (to.frags = frags);
        (0, $b1bee206b7624e4c$export$2e2bcd8739ae039)((pass, p)=>{
            // Create `macro`s for this pass in advance.
            state.passNow = p;
            // Specify a `'vert'` type `shader` for any per-`shader` `macro` hooks.
            verts && (verts[p] ??= (0, $5bb6ca9eea4b6017$export$d38b14fb9031108e)(state, "vert") + $dca3c1826e5966d7$export$95b2c9ea2de43ebb(vert, null, state));
            // Specify a `'frag'` type `shader` for any per-`shader` `macro` hooks.
            frags && (frags[p] ??= (0, $5bb6ca9eea4b6017$export$d38b14fb9031108e)(state, "frag") + $dca3c1826e5966d7$export$95b2c9ea2de43ebb(frag, null, state));
        }, maps.passes);
        // Set the pass back to what it was.
        state.passNow = passNow;
    }
    /** A `command` to render `pass` updates via a `GL` `pipeline` description. */ to.pass = command(to.pipeline = {
        // Uses the full-screen vertex `shader` state by default.
        vert (c, s) {
            const { passNow: p, step: { vert: v = vert, verts: vs = verts } } = state;
            // Specify a `'vert'` type `shader` for any per-`shader` `macro` hooks.
            return vs?.[p] ?? (0, $5bb6ca9eea4b6017$export$d38b14fb9031108e)(s, "vert") + $dca3c1826e5966d7$export$95b2c9ea2de43ebb(v, c, s);
        },
        frag (c, s) {
            const { passNow: p, step: { frag: f = frag, frags: fs = frags } } = state;
            // Specify a `'frag'` type `shader` for any per-`shader` `macro` hooks.
            return fs?.[p] ?? (0, $5bb6ca9eea4b6017$export$d38b14fb9031108e)(s, "frag") + $dca3c1826e5966d7$export$95b2c9ea2de43ebb(f, c, s);
        },
        /** Need an active `pass` with `framebuffer`, or may draw to the screen. */ framebuffer: (_, s)=>$dca3c1826e5966d7$export$d86e3abd7686c23f(s)?.framebuffer,
        count: count,
        uniforms: uniforms,
        attributes: {
            [n + "position"]: (_, s)=>s.positions,
            ...attributes
        },
        depth: {
            enable: false
        },
        blend: {
            enable: false
        },
        /** Any `pipeline` properties shallow-override others of the same name. */ ...pipeline
    });
    if (merge && (to.merge = merge)) {
        /** Any merged `texture`'s update, set up if not already given. */ merge.update ??= $dca3c1826e5966d7$export$12661000d11a17d2;
        /** Any merged `texture`'s clear, set up if not already given. */ merge.clear ??= $dca3c1826e5966d7$export$ca14b6cb1bf101d2;
    }
    /** Guard for number overflow; set to `0` to ignore or handle in `GLSL`. */ to.stepBy = (state = to, by = 1)=>{
        const { stepNow: stepNow = 0, stepMax: stepMax = (0, $bc78d1a683d7cfc1$export$2902d6d00b7c2bce) } = state;
        state.stepNow = (0, $e2f6bbbfbdb75d47$export$2e2bcd8739ae039)(stepNow + by, stepMax || Infinity);
        return state;
    };
    /** Executes the next step and all its passes. */ to.step = (state = to)=>{
        const stepState = state.onStep?.(state) ?? state;
        const { maps: maps, merge: merge, pass: pass, onPass: onPass, stepBy: stepBy, clearPass: clearPass = stepState.clearPass = (0, $bc78d1a683d7cfc1$export$2fcc13103217f9a3)() } = stepState;
        const clearFramebuffer = clearPass && clearPass.framebuffer;
        const mergeUpdate = merge?.update;
        stepBy(stepState);
        (0, $b1bee206b7624e4c$export$2e2bcd8739ae039)((p, i)=>{
            stepState.passNow = i;
            const passState = onPass?.(stepState, p) ?? stepState;
            /** Only call `clear` if specified, can just use blending otherwise. */ clearPass && (clearPass.framebuffer = $dca3c1826e5966d7$export$d86e3abd7686c23f(passState)?.framebuffer) && clear1(clearPass);
            pass(passState);
            // Update any merged `texture` upon each pass.
            mergeUpdate?.(passState);
        }, maps.passes);
        /** Reset any changed properties. */ clearPass && (clearPass.framebuffer = clearFramebuffer);
        return stepState;
    };
    /** Clears all passes and merged data. */ to.clear = (state = to)=>{
        const s = state.onClear?.(state) ?? state;
        const { maps: maps, merge: merge, clearPass: c = s.clearPass = (0, $bc78d1a683d7cfc1$export$2fcc13103217f9a3)() } = s;
        if (!c) return s;
        const cf = c.framebuffer;
        (0, $b1bee206b7624e4c$export$2e2bcd8739ae039)((p, i)=>{
            s.passNow = i;
            (c.framebuffer = $dca3c1826e5966d7$export$d86e3abd7686c23f(s)?.framebuffer) && clear1(c);
        }, maps.passes);
        /** Reset any changed properties. */ c.framebuffer = cf;
        merge?.clear?.(s);
        return s;
    };
    return to;
}
/**
 * @todo [Fix `@callback`/`@typedef`](https://github.com/TypeStrong/typedoc/issues/1896):
 *   nested `@param`; omits `@return`/`@see`/`@this`
 *
 * @callback onStep
 * Callback upon each step.
 *
 * **See**
 * - {@link toStep}
 * - {@link data.toData}
 * - {@link state.framebuffer}
 *
 * **Returns**
 * - A `stepState` object to use for each of the step's next passes; or
 *   `null`ish to use the given `props`.
 *
 * @param {object} [props] The `props` passed to `run`.
 * @param {framebuffer[]} step The `framebuffer`s for `props.stepNow` from
 *   `props.steps`, where the next state step will be drawn. See `toData`.
 *
 * @returns {object}
 */ /**
 * @todo [Fix `@callback`/`@typedef`](https://github.com/TypeStrong/typedoc/issues/1896):
 *   nested `@param`; omits `@return`/`@see`/`@this`
 *
 * @callback onPass
 * Callback upon each pass.
 *
 * **See**
 * - {@link toStep}
 * - {@link maps.mapGroups}
 *
 * **Returns**
 * - A `passState` object to use for the render `command` call; or `null`ish to
 *   use the given `stepState`.
 *
 * @param {object} [stepState] The `props` passed to `run` via any `onStep`.
 * @param {number[]} pass The maps for the next pass. See `mapGroups`.
 *
 * @returns {object}
 */ /** A wrapper around `updateMerge`, handy for testing. */ function $dca3c1826e5966d7$var$updateMergeTest(state, update = $dca3c1826e5966d7$export$12661000d11a17d2, after = 2) {
    const { color: color, map: pass } = $dca3c1826e5966d7$export$d86e3abd7686c23f(state);
    const { merge: { all: all, next: next }, stepNow: s, passNow: p, size: size, maps: maps } = state;
    const { channels: channels } = all;
    const { steps: sl, shape: [w, h], merge: { shape: [wl, hl] } } = size;
    const tl = maps.textures.length;
    const y = s % sl * h;
    const lc = y * tl * w;
    const to = update(state);
    let f = next?.framebuffer;
    /** Handle `object`s or `regl`-like extended `function`s. */ f.call !== $dca3c1826e5966d7$var$call && (f = f?.call);
    console.warn(s, p, pass, ":");
    console.warn("- l", 0, "r", tl * w, "w", w, "wl", wl);
    console.warn("- t", y, "b", y + h, "h", h, "hl", hl);
    console.warn("- c", channels, "lc", lc * channels, "rc", (lc + w * h) * channels, "sc", w * h * channels, "slc", wl * hl * channels);
    f.call(f, {
        color: to
    }).use.call(f, ()=>console.warn(Array.prototype.reduce.call(regl.read(), (o, v, i)=>o + (i ? ",	" : "") + (!i ? "" : i % (tl * w * h * channels) === 0 ? `\n${"=".repeat(100)}step${"=".repeat(100)}\n` : i % (tl * w * channels) === 0 ? "\n" : i % (w * channels) === 0 ? " || 	" : i % channels === 0 ? " / 	" : "") + (i * 1e-3).toFixed(3).slice(2) + ": " + (v ? v.toFixed(2) : "___"), "\n")));
    if (s && after && s % (sl * after) === 0) debugger;
    return to;
}
var $dca3c1826e5966d7$export$2e2bcd8739ae039 = $dca3c1826e5966d7$export$d89197afac86b993;


const { isFinite: $2b0f5ebd78a3f030$var$isFinite } = Number;
const $2b0f5ebd78a3f030$export$658d3265ca8f5f4e = (version)=>$2b0f5ebd78a3f030$var$isFinite(version) ? version : parseFloat(version?.match?.((0, $bc78d1a683d7cfc1$export$5544d416ac8224f1))?.[0] ?? version, 10);
function $2b0f5ebd78a3f030$export$a8489f67fe30ef76(api, state = {}, to = state) {
    const { maxDrawbuffers: maxDrawbuffers, glsl: apiGLSL } = api.limits ?? api;
    const { maps: maps = {}, glsl: glsl = apiGLSL } = state;
    const { buffersMax: buffersMax } = maps;
    /** The parsed `GLSL` version. */ to.glsl = $2b0f5ebd78a3f030$export$658d3265ca8f5f4e(glsl);
    /** Any `maps.buffersMax` supersedes any `maxDrawbuffers` from the `api`. */ maps.buffersMax ??= maxDrawbuffers;
    state.maps = (0, $bbb23253d9fa3113$export$798cdecdcbbf9755)(maps, to.maps ??= {});
    (0, $db5eb7ff43e44c77$export$24a6b176bdc41ce5)(api, state, to);
    (0, $42d53ffb3630b5df$export$1aad3af825e3305b)(state, to.uniforms ??= {});
    (0, $dca3c1826e5966d7$export$d89197afac86b993)(api, state, to);
    return to;
}
var $2b0f5ebd78a3f030$export$2e2bcd8739ae039 = $2b0f5ebd78a3f030$export$a8489f67fe30ef76;







const { max: $fb274f7b3d6bb589$var$max } = Math;
const $fb274f7b3d6bb589$export$d538e2b459c01d7 = (states = 1, form = 2, count = 1)=>$fb274f7b3d6bb589$var$max(1, states - form + 1) * form * count;
var $fb274f7b3d6bb589$export$2e2bcd8739ae039 = $fb274f7b3d6bb589$export$d538e2b459c01d7;


var $91eaeaf1b2d57fd4$exports = {};
$91eaeaf1b2d57fd4$exports = '/**\n * The update step for a GPGPU particle simulation.\n * Requires setup with preprocessor macros - see `macroPass`.\n * Executed in one or more passes; each chunk depending on a `gpgpu` macro may\n * be combined with others into one pass or separated into its own pass; `gpgpu`\n * preprocessor macros control the combination according to which `values` are\n * currently bound for `output` to the next `state`.\n *\n * @see {@link step.toStep}\n * @see {@link macros.macroPass}\n */\n\n#ifdef GL_EXT_draw_buffers\n  #extension GL_EXT_draw_buffers : require\n#endif\n\nprecision highp float;\n#define GLSLIFY 1\n\n// Setting up the macros and aliases `gl-gpgpu` provides.\n\n/** Set up sampling logic via `gl-gpgpu` macro. */\ngpgpu_useSamples\n\n// Set up minimal texture reads logic; only read what a value with a currently\n// bound output `derives` from other `values` for its next state.\n// See `derives` for how each `reads_${value}_${derive}` is indexed\n// per-`derive`-per-`value`.\n#ifdef gpgpu_output_position\n  gpgpu_useReads_position\n#endif\n#ifdef gpgpu_output_motion\n  gpgpu_useReads_motion\n#endif\n#ifdef gpgpu_output_life\n  gpgpu_useReads_life\n#endif\n\n// The main shader.\n\n/** States from `gl-gpgpu`, merged or separate. */\n#ifdef gpgpu_splits\n  /** States from `gl-gpgpu` in separate `texture`/s. */\n  uniform sampler2D gpgpu_states[gpgpu_splits];\n#else\n  /** States from `gl-gpgpu` in one merged `texture`. */\n  uniform sampler2D gpgpu_states;\n#endif\n\n/** Current step from `gl-gpgpu`; needed for `tapStates` or `tapStatesBy`. */\nuniform float gpgpu_stepNow;\n\n// Common shader inputs and parts.\n\nuniform float dt1;\nuniform float loop;\n\n/** Default UV coordinates from default `gpgpu` vertex shader. */\nvarying vec2 gpgpu_uv;\n\nhighp float random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt= dot(co.xy ,vec2(a,b));\n    highp float sn= mod(dt,3.14);\n    return fract(sin(sn) * c);\n}\n\nfloat when_lt_1604150559(float x, float y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec2 when_lt_1604150559(vec2 x, vec2 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec3 when_lt_1604150559(vec3 x, vec3 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec4 when_lt_1604150559(vec4 x, vec4 y) {\n  return max(sign(y - x), 0.0);\n}\n\nfloat when_gt_2315452051(float x, float y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec2 when_gt_2315452051(vec2 x, vec2 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec3 when_gt_2315452051(vec3 x, vec3 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec4 when_gt_2315452051(vec4 x, vec4 y) {\n  return max(sign(x - y), 0.0);\n}\n\nfloat when_le_1535977339(float x, float y) {\n  return 1.0 - when_gt_2315452051(x, y);\n}\n\nvec2 when_le_1535977339(vec2 x, vec2 y) {\n  return 1.0 - when_gt_2315452051(x, y);\n}\n\nvec3 when_le_1535977339(vec3 x, vec3 y) {\n  return 1.0 - when_gt_2315452051(x, y);\n}\n\nvec4 when_le_1535977339(vec4 x, vec4 y) {\n  return 1.0 - when_gt_2315452051(x, y);\n}\n\n// Any shader inputs or parts can also be split up by usage in different passes.\n\n#ifdef gpgpu_output_position\n  uniform float moveCap;\n  uniform vec2 pace;\n  uniform vec3 source;\n\n  /** @todo Try Velocity Verlet integration. */\n  /**\n * Verlet integration; using positions (past and current) and acceleration; 1-4\n * dimensions; variable timestep.\n *\n * @see Slide 26 of the second part of Acko\'s "Animating Your Way to Glory"\n *     http://acko.net/blog/animate-your-way-to-glory/\n * @see "Verlet integration (without velocities)" on\n *     https://en.wikipedia.org/wiki/Verlet_integration#Verlet_integration_(without_velocities)\n *\n * @param {float|vec2|vec3|vec4} `p0` Position, past.\n * @param {float|vec2|vec3|vec4} `p1` Position, now.\n * @param {float|vec2|vec3|vec4} `a` Acceleration.\n * @param {float} `dt0` Time elapsed, past.\n * @param {float} `dt1` Time elapsed, now.\n *\n * @returns {float|vec2|vec3|vec4} The next position.\n */\n\nfloat verlet(float p0, float p1, float a, float dt0, float dt1) {\n    return (2.0*p1)-p0+(a*dt0*dt1);\n}\n\nvec2 verlet(vec2 p0, vec2 p1, vec2 a, float dt0, float dt1) {\n    return (2.0*p1)-p0+(a*dt0*dt1);\n}\n\nvec3 verlet(vec3 p0, vec3 p1, vec3 a, float dt0, float dt1) {\n    return (2.0*p1)-p0+(a*dt0*dt1);\n}\n\nvec4 verlet(vec4 p0, vec4 p1, vec4 a, float dt0, float dt1) {\n    return (2.0*p1)-p0+(a*dt0*dt1);\n}\n\n/**\n * Verlet integration; using positions (past and current) and acceleration; 1-4\n * dimensions; constant timestep.\n *\n * @see Slide 26 of the second part of Acko\'s "Animating Your Way to Glory"\n *     http://acko.net/blog/animate-your-way-to-glory/\n * @see "Verlet integration (without velocities)" on\n *     https://en.wikipedia.org/wiki/Verlet_integration#Verlet_integration_(without_velocities)\n *\n * @param {float|vec2|vec3|vec4} `p0` Position, past.\n * @param {float|vec2|vec3|vec4} `p1` Position, now.\n * @param {float|vec2|vec3|vec4} `a` Acceleration.\n * @param {float} `dt` Time elapsed.\n *\n * @returns {float|vec2|vec3|vec4} The next position.\n */\n\nfloat verlet(float p0, float p1, float a, float dt) {\n    return verlet(p0, p1, a, dt, dt);\n}\n\nvec2 verlet(vec2 p0, vec2 p1, vec2 a, float dt) {\n    return verlet(p0, p1, a, dt, dt);\n}\n\nvec3 verlet(vec3 p0, vec3 p1, vec3 a, float dt) {\n    return verlet(p0, p1, a, dt, dt);\n}\n\nvec4 verlet(vec4 p0, vec4 p1, vec4 a, float dt) {\n    return verlet(p0, p1, a, dt, dt);\n}\n\n#endif\n\n#ifdef gpgpu_output_motion\n  uniform float epsilon;\n  /** Sink position, and universal gravitational constant. */\n  uniform vec4 sink;\n  /** Constant acceleration of gravity; and whether to use it or the `sink`. */\n  uniform vec4 g;\n#endif\n\n#ifdef gpgpu_output_life\n  /** A particle\'s lifetime range, and whether it\'s allowed to respawn. */\n  uniform vec3 lifetime;\n\n  float map(float value, float inMin, float inMax, float outMin, float outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec2 map(vec2 value, vec2 inMin, vec2 inMax, vec2 outMin, vec2 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec3 map(vec3 value, vec3 inMin, vec3 inMax, vec3 outMin, vec3 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec4 map(vec4 value, vec4 inMin, vec4 inMax, vec4 outMin, vec4 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\n#endif\n\n#if defined(gpgpu_output_position) || defined(gpgpu_output_motion)\n  uniform float dt0;\n  uniform float useVerlet;\n  uniform vec2 spout;\n\n  // Math.PI * 2\nconst float TAU = 6.28318530718;\n\n  /**\n * @param {float} angle An angle, in radians, expects range `[0, 2*pi]`.\n * @param {float} depth A depth, expects range `[-1, 1]`.\n *\n * @see [Spherical distribution](https://observablehq.com/@rreusser/equally-distributing-points-on-a-sphere)\n */\nvec3 onSphere(float angle, float depth) {\n  return vec3(sqrt(1.0-(depth*depth))*vec2(cos(angle), sin(angle)), depth);\n}\n\n#endif\n\nfloat canSpawn(float life) {\n  // Whether to prefill initial states before spawning, or start with all `0`.\n  #ifdef prefill\n    return when_lt_1604150559(life, 0.0);\n  #else\n    return when_le_1535977339(life, 0.0);\n  #endif\n}\n\nvoid main() {\n  /** Sample the desired state values - creates the `gpgpu_data` `array`. */\n  gpgpu_tapState(gpgpu_uv);\n\n  // Read values.\n\n  // If reads all map to the same value sample, any of them will do.\n  #if defined(gpgpu_output_position) || defined(gpgpu_output_motion)\n    #if defined(gpgpu_output_position)\n      #define readMotion gpgpu_reads_position_motion\n      #define readPosition1 gpgpu_reads_position_position_new_0\n    #elif defined(gpgpu_output_motion)\n      #define readMotion gpgpu_reads_motion_motion\n      #define readPosition1 gpgpu_reads_motion_position\n    #endif\n\n    vec3 position1 = gpgpu_data[readPosition1].gpgpu_channels_position;\n    vec3 motion = gpgpu_data[readMotion].gpgpu_channels_motion;\n  #endif\n\n  #ifdef gpgpu_output_position\n    #if gpgpu_stepsPast > 1\n      vec3 position0 = gpgpu_data[gpgpu_reads_position_position_new_1]\n        .gpgpu_channels_position;\n    #else\n      vec3 position0 = position1;\n    #endif\n  #endif\n\n  // If reads all map to the same value sample, any of them will do.\n  #if defined(gpgpu_output_position)\n    #define readLife gpgpu_reads_position_life\n  #elif defined(gpgpu_output_life)\n    #define readLife gpgpu_reads_life_life_new\n  #elif defined(gpgpu_output_motion)\n    #define readLife gpgpu_reads_motion_life\n  #endif\n\n  vec2 life = gpgpu_data[readLife].gpgpu_channels_life;\n\n  #ifdef gpgpu_output_life\n    vec2 lifeLast = gpgpu_data[gpgpu_reads_life_life_old].gpgpu_channels_life;\n  #endif\n\n  // Update and output values.\n  // Note that the update/output logic components within each `#if` macro\n  // block from `gpgpu` are independent modules, as the `gpgpu` macros\n  // determine whether they\'re executed across one or more passes - they could\n  // also be coded in separate files called from here, however they\'re coded\n  // inline here for brevity, relevance, and easy access to shared variables.\n\n  /** Whether the particle is ready to respawn. */\n  float spawn = canSpawn(life.x);\n\n  #if defined(gpgpu_output_position) || defined(gpgpu_output_motion)\n    // Workaround for switching Euler/Verlet; interpret `motion` data as\n    // acceleration/velocity, respectively.\n    vec3 velocity = motion;\n    vec3 acceleration = motion;\n\n    /** Spawn randomly on a sphere around the source, move in that direction. */\n    vec3 spoutSpawn = random((-gpgpu_uv.st*(0.6+loop))/(0.1+dt0))*\n      onSphere(random((gpgpu_uv.st*(0.3+loop))/(0.9+dt0))*TAU,\n        mix(-1.0, 1.0, random((-gpgpu_uv.ts*(0.2+loop))/(0.8+dt1))));\n  #endif\n\n  #ifdef gpgpu_output_position\n    /** For numeric accuracy, encoded as exponent `[b, p] => b*(10**p)`. */\n    float speed = pace.s*pow(10.0, pace.t);\n\n    /**\n     * Constrain Verlet movement; handle here for better numerical accuracy.\n     * Any position changes below the movement cap remain the same; any\n     * bigger clamped towards current position, by the ratio over the limit.\n     */\n    vec3 back = mix(position0, position1,\n      clamp((distance(position1, position0)/moveCap)-1.0, 0.0, 1.0));\n\n    // Use either Euler integration...\n    vec3 positionTo = mix(position1+(velocity*dt1*speed),\n      // ... or Verlet integration...\n      verlet(back, position1, acceleration*speed, dt0, dt1),\n      // ... according to which is currently active.\n      useVerlet);\n\n    /** Spawn around the source. */\n    vec3 positionSpawn = source+(spout.x*spoutSpawn);\n\n    /** Output the next position value to its channels in the state texture. */\n    gpgpu_output_position = mix(positionTo, positionSpawn, spawn);\n  #endif\n  #ifdef gpgpu_output_motion\n    /**\n     * Gravitate towards the sink point (simplified).\n     * @see [Wikipedia on gravitation](https://en.wikipedia.org/wiki/Newton%27s_law_of_universal_gravitation)\n     */\n    vec3 pull = sink.xyz-position1;\n    float pullL2 = dot(pull, pull);\n\n    pull *= sink.w/max(pullL2*sqrt(pullL2), epsilon);\n\n    /** Use sink point, or constant acceleration due to gravity. */\n    acceleration = mix(pull, g.xyz, g.w);\n\n    vec3 motionTo = mix(velocity+(acceleration*dt1), acceleration, useVerlet);\n    vec3 motionNew = spout.y*spoutSpawn;\n\n    /** Output the next motion value to its channels in the state texture. */\n    gpgpu_output_motion = mix(motionTo, motionNew, spawn);\n  #endif\n  #ifdef gpgpu_output_life\n    vec2 lifeTo = vec2(life.x-dt1, life.y);\n\n    vec2 lifeNew = vec2(map(random(gpgpu_uv*(1.0+loop)),\n      0.0, 1.0, lifetime.s, lifetime.t));\n\n    /** Whether the oldest state has faded. */\n    float faded = canSpawn(lifeLast.x);\n\n    /**\n     * Output the next life value to its channels in the state texture.\n     * Only spawn life once the oldest step reaches the end of its lifetime\n     * (past and current life are both 0), and if it\'s allowed to respawn.\n     */\n    gpgpu_output_life = mix(lifeTo, lifeNew, spawn*faded*lifetime.z);\n  #endif\n}\n';


var $0864ed465b4b61e3$exports = {};
$0864ed465b4b61e3$exports = "/**\n * Drawing a GPGPU particle simulation.\n * Requires setup with preprocessor macros. See `macroPass` and `macroValues`.\n *\n * @see {@link macros.macroPass}\n * @see {@link macros.macroValues}\n */\n\nprecision highp float;\n#define GLSLIFY 1\n\n// Set up sampling logic.\ngpgpu_useSamples\n// Only the first value derives from all values, giving minimal `reads`.\n// See `derives` for how each `reads_position_${derive}` is indexed.\ngpgpu_useReads_position\n\nattribute float index;\n\n/** States from `gl-gpgpu`, merged or separate. */\n#ifdef gpgpu_splits\n  /** States from `gl-gpgpu` in separate `texture`/s. */\n  uniform sampler2D gpgpu_states[gpgpu_splits];\n#else\n  /** States from `gl-gpgpu` in one merged `texture`. */\n  uniform sampler2D gpgpu_states;\n#endif\n\n/** Current step from `gl-gpgpu`; needed for `tapStates` or `tapStatesBy`. */\nuniform float gpgpu_stepNow;\n/** Further `gl-gpgpu` uniforms. */\nuniform vec4 gpgpu_stateShape;\nuniform vec2 gpgpu_viewShape;\n\nuniform mat4 modelView;\nuniform mat4 projection;\nuniform vec2 aspect;\nuniform vec2 widths;\nuniform float wide;\nuniform float dt;\nuniform float loop;\nuniform vec2 paceColor;\nuniform float useVerlet;\nuniform float form;\nuniform vec2 hues;\n\nuniform float fizz;\nuniform float fizzMax;\nuniform float fizzRate;\nuniform float fizzCurve;\n\n/** View-space position. */\nvarying vec4 positionView;\n/** Center and radius for points or lines; only points have `gl_PointCoord`. */\nvarying vec3 sphere;\nvarying vec4 color;\nvarying vec3 emissive;\n\nfloat when_gt_1540259130(float x, float y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec2 when_gt_1540259130(vec2 x, vec2 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec3 when_gt_1540259130(vec3 x, vec3 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec4 when_gt_1540259130(vec4 x, vec4 y) {\n  return max(sign(x - y), 0.0);\n}\n\nhighp float random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt= dot(co.xy ,vec2(a,b));\n    highp float sn= mod(dt,3.14);\n    return fract(sin(sn) * c);\n}\n\nfloat map(float value, float inMin, float inMax, float outMin, float outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec2 map(vec2 value, vec2 inMin, vec2 inMax, vec2 outMin, vec2 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec3 map(vec3 value, vec3 inMin, vec3 inMax, vec3 outMin, vec3 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec4 map(vec4 value, vec4 inMin, vec4 inMax, vec4 outMin, vec4 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\n// Math.PI * 2\nconst float TAU = 6.28318530718;\n\nfloat hue2rgb(float f1, float f2, float hue) {\n    if (hue < 0.0)\n        hue += 1.0;\n    else if (hue > 1.0)\n        hue -= 1.0;\n    float res;\n    if ((6.0 * hue) < 1.0)\n        res = f1 + (f2 - f1) * 6.0 * hue;\n    else if ((2.0 * hue) < 1.0)\n        res = f2;\n    else if ((3.0 * hue) < 2.0)\n        res = f1 + (f2 - f1) * ((2.0 / 3.0) - hue) * 6.0;\n    else\n        res = f1;\n    return res;\n}\n\nvec3 hsl2rgb(vec3 hsl) {\n    vec3 rgb;\n    \n    if (hsl.y == 0.0) {\n        rgb = vec3(hsl.z); // Luminance\n    } else {\n        float f2;\n        \n        if (hsl.z < 0.5)\n            f2 = hsl.z * (1.0 + hsl.y);\n        else\n            f2 = hsl.z + hsl.y - hsl.y * hsl.z;\n            \n        float f1 = 2.0 * hsl.z - f2;\n        \n        rgb.r = hue2rgb(f1, f2, hsl.x + (1.0/3.0));\n        rgb.g = hue2rgb(f1, f2, hsl.x);\n        rgb.b = hue2rgb(f1, f2, hsl.x - (1.0/3.0));\n    }   \n    return rgb;\n}\n\nvec3 hsl2rgb(float h, float s, float l) {\n    return hsl2rgb(vec3(h, s, l));\n}\n\n/**\n * @param {float} angle An angle, in radians, expects range `[0, 2*pi]`.\n * @param {float} depth A depth, expects range `[-1, 1]`.\n *\n * @see [Spherical distribution](https://observablehq.com/@rreusser/equally-distributing-points-on-a-sphere)\n */\nvec3 onSphere(float angle, float depth) {\n  return vec3(sqrt(1.0-(depth*depth))*vec2(cos(angle), sin(angle)), depth);\n}\n\n/**\n * Convenience to turn a 1D entry index into a 2D texture `UV` for sampling.\n * Note that this does not wrap the y-axis, so if the `index` exceeds the range\n * `[0, (size.x*size.y)-1]`, the result y-axis will exceed the range `[0, 1]`.\n *\n * @see {@link util/remain-div.glsl!}\n *\n * @param {float|int} `index` 1D index, expect range `[0, (size.x*size.y)-1]`.\n * @param {float|int|vec2|ivec2} `size` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n *\n * @returns {vec2} 2D `UV` texture sample coordinate, expect range `[0, 1]`.\n */\n\n/**\n * Equivalent to a _remainder_ operator; same as `mod` for same-signed operands,\n * but different for differently-signed operands, like JavaScript's `%`\n * operator.\n * Reuses the truncated division, and returns both; as both are useful in\n * various places, e.g: index conversion.\n *\n * @see [GLSL modulo](https://www.shaderific.com/glsl-functions#modulo)\n * @see [JS modulo/remainder](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder)\n *\n * @param {float|int} `x` The first remainder/divide operand, expect `x >= 0`.\n * @param {float|int} `y` The second remainder/divide operand, expect `y >= 0`.\n *\n * @returns {vec2|ivec2} The result as `[(remainder), (truncated division)]`;\n *   always a `vec2` if any operand is a `float`.\n */\n\nivec2 remainDiv(int x, int y) {\n  // Careful handling integer maths; decimals truncated, works like a\n  // _remainder_ operator, rather than `mod`.\n  int d = x/y;\n\n  return ivec2(x-(y*d), d);\n}\n\nvec2 remainDiv(float x, int y) {\n  int d = int(x)/y;\n\n  // Remainder; like `mod` but with truncated `d` not floored, reuses `d`.\n  // return vec2(mod(x, y), d);\n  return vec2(x-float(y*d), d);\n}\n\n/**\n * Assume higher accuracy is desired; if less computation with `int` is desired,\n * use `remainDiv(int(x), int(y))` or `vec2(remainDiv(int(x), int(y)))` instead.\n */\nvec2 remainDiv(float x, float y) { return remainDiv(x, int(y)); }\n\n/**\n * Assume higher accuracy is desired; if less computation with `int` is desired,\n * use `remainDiv(x, int(y))` or `vec2(remainDiv(x, int(y)))` instead.\n */\nvec2 remainDiv(int x, float y) { return remainDiv(float(x), y); }\n\nvec2 indexUV(float index, vec2 size) {\n  return remainDiv(index, size.x)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(int index, ivec2 size) {\n  return vec2(remainDiv(index, size.x))/max(vec2(size-1), 1.0);\n}\n\nvec2 indexUV(float index, ivec2 size) {\n  return remainDiv(index, size.x)/max(vec2(size-1), 1.0);\n}\n\nvec2 indexUV(int index, vec2 size) {\n  return remainDiv(index, size.x)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(float index, float size) {\n  return remainDiv(index, size)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(int index, float size) {\n  return remainDiv(index, size)/max(size-1.0, 1.0);\n}\n\nvec2 indexUV(float index, int size) {\n  return remainDiv(index, size)/max(float(size-1), 1.0);\n}\n\nvec2 indexUV(int index, int size) {\n  return vec2(remainDiv(index, size))/max(float(size-1), 1.0);\n}\n\n/**\n * Convenience to sample entries safely at their texel center.\n * Where `spreadUV` is for lookup ranges, `offsetUV` is for lookup queries.\n *\n * @see [`spreadUV`](./spread-uv.glsl)\n *\n * @param {vec2} `uv` UV texture sample coordinate, expect range `[0, 1]`.\n * @param {float|int|vec2|ivec2} `[size=1.0]` Texture's size, expect\n *   `[width, height]`, or if given a scalar interpret both as `side`.\n * @param {float|vec2} `[pad=0.5]` Texel `pad` to offset, expect range `[0, 1]`.\n *\n * @returns {vec2} The `uv` offset by `pad` to texel center, expect range\n *   `[0+pad, 1-pad]`.\n */\n\nvec2 offsetUV(vec2 uv, float size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, float pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, vec2 size, vec2 pad) {\n  return ((uv*(size-1.0))+pad)/size;\n}\n\nvec2 offsetUV(vec2 uv, int size, float pad) {\n  return offsetUV(uv, float(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, float pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, ivec2 size, vec2 pad) {\n  return offsetUV(uv, vec2(size), pad);\n}\n\nvec2 offsetUV(vec2 uv, float size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, vec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, int size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv, ivec2 size) { return offsetUV(uv, size, 0.5); }\nvec2 offsetUV(vec2 uv) { return offsetUV(uv, 1.0, 0.5); }\n\n#if gpgpu_stepsPast > 1\n  // If multiple steps are given, shift into past steps.\n  // Lookups mostly equivalent; input and result iteration order differ.\n  #define indexFormsStates\n  #ifdef indexFormsStates\n    /**\n * The step and entry indexes corresponding to the number of entries and steps\n * for pairs of elements (e.g: lines linking each index's steps); as detailed in\n * the `indexForms` `JS` `function`.\n * Given the vertex index and number of steps; iterates entries-then-steps.\n *\n * @see {@link index-forms}\n * @see {@link util/remain-div.glsl!}\n *\n * @param {float|int} `index` The index of a vertex; expects simple sequential\n *   index attribute.\n * @param {float|int} `states` How many steps of state each entry has.\n * @param {float|int} [`form`] How many steps of state each form covers.\n *\n * @returns {vec2|ivec2} The step and entry index, respectively, to look up the\n *   correct data to draw the given `form` along each entry's steps of state;\n *   always a `vec2` if any operand is a `float`, an `ivec2` if all are `int`;\n *   iterates with `index` by entries-then-steps.\n */\n\n// Careful handling integer maths - decimals truncated.\nivec2 indexForms_1(int index, int states, int form) {\n  int f = form-1;\n  ivec2 stepEntry = remainDiv(index, (states-f)*form);\n\n  stepEntry.s = (stepEntry.s+f)/form;\n\n  return stepEntry;\n}\n\nvec2 indexForms_1(float index, float states, float form) {\n  vec2 stepEntry = remainDiv(index/form, states-form+1.0);\n\n  stepEntry.s = ceil(stepEntry.s);\n\n  return stepEntry;\n}\n\n// Mixed-type overloads assume higher accuracy is desired; if less computation\n// with `int` is desired, use `indexForms(int(index), int(states), int(form))`\n// or `vec2(indexForms(int(index), int(states), int(form)))` instead.\n\nvec2 indexForms_1(int index, float states, float form) {\n  return indexForms_1(float(index), states, form);\n}\n\nvec2 indexForms_1(float index, int states, float form) {\n  return indexForms_1(index, float(states), form);\n}\n\nvec2 indexForms_1(float index, float states, int form) {\n  return indexForms_1(index, states, float(form));\n}\n\nvec2 indexForms_1(float index, int states, int form) {\n  return indexForms_1(index, float(states), float(form));\n}\n\nvec2 indexForms_1(int index, float states, int form) {\n  return indexForms_1(float(index), states, float(form));\n}\n\nvec2 indexForms_1(int index, int states, float form) {\n  return indexForms_1(float(index), float(states), form);\n}\n\n// Expects pairs by default, though also works for single points and possibly\n// useful for other forms.\n// Mixed-type overloads assume higher accuracy is desired; if less computation\n// with `int` is desired, use `indexForms(int(index), int(states))` or\n// `vec2(indexForms(int(index), int(states)))` instead.\n\nivec2 indexForms_1(int index, int states) {\n  return indexForms_1(index, states, 2);\n}\n\nvec2 indexForms_1(float index, float states) {\n  return indexForms_1(index, states, 2.0);\n}\n\nvec2 indexForms_1(int index, float states) {\n  return indexForms_1(float(index), states, 2.0);\n}\n\nvec2 indexForms_1(float index, int states) {\n  return indexForms_1(index, float(states), 2.0);\n}\n\n  #else\n    /**\n * The step and entry indexes corresponding to the number of entries and steps\n * for pairs of elements (e.g: lines linking each index's steps); as detailed in\n * the `indexForms` `JS` `function`.\n * Given the vertex index and number of entries; iterates steps-then-entries.\n *\n * Works out as 2 `remainDiv`:\n * `[(index%form)+floor(floor(index/form)/count), floor(index/form)%count]`\n * `[indexForm.s+floor(indexForm.t/count), indexForm.t%count]`\n * `[indexForm.s+stepEntry.t, stepEntry.s]`\n *\n * @see {@link index-forms}\n * @see {@link util/remain-div.glsl!}\n *\n * @param {float|int} `index` The index of a vertex; expects simple sequential\n *   index attribute.\n * @param {float|int} `count` How many entries are in each step of state.\n * @param {float|int} [`form`] How many steps of state each form covers.\n *\n * @returns {vec2|ivec2} The step and entry index, respectively, to look up the\n *   correct data to draw the given `form` along each entry's steps of state;\n *   always a `vec2` if any operand is a `float`, an `ivec2` if all are `int`;\n *   iterates with `index` by steps-then-entries.\n */\n\n// Careful handling integer maths - decimals truncated.\nivec2 indexForms_0(int index, int count, int form) {\n  ivec2 indexForm = remainDiv(index, form);\n  ivec2 stepEntry = remainDiv(indexForm.t, count).ts;\n\n  stepEntry.s += indexForm.s;\n\n  return stepEntry;\n}\n\nvec2 indexForms_0(float index, float count, float form) {\n  vec2 indexForm = remainDiv(index, form);\n  vec2 stepEntry = remainDiv(indexForm.t, count).ts;\n\n  stepEntry.s += indexForm.s;\n\n  return stepEntry;\n}\n\n// Mixed-type overloads assume higher accuracy is desired; if less computation\n// with `int` is desired, use `indexForms(int(index), int(count), int(form))` or\n// `vec2(indexForms(int(index), int(count), int(form)))` instead.\n\nvec2 indexForms_0(int index, float count, float form) {\n  return indexForms_0(float(index), count, form);\n}\n\nvec2 indexForms_0(float index, int count, float form) {\n  return indexForms_0(index, float(count), form);\n}\n\nvec2 indexForms_0(float index, float count, int form) {\n  return indexForms_0(index, count, float(form));\n}\n\nvec2 indexForms_0(float index, int count, int form) {\n  return indexForms_0(index, float(count), float(form));\n}\n\nvec2 indexForms_0(int index, float count, int form) {\n  return indexForms_0(float(index), count, float(form));\n}\n\nvec2 indexForms_0(int index, int count, float form) {\n  return indexForms_0(float(index), float(count), form);\n}\n\n// Expects pairs by default, though also works for single points and possibly\n// useful for other forms.\n// Mixed-type overloads assume higher accuracy is desired; if less computation\n// with `int` is desired, use `indexForms(int(index), int(count))` or\n// `vec2(indexForms(int(index), int(count)))` instead.\n\nivec2 indexForms_0(int index, int count) {\n  return indexForms_0(index, count, 2);\n}\n\nvec2 indexForms_0(float index, float count) {\n  return indexForms_0(index, count, 2.0);\n}\n\nvec2 indexForms_0(int index, float count) {\n  return indexForms_0(float(index), count, 2.0);\n}\n\nvec2 indexForms_0(float index, int count) {\n  return indexForms_0(index, float(count), 2.0);\n}\n\n  #endif\n#endif\n\nconst vec4 hide = vec4(0, 0, 0, -1);\n\nfloat triangleWave(float x) { return (abs(fract(x)-0.5)*4.0)-1.0; }\n\nvoid main() {\n  #if gpgpu_stepsPast > 1\n    // If multiple steps are given, find past step and entry.\n    // Lookups mostly equivalent; input and result iteration order differ.\n    #ifdef indexFormsStates\n      vec2 stepEntry = indexForms_1(index, gpgpu_stepsPast, form);\n    #else\n      vec2 stepEntry = indexForms_0(index, gpgpu_entries, form);\n    #endif\n\n    float stepPast = stepEntry.s;\n    float entry = stepEntry.t;\n  #else\n    // If only 1 step is given, past step and entry are known.\n    float stepPast = 0.0;\n    float entry = index;\n  #endif\n\n  // Turn 1D index into 2D texture UV; offset to texel center, avoids errors.\n  vec2 st = offsetUV(indexUV(entry, gpgpu_stateShape.xy), gpgpu_stateShape.xy);\n\n  // Can also use the `reads` logic to take the minimum possible samples here.\n  // Sample the desired state values; creates the `gpgpu_data` `array`.\n  #if gpgpu_stepsPast > 1\n    // Shift into past steps.\n    gpgpu_tapStateBy(st, stepPast, 0)\n  #else\n    // No past steps, no shift.\n    gpgpu_tapState(st)\n  #endif\n\n  // Read the values.\n\n  vec3 position1 = gpgpu_data[gpgpu_reads_position_position_new_0]\n    .gpgpu_channels_position;\n\n  #if gpgpu_stepsPast > 1\n    vec3 position0 = gpgpu_data[gpgpu_reads_position_position_new_1]\n      .gpgpu_channels_position;\n  #else\n    vec3 position0 = position1;\n  #endif\n\n  vec3 motion = gpgpu_data[gpgpu_reads_position_motion].gpgpu_channels_motion;\n  vec2 life = gpgpu_data[gpgpu_reads_position_life].gpgpu_channels_life;\n\n  // Work with the values.\n\n  float alive = when_gt_1540259130(life.x, 0.0);\n  float ago = stepPast/max(float(gpgpu_stepsPast-1), 1.0);\n\n  /** Fizz randomly on a sphere around older positions. */\n  float fl = pow(clamp(stepPast/fizz, 0.0, 1.0), fizzCurve)*fizzMax;\n  float ft = loop*fizzRate*mix(-1.0, 1.0, mod(entry, 2.0))/(1.0+fl);\n  float fa = (random(position1.xy+entry)+ft)*TAU;\n  float fd = triangleWave(random(vec2(position1.z, life.x)-entry)+ft);\n\n  positionView = modelView*vec4(position1+(fl*onSphere(fa, fd)), 1);\n  // positionView = vec4(mix(vec2(-0.5), vec2(0.5), st), 0.2, 1);\n\n  vec4 to = mix(hide, projection*positionView, alive);\n\n  to.xy *= aspect;\n  gl_Position = to;\n\n  float fade = clamp(pow(1.0-ago, 0.9), 0.0, 1.0)*\n    clamp(pow(life.x/life.y, 0.5), 0.0, 1.0);\n\n  float scale = clamp(pow(1.0-(life.x/life.y), 0.4), 0.0, 1.0);\n\n  float size = gl_PointSize = alive*0.5*\n    clamp((wide*fade*scale)/to.w, widths.s, widths.t);\n\n  /**\n   * Convert vertex position to `gl_FragCoord` window-space.\n   * @see [SO](https://stackoverflow.com/a/7158573)\n   * @see [SO](https://stackoverflow.com/a/54237532/716898)\n   */\n  sphere = vec3(gpgpu_viewShape*(((to.xy/to.w)*0.5)+0.5), size*0.5);\n\n  float hue = fract(mix(hues.s, hues.t, entry/float(gpgpu_entries)));\n  vec3 velocity = mix(motion, (position1-position0)/dt, useVerlet);\n\n  color = vec4(hsl2rgb(hue, mix(1.0, 0.1, ago), 0.7), fade);\n\n  emissive = hsl2rgb(hue, 1.0,\n    clamp(pow(dot(velocity, velocity)*paceColor.s, paceColor.t), 0.0, 0.8));\n}\n";


var $83eacfac60e27234$exports = {};
$83eacfac60e27234$exports = "/**\n * Drawing a GPGPU particle simulation.\n * Requires setup with preprocessor macros. See `macroPass` and `macroValues`.\n *\n * @see {@link macros.macroPass}\n * @see {@link macros.macroValues}\n *\n * @todo Simple light shading.\n */\n\n#ifdef GL_EXT_frag_depth\n  #extension GL_EXT_frag_depth : enable\n#endif\n\nprecision highp float;\n#define GLSLIFY 1\n\nuniform float wide;\n/** Scale depths over near and far range, and precision (arbitrarily). */\nuniform vec3 depths;\n/** Fog start offset, scale, exponent, maximum effect. */\nuniform vec4 fog;\n/** The clear and fog color. */\nuniform vec4 clear;\n/** Material roughness, albedo, and skin thickness. */\nuniform vec3 material;\nuniform vec3 lightAmbient;\n\n#ifndef lightPointsL\n  #define lightPointsL 0\n#elif lightPointsL > 0\n  uniform vec3 lightPointPositions[lightPointsL];\n  uniform vec3 lightPointColors[lightPointsL];\n  uniform vec3 lightPointFactors[lightPointsL];\n#endif\n\n/** View-space position. */\nvarying vec4 positionView;\n/** Center and radius for points or lines; only points have `gl_PointCoord`. */\nvarying vec3 sphere;\nvarying vec4 color;\nvarying vec3 emissive;\n\nfloat map(float value, float inMin, float inMax, float outMin, float outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec2 map(vec2 value, vec2 inMin, vec2 inMax, vec2 outMin, vec2 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec3 map(vec3 value, vec3 inMin, vec3 inMax, vec3 outMin, vec3 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nvec4 map(vec4 value, vec4 inMin, vec4 inMax, vec4 outMin, vec4 outMax) {\n  return outMin + (outMax - outMin) * (value - inMin) / (inMax - inMin);\n}\n\nfloat when_lt_1604150559(float x, float y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec2 when_lt_1604150559(vec2 x, vec2 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec3 when_lt_1604150559(vec3 x, vec3 y) {\n  return max(sign(y - x), 0.0);\n}\n\nvec4 when_lt_1604150559(vec4 x, vec4 y) {\n  return max(sign(y - x), 0.0);\n}\n\nfloat when_gt_1117569599(float x, float y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec2 when_gt_1117569599(vec2 x, vec2 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec3 when_gt_1117569599(vec3 x, vec3 y) {\n  return max(sign(x - y), 0.0);\n}\n\nvec4 when_gt_1117569599(vec4 x, vec4 y) {\n  return max(sign(x - y), 0.0);\n}\n\nfloat orenNayarDiffuse(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float albedo) {\n  \n  float LdotV = dot(lightDirection, viewDirection);\n  float NdotL = dot(lightDirection, surfaceNormal);\n  float NdotV = dot(surfaceNormal, viewDirection);\n\n  float s = LdotV - NdotL * NdotV;\n  float t = mix(1.0, max(NdotL, NdotV), step(0.0, s));\n\n  float sigma2 = roughness * roughness;\n  float A = 1.0 + sigma2 * (albedo / (sigma2 + 0.13) + 0.5 / (sigma2 + 0.33));\n  float B = 0.45 * sigma2 / (sigma2 + 0.09);\n\n  return albedo * max(0.0, NdotL) * (A + B * s / t) / 3.14159265;\n}\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat beckmannSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness) {\n  return beckmannDistribution(dot(surfaceNormal, normalize(lightDirection + viewDirection)), roughness);\n}\n\n/**\n * Point-light attenuation.\n *\n * @see [I'm Doing it Wrong - Light Attenuation](https://imdoingitwrong.wordpress.com/2011/01/31/light-attenuation/)\n *\n * @param d A vector of light position distance, [distance, distance squared].\n * @param a A vector of attenuation factors, [constant, linear, quadratic].\n *\n * @returns The attenuation of the point-light.\n */\nfloat attenuate(vec2 d, vec3 a) { return 1.0/dot(a, vec3(1, d)); }\nfloat attenuate(float d2, vec3 a) { return attenuate(vec2(sqrt(d2), d2), a); }\n\n/**\n * Spherical-light attenuation.\n *\n * @see [I'm Doing it Wrong - Light Attenuation](https://imdoingitwrong.wordpress.com/2011/01/31/light-attenuation/)\n *\n * @param d A vector of light position distance, [distance, distance squared].\n * @param r A vector of spherical-light radius, [radius, radius squared].\n *\n * @returns The attenuation of the spherical-light.\n */\nfloat attenuate(vec2 d, vec2 r) { return attenuate(d, vec3(1, vec2(2, 1)/r)); }\nfloat attenuate(vec2 d, float r2) { return attenuate(d, vec2(sqrt(r2), r2)); }\nfloat attenuate(float d2, vec2 r) { return attenuate(vec2(sqrt(d2), d2), r); }\n\nfloat attenuate(float d2, float r2) {\n  return attenuate(vec2(sqrt(d2), d2), r2);\n}\n\nvoid main() {\n  /**\n   * Distance to a sphere's surface, and resulting normal and depth.\n   *\n   * @see [SO](https://stackoverflow.com/a/31829666/716898)\n   * @see [SO](https://stackoverflow.com/questions/53271461/drawing-a-sphere-normal-map-in-the-fragment-shader)\n   * @see [Shadertoy](https://www.shadertoy.com/view/XsfXDr)\n   * @see [Figure 13.2. Circle Point Computation](https://nicolbolas.github.io/oldtut/Illumination/Tutorial%2013.html)\n   */\n  float r = sphere.b;\n  float r2 = r*r;\n  vec2 cf = gl_FragCoord.xy-sphere.xy;\n  float cfl2 = dot(cf, cf);\n  float isWide = when_gt_1117569599(wide, 1.0);\n\n  // Don't round if maximum width isn't enough.\n  if(isWide*cfl2 > r2) { discard; }\n\n  /** Vector pointing from the `sphere`'s center towards the eye. */\n  vec3 axis = vec3(cf, sqrt(r2-cfl2));\n  vec3 normal = axis/r;\n  float sphereDepth = abs(axis.z/wide);\n\n  #ifdef GL_EXT_frag_depth\n    /** The `sphere`'s fragment depth; scaled (arbitrarily) into depth space. */\n    gl_FragDepthEXT = map(gl_FragCoord.z-(depths.b*sphereDepth),\n      depths.s, depths.t, 0.0, 1.0);\n  #endif\n\n  vec3 lit = lightAmbient;\n  vec3 pe = -positionView.xyz;\n  float peL = length(pe);\n\n  pe /= peL;\n\n  #if lightPointsL > 0\n    for(int l = 0; l < lightPointsL; ++l) {\n      vec3 lightPosition = lightPointPositions[l];\n      vec3 lightColor = lightPointColors[l];\n      vec3 lightFactor = lightPointFactors[l];\n      float rough = material.r;\n      float albedo = material.g;\n      vec3 pl = lightPosition-positionView.xyz;\n      vec2 plL = vec2(dot(pl, pl));\n\n      pl /= (plL.s = sqrt(plL.s));\n\n      lit += lightColor*attenuate(plL, lightFactor)*\n        (orenNayarDiffuse(pl, pe, normal, rough, albedo)+\n          beckmannSpecular(pl, pe, normal, rough));\n    }\n  #endif\n\n  // More transparent looking directly at thin material, if wide enough.\n  float thick = 1.0-abs(normal.z*(1.0-material.z)*isWide);\n  float foggy = min(pow(max(peL-sphereDepth-fog.x, 0.0)*fog.y, fog.z), fog.w);\n  vec3 shade = mix((color.rgb*lit)+emissive, clear.rgb, foggy);\n  float fade = color.a*thick;\n\n  gl_FragColor = vec4(shade*fade, fade);\n}\n";



const $bddabbe5f862bd69$export$2c9e8a9632a706b2 = (a, b, t)=>a + (b - a) * t;
const $bddabbe5f862bd69$export$ab522535e0b1ca97 = (a, b, c, d, u, v)=>{
    const iu = 1 - u;
    const iv = 1 - v;
    return a * iu * iv + b * u * iv + c * iu * v + d * u * v;
};
const $bddabbe5f862bd69$export$f15178c7cbd79119 = (a, b, c, t)=>{
    const s = 1 - t;
    return a * s * s + b * 2 * s * t + c * t * t;
};
const $bddabbe5f862bd69$export$34348eb43739343a = (a, b, c, d, t)=>{
    const t2 = t * t;
    const s = 1 - t;
    const s2 = s * s;
    return a * s2 * s + b * 3 * s2 * t + c * 3 * t2 * s + d * t2 * t;
};
const $bddabbe5f862bd69$export$ae2be88f8e183fdf = (a, b, c, d, t)=>{
    const y1 = 0.5 * (c - a);
    const y2 = 1.5 * (b - c) + 0.5 * (d - a);
    return ((y2 * t + a - b + y1 - y2) * t + y1) * t + b;
};
const $bddabbe5f862bd69$export$65f76f93c696beb2 = (a, ta, b, tb, t)=>{
    const s = t - 1;
    const t2 = t * t;
    const s2 = s * s;
    const h00 = (1 + 2 * t) * s2;
    const h10 = t * s2;
    const h01 = t2 * (3 - 2 * t);
    const h11 = t2 * s;
    return h00 * a + h10 * ta + h01 * b + h11 * tb;
};
const $bddabbe5f862bd69$export$87139e61e575d4bf = (a, b, c, d, t)=>{
    d *= 0.5;
    const aa = -0.5 * a + 1.5 * b - 1.5 * c + d;
    const bb = a - 2.5 * b + 2 * c - d;
    const cc = -0.5 * a + 0.5 * c;
    const dd = b;
    const t2 = t * t;
    return t * t2 * aa + t2 * bb + t * cc + dd;
};
const $bddabbe5f862bd69$export$6a869e9bc3150e61 = (s00, s01, s02, s03, s10, s11, s12, s13, s20, s21, s22, s23, s30, s31, s32, s33, u, v)=>$bddabbe5f862bd69$export$87139e61e575d4bf($bddabbe5f862bd69$export$87139e61e575d4bf(s00, s01, s02, s03, u), $bddabbe5f862bd69$export$87139e61e575d4bf(s10, s11, s12, s13, u), $bddabbe5f862bd69$export$87139e61e575d4bf(s20, s21, s22, s23, u), $bddabbe5f862bd69$export$87139e61e575d4bf(s30, s31, s32, s33, u), v);
const $bddabbe5f862bd69$export$7e21906635d79e99 = (prev, next, scale = 0.5, ta = 0, tc = 2)=>scale * ((next - prev) / (tc - ta));
const $bddabbe5f862bd69$export$500bf4d5599786a0 = (prev, curr, next, ta = 0, tb = 1, tc = 2)=>0.5 * ((next - curr) / (tc - tb) + (curr - prev) / (tb - ta));
const $bddabbe5f862bd69$export$dc0b63720788090c = (f, from, to)=>(t)=>$bddabbe5f862bd69$export$2c9e8a9632a706b2(from, to, f(t));
const $bddabbe5f862bd69$export$f99d756c6d81ae3f = (t)=>{
    t = 1 - t;
    return Math.sqrt(1 - t * t);
};
const $bddabbe5f862bd69$export$31e259240b6f6ac6 = (t)=>1 - $bddabbe5f862bd69$export$f99d756c6d81ae3f(1 - t);
const $bddabbe5f862bd69$export$21cde5187c2605a3 = (pos, strength, t)=>{
    const impl = strength > 0 ? $bddabbe5f862bd69$export$31e259240b6f6ac6 : $bddabbe5f862bd69$export$f99d756c6d81ae3f;
    const tp = 1 - pos;
    const tl = t <= pos ? impl(t / pos) * pos : 1 - impl((1 - t) / tp) * tp;
    return $bddabbe5f862bd69$export$2c9e8a9632a706b2(t, tl, Math.abs(strength));
};
const $bddabbe5f862bd69$export$c2a6cd60d490c7cc = (t)=>1 - (Math.cos(t * (0, $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3)) * 0.5 + 0.5);
const $bddabbe5f862bd69$export$3efa2e65a6a1f7e = (n, t)=>Math.floor(t * n) / n;
const $bddabbe5f862bd69$export$e3ce947fb98643bf = (k, amp, t)=>{
    const tk = t * k;
    return 1 - amp * Math.sin(tk) / tk * Math.cos(t * (0, $eedf3d90282d0b7e$export$f504979d7e0a75c7));
};
const $bddabbe5f862bd69$export$b0f87bb1f6530fd8 = (ease2, t)=>Math.pow(t, ease2);
const $bddabbe5f862bd69$export$858a1eaaa2a98897 = (k, t)=>{
    const h = k * t;
    return h * Math.exp(1 - h);
};
const $bddabbe5f862bd69$export$57790f9172054d97 = (k, t)=>t < 0.5 ? 0.5 * Math.pow(2 * t, k) : 1 - 0.5 * Math.pow(2 - 2 * t, k);
const $bddabbe5f862bd69$export$b465b7f8c1ade29b = (k, t)=>Math.pow(4 * t * (1 - t), k);
const $bddabbe5f862bd69$export$946d36094c15c76 = (w, c, t)=>{
    t = Math.abs(t - c);
    return t > w ? 0 : (t /= w, 1 - t * t * (3 - 2 * t));
};
const $bddabbe5f862bd69$export$494db73f2e58d3b = (t)=>t !== 0 ? Math.sin(t) / t : 1;
const $bddabbe5f862bd69$export$b64d7743733295fd = (k, t)=>$bddabbe5f862bd69$export$494db73f2e58d3b((0, $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3) * k * t);
const $bddabbe5f862bd69$export$d4f55d979a79ea25 = (a, t)=>t !== 0 ? -a < t && t < a ? $bddabbe5f862bd69$export$494db73f2e58d3b((0, $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3) * t) * $bddabbe5f862bd69$export$494db73f2e58d3b((0, $eedf3d90282d0b7e$export$6b5c1ceb16d01dc3) * t / a) : 0 : 1;
const $bddabbe5f862bd69$export$3b295495ca3cad7c = (bias, k, t)=>t != bias ? 1 / (1 + Math.exp(-k * (t - bias))) : 0.5;
const $bddabbe5f862bd69$export$5698c0a4d95f77d3 = (k, t)=>$bddabbe5f862bd69$export$3b295495ca3cad7c(0.5, k, t);
const $bddabbe5f862bd69$export$59f0c4bf80c0566a = (k, t)=>$bddabbe5f862bd69$export$3b295495ca3cad7c(0, k, t);
const $bddabbe5f862bd69$export$1496d4365b1ce8ba = (a, b, t)=>t <= b ? b * t / (t + a * (b - t) + (0, $eedf3d90282d0b7e$export$56469a43a57ad8b6)) : (1 - b) * (t - 1) / (1 - t - a * (b - t) + (0, $eedf3d90282d0b7e$export$56469a43a57ad8b6)) + 1;
const $bddabbe5f862bd69$export$ee688f112e9bbaf = (a, b, num)=>(b / a) ** (1 / num);
const $bddabbe5f862bd69$export$b2743cdc8f493e4c = (bias, sigma, t)=>Math.exp(-((t - bias) ** 2) / (2 * sigma * sigma));




const [$74bbc4f2d7c90db3$export$5fde601f2db1a7a6, $74bbc4f2d7c90db3$export$f5f3637a663c816, $74bbc4f2d7c90db3$export$b845ad3a59cfd772, $74bbc4f2d7c90db3$export$5a6ac9c3945935e8] = (0, $8547a8b0e5e715cd$export$503c6222d3c48f54)((0, $e0168624d1423262$export$524378831b80c0aa)("*", "+"), (0, $e0168624d1423262$export$1b218a0354f287), (0, $e0168624d1423262$export$ff73a40106eb353));




const [$8681f58331b84a4e$export$b1681e55aa41cf93, $8681f58331b84a4e$export$ce03ce82183fcacf, $8681f58331b84a4e$export$fce72d6f58f3bf47, $8681f58331b84a4e$export$cbb07426a95117ea] = (0, $8547a8b0e5e715cd$export$503c6222d3c48f54)((0, $e0168624d1423262$export$5e8f180ef0142226), "o,a", (0, $e0168624d1423262$export$8443f1c33458c80b), "o,a", "o", (0, $e0168624d1423262$export$51277e3ac6690f26));




const $9a02bc81e88314b7$var$mi = -Infinity;
const $9a02bc81e88314b7$var$mx = Infinity;
const $9a02bc81e88314b7$export$df24318f7b7a47df = Object.freeze([
    $9a02bc81e88314b7$var$mi,
    $9a02bc81e88314b7$var$mi
]);
const $9a02bc81e88314b7$export$d0ebc6d8df6f38f1 = Object.freeze([
    $9a02bc81e88314b7$var$mx,
    $9a02bc81e88314b7$var$mx
]);
const $9a02bc81e88314b7$export$b07c55cad352613c = Object.freeze([
    1,
    1
]);
const $9a02bc81e88314b7$export$c2fad5ac839d6a20 = Object.freeze([
    0,
    0
]);
const $9a02bc81e88314b7$export$3d76695dcdb4727a = Object.freeze([
    1,
    0
]);
const $9a02bc81e88314b7$export$2f0e6bc49da0388c = Object.freeze([
    0,
    1
]);
const $9a02bc81e88314b7$export$bd79be661f4ebe1f = Object.freeze([
    $9a02bc81e88314b7$var$mi,
    $9a02bc81e88314b7$var$mi,
    $9a02bc81e88314b7$var$mi
]);
const $9a02bc81e88314b7$export$9c6031f1a17fe1c1 = Object.freeze([
    $9a02bc81e88314b7$var$mx,
    $9a02bc81e88314b7$var$mx,
    $9a02bc81e88314b7$var$mx
]);
const $9a02bc81e88314b7$export$c41c0154fcf1768c = Object.freeze([
    1,
    1,
    1
]);
const $9a02bc81e88314b7$export$8b0b3f9a2d1cfdb4 = Object.freeze([
    0,
    0,
    0
]);
const $9a02bc81e88314b7$export$6206fb01145c2fc7 = Object.freeze([
    1,
    0,
    0
]);
const $9a02bc81e88314b7$export$cdf9cc3fd2d632ca = Object.freeze([
    0,
    1,
    0
]);
const $9a02bc81e88314b7$export$daec30a5ef5beb6b = Object.freeze([
    0,
    0,
    1
]);
const $9a02bc81e88314b7$export$cd773ae416c5c457 = Object.freeze([
    $9a02bc81e88314b7$var$mi,
    $9a02bc81e88314b7$var$mi,
    $9a02bc81e88314b7$var$mi,
    $9a02bc81e88314b7$var$mi
]);
const $9a02bc81e88314b7$export$4a1470f29ced2012 = Object.freeze([
    $9a02bc81e88314b7$var$mx,
    $9a02bc81e88314b7$var$mx,
    $9a02bc81e88314b7$var$mx,
    $9a02bc81e88314b7$var$mx
]);
const $9a02bc81e88314b7$export$d910f96f79280336 = Object.freeze([
    1,
    1,
    1,
    1
]);
const $9a02bc81e88314b7$export$75d254fcf3149d8c = Object.freeze([
    0,
    0,
    0,
    0
]);
const $9a02bc81e88314b7$export$a0836bef9f1ade50 = Object.freeze([
    1,
    0,
    0,
    0
]);
const $9a02bc81e88314b7$export$79268303819edbbe = Object.freeze([
    0,
    1,
    0,
    0
]);
const $9a02bc81e88314b7$export$12b700018201cb9d = Object.freeze([
    0,
    0,
    1,
    0
]);
const $9a02bc81e88314b7$export$284056b49bcc0ed1 = Object.freeze([
    0,
    0,
    0,
    1
]);




const $cb49977d99ce4879$var$cos = Math.cos;
const $cb49977d99ce4879$var$sin = Math.sin;
const $cb49977d99ce4879$export$6e6697ef026a96 = (0, $ce0f4130aecaba84$export$c37d18c23b2ea60c)(1);
const $cb49977d99ce4879$export$35e1b8cbdfc11933 = $cb49977d99ce4879$export$6e6697ef026a96.add(2, (out, v, offset = (0, $9a02bc81e88314b7$export$c2fad5ac839d6a20))=>(0, $0af0502c9d4a179a$export$363c2f72629e4a7f)(out || v, (0, $3b8164dc7437bdac$export$5dceb76539a08116)(v[1], v[0]), offset));
const $cb49977d99ce4879$export$c922d23b3f1f2998 = $cb49977d99ce4879$export$6e6697ef026a96.add(3, (out, v, offset = (0, $9a02bc81e88314b7$export$8b0b3f9a2d1cfdb4))=>{
    const r = v[0];
    const theta = v[1];
    const phi = v[2];
    const ct = $cb49977d99ce4879$var$cos(theta);
    return (0, $5d21eae0771d5dbf$export$ba8c70ce75474f8d)(out || v, r * ct * $cb49977d99ce4879$var$cos(phi) + offset[0], r * ct * $cb49977d99ce4879$var$sin(phi) + offset[1], r * $cb49977d99ce4879$var$sin(theta) + offset[2]);
});



const { sin: $66a86d7d019bea8d$var$sin, cos: $66a86d7d019bea8d$var$cos } = Math;
const $66a86d7d019bea8d$export$5610d322dd37c6c0 = (a, to = [])=>(0, $5d21eae0771d5dbf$export$dcfbb7940cfb3a48)(to, $66a86d7d019bea8d$var$cos(a), $66a86d7d019bea8d$var$sin(a));
var $66a86d7d019bea8d$export$2e2bcd8739ae039 = $66a86d7d019bea8d$export$5610d322dd37c6c0;


const { random: $cf29cfd0fe747fc4$var$random, min: $cf29cfd0fe747fc4$var$min, PI: $cf29cfd0fe747fc4$var$pi, TAU: $cf29cfd0fe747fc4$var$tau = $cf29cfd0fe747fc4$var$pi * 2 } = Math;
function $cf29cfd0fe747fc4$export$267b06a7460aa7d3(at, state, idle, dt) {
    const { radius: radius, yaw: yaw, spin: spin, turn: turn, wait: w, curve: curve = 5, to: to = state.to = [], pole: pole = state.pole = [
        0,
        $cf29cfd0fe747fc4$var$random() * $cf29cfd0fe747fc4$var$tau,
        $cf29cfd0fe747fc4$var$random() * $cf29cfd0fe747fc4$var$tau
    ] } = state;
    if (!(pole[0] = w && idle && $cf29cfd0fe747fc4$var$min(idle / w, 1) ** curve * radius)) return at;
    const t = state.turn = turn == null ? $cf29cfd0fe747fc4$var$random() * $cf29cfd0fe747fc4$var$tau : turn + (yaw && dt && (0, $bddabbe5f862bd69$export$2c9e8a9632a706b2)(-$cf29cfd0fe747fc4$var$pi, $cf29cfd0fe747fc4$var$pi, $cf29cfd0fe747fc4$var$random()) * yaw * dt) % $cf29cfd0fe747fc4$var$tau;
    /** Scale `turn` direction by `spin` angular speed to add to `pole` angles. */ spin && dt && (0, $74bbc4f2d7c90db3$export$f5f3637a663c816)(pole, (0, $66a86d7d019bea8d$export$5610d322dd37c6c0)(t, to), spin * $cf29cfd0fe747fc4$var$tau * dt, pole, 1, 0, 1);
    (0, $cb49977d99ce4879$export$c922d23b3f1f2998)(to, pole, at);
    const atl = at.length;
    /** Just copy over any other values following the first position values. */ return (to.length = atl) > 3 ? (0, $8681f58331b84a4e$export$b1681e55aa41cf93)(to, at, atl - 3, 3, 3) : to;
}
var $cf29cfd0fe747fc4$export$2e2bcd8739ae039 = $cf29cfd0fe747fc4$export$267b06a7460aa7d3;


const { GRAVITATIONAL_CONSTANT: $53e56069ca082632$var$ugc, GRAV_ACCEL: $53e56069ca082632$var$g } = (0, $f39fdf036bba3609$exports.CGS);
const { abs: $53e56069ca082632$var$abs, floor: $53e56069ca082632$var$floor, random: $53e56069ca082632$var$random, sin: $53e56069ca082632$var$sin, cos: $53e56069ca082632$var$cos, min: $53e56069ca082632$var$min, max: $53e56069ca082632$var$max, sqrt: $53e56069ca082632$var$sqrt, log2: $53e56069ca082632$var$log2, PI: $53e56069ca082632$var$pi } = Math;
const $53e56069ca082632$var$tau = $53e56069ca082632$var$pi * 2;
self.gpgpu = (0, $2b0f5ebd78a3f030$export$2e2bcd8739ae039);
self.macroPass = (0, $5bb6ca9eea4b6017$export$d38b14fb9031108e);
self.mapStep = (0, $bbb23253d9fa3113$export$798cdecdcbbf9755);
self.toUniforms = (0, $42d53ffb3630b5df$export$1aad3af825e3305b);
self.getDrawIndexes = (0, $590beef2a696b8fd$export$87ed20f81f3c66ff);
self.indexForms = (0, $fb274f7b3d6bb589$export$2e2bcd8739ae039);
const $53e56069ca082632$var$canvas = document.querySelector("canvas");
// Handle query parameters.
const $53e56069ca082632$var$getQuery = (search = location.search)=>new URLSearchParams(search);
function $53e56069ca082632$var$setQuery(entries, q = $53e56069ca082632$var$getQuery()) {
    entries && (0, $b1bee206b7624e4c$export$2e2bcd8739ae039)(([k, v = null])=>v === null ? q.delete(k) : q.set(k, v), entries);
    return q;
}
const $53e56069ca082632$var$query = $53e56069ca082632$var$getQuery();
// Scroll to the top.
const $53e56069ca082632$var$scroll = $53e56069ca082632$var$query.get("scroll") === "false" ? ()=>{} : ()=>$53e56069ca082632$var$canvas.scrollIntoView(true);
const $53e56069ca082632$var$scrollDefer = ()=>setTimeout($53e56069ca082632$var$scroll, 0);
function $53e56069ca082632$var$toggleError(e) {
    $53e56069ca082632$var$canvas.classList[e ? "add" : "remove"]("hide");
    document.querySelector(".error").classList[e ? "remove" : "add"]("hide");
    document.querySelector("aside").classList[e ? "add" : "remove"]("show");
}
$53e56069ca082632$var$toggleError();
$53e56069ca082632$var$scrollDefer();
// Check for any extensions that need to be applied.
const $53e56069ca082632$var$fragDepth = $53e56069ca082632$var$query.get("depth") === "frag";
// Set up GL.
const $53e56069ca082632$var$extend = {
    halfFloat: (0, $bc78d1a683d7cfc1$export$5d97924d29f48e83)(),
    float: (0, $bc78d1a683d7cfc1$export$ac0cd3cc21f80dfc)(),
    drawBuffers: (0, $bc78d1a683d7cfc1$export$fdb75c5ac32869de)(),
    fragDepth: [
        "ext_frag_depth"
    ]
};
const $53e56069ca082632$var$pixelRatio = $53e56069ca082632$var$max(devicePixelRatio, 1.5) || 1.5;
const $53e56069ca082632$var$regl = self.regl = (0, (/*@__PURE__*/$parcel$interopDefault($29ef9b50340ec350$exports)))({
    canvas: $53e56069ca082632$var$canvas,
    pixelRatio: $53e56069ca082632$var$pixelRatio,
    extensions: $53e56069ca082632$var$extend.required = $53e56069ca082632$var$extend.halfFloat,
    optionalExtensions: $53e56069ca082632$var$extend.optional = $53e56069ca082632$var$fragDepth ? [
        ...$53e56069ca082632$var$extend.float,
        ...$53e56069ca082632$var$extend.drawBuffers,
        ...$53e56069ca082632$var$extend.fragDepth
    ] : [
        ...$53e56069ca082632$var$extend.float,
        ...$53e56069ca082632$var$extend.drawBuffers
    ],
    onDone: $53e56069ca082632$var$toggleError
});
console.group("Extensions");
console.log("required", $53e56069ca082632$var$extend.required && (0, $338b36538fe76dc4$export$2e2bcd8739ae039)((o, e)=>o + (o && "; ") + e + ": " + $53e56069ca082632$var$regl.hasExtension(e), $53e56069ca082632$var$extend.required, ""));
console.log("optional", $53e56069ca082632$var$extend.optional && (0, $338b36538fe76dc4$export$2e2bcd8739ae039)((o, e)=>o + (o && "; ") + e + ": " + $53e56069ca082632$var$regl.hasExtension(e), $53e56069ca082632$var$extend.optional, ""));
console.groupEnd();
/**
 * How many state values (channels) are tracked independently of others.
 * The order here is the order used in the shaders and generated macros, but for
 * optimal lookups may be `packed` into channels/textures/passes differently.
 */ const $53e56069ca082632$var$valuesMap = new Map()// Position, uses 3 channels.
.set("position", 3)// Motion, uses 3 channels.
.set("motion", 3)// Life, uses 2 channels.
.set("life", 2);
const $53e56069ca082632$var$values = [];
const $53e56069ca082632$var$valuesIndex = {};
const $53e56069ca082632$var$alias = [];
$53e56069ca082632$var$valuesMap.forEach((v, k)=>$53e56069ca082632$var$alias[$53e56069ca082632$var$valuesIndex[k] = $53e56069ca082632$var$values.push(v) - 1] = k);
console.log($53e56069ca082632$var$values, "`values`");
/** Limits of this device and these `values`. */ const { maxTextureUnits: $53e56069ca082632$var$maxTextureUnits, maxTextureSize: $53e56069ca082632$var$maxTextureSize, lineWidthDims: $53e56069ca082632$var$lineWidthDims, pointSizeDims: $53e56069ca082632$var$pointSizeDims, depthBits: $53e56069ca082632$var$depthBits } = $53e56069ca082632$var$regl.limits;
/**
 * Whether to merge states into one texture; separate textures if not given.
 * Merge by default for maximum platform compatibility.
 */ const $53e56069ca082632$var$merge = $53e56069ca082632$var$query.get("merge") !== "false";
/**
 * Better stay farther under maximum texture size, for errors/crashes.
 *
 * @todo Drawing issues with `scale` and `steps` both over 10.
 */ const $53e56069ca082632$var$limits = {
    scale: [
        0,
        $53e56069ca082632$var$log2($53e56069ca082632$var$maxTextureSize)
    ]
};
/** A scale that seems to work well from experimentation with `GL` limits. */ const $53e56069ca082632$var$niceScale = (0, $745f5a1412ccd482$export$7d15b64cf5a3a4c4)(8, ...$53e56069ca082632$var$limits.scale);
/** The data entries scale, from user input or default best-guess. */ const $53e56069ca082632$var$scale = (0, $745f5a1412ccd482$export$7d15b64cf5a3a4c4)(parseFloat($53e56069ca082632$var$query.get("scale") || $53e56069ca082632$var$niceScale, 10) || 0, ...$53e56069ca082632$var$limits.scale);
/** How many steps are used for output. */ const $53e56069ca082632$var$bound = 1;
/** The steps of state to track. */ $53e56069ca082632$var$limits.steps = [
    1 + $53e56069ca082632$var$bound,
    // Maximum steps must fit the maximum total texture size if merging.
    $53e56069ca082632$var$floor($53e56069ca082632$var$merge ? $53e56069ca082632$var$maxTextureSize / 2 ** $53e56069ca082632$var$scale : ($53e56069ca082632$var$maxTextureUnits - $53e56069ca082632$var$bound) / (0, $338b36538fe76dc4$export$2e2bcd8739ae039)((s, v)=>s + v, $53e56069ca082632$var$values) * 4)
];
console.log("limits", $53e56069ca082632$var$limits, $53e56069ca082632$var$regl.limits);
/**
 * 2 active states, as many others as can be bound; at least 2 past states
 * needed for Verlet integration, 1 for Euler integration.
 */ const $53e56069ca082632$var$steps = $53e56069ca082632$var$floor((0, $745f5a1412ccd482$export$7d15b64cf5a3a4c4)(parseFloat($53e56069ca082632$var$query.get("steps"), 10) || 2 + $53e56069ca082632$var$bound, ...$53e56069ca082632$var$limits.steps));
/** How many past steps (not bound to outputs) are in the GPGPU state. */ const $53e56069ca082632$var$stepsPast = $53e56069ca082632$var$steps - $53e56069ca082632$var$bound;
/** Whether to allow Verlet integration; within available resource limits. */ const $53e56069ca082632$var$canVerlet = $53e56069ca082632$var$stepsPast > 1;
/** Whether to prefill initial states before spawning, or start with all `0`. */ const $53e56069ca082632$var$prefill = $53e56069ca082632$var$query.get("prefill") !== "false";
/**
 * Form vertexes to draw; if not given, uses trails of 'lines' if there are
 * enough steps, or 'points' if not.
 */ const $53e56069ca082632$var$form = $53e56069ca082632$var$floor(parseFloat($53e56069ca082632$var$query.get("form"), 10) || 0);
/** How wide the `form` is; to be scaled by `viewScale`. */ const $53e56069ca082632$var$wide = parseFloat($53e56069ca082632$var$query.get("wide") || 1e-3 * $53e56069ca082632$var$pixelRatio, 10) || 0;
/** The amount to spin the scene initially. */ const $53e56069ca082632$var$spin0 = parseFloat($53e56069ca082632$var$query.get("spin-0") || 1e-2 * $53e56069ca082632$var$pi, 10) || 0;
/** The pace to spin the scene each frame. */ const $53e56069ca082632$var$spinPace = parseFloat($53e56069ca082632$var$query.get("spin-pace") || 5e-5, 10) || 0;
/** How much to scale the spout speeds. */ const $53e56069ca082632$var$spoutPace = parseFloat($53e56069ca082632$var$query.get("spout-pace") || 1, 10) || 0;
/** Offset on the z-axis from the origin to the source. */ const $53e56069ca082632$var$gapZ = parseFloat($53e56069ca082632$var$query.get("gap-z") || 0.15, 10) || 0;
/** How much to shake the source around while idling. */ const $53e56069ca082632$var$shakeSource = parseFloat($53e56069ca082632$var$query.get("shake-source") || 2e-2, 10) || 0;
/** How much to shake the sink around while idling. */ const $53e56069ca082632$var$shakeSink = parseFloat($53e56069ca082632$var$query.get("shake-sink") || 2e-2, 10) || 0;
/** How many older state positions to fizz around, and other inputs. */ const $53e56069ca082632$var$fizz = {
    at: parseFloat($53e56069ca082632$var$query.get("fizz") || (0, $745f5a1412ccd482$export$7d15b64cf5a3a4c4)($53e56069ca082632$var$steps, 5, 2e2), 10) || 0,
    max: parseFloat($53e56069ca082632$var$query.get("fizz-max") || (0, $937d5a0bb1da012a$export$a896d6add2646fd2)($53e56069ca082632$var$steps, 5, 20, 2e-3, 4e-3), 10) || 0,
    rate: parseFloat($53e56069ca082632$var$query.get("fizz-rate") || 5e-4, 10) || 0,
    curve: parseFloat($53e56069ca082632$var$query.get("fizz-curve") || 1.7, 10) || 0
};
/** Hue range between 2 values. */ const $53e56069ca082632$var$hues = $53e56069ca082632$var$query.getAll("hue");
// Parse any present hues, fill any missing hues, using only up to 2 hues.
(0, $ea53246f0372c42f$export$2e2bcd8739ae039)((h, i)=>parseFloat(h || (i ? $53e56069ca082632$var$hues[i - 1] + 60 / 360 : 0), 10) || 0, (0, $2ba8e5839a6e0a10$export$2e2bcd8739ae039)($53e56069ca082632$var$hues, null, $53e56069ca082632$var$hues.length, $53e56069ca082632$var$hues.length = 2), 0);
/** Use lights, dark, or unlit. */ const $53e56069ca082632$var$lit = $53e56069ca082632$var$query.get("lit");
/** How much particle speed lights them up. */ const $53e56069ca082632$var$paceLit = parseFloat($53e56069ca082632$var$query.get("pace-lit") || 1, 10) || 0;
/** The material's roughness. */ const $53e56069ca082632$var$rough = parseFloat($53e56069ca082632$var$query.get("rough") || 0.7, 10) || 0;
/** The material's albedo. */ const $53e56069ca082632$var$albedo = parseFloat($53e56069ca082632$var$query.get("albedo") || 0.9, 10) || 0;
/** The material's skin thickness. */ const $53e56069ca082632$var$skin = parseFloat($53e56069ca082632$var$query.get("skin") || 1, 10) || 0;
/**
 * Variable-step (delta-time) if given `false`y/`NaN`; fixed-step (add-step)
 * if given another number; uses default fixed-step if not given.
 */ const $53e56069ca082632$var$timeQuery = $53e56069ca082632$var$query.get("timestep");
const $53e56069ca082632$var$timestepDef = 1e3 / 60;
/** Whether to use a fixed timestep or render variably as soon as possible. */ const $53e56069ca082632$var$timestep = parseFloat($53e56069ca082632$var$timeQuery ?? $53e56069ca082632$var$timestepDef, 10) || null;
/** Whether to primarily control the source or sink */ const $53e56069ca082632$var$flipPointer = $53e56069ca082632$var$query.get("flip-pointer") === "true";
/** Whether the guide is open by default. */ const $53e56069ca082632$var$guide = $53e56069ca082632$var$query.get("guide") !== "false";
console.log(location.search + ":\n", ...[
    ...$53e56069ca082632$var$query.entries()
].flat(), "\n", "merge:", $53e56069ca082632$var$merge, "scale:", $53e56069ca082632$var$scale, "steps:", $53e56069ca082632$var$steps, "prefill:", $53e56069ca082632$var$prefill, "timestep:", $53e56069ca082632$var$timestep, "depth:", $53e56069ca082632$var$fragDepth, "form:", $53e56069ca082632$var$form, "wide:", $53e56069ca082632$var$wide, "spin0:", $53e56069ca082632$var$spin0, "spinPace:", $53e56069ca082632$var$spinPace, "spoutPace:", $53e56069ca082632$var$spoutPace, "gapZ:", $53e56069ca082632$var$gapZ, "shakeSource:", $53e56069ca082632$var$shakeSource, "shakeSink:", $53e56069ca082632$var$shakeSink, "flipPointer:", $53e56069ca082632$var$flipPointer, "fizz:", $53e56069ca082632$var$fizz, "hues:", $53e56069ca082632$var$hues, "lit:", $53e56069ca082632$var$lit, "paceLit:", $53e56069ca082632$var$paceLit, "rough:", $53e56069ca082632$var$rough, "albedo:", $53e56069ca082632$var$albedo, "skin:", $53e56069ca082632$var$skin, "guide:", $53e56069ca082632$var$guide);
// Set up the links.
function $53e56069ca082632$var$setupLink(a, to) {
    const { search: search, hash: hash } = a;
    const has = search.length > 1 && $53e56069ca082632$var$getQuery(search).entries();
    return a.href = "?" + $53e56069ca082632$var$setQuery(has && to ? [
        ...has,
        ...to
    ] : has ? [
        ...has
    ] : to) + hash;
}
$53e56069ca082632$var$setupLink(document.querySelector("#verlet"), [
    [
        "steps",
        2 + $53e56069ca082632$var$bound
    ],
    [
        "scale",
        9
    ]
]);
$53e56069ca082632$var$setupLink(document.querySelector("#euler"), [
    [
        "steps",
        1 + $53e56069ca082632$var$bound
    ],
    [
        "scale",
        9
    ]
]);
$53e56069ca082632$var$setupLink(document.querySelector("#trail"), [
    [
        "steps",
        9 + $53e56069ca082632$var$bound
    ],
    [
        "scale",
        8
    ]
]);
$53e56069ca082632$var$setupLink(document.querySelector("#trace"), [
    [
        "steps",
        3e2
    ],
    [
        "scale",
        4
    ]
]);
$53e56069ca082632$var$setupLink(document.querySelector("#bubbles"));
$53e56069ca082632$var$setupLink(document.querySelector("#molecular"));
$53e56069ca082632$var$setupLink(document.querySelector("#millions"));
$53e56069ca082632$var$setupLink(document.querySelector("#form"), [
    [
        "form",
        $53e56069ca082632$var$form ? ($53e56069ca082632$var$form + 1) % 3 || null : 1
    ]
]);
$53e56069ca082632$var$setupLink(document.querySelector("#lit"), [
    [
        "lit",
        $53e56069ca082632$var$lit === "dark" ? false : $53e56069ca082632$var$lit === "false" ? null : "dark"
    ]
]);
$53e56069ca082632$var$setupLink(document.querySelector("#spin"), [
    [
        "spin-pace",
        $53e56069ca082632$var$spinPace ? 0 : null
    ]
]);
$53e56069ca082632$var$setupLink(document.querySelector("#gap"), [
    [
        "gap-z",
        $53e56069ca082632$var$gapZ ? 0 : null
    ]
]);
$53e56069ca082632$var$setupLink(document.querySelector("#timestep"), [
    [
        "timestep",
        $53e56069ca082632$var$timeQuery == null ? "" : null
    ]
]);
$53e56069ca082632$var$setupLink(document.querySelector("#merge"), [
    [
        "merge",
        $53e56069ca082632$var$merge ? false : null
    ]
]);
$53e56069ca082632$var$setupLink(document.querySelector("#guide"), [
    [
        "guide",
        $53e56069ca082632$var$guide ? false : null
    ]
]);
/** Scroll back if links are clicked or change hash; just want highlights. */ function $53e56069ca082632$var$hashScroll() {
    const h = location.hash;
    if (!document.querySelector(`.link-preset${h}, .link-tweak${h}`)) return;
    $53e56069ca082632$var$scroll();
    $53e56069ca082632$var$scrollDefer();
}
(0, $b1bee206b7624e4c$export$2e2bcd8739ae039)((l)=>l.addEventListener("click", $53e56069ca082632$var$hashScroll), document.querySelectorAll(".link-preset, .link-tweak"));
addEventListener("hashchange", $53e56069ca082632$var$hashScroll);
// Toggle the guide according to query.
document.querySelector("#flip-guide").checked = $53e56069ca082632$var$guide;
// Set up state flow - read and write the `gl-gpgpu` state each step.
/** Map how any next output `values` derive from any past input `values`. */ const $53e56069ca082632$var$derives = [];
// Next `position` state `values` derive from past state `values`:
$53e56069ca082632$var$derives[$53e56069ca082632$var$valuesIndex.position] = [
    // `position`, 2nd `step` past.
    {
        value: $53e56069ca082632$var$valuesIndex.position,
        step: (0, $e2f6bbbfbdb75d47$export$2e2bcd8739ae039)(1, $53e56069ca082632$var$stepsPast)
    },
    // `position`, 1st `step` past.
    $53e56069ca082632$var$valuesIndex.position,
    // `motion`, 1st `step` past.
    $53e56069ca082632$var$valuesIndex.motion,
    // `life`, 1st `step` past.
    $53e56069ca082632$var$valuesIndex.life
];
// Next `motion` state `values` derive from past state `values`:
$53e56069ca082632$var$derives[$53e56069ca082632$var$valuesIndex.motion] = [
    // `motion`, 1st `step` past.
    $53e56069ca082632$var$valuesIndex.motion,
    // `life`, 1st `step` past.
    $53e56069ca082632$var$valuesIndex.life,
    // `position`, 1st `step` past.
    $53e56069ca082632$var$valuesIndex.position
];
// Next `life` state `values` derive from past state `values`:
$53e56069ca082632$var$derives[$53e56069ca082632$var$valuesIndex.life] = [
    // `life`, farthest `step` past.
    {
        value: $53e56069ca082632$var$valuesIndex.life,
        step: (0, $e2f6bbbfbdb75d47$export$2e2bcd8739ae039)(-1, $53e56069ca082632$var$stepsPast)
    },
    // `life`, 1st `step` past.
    $53e56069ca082632$var$valuesIndex.life
];
console.log($53e56069ca082632$var$derives, "`derives`");
/** Shake around a position, via the `state.props`. */ const $53e56069ca082632$var$toShake = (k)=>(_, { props: { [k]: s, timer: { idle: idle, dt: dt } } })=>{
        const { to: to, at: at, shake: state } = s;
        return (0, $cf29cfd0fe747fc4$export$267b06a7460aa7d3)(to ?? at, state, idle, dt);
    };
/** The main `gl-gpgpu` state. */ const $53e56069ca082632$var$state = (0, $2b0f5ebd78a3f030$export$2e2bcd8739ae039)($53e56069ca082632$var$regl, {
    // Logic given as state `values`, `gl-gpgpu` maps optimal inputs and outputs.
    maps: {
        values: // How many state `values` (channels) are tracked independently of others.
        $53e56069ca082632$var$values,
        derives: // Map how next output `values` derive from any past input `values`.
        $53e56069ca082632$var$derives,
        alias: // Give the values names for more convenient macros and order-independence.
        $53e56069ca082632$var$alias
    },
    steps: // How many steps of state to track.
    $53e56069ca082632$var$steps,
    bound: // How many states are bound to frame-buffer outputs at any step.
    $53e56069ca082632$var$bound,
    scale: // How many `entries` to track, here encoded as the power-of-2 size, per side
    // of each data-`texture`: `(2**scale)**2`; can also be given in other ways.
    $53e56069ca082632$var$scale,
    merge: // Whether to merge all states into one data-`texture`, or leave all
    // data-`texture`s separate.
    $53e56069ca082632$var$merge,
    // Data type according to platform capabilities.
    // @todo Seems to move differently with `'half float'` Verlet integration.
    type: $53e56069ca082632$var$extend.float.every($53e56069ca082632$var$regl.hasExtension) ? "float" : "half float",
    // Configure macro hooks, globally or per-shader.
    macros: {
        // No `macros` needed for the `vert` shader; all other `macros` generated.
        vert: false
    },
    // A fragment shader to compute each state step, with `gl-gpgpu` macros.
    // Vertex shaders can also be given.
    frag: ($53e56069ca082632$var$prefill ? "#define prefill\n\n" : "") + (0, (/*@__PURE__*/$parcel$interopDefault($91eaeaf1b2d57fd4$exports))),
    // Cache in `frags` all `macros` prepended to `frag` shader per-pass.
    frags: [],
    // Custom `uniforms` to be passed to shaders, with those `gl-gpgpu` mixes in.
    uniforms: {
        dt: (_, { props: { timer: { dt: dt, rate: r } } })=>dt * r,
        dt0: (_, { props: { timer: { dts: dts, rate: r } } })=>dts[0] * r,
        dt1: (_, { props: { timer: { dts: dts, rate: r } } })=>dts[1] * r,
        time: (_, { props: { timer: { time: t, rate: r } } })=>t * r,
        loop: (_, { props: { timer: { time: t, rate: r, loop: l } } })=>$53e56069ca082632$var$abs((t * r + l) % (l * 2) - l),
        // Shake the source around while idling.
        source: $53e56069ca082632$var$toShake("source"),
        // Shake the sink around while idling.
        sink: $53e56069ca082632$var$toShake("sink"),
        lifetime: $53e56069ca082632$var$regl.prop("props.lifetime"),
        useVerlet: $53e56069ca082632$var$regl.prop("props.useVerlet"),
        epsilon: $53e56069ca082632$var$regl.prop("props.epsilon"),
        moveCap: $53e56069ca082632$var$regl.prop("props.moveCap"),
        g: $53e56069ca082632$var$regl.prop("props.g"),
        pace: $53e56069ca082632$var$regl.prop("props.pace"),
        // One option in these arrays is used, by Euler/Verlet respectively.
        spout: (_, { props: { spout: ss, useVerlet: u } })=>ss[+u]
    },
    // Custom properties, namespaced to avoid clashing with `gl-gpgpu` ones.
    props: {
        // Time control and state.
        timer: (0, $aa3af7eb13cf442c$export$2e2bcd8739ae039)({
            // Fixed-step (add-step), or real-time (variable delta-time).
            step: $53e56069ca082632$var$timestep || "-",
            now: $53e56069ca082632$var$timestep ? undefined : ()=>$53e56069ca082632$var$regl.now() * 1e3,
            // Track past 2 time-differences for Verlet integration.
            dts: (0, $2ba8e5839a6e0a10$export$2e2bcd8739ae039)(2, 0),
            // Amount of time without applicable user-interaction.
            idle: 0,
            // Speed up or slow down the passage of time.
            rate: 1,
            // Loop time over this period to avoid instability using unbounded `time`.
            loop: 1e6
        }),
        // A particle's lifetime range, and whether it's allowed to spawn.
        lifetime: [
            6e2,
            6e3,
            1
        ],
        // Whether to use Verlet (midpoint) or Euler (forward) integration.
        useVerlet: +$53e56069ca082632$var$canVerlet,
        // A small number greater than 0; avoids speeds exploding.
        epsilon: 1e-5,
        // How far a particle can move in any frame.
        moveCap: 7e-3,
        flipPointer: // Whether to primarily control the source or sink.
        $53e56069ca082632$var$flipPointer,
        // The position around which particles spawn.
        source: {
            // The initial source, may be transformed into a new property `to`.
            at: [
                0,
                0,
                $53e56069ca082632$var$gapZ
            ],
            // If shaken around while idling, transform `to` or `at` into `shaken`.
            shake: {
                radius: $53e56069ca082632$var$shakeSource,
                yaw: 1e-2,
                spin: 3e-4,
                wait: 7e3
            }
        },
        // Sink position, and universal gravitational constant.
        sink: {
            // The initial sink, may be transformed into a new property `to`.
            at: [
                // Sink position.
                0,
                0,
                0,
                // Universal gravitational constant (scaled).
                $53e56069ca082632$var$ugc * 2e6
            ],
            // If shaken around while idling, transform `to` or `at` into `shaken`.
            shake: {
                radius: $53e56069ca082632$var$shakeSink,
                yaw: 1e-3,
                spin: 1e-3,
                wait: 5e3
            }
        },
        // Constant acceleration of gravity; and whether to use it or the `sink`.
        g: [
            // Constant acceleration of gravity.
            0,
            -$53e56069ca082632$var$g * 1e-2,
            0,
            // Whether to use it or the `sink`.
            0
        ],
        // Speed scale. Exponent encoding `[b, p] => b*(10**p)` for numeric accuracy.
        pace: [
            1,
            -8
        ],
        // One option in these arrays is used, by Euler/Verlet respectively.
        // The distance from the `source`, and speed, that particles spawn with.
        spout: [
            [
                0,
                3e3 * $53e56069ca082632$var$spoutPace
            ],
            [
                0,
                2e2 * $53e56069ca082632$var$spoutPace
            ]
        ]
    }
});
console.log(self.state = $53e56069ca082632$var$state);
console.group("How `values` are `packed` to fit texture channels efficiently");
console.log("`values` (numbers of channels used together):", ...$53e56069ca082632$var$state.maps.values);
console.log("`packed` (if any, indexes `values`):", ...$53e56069ca082632$var$state.maps.packed);
console.log("`textures` (indexes `values`, via any `packed` or directly):", ...$53e56069ca082632$var$state.maps.textures);
console.log("`valueToTexture` (indexes `textures` via `value` index):", ...$53e56069ca082632$var$state.maps.valueToTexture);
console.groupEnd();
console.log("`entries` (total number of states of `values` updated per-step):", $53e56069ca082632$var$state.size.entries);
// Set up rendering - reading but not writing the `gl-gpgpu` state each frame.
// For this demo, done separately, but sharing the same resources.
/**
 * Draw all states with none bound as outputs.
 * @todo Errors without `merge`; why, if the framebuffer isn't bound?
 */ const $53e56069ca082632$var$drawBound = +!$53e56069ca082632$var$merge;
const $53e56069ca082632$var$drawSteps = $53e56069ca082632$var$steps - $53e56069ca082632$var$drawBound;
const $53e56069ca082632$var$useLines = $53e56069ca082632$var$merge && $53e56069ca082632$var$drawSteps > 1;
console.log("drawSteps", $53e56069ca082632$var$drawSteps, "useLines", $53e56069ca082632$var$useLines);
/**
 * Vertex counts by `form`; how many steps a `form` covers, for all entries;
 * respectively for: none, points, lines.
 * Note `state.size.entries` equals the value returned by `countDrawIndexes`.
 */ const $53e56069ca082632$var$drawCounts = (0, $ea53246f0372c42f$export$2e2bcd8739ae039)((_, f)=>(0, $fb274f7b3d6bb589$export$2e2bcd8739ae039)($53e56069ca082632$var$drawSteps, f, $53e56069ca082632$var$state.size.entries), (0, $2ba8e5839a6e0a10$export$2e2bcd8739ae039)(2 + $53e56069ca082632$var$useLines), 0);
/** Use `min` for contain, `max` for cover. */ const $53e56069ca082632$var$viewScale = $53e56069ca082632$var$min;
/**
 * @see [glsl-aspect](https://github.com/keeffEoghan/glsl-aspect/blob/master/index.glsl)
 * @see [glsl-aspect/contain](https://github.com/keeffEoghan/glsl-aspect/blob/master/contain.glsl)
 */ const $53e56069ca082632$var$aspect = (size, ar)=>(0, $14b7c6a934cee185$export$eb08a4e6e8934de4)(ar, (0, $b047c4fd650d33dd$export$c8a0e366d15bb712)(ar, size, $53e56069ca082632$var$viewScale(...size)));
/** Reuse the `gl-gpgpu` state, mix in drawing-specific state. */ const $53e56069ca082632$var$drawState = {
    ...$53e56069ca082632$var$state,
    // Omit some properties unused in drawing for some clarity.
    count: undefined,
    vert: undefined,
    frag: undefined,
    attributes: undefined,
    // Override other properties for drawing.
    bound: $53e56069ca082632$var$drawBound,
    // Drawing, not updating data, so no `output` macros; no `frag` needed either.
    macros: {
        output: 0,
        frag: 0
    },
    // Custom properties, namespaced to avoid clashing with `gl-gpgpu` ones etc.
    drawProps: {
        // Transformation matrices.
        model: {
            matrix: (0, $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5)([]),
            inverse: (0, $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5)([]),
            // Continuous rotation.
            rotation: (0, $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5)([]),
            axis: [
                0,
                1,
                0
            ],
            angle: ($53e56069ca082632$var$timestep || $53e56069ca082632$var$timestepDef) * $53e56069ca082632$var$spinPace * $53e56069ca082632$var$tau,
            angle0: $53e56069ca082632$var$spin0 * $53e56069ca082632$var$tau
        },
        view: {
            matrix: (0, $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5)([]),
            inverse: (0, $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5)([]),
            // Look from the `eye` at the `target` while oriented `up`.
            eye: [
                0,
                0,
                0.5
            ],
            target: [
                0,
                0,
                0
            ],
            up: [
                0,
                1,
                0
            ],
            // Ray origin and direction for casting.
            ray: [
                [],
                []
            ]
        },
        projection: {
            matrix: (0, $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5)([]),
            inverse: (0, $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5)([])
        },
        // Cached combined transformations.
        transform: {
            modelView: {
                matrix: (0, $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5)([]),
                inverse: (0, $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5)([])
            },
            // viewProjection: { matrix: identity44([]), inverse: identity44([]) },
            modelViewProjection: {
                matrix: (0, $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5)([]),
                inverse: (0, $2fbfcdfe1b5736bc$export$2191d5173c5a0ec5)([])
            }
        },
        // View dimensions.
        size: [
            1,
            1
        ],
        // View aspect ratio scale, per x- and y-axes.
        aspect: [
            1,
            1
        ],
        light: {
            ambient: (0, $2ba8e5839a6e0a10$export$2e2bcd8739ae039)(3, $53e56069ca082632$var$lit === "dark" ? 0.1 : $53e56069ca082632$var$lit === "false" ? 1 : 0.4),
            // Point-lights: position (`at` transforms `to`); color, attenuate factor.
            points: $53e56069ca082632$var$lit && $53e56069ca082632$var$lit.search(/^(dark|false)$/g) === 0 ? null : [
                // A white spherical-light with radius `0.3` - see https://imdoingitwrong.wordpress.com/2011/01/31/light-attenuation/
                {
                    at: [
                        0,
                        1,
                        0
                    ],
                    color: [
                        20,
                        20,
                        20
                    ],
                    factor: [
                        1,
                        2 / 0.3,
                        0.3 ** -2
                    ]
                },
                // A cyan-ish point-light, higher linear attenuation.
                {
                    at: [
                        $53e56069ca082632$var$cos(0),
                        -1,
                        $53e56069ca082632$var$sin(0)
                    ],
                    color: [
                        1,
                        9,
                        9
                    ],
                    factor: [
                        1,
                        9,
                        3
                    ]
                },
                // A magenta-ish point-light, higher quadratic attenuation.
                {
                    at: [
                        $53e56069ca082632$var$cos($53e56069ca082632$var$tau * 0.33),
                        -1,
                        $53e56069ca082632$var$sin($53e56069ca082632$var$tau * 0.33)
                    ],
                    color: [
                        9,
                        1,
                        9
                    ],
                    factor: [
                        1,
                        3,
                        9
                    ]
                },
                // A yellow-ish point-light, even attenuation.
                {
                    at: [
                        $53e56069ca082632$var$cos($53e56069ca082632$var$tau * 0.66),
                        -1,
                        $53e56069ca082632$var$sin($53e56069ca082632$var$tau * 0.66)
                    ],
                    color: [
                        9,
                        9,
                        1
                    ],
                    factor: [
                        1,
                        5,
                        5
                    ]
                }
            ]
        },
        // Material roughness, albedo, and skin thickness.
        material: [
            $53e56069ca082632$var$rough,
            $53e56069ca082632$var$albedo,
            $53e56069ca082632$var$skin
        ],
        // Scale depths over near and far range, and precision (arbitrarily).
        depths: [
            1e-2,
            1,
            5e-2 / $53e56069ca082632$var$depthBits
        ],
        // Fog start offset, scale, exponent, maximum effect.
        fog: [
            -1,
            0.4,
            1,
            0.9
        ],
        // The clear and fog color.
        clear: [
            0,
            0,
            0,
            0
        ],
        // How many vertexes per form.
        form: (0, $745f5a1412ccd482$export$7d15b64cf5a3a4c4)($53e56069ca082632$var$form || 2, 1, 1 + $53e56069ca082632$var$useLines),
        // Vertex counts, by form; how many steps a form covers, for all entries.
        counts: $53e56069ca082632$var$drawCounts,
        // Which primitives can be drawn, by form.
        primitives: [
            ,
            "points",
            "lines"
        ],
        // Which primitive dimensions can be drawn, by form.
        widths: [
            ,
            $53e56069ca082632$var$pointSizeDims,
            $53e56069ca082632$var$lineWidthDims
        ],
        wide: // How wide the form is; to be scaled by `viewScale`.
        $53e56069ca082632$var$wide,
        fizz: // How many older state positions to fizz around, and other inputs.
        $53e56069ca082632$var$fizz,
        hues: // Hue range to colour particles.
        $53e56069ca082632$var$hues,
        // One option in these arrays is used, by Euler/Verlet respectively.
        // Speed-to-colour scaling, as `[multiply, power]`.
        paceColor: [
            [
                $53e56069ca082632$var$paceLit * 2e-9,
                2
            ],
            [
                $53e56069ca082632$var$paceLit * 2e7,
                2
            ]
        ]
    },
    // Map everything similarly to the `gl-gpgpu` step, `mapStep` can be reused to
    // create new mappings with some additions for drawing.
    maps: (0, $bbb23253d9fa3113$export$798cdecdcbbf9755)({
        ...$53e56069ca082632$var$state.maps,
        /**
     * To ensure drawing happens in one pass, disregard buffers to prevent
     * multiple passes (as happens in `state.step` to bind all `texture`s across
     * limited buffer outputs).
     */ buffersMax: 0,
        /**
     * Read all past `values` to derive one value; that is, look up all states
     * in one draw pass.
     *
     * This case creates `macros` of a `reads_${value}_i` list, where `value` is
     * `0` and each entry in this list gives a `[step, value]` pair, here being
     * `[0, 0]`, `[0, 1]`, `[0, 2]`, `[1, 0]`.
     */ derives: [
            // Entries of the first value's `derives` (`derives[0]`) `array` denote
            // that it derives from:
            [
                // All `values` (denoted by `true`), 1st step past.
                true,
                // The `position` value, 2nd step past.
                {
                    value: $53e56069ca082632$var$valuesIndex.position,
                    step: (0, $e2f6bbbfbdb75d47$export$2e2bcd8739ae039)(1, $53e56069ca082632$var$drawSteps)
                }
            ]
        ]
    })
};
/** Hook up `gl-gpgpu` uniforms by extending them. */ const $53e56069ca082632$var$drawUniforms = (0, $42d53ffb3630b5df$export$1aad3af825e3305b)($53e56069ca082632$var$drawState, {
    ...$53e56069ca082632$var$drawState.uniforms,
    modelView: $53e56069ca082632$var$regl.prop("drawProps.transform.modelView.matrix"),
    projection: $53e56069ca082632$var$regl.prop("drawProps.projection.matrix"),
    eye: $53e56069ca082632$var$regl.prop("drawProps.view.eye"),
    aspect: $53e56069ca082632$var$regl.prop("drawProps.aspect"),
    material: $53e56069ca082632$var$regl.prop("drawProps.material"),
    depths: $53e56069ca082632$var$regl.prop("drawProps.depths"),
    fog: $53e56069ca082632$var$regl.prop("drawProps.fog"),
    clear: $53e56069ca082632$var$regl.prop("drawProps.clear"),
    // How many vertexes per form.
    form: $53e56069ca082632$var$regl.prop("drawProps.form"),
    fizz: $53e56069ca082632$var$regl.prop("drawProps.fizz.at"),
    fizzMax: $53e56069ca082632$var$regl.prop("drawProps.fizz.max"),
    fizzRate: $53e56069ca082632$var$regl.prop("drawProps.fizz.rate"),
    fizzCurve: $53e56069ca082632$var$regl.prop("drawProps.fizz.curve"),
    hues: $53e56069ca082632$var$regl.prop("drawProps.hues"),
    lightAmbient: $53e56069ca082632$var$regl.prop("drawProps.light.ambient"),
    paceColor: (_, { drawProps: dp, props: p })=>dp.paceColor[+p.useVerlet],
    widths: (_, { drawProps: { widths: ws, form: f } })=>ws[f],
    wide: (_, { drawProps: { wide: w, widths: ws, form: f, size: s } })=>(0, $745f5a1412ccd482$export$7d15b64cf5a3a4c4)(w * $53e56069ca082632$var$viewScale(...s), ...ws[f])
});
/** Convert point-lights from object-oriented to flat data-oriented. */ const $53e56069ca082632$var$lightPoints = $53e56069ca082632$var$drawState.drawProps.light.points;
$53e56069ca082632$var$lightPoints && (0, $338b36538fe76dc4$export$2e2bcd8739ae039)((o, _, l)=>{
    const n = "lightPoint";
    const i = `[${l}]`;
    o[n + "Positions" + i] = (_, p)=>{
        const { light: light, transform: transform } = p.drawProps;
        const lp = light.points[l];
        const { at: at, to: to = lp.to = [] } = lp;
        return (0, $38addd61b75018c2$export$1c6c7bbb3c786559)(to, transform.modelView.matrix, at);
    };
    o[n + "Colors" + i] = $53e56069ca082632$var$regl.prop(`drawProps.light.points${i}.color`);
    o[n + "Factors" + i] = $53e56069ca082632$var$regl.prop(`drawProps.light.points${i}.factor`);
    return o;
}, $53e56069ca082632$var$lightPoints, $53e56069ca082632$var$drawUniforms);
/** The `GL` render command pipeline state. */ const $53e56069ca082632$var$drawPipeline = {
    // Use `gl-gpgpu` `macro` mappings by prepending `macro`s from a single pass.
    vert: (_, p)=>(0, $5bb6ca9eea4b6017$export$d38b14fb9031108e)(p) + `#define lightPointsL ${p.drawProps.light.points?.length ?? 0}\n` + (0, (/*@__PURE__*/$parcel$interopDefault($0864ed465b4b61e3$exports))),
    frag: (_, p)=>`#define lightPointsL ${p.drawProps.light.points?.length ?? 0}\n` + (0, (/*@__PURE__*/$parcel$interopDefault($83eacfac60e27234$exports))),
    // Maximum count here to set up buffers, can be partly used later.
    attributes: {
        index: (0, $590beef2a696b8fd$export$87ed20f81f3c66ff)($53e56069ca082632$var$max(...$53e56069ca082632$var$drawCounts))
    },
    uniforms: $53e56069ca082632$var$drawUniforms,
    lineWidth: (_, { drawProps: { wide: w, size: s } })=>(0, $745f5a1412ccd482$export$7d15b64cf5a3a4c4)(w * $53e56069ca082632$var$viewScale(...s), ...$53e56069ca082632$var$lineWidthDims),
    // Vertex counts by form; how many steps a form covers, for all entries.
    count: (_, { count: c, drawProps: { counts: cs, form: f } })=>c ?? cs[f],
    blend: {
        enable: true,
        func: {
            src: "one",
            dst: "one minus src alpha"
        }
    },
    primitive: (_, { drawProps: { primitive: p, primitives: ps, form: f } })=>p ?? ps[f]
};
console.log(self.drawState = $53e56069ca082632$var$drawState, self.drawPipeline = $53e56069ca082632$var$drawPipeline);
/** Function to execute the render command pipeline state every frame. */ const $53e56069ca082632$var$draw = $53e56069ca082632$var$regl($53e56069ca082632$var$drawPipeline);
const $53e56069ca082632$var$clearView = {
    color: $53e56069ca082632$var$drawState.drawProps.clear,
    depth: 1
};
/** Rotate the model by an angle; update the matrix and inverse. */ function $53e56069ca082632$var$rotateModel(angle = $53e56069ca082632$var$drawState.drawProps.model.angle) {
    if (!angle) return;
    const { model: model } = $53e56069ca082632$var$drawState.drawProps;
    const { rotation: r, axis: axis, matrix: mm, inverse: mi } = model;
    return (0, $10e45118cd110752$export$f3d3af87b23e55b9)(mi, (0, $6d7c0a538c53a7fd$export$d012f6a5572fd758)(mm, (0, $9245048e660b6c56$export$6af315cc92b6bcce)(r, axis, angle), mm));
}
/** Update the view matrix and inverse. */ function $53e56069ca082632$var$updateView() {
    const { eye: eye, target: target, up: up, matrix: vm, inverse: vi } = $53e56069ca082632$var$drawState.drawProps.view;
    return (0, $10e45118cd110752$export$f3d3af87b23e55b9)(vi, (0, $c89cf6c34e6d5f69$export$d924e14fd6d9aa66)(vm, eye, target, up));
}
/** Update the projection matrix and inverse. */ function $53e56069ca082632$var$updateProjection() {
    const { depths: [d0, d1], projection: p } = $53e56069ca082632$var$drawState.drawProps;
    const { matrix: pm, inverse: pi } = p;
    /** Aspect ratio is handled separately, so set to 1 in the projection. */ (0, $10e45118cd110752$export$f3d3af87b23e55b9)(pi, (0, $2aa49d03cb7ea07e$export$541149539f3a4684)(pm, 40, 1, d0, d1));
}
/** Update each needed cached combined transformation matrix and inverse. */ function $53e56069ca082632$var$updateTransform() {
    const { transform: t, model: model, view: view, projection: projection } = $53e56069ca082632$var$drawState.drawProps;
    const { modelView: tmv, viewProjection: tvp, modelViewProjection: tmvp } = t;
    const mm = model.matrix;
    const vm = view.matrix;
    const pm = projection.matrix;
    tmv && (0, $10e45118cd110752$export$f3d3af87b23e55b9)(tmv.inverse, (0, $f53b42fca9402ef8$export$ee1b3e54f0441b22)(tmv.matrix, vm, mm));
    tvp && (0, $10e45118cd110752$export$f3d3af87b23e55b9)(tvp.inverse, (0, $f53b42fca9402ef8$export$ee1b3e54f0441b22)(tvp.matrix, pm, vm));
    tmvp && (0, $10e45118cd110752$export$f3d3af87b23e55b9)(tmvp.inverse, (0, $f53b42fca9402ef8$export$ee1b3e54f0441b22)(tmvp.matrix, pm, vm, mm));
}
/** Rotate the model to its starting angle. */ $53e56069ca082632$var$rotateModel($53e56069ca082632$var$drawState.drawProps.model.angle0);
/** Initialise the view matrix. */ $53e56069ca082632$var$updateView();
/** Initialise the projection matrix. */ $53e56069ca082632$var$updateProjection();
function $53e56069ca082632$var$stopEvent(e) {
    e.stopPropagation();
    e.preventDefault();
}
/** Pause the spawning while pointer is held down. */ let $53e56069ca082632$var$hold;
/** Pause particles spawning. */ $53e56069ca082632$var$canvas.addEventListener("contextmenu", (e)=>{
    // Whether a particle's allowed to spawn.
    $53e56069ca082632$var$state.props.lifetime[2] = 0;
    $53e56069ca082632$var$hold = false;
    $53e56069ca082632$var$stopEvent(e);
});
/** Switch primary pointer control between source and sink. */ $53e56069ca082632$var$canvas.addEventListener("onpointerup" in self ? "pointerup" : "ontouchend" in self ? "touchend" : "mouseup", (e)=>{
    /** Unpause the spawning when pointer is released. */ const spawned = $53e56069ca082632$var$state.props.lifetime[2];
    const held = $53e56069ca082632$var$hold;
    // Whether a particle's allowed to spawn.
    $53e56069ca082632$var$state.props.lifetime[2] = 1;
    $53e56069ca082632$var$hold = false;
    // Don't switch primary pointer control if pointer was being held down,
    // particles weren't spawning, or any non-primary button was released.
    if (held || !spawned || e.button !== 0) return;
    // Switch primary pointer control if this wasn't press-held.
    $53e56069ca082632$var$state.props.flipPointer = !$53e56069ca082632$var$state.props.flipPointer;
    $53e56069ca082632$var$stopEvent(e);
});
/** Move either the source or the sink, according to primary pointer. */ $53e56069ca082632$var$canvas.addEventListener("onpointermove" in self ? "pointermove" : "ontouchmove" in self ? "touchmove" : "mousemove", (e)=>{
    const { clientX: x, clientY: y, type: type, pointerType: pointerType, isPrimary: isPrimary = true } = e;
    const { top: top, right: right, bottom: bottom, left: left } = $53e56069ca082632$var$canvas.getBoundingClientRect();
    const { source: i, sink: o, flipPointer: flipPointer, timer: t } = $53e56069ca082632$var$state.props;
    const touch = type === "touchmove" || pointerType === "touch";
    /** Move source or sink, switch by primary/other pointer/s in `xor` flip. */ const pick = isPrimary !== flipPointer ? o : i;
    /** Transform from screen-space to world-space. */ const { at: at, to: to = pick.to = [] } = pick;
    const { aspect: ar, transform: transform, model: model, view: view } = $53e56069ca082632$var$drawState.drawProps;
    const { eye: eye, ray: [ro, rv] } = view;
    /** Include any additional data. */ (0, $ea53246f0372c42f$export$2e2bcd8739ae039)((v)=>v, at, to);
    /** Screen-space pointer as a `ray` target. */ (0, $5d21eae0771d5dbf$export$ba8c70ce75474f8d)(rv, (0, $937d5a0bb1da012a$export$1e044b7877db048c)(x, left, right, -1, 1), (0, $937d5a0bb1da012a$export$1e044b7877db048c)(y, top, bottom, 1, -1), 1);
    /** Aspect ratio scale and un-project the `ray` target. */ (0, $38addd61b75018c2$export$1c6c7bbb3c786559)(rv, transform.modelViewProjection.inverse, (0, $36a238e94b0bc796$export$87ee28508e334108)(rv, rv, ar));
    /** Un-transform `eye` as `ray` origin, subtract `ray` target as vector. */ (0, $fd7187d8c34fec7e$export$4d77c846ee8dc708)(rv, rv, (0, $38addd61b75018c2$export$1c6c7bbb3c786559)(ro, model.inverse, eye));
    /** Cast along `ray` by the initial `eye` to `at` distance, as `to`. */ (0, $0af0502c9d4a179a$export$287691874d09163a)(to, ro, (0, $8778c839920652eb$export$6feaa6aa9769ce13)(rv, rv, (0, $582a8b5bf10e06ee$export$49f8ee6768bb070e)(eye, at)));
    // For touch devices, don't pause spawn if touch moves while held down.
    touch && ($53e56069ca082632$var$hold = true);
    // Reset the idle time for any movement.
    t.idle = 0;
    document.body.classList.remove("idle");
});
/** Toggle physics and graphics modes. */ $53e56069ca082632$var$canvas.addEventListener("dblclick", (e)=>{
    const { props: p, drawProps: d } = $53e56069ca082632$var$drawState;
    const v = $53e56069ca082632$var$canVerlet && (p.useVerlet = 1 - p.useVerlet);
    const f = $53e56069ca082632$var$form || (d.form = 1 + ($53e56069ca082632$var$useLines && ($53e56069ca082632$var$canVerlet ? v : d.form % 2)));
    console.log("useVerlet", v, "form", f, // See how this derives other properties.
    "count", $53e56069ca082632$var$drawPipeline.count(0, $53e56069ca082632$var$drawState), "primitive", $53e56069ca082632$var$drawPipeline.primitive(0, $53e56069ca082632$var$drawState));
});
/** Toggle fullscreen by button. */ document.querySelector("#fullscreen")?.addEventListener?.("click", ()=>$53e56069ca082632$var$canvas.requestFullscreen());
/** Toggle fullscreen by key-press. */ document.addEventListener("keyup", (e)=>e.key === "f" && $53e56069ca082632$var$canvas.requestFullscreen());
const $53e56069ca082632$var$$fallback = document.querySelector("#fallback");
if ($53e56069ca082632$var$$fallback && $53e56069ca082632$var$query.get("fallback") !== "false") {
    /** Scroll back up when fallback demo video loads. */ $53e56069ca082632$var$$fallback.addEventListener("load", $53e56069ca082632$var$scrollDefer);
    $53e56069ca082632$var$$fallback.src = $53e56069ca082632$var$$fallback.dataset.src;
}
/** Resize the canvas and any dependent properties. */ function $53e56069ca082632$var$resize() {
    const { size: size, aspect: ar } = $53e56069ca082632$var$drawState.drawProps;
    const [w, h] = (0, $86721001f8014b70$export$b54ddf06b57709b1)(size, (0, $5d21eae0771d5dbf$export$dcfbb7940cfb3a48)(size, innerWidth, innerHeight), $53e56069ca082632$var$pixelRatio);
    $53e56069ca082632$var$canvas.width = w;
    $53e56069ca082632$var$canvas.height = h;
    $53e56069ca082632$var$aspect(size, ar);
}
addEventListener("resize", $53e56069ca082632$var$resize);
$53e56069ca082632$var$resize();
function $53e56069ca082632$var$stepTime(to) {
    const { dt: dt, dts: dts } = (0, $aa3af7eb13cf442c$export$2e2bcd8739ae039)(to);
    dts[0] = dts[1];
    to.idle += dts[1] = dt;
    return to;
}
/** Compute the next step of state for a frame. */ function $53e56069ca082632$var$frameStep() {
    try {
        $53e56069ca082632$var$stepTime($53e56069ca082632$var$state.props.timer);
        $53e56069ca082632$var$state.step();
    } catch (e) {
        $53e56069ca082632$var$toggleError(e);
    }
}
// Whether to prefill initial states before spawning, or start with all `0`.
for(let p = $53e56069ca082632$var$prefill && $53e56069ca082632$var$stepsPast; p; --p)$53e56069ca082632$var$frameStep();
$53e56069ca082632$var$regl.frame(()=>{
    try {
        $53e56069ca082632$var$frameStep();
        // Update the draw state.
        $53e56069ca082632$var$drawState.stepNow = $53e56069ca082632$var$state.stepNow + 1 - $53e56069ca082632$var$drawBound;
        // Rotate the scene each frame.
        $53e56069ca082632$var$rotateModel();
        // Update the transformation matrices.
        $53e56069ca082632$var$updateTransform();
        // Clear and draw.
        $53e56069ca082632$var$regl.clear($53e56069ca082632$var$clearView);
        $53e56069ca082632$var$draw($53e56069ca082632$var$drawState);
        // Update idle view.
        $53e56069ca082632$var$state.props.timer.idle > 3e3 && document.body.classList.add("idle");
    } catch (e) {
        $53e56069ca082632$var$toggleError(e);
    }
});


//# sourceMappingURL=index.8fabca8d.js.map
